import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  JSON: Record<string, unknown>;
  MongoID: string;
  RegExpAsString: any;
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  attention?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: Maybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: Maybe<EnumAddressInfoRefType>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AuditNote = {
  __typename?: 'AuditNote';
  _id: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  explanation: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy: ObjectPatchesUpdatedBy;
};

export type AuthorizeResult = {
  __typename?: 'AuthorizeResult';
  token: Scalars['String'];
  url: Scalars['String'];
};

/** Workflow schema for the autoretouch service */
export type AutoRetouchWorkflow = {
  __typename?: 'AutoRetouchWorkflow';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type BrandApi = {
  __typename?: 'BrandApi';
  _id: Scalars['MongoID'];
  autoPublish?: Maybe<Scalars['Boolean']>;
  autoretouch?: Maybe<BrandApiAutoretouch>;
  b2ceurope?: Maybe<BrandApiB2ceurope>;
  burd?: Maybe<BrandApiBurd>;
  createdAt?: Maybe<Scalars['Date']>;
  externShop?: Maybe<BrandApiExternShop>;
  googleTrackingId?: Maybe<Scalars['String']>;
  sendgrid?: Maybe<BrandApiSendgrid>;
  shopId?: Maybe<Scalars['MongoID']>;
  shopify?: Maybe<BrandApiShopify>;
  spy?: Maybe<BrandApiSpy>;
  traede?: Maybe<BrandApiTraede>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type BrandApiAutoretouch = {
  __typename?: 'BrandApiAutoretouch';
  autoProcess?: Maybe<Scalars['Boolean']>;
  autoRotate?: Maybe<Scalars['Float']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type BrandApiAutoretouchInput = {
  autoProcess?: InputMaybe<Scalars['Boolean']>;
  autoRotate?: InputMaybe<Scalars['Float']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

export type BrandApiB2ceurope = {
  __typename?: 'BrandApiB2ceurope';
  password?: Maybe<Scalars['String']>;
  userid?: Maybe<Scalars['String']>;
};

export type BrandApiB2ceuropeInput = {
  password?: InputMaybe<Scalars['String']>;
  userid?: InputMaybe<Scalars['String']>;
};

export type BrandApiBurd = {
  __typename?: 'BrandApiBurd';
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type BrandApiBurdInput = {
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type BrandApiExternShop = {
  __typename?: 'BrandApiExternShop';
  serviceBus?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type BrandApiExternShopInput = {
  serviceBus?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
};

export type BrandApiInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  autoPublish?: InputMaybe<Scalars['Boolean']>;
  autoretouch?: InputMaybe<BrandApiAutoretouchInput>;
  b2ceurope?: InputMaybe<BrandApiB2ceuropeInput>;
  burd?: InputMaybe<BrandApiBurdInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  externShop?: InputMaybe<BrandApiExternShopInput>;
  googleTrackingId?: InputMaybe<Scalars['String']>;
  sendgrid?: InputMaybe<BrandApiSendgridInput>;
  shopify?: InputMaybe<BrandApiShopifyInput>;
  spy?: InputMaybe<BrandApiSpyInput>;
  traede?: InputMaybe<BrandApiTraedeInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type BrandApiSendgrid = {
  __typename?: 'BrandApiSendgrid';
  from?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type BrandApiSendgridInput = {
  from?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type BrandApiShopify = {
  __typename?: 'BrandApiShopify';
  capture?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  options?: Maybe<BrandApiShopifyOptions>;
  refund?: Maybe<Scalars['Boolean']>;
  shopifyLocationId?: Maybe<Scalars['String']>;
};

export type BrandApiShopifyInput = {
  capture?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<BrandApiShopifyOptionsInput>;
  refund?: InputMaybe<Scalars['Boolean']>;
  shopifyLocationId?: InputMaybe<Scalars['String']>;
};

export type BrandApiShopifyOptions = {
  __typename?: 'BrandApiShopifyOptions';
  color?: Maybe<Scalars['Boolean']>;
  colorName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Boolean']>;
  sizeName?: Maybe<Scalars['String']>;
};

export type BrandApiShopifyOptionsInput = {
  color?: InputMaybe<Scalars['Boolean']>;
  colorName?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Boolean']>;
  sizeName?: InputMaybe<Scalars['String']>;
};

export type BrandApiSpy = {
  __typename?: 'BrandApiSpy';
  captureUrl?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  refundUrl?: Maybe<Scalars['String']>;
};

export type BrandApiSpyInput = {
  captureUrl?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  refundUrl?: InputMaybe<Scalars['String']>;
};

export type BrandApiTraede = {
  __typename?: 'BrandApiTraede';
  accessToken?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  itemNumberPrefix?: Maybe<Scalars['String']>;
};

export type BrandApiTraedeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  itemNumberPrefix?: InputMaybe<Scalars['String']>;
};

export type BrandCarrier = {
  __typename?: 'BrandCarrier';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  shippingCarrier?: Maybe<ShippingCarrier>;
  shippingCarrierId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
};

/** Conditions for the public */
export type BrandConditionPublic = {
  __typename?: 'BrandConditionPublic';
  condition: Scalars['Int'];
  description: Scalars['String'];
  name: Scalars['String'];
};

export type BrandHouse = {
  __typename?: 'BrandHouse';
  _id: Scalars['MongoID'];
  address?: Maybe<AddressInfo>;
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
  /** Conditions */
  conditions?: Maybe<Array<Maybe<BrandConditionPublic>>>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Brandhouse has been deactivated */
  deactivated?: Maybe<Scalars['Boolean']>;
  initials?: Maybe<Scalars['String']>;
  license?: Maybe<Scalars['String']>;
  logisticsPartnerId: Scalars['MongoID'];
  name?: Maybe<Scalars['String']>;
  /** List of all metafield values found on the given key */
  productMetaFieldValues?: Maybe<Array<Scalars['String']>>;
  /** List of all tags found on brand products */
  productTags?: Maybe<Array<Scalars['String']>>;
  /** List of all product types found on brand products */
  productTypes?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** When true, all configuration changes require an audit note with explanation */
  requireChangeExplanation?: Maybe<Scalars['Boolean']>;
  /** Brand settings */
  settings?: Maybe<BrandSetting>;
  /** Lists all shops for this brand */
  shops?: Maybe<Array<Maybe<Shop>>>;
  /** List of all sources found on brand products */
  sources?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};


export type BrandHouseProductMetaFieldValuesArgs = {
  key: Scalars['String'];
};

export type BrandItem = {
  __typename?: 'BrandItem';
  _id: Scalars['MongoID'];
  /** Attributes of the clothing item */
  attributes?: Maybe<BrandItemAttributes>;
  beforePrices?: Maybe<Array<Maybe<Pricing>>>;
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  /** Brand product size information */
  brandProductSize?: Maybe<BrandProductSize>;
  /** The master data variant/size */
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** The master data variant */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: Maybe<Scalars['Date']>;
  /** Localized color of the item */
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** True if the comment has been approved */
  commentApproved?: Maybe<Scalars['Boolean']>;
  /** Previous owner comments for the item, localized */
  commentLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** Condition of the item, between 1 and 3 */
  condition: Scalars['Float'];
  /** The countryOrigin of this brand item */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Returns a list of data problems */
  dataErrors?: Maybe<Array<Scalars['String']>>;
  /** Actual days the item has been available for purchase (daysSinceFirstListed - daysOffline), null if never listed */
  daysForSale?: Maybe<Scalars['Int']>;
  /** Total days this item has been offline since firstListedDate */
  daysOffline?: Maybe<Scalars['Float']>;
  /** Total days since the item was first listed for sale (null if never listed) */
  daysSinceFirstListed?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Localized description of the item */
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  directPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** If true, the RRP list price is disabled */
  disableRRPListPrice?: Maybe<Scalars['Boolean']>;
  /** The date this item was discarded by the owner - a discarded item is not for sale */
  discarded?: Maybe<Scalars['Date']>;
  /** Whether the logistics partner has checked this stockitem since last recount */
  effectiveChecked: Scalars['Boolean'];
  /** Whether the logistics partner has marked this this stockitem as lost */
  effectiveMissing: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  /** The date when this item was first listed for sale (never recalculated) */
  firstListedDate?: Maybe<Scalars['Date']>;
  hasComment?: Maybe<Scalars['Boolean']>;
  hasCustomImages?: Maybe<Scalars['Boolean']>;
  /** True if this item has errors */
  hasErrors: Scalars['Boolean'];
  hasLocation?: Maybe<Scalars['Boolean']>;
  hasMasterData?: Maybe<Scalars['Boolean']>;
  hasProblems?: Maybe<Scalars['Boolean']>;
  hasTranslatedComment?: Maybe<Scalars['Boolean']>;
  /** 512-dimensional embedding vector for the primary image */
  imageEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns an array of images for this branditem */
  images?: Maybe<Array<Maybe<BrandItemImage>>>;
  /** If true, the manufacturer is invalid */
  invalidManufacturer?: Maybe<Scalars['Boolean']>;
  /** The invoice line for this item, if it exists */
  invoiceLine?: Maybe<InvoiceLine>;
  /** The invoice state for this item */
  invoiceState: Scalars['String'];
  /** Whether this stockitem is in-season */
  isInSeason: Scalars['Boolean'];
  isSold: Scalars['Boolean'];
  isTradeIn: Scalars['Boolean'];
  /** Internal EAN number for this brand-item */
  itemEan: Scalars['String'];
  /** Returns a list of item metafields */
  itemMetas?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  /** The itemNr is a unique number for each branditem in context of the brandhouse */
  itemNr: Scalars['Float'];
  /** The SKU for this branditem */
  itemSku: Scalars['String'];
  /** State of the branditem */
  itemState: EnumBrandItemItemState;
  /** Returns a list of item tags */
  itemTags?: Maybe<Array<Maybe<BrandItemTag>>>;
  /** History of all location changes for this brand item */
  layawayHistory?: Maybe<Array<Maybe<BrandItemLayaway>>>;
  /** True if this item is linked to masterdata from a legacy group */
  legacyGroup: Scalars['Boolean'];
  /** The list price in selected currency, if not provided then shop currency */
  listPrice?: Maybe<Scalars['Float']>;
  /** List prices for this stockitem */
  listPrices?: Maybe<Array<Maybe<Pricing>>>;
  masterDataInfo?: Maybe<BrandItemMasterDataInfo>;
  /** Localized MAS masterdata metafields used as the source for item metafield resolution */
  masterDataLocalizedMetafields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** MAS masterdata metafields used as the source for item metafield resolution */
  masterDataMetafields?: Maybe<Array<Maybe<MetaField>>>;
  /** The brandproduct masterdata that this itemis linked to */
  masterDataProduct?: Maybe<BrandProduct>;
  /** When MAS masterdata was last pulled into this item */
  masterDataPulledAt?: Maybe<Scalars['Date']>;
  masterDataSnapshot?: Maybe<BrandItemMasterDataSnapshot>;
  /** The external MAS masterdata variant id */
  masterDataVariantId?: Maybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: Maybe<Scalars['Date']>;
  /** Localized name of the item */
  nameLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The NFC Tag for this stockitem */
  nfcTag?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<OptionInstance>>>;
  /** If this branditem has an active orderline in one of its shops then this will be returned here */
  orderline?: Maybe<Order2Item>;
  /** If this branditem has orderlines in one of its shops then this will be returned here */
  orderlines?: Maybe<Array<Maybe<Order2Item>>>;
  /** The originalEan of this brand item */
  originalEan?: Maybe<Scalars['String']>;
  /** The originalSku of this brand item */
  originalSku?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<BrandItemProblem>>>;
  resolved?: Maybe<BrandItemResolved>;
  reviewInfos?: Maybe<Array<Maybe<BrandItemReviewInfo>>>;
  /** The sales rank score (0-100) based on seasonal relevance and attribute popularity */
  salesRank: Scalars['Float'];
  /** Score indicating how sellable the item is (0-100) */
  salesScore?: Maybe<Scalars['Float']>;
  /** Timestamp when the sales score was last calculated */
  salesScoreTs?: Maybe<Scalars['Date']>;
  /** The selling price before tax in selected currency, if not provided then shop currency */
  sellingPrice?: Maybe<Scalars['Float']>;
  /** The selling prices for this branditem */
  sellingPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop info for this branditem */
  shops?: Maybe<Array<Maybe<BrandItemShopInfo>>>;
  /** The size of the item in a given language */
  size?: Maybe<Scalars['String']>;
  /** Localized size of the item */
  sizeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The date this item was sold */
  soldTs?: Maybe<Scalars['Date']>;
  /** The sortorder of this branditem */
  sortorder?: Maybe<Scalars['Float']>;
  /** The source type for this item */
  sourceType?: Maybe<ItemSourceType>;
  /** Aggregated state for this item, collected from multiple data sources */
  stateAggregation?: Maybe<BrandItemAggregatedStateEnum>;
  /** Statistics for this branditem */
  statistics?: Maybe<BrandItemStatistics>;
  stockLocation?: Maybe<Scalars['String']>;
  /** The barcode of the bag that the item is placed in at the stock location */
  stockLocationBag?: Maybe<Scalars['String']>;
  stockLocationTs?: Maybe<Scalars['Date']>;
  /** Returns a list of tags for this stockitem, use itemTags to see where the tag originated from */
  tags?: Maybe<Array<Scalars['String']>>;
  /** True if this item is a test item */
  test?: Maybe<Scalars['Boolean']>;
  /** Returns the tradein item that this branditem was made from */
  tradeInItem?: Maybe<TradeInItem>;
  /** Link to the tradein item, if applicable */
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  /** The product type of this brand item */
  typeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** This item is registered out of warehouse by the logisticspartner at the given date */
  unavailable?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Returns the VAS for this item */
  vas?: Maybe<Array<Maybe<BrandItemVas>>>;
  vasId?: Maybe<Scalars['String']>;
  /** Image references received from VAS for this item */
  vasImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The current logistics state based on VAS entries */
  vasState?: Maybe<BrandItemLogisticsStateEnum>;
  /** The VAS contract version for this item */
  vasType?: Maybe<BrandItemVasTypeEnum>;
  /** The vendor type of this brand item */
  vendor?: Maybe<Scalars['String']>;
  /** Total page views for this item across all shops */
  views?: Maybe<Scalars['Float']>;
  /** Total unique visitors for this item across all shops */
  visitors?: Maybe<Scalars['Float']>;
};


export type BrandItemImageUrlsArgs = {
  potentialImages?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemItemMetasArgs = {
  excludeAuto?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemItemTagsArgs = {
  includeAuto?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemListPriceArgs = {
  currency: Scalars['String'];
  excludeVAT?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedArgs = {
  applyFallbackLocale?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemSalesRankArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type BrandItemSellingPriceArgs = {
  currency: Scalars['String'];
  excludeVAT?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemSizeArgs = {
  language: Scalars['String'];
};


export type BrandItemStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export enum BrandItemAggregatedStateEnum {
  Blocked = 'BLOCKED',
  Discarded = 'DISCARDED',
  Draft = 'DRAFT',
  Forsale = 'FORSALE',
  Forsalepartly = 'FORSALEPARTLY',
  Missing = 'MISSING',
  Nolocation = 'NOLOCATION',
  None = 'NONE',
  Notforsale = 'NOTFORSALE',
  Outofseason = 'OUTOFSEASON',
  Review = 'REVIEW',
  Sold = 'SOLD',
  Unavailable = 'UNAVAILABLE'
}

export type BrandItemAttributes = {
  __typename?: 'BrandItemAttributes';
  apparentFabricType: EnumBrandItemAttributesApparentFabricType;
  confidence?: Maybe<Scalars['Float']>;
  dataProblem?: Maybe<Scalars['String']>;
  dateScanned?: Maybe<Scalars['Date']>;
  formalityLevel: EnumBrandItemAttributesFormalityLevel;
  graphicKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  neckline?: Maybe<EnumBrandItemAttributesNeckline>;
  notableFeatures?: Maybe<Array<Maybe<EnumBrandItemAttributesNotableFeatures>>>;
  pattern: EnumBrandItemAttributesPattern;
  primaryColor: EnumBrandItemAttributesPrimaryColor;
  seasonSuitability?: Maybe<Array<Maybe<EnumBrandItemAttributesSeasonSuitability>>>;
  secondaryColors?: Maybe<Array<Maybe<EnumBrandItemAttributesSecondaryColors>>>;
  size?: Maybe<Scalars['String']>;
  subType?: Maybe<EnumBrandItemAttributesSubType>;
  textureAppearance: EnumBrandItemAttributesTextureAppearance;
  type: EnumBrandItemAttributesType;
};

export type BrandItemAttributesInput = {
  apparentFabricType: EnumBrandItemAttributesApparentFabricType;
  confidence?: InputMaybe<Scalars['Float']>;
  dataProblem?: InputMaybe<Scalars['String']>;
  dateScanned?: InputMaybe<Scalars['Date']>;
  formalityLevel: EnumBrandItemAttributesFormalityLevel;
  graphicKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  neckline?: InputMaybe<EnumBrandItemAttributesNeckline>;
  notableFeatures?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesNotableFeatures>>>;
  pattern: EnumBrandItemAttributesPattern;
  primaryColor: EnumBrandItemAttributesPrimaryColor;
  seasonSuitability?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSeasonSuitability>>>;
  secondaryColors?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSecondaryColors>>>;
  size?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<EnumBrandItemAttributesSubType>;
  textureAppearance: EnumBrandItemAttributesTextureAppearance;
  type: EnumBrandItemAttributesType;
};

/** List of items with pagination. */
export type BrandItemBrandItemPagination = {
  __typename?: 'BrandItemBrandItemPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<BrandItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BrandItemImage = {
  __typename?: 'BrandItemImage';
  _id: Scalars['MongoID'];
  /** Alternative descriptive text for the image */
  altText?: Maybe<Scalars['String']>;
  auditApproved?: Maybe<Scalars['Boolean']>;
  auditApprovedBy?: Maybe<ObjectPatchesUpdatedBy>;
  auditApprovedTs?: Maybe<Scalars['Date']>;
  brandHouseId: Scalars['MongoID'];
  brandItemId: Scalars['MongoID'];
  brandProductImageId?: Maybe<Scalars['MongoID']>;
  /** URL to the processed image */
  brandProductImageUrl?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  externId?: Maybe<Scalars['String']>;
  failed?: Maybe<Scalars['Boolean']>;
  hide?: Maybe<Scalars['Date']>;
  imageId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: Maybe<Scalars['String']>;
  /** URL to the processed image */
  imageUrl?: Maybe<Scalars['String']>;
  /** If the image is the original image for the brand item */
  originalImage?: Maybe<Scalars['Boolean']>;
  perspective?: Maybe<EnumBrandItemImagePerspective>;
  process?: Maybe<Scalars['Boolean']>;
  processError?: Maybe<Scalars['String']>;
  processStart?: Maybe<Scalars['Date']>;
  requireAudit?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumBrandItemImageType>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  uploadId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the upload, used to compare images */
  uploadMd5?: Maybe<Scalars['String']>;
  /** URL to the original uploaded image */
  uploadUrl?: Maybe<Scalars['String']>;
};

export type BrandItemImageInputInput = {
  /** The internal identifier, if missing or null a new image will be created */
  _id?: InputMaybe<Scalars['MongoID']>;
  /** An alternative text for the image, typically shown as a title on the web */
  altText?: InputMaybe<Scalars['String']>;
  /** The ID of the brand product image, either this or the uploadId must be supplied */
  brandProductImageId?: InputMaybe<Scalars['MongoID']>;
  /** The external identifier */
  externId?: InputMaybe<Scalars['String']>;
  /** The ID of the processed image */
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** Whether its an original image for the product */
  originalImage?: InputMaybe<Scalars['Boolean']>;
  /** The perspective of the image */
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  /** Whether the post-processing (background removal etc) should be run on this image */
  process?: InputMaybe<Scalars['Boolean']>;
  /** The type of the image */
  type?: InputMaybe<ImageTypeEnum>;
  /** The ID of the uploaded image, either this or the brandProductImageId must be supplied */
  uploadId?: InputMaybe<Scalars['MongoID']>;
  /** The url of the image upload, either uploadId or uploadUrl must be set */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type BrandItemInputInput = {
  /** The internal identifier, if missing or null a new item will be created */
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Attributes for this brand item */
  attributes?: InputMaybe<BrandItemAttributesInput>;
  /** The rrp prices in supported currencies */
  beforePrices?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** The ID of the brand product size that this item is derived from */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The date of the last time this item was seen and checked */
  checked?: InputMaybe<Scalars['Date']>;
  /** The color of the item localized */
  colorLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** True if the comment has been approved */
  commentApproved?: InputMaybe<Scalars['Boolean']>;
  /** Previous owner comments for the item, localized */
  commentLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The tariff / commodity code for this item */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The condition grading of the brand item - between 1 and 3 */
  condition?: InputMaybe<Scalars['Int']>;
  /** The country code of the country that made this item */
  countryOrigin?: InputMaybe<Scalars['String']>;
  /** The description of the item localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The direct selling prices in supported currencies */
  directPrices?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** True if the list price should be disabled for this item */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** The date this item was discarded by the owner - a discarded item is not for sale */
  discarded?: InputMaybe<Scalars['Date']>;
  /** Unique identifier for the item */
  externalId?: InputMaybe<Scalars['String']>;
  /** 512-dimensional embedding vector for the primary image */
  imageEmbedding?: InputMaybe<Array<Scalars['Float']>>;
  /** The images for this item */
  images?: InputMaybe<Array<InputMaybe<BrandItemImageInputInput>>>;
  /** True if the manufacturer is invalid */
  invalidManufacturer?: InputMaybe<Scalars['Boolean']>;
  /** Issues for this branditem */
  issues?: InputMaybe<Array<InputMaybe<ItemIssueInput>>>;
  /** The publication state of this item */
  itemState?: InputMaybe<BrandItemStateEnum>;
  /** Tags for the item */
  itemTags?: InputMaybe<Array<InputMaybe<BrandItemTagInput>>>;
  /** The MAS masterdata variant id that this item is derived from */
  masterDataVariantId?: InputMaybe<Scalars['String']>;
  /** The date of the last time this item was recorded missing */
  missing?: InputMaybe<Scalars['Date']>;
  /** The name of the item localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The NFC tag for this branditem */
  nfcTag?: InputMaybe<Scalars['String']>;
  /** An internal note for this item */
  note?: InputMaybe<Scalars['String']>;
  /** Options for this branditem */
  options?: InputMaybe<Array<InputMaybe<OptionInstanceInput>>>;
  /** Optionally provide the original ean number for this stockitem - mostly relevant if not linked to masterdata */
  originalEan?: InputMaybe<Scalars['String']>;
  /** Optionally provide the original sku number for this stockitem - mostly relevant if not linked to masterdata */
  originalSku?: InputMaybe<Scalars['String']>;
  /** Problems for this brand item */
  problems?: InputMaybe<Array<InputMaybe<BrandItemProblemInput>>>;
  /** Info from the review process */
  reviewInfos?: InputMaybe<Array<InputMaybe<BrandItemReviewInfoInput>>>;
  /** The size of the item localized */
  sizeLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Sortorder for the branditem */
  sortorder?: InputMaybe<Scalars['Int']>;
  /** The source type for this item */
  sourceType?: InputMaybe<ItemSourceType>;
  /** The location of the item */
  stockLocation?: InputMaybe<Scalars['String']>;
  /** The bag the item is placed in */
  stockLocationBag?: InputMaybe<Scalars['String']>;
  /** True if this item is a test item */
  test?: InputMaybe<Scalars['Boolean']>;
  /** The tradein item for this brand item */
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  /** Type of product localized */
  typeLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The date the item was unavailable from */
  unavailable?: InputMaybe<Scalars['Date']>;
  /** List of VAS for this branditem */
  vas?: InputMaybe<Array<InputMaybe<BrandItemVasInput>>>;
  /** Unique VAS identifier for the item */
  vasId?: InputMaybe<Scalars['String']>;
  /** Image references received from VAS for this item */
  vasImages?: InputMaybe<Array<Scalars['String']>>;
  /** The VAS contract version for this item */
  vasType?: InputMaybe<BrandItemVasTypeEnum>;
  /** Vendor of the item */
  vendor?: InputMaybe<Scalars['String']>;
};

export type BrandItemLayaway = {
  __typename?: 'BrandItemLayaway';
  _id: Scalars['MongoID'];
  brandItem?: Maybe<BrandItem>;
  /** Reference to the BrandItem */
  brandItemId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Stock location of the item */
  stockLocation?: Maybe<Scalars['String']>;
  /** Stock location bag of the item */
  stockLocationBag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** Who made this location change */
  updatedBy: ObjectPatchesUpdatedBy;
};

/** List of items with pagination. */
export type BrandItemLayawayBrandItemLayawayPagination = {
  __typename?: 'BrandItemLayawayBrandItemLayawayPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<BrandItemLayaway>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum BrandItemLogisticsStateEnum {
  Completed = 'COMPLETED',
  Discarded = 'DISCARDED',
  Progressing = 'PROGRESSING',
  Received = 'RECEIVED',
  Repairing = 'REPAIRING',
  Washing = 'WASHING'
}

export type BrandItemMasterDataBackfillResult = {
  __typename?: 'BrandItemMasterDataBackfillResult';
  queued: Scalars['Int'];
  requested: Scalars['Int'];
  skipped: Scalars['Int'];
};

export type BrandItemMasterDataInfo = {
  __typename?: 'BrandItemMasterDataInfo';
  /** Color pf product */
  color?: Maybe<Scalars['String']>;
  /** Master data ean */
  ean?: Maybe<Scalars['String']>;
  /** External ID */
  externalId?: Maybe<Scalars['String']>;
  /** Name of product */
  name?: Maybe<Scalars['String']>;
  /** Size of product */
  size?: Maybe<Scalars['String']>;
  /** Master data sku */
  sku?: Maybe<Scalars['String']>;
};

export type BrandItemMasterDataMigrationFieldSnapshot = {
  __typename?: 'BrandItemMasterDataMigrationFieldSnapshot';
  brandId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  ean?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

export type BrandItemMasterDataMigrationItem = {
  __typename?: 'BrandItemMasterDataMigrationItem';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  brandItemId: Scalars['MongoID'];
  candidate?: Maybe<BrandItemMasterDataMigrationFieldSnapshot>;
  confidence?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Date']>;
  current?: Maybe<BrandItemMasterDataMigrationFieldSnapshot>;
  error?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['Date']>;
  proposedMasterDataProductId?: Maybe<Scalars['String']>;
  proposedMasterDataVariantId?: Maybe<Scalars['String']>;
  reasons?: Maybe<Array<Scalars['String']>>;
  runId: Scalars['MongoID'];
  signals?: Maybe<Array<Maybe<BrandItemMasterDataMigrationSignal>>>;
  status?: Maybe<BrandItemMasterDataMigrationItemStatus>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum BrandItemMasterDataMigrationItemStatus {
  AlreadyLinked = 'AlreadyLinked',
  Auto = 'Auto',
  Failed = 'Failed',
  Migrated = 'Migrated',
  NoMatch = 'NoMatch',
  Processing = 'Processing',
  Queued = 'Queued',
  Review = 'Review',
  Stale = 'Stale'
}

export type BrandItemMasterDataMigrationRun = {
  __typename?: 'BrandItemMasterDataMigrationRun';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<BrandItemMasterDataMigrationUpdatedBy>;
  failedCount: Scalars['Int'];
  matchedCount: Scalars['Int'];
  migratedCount: Scalars['Int'];
  noMatchCount: Scalars['Int'];
  processedCount: Scalars['Int'];
  requestedCount: Scalars['Int'];
  reviewCount: Scalars['Int'];
  sourcePreviewRunId?: Maybe<Scalars['MongoID']>;
  staleCount: Scalars['Int'];
  status?: Maybe<BrandItemMasterDataMigrationRunStatus>;
  type?: Maybe<BrandItemMasterDataMigrationRunKind>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum BrandItemMasterDataMigrationRunKind {
  Migration = 'Migration',
  Preview = 'Preview'
}

export enum BrandItemMasterDataMigrationRunStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Processing = 'Processing',
  Queued = 'Queued'
}

export type BrandItemMasterDataMigrationSelectionInput = {
  brandItemId: Scalars['MongoID'];
  masterDataVariantId: Scalars['String'];
};

export type BrandItemMasterDataMigrationSignal = {
  __typename?: 'BrandItemMasterDataMigrationSignal';
  detail?: Maybe<Scalars['String']>;
  result?: Maybe<BrandItemMasterDataMigrationSignalResult>;
  score?: Maybe<Scalars['Float']>;
  type?: Maybe<BrandItemMasterDataMigrationSignalType>;
  weight?: Maybe<BrandItemMasterDataMigrationSignalWeight>;
};

export enum BrandItemMasterDataMigrationSignalResult {
  Ambiguous = 'Ambiguous',
  Contradiction = 'Contradiction',
  DiscardedShared = 'DiscardedShared',
  Match = 'Match',
  Missing = 'Missing',
  WeakMatch = 'WeakMatch'
}

export enum BrandItemMasterDataMigrationSignalType {
  ColorSize = 'ColorSize',
  Ean = 'Ean',
  ExternalId = 'ExternalId',
  Name = 'Name',
  Sku = 'Sku',
  Style = 'Style',
  Tags = 'Tags',
  Type = 'Type',
  Vendor = 'Vendor'
}

export enum BrandItemMasterDataMigrationSignalWeight {
  Medium = 'Medium',
  Strong = 'Strong',
  Weak = 'Weak'
}

export type BrandItemMasterDataMigrationUpdatedBy = {
  __typename?: 'BrandItemMasterDataMigrationUpdatedBy';
  ref?: Maybe<Scalars['MongoID']>;
  type: Scalars['String'];
};

export type BrandItemMasterDataRefreshResult = {
  __typename?: 'BrandItemMasterDataRefreshResult';
  queued: Scalars['Int'];
  requested: Scalars['Int'];
  skipped: Scalars['Int'];
};

export type BrandItemMasterDataSnapshot = {
  __typename?: 'BrandItemMasterDataSnapshot';
  /** Source BrandProduct at time of snapshot */
  brandProductId?: Maybe<Scalars['MongoID']>;
  /** Source BrandProductSize at time of snapshot */
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** Source BrandProductVariant at time of snapshot */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  /** Localized product metafields at time of snapshot */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Product metafields at time of snapshot */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** Size metafields at time of snapshot */
  sizeMetaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** When the snapshot was taken */
  snapshotTs?: Maybe<Scalars['Date']>;
  /** Product tags at time of snapshot */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Variant weight at time of snapshot */
  weight?: Maybe<Scalars['Float']>;
};

export type BrandItemMasterImage = {
  __typename?: 'BrandItemMasterImage';
  altText?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  externId?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  perspective?: Maybe<ImagePerspectiveEnum>;
  sourceType?: Maybe<BrandItemMasterImageSourceType>;
  type?: Maybe<ImageTypeEnum>;
};

export enum BrandItemMasterImageSourceType {
  BrandProductSize = 'BRAND_PRODUCT_SIZE',
  BrandProductVariant = 'BRAND_PRODUCT_VARIANT',
  MasterdataService = 'MASTERDATA_SERVICE',
  MasterdataSnapshot = 'MASTERDATA_SNAPSHOT'
}

export type BrandItemProblem = {
  __typename?: 'BrandItemProblem';
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  solved: Scalars['Boolean'];
};

export type BrandItemProblemInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved: Scalars['Boolean'];
};

export type BrandItemResolved = {
  __typename?: 'BrandItemResolved';
  _id: Scalars['MongoID'];
  /** Attributes of the clothing item */
  attributes?: Maybe<BrandItemAttributes>;
  beforePrices?: Maybe<Array<Maybe<Pricing>>>;
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  /** Brand product size information */
  brandProductSize?: Maybe<BrandProductSize>;
  /** The master data variant/size */
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** The master data variant */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: Maybe<Scalars['Date']>;
  /** Localized color of the item */
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** True if the comment has been approved */
  commentApproved?: Maybe<Scalars['Boolean']>;
  /** Previous owner comments for the item, localized */
  commentLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** Condition of the item, between 1 and 3 */
  condition: Scalars['Float'];
  /** The countryOrigin of this brand item */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Returns a list of data problems */
  dataErrors?: Maybe<Array<Scalars['String']>>;
  /** Actual days the item has been available for purchase (daysSinceFirstListed - daysOffline), null if never listed */
  daysForSale?: Maybe<Scalars['Int']>;
  /** Total days this item has been offline since firstListedDate */
  daysOffline?: Maybe<Scalars['Float']>;
  /** Total days since the item was first listed for sale (null if never listed) */
  daysSinceFirstListed?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Localized description of the item */
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  directPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** If true, the RRP list price is disabled */
  disableRRPListPrice?: Maybe<Scalars['Boolean']>;
  /** The date this item was discarded by the owner - a discarded item is not for sale */
  discarded?: Maybe<Scalars['Date']>;
  /** Whether the logistics partner has checked this stockitem since last recount */
  effectiveChecked: Scalars['Boolean'];
  /** Whether the logistics partner has marked this this stockitem as lost */
  effectiveMissing: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  /** The date when this item was first listed for sale (never recalculated) */
  firstListedDate?: Maybe<Scalars['Date']>;
  hasComment?: Maybe<Scalars['Boolean']>;
  hasCustomImages?: Maybe<Scalars['Boolean']>;
  /** True if this item has errors */
  hasErrors: Scalars['Boolean'];
  hasLocation?: Maybe<Scalars['Boolean']>;
  hasMasterData?: Maybe<Scalars['Boolean']>;
  hasProblems?: Maybe<Scalars['Boolean']>;
  hasTranslatedComment?: Maybe<Scalars['Boolean']>;
  /** 512-dimensional embedding vector for the primary image */
  imageEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns an array of images for this branditem */
  images?: Maybe<Array<Maybe<BrandItemImage>>>;
  /** If true, the manufacturer is invalid */
  invalidManufacturer?: Maybe<Scalars['Boolean']>;
  /** The invoice line for this item, if it exists */
  invoiceLine?: Maybe<InvoiceLine>;
  /** The invoice state for this item */
  invoiceState: Scalars['String'];
  /** Whether this stockitem is in-season */
  isInSeason: Scalars['Boolean'];
  isSold: Scalars['Boolean'];
  isTradeIn: Scalars['Boolean'];
  /** Internal EAN number for this brand-item */
  itemEan: Scalars['String'];
  /** Returns a list of item metafields */
  itemMetas?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  /** The itemNr is a unique number for each branditem in context of the brandhouse */
  itemNr: Scalars['Float'];
  /** The SKU for this branditem */
  itemSku: Scalars['String'];
  /** State of the branditem */
  itemState: EnumBrandItemItemState;
  /** Returns a list of item tags */
  itemTags?: Maybe<Array<Maybe<BrandItemTag>>>;
  /** History of all location changes for this brand item */
  layawayHistory?: Maybe<Array<Maybe<BrandItemLayaway>>>;
  /** True if this item is linked to masterdata from a legacy group */
  legacyGroup: Scalars['Boolean'];
  /** The list price in selected currency, if not provided then shop currency */
  listPrice?: Maybe<Scalars['Float']>;
  /** List prices for this stockitem */
  listPrices?: Maybe<Array<Maybe<Pricing>>>;
  masterDataInfo?: Maybe<BrandItemMasterDataInfo>;
  /** Localized MAS masterdata metafields used as the source for item metafield resolution */
  masterDataLocalizedMetafields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** MAS masterdata metafields used as the source for item metafield resolution */
  masterDataMetafields?: Maybe<Array<Maybe<MetaField>>>;
  /** The brandproduct masterdata that this itemis linked to */
  masterDataProduct?: Maybe<BrandProduct>;
  /** When MAS masterdata was last pulled into this item */
  masterDataPulledAt?: Maybe<Scalars['Date']>;
  masterDataSnapshot?: Maybe<BrandItemMasterDataSnapshot>;
  /** The external MAS masterdata variant id */
  masterDataVariantId?: Maybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: Maybe<Scalars['Date']>;
  /** Localized name of the item */
  nameLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The NFC Tag for this stockitem */
  nfcTag?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<OptionInstance>>>;
  /** If this branditem has an active orderline in one of its shops then this will be returned here */
  orderline?: Maybe<Order2Item>;
  /** If this branditem has orderlines in one of its shops then this will be returned here */
  orderlines?: Maybe<Array<Maybe<Order2Item>>>;
  /** The originalEan of this brand item */
  originalEan?: Maybe<Scalars['String']>;
  /** The originalSku of this brand item */
  originalSku?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<BrandItemProblem>>>;
  reviewInfos?: Maybe<Array<Maybe<BrandItemReviewInfo>>>;
  /** The sales rank score (0-100) based on seasonal relevance and attribute popularity */
  salesRank: Scalars['Float'];
  /** Score indicating how sellable the item is (0-100) */
  salesScore?: Maybe<Scalars['Float']>;
  /** Timestamp when the sales score was last calculated */
  salesScoreTs?: Maybe<Scalars['Date']>;
  /** The selling price before tax in selected currency, if not provided then shop currency */
  sellingPrice?: Maybe<Scalars['Float']>;
  /** The selling prices for this branditem */
  sellingPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop info for this branditem */
  shops?: Maybe<Array<Maybe<BrandItemShopInfo>>>;
  /** The size of the item in a given language */
  size?: Maybe<Scalars['String']>;
  /** Localized size of the item */
  sizeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The date this item was sold */
  soldTs?: Maybe<Scalars['Date']>;
  /** The sortorder of this branditem */
  sortorder?: Maybe<Scalars['Float']>;
  /** The source type for this item */
  sourceType?: Maybe<ItemSourceType>;
  /** Aggregated state for this item, collected from multiple data sources */
  stateAggregation?: Maybe<BrandItemAggregatedStateEnum>;
  /** Statistics for this branditem */
  statistics?: Maybe<BrandItemStatistics>;
  stockLocation?: Maybe<Scalars['String']>;
  /** The barcode of the bag that the item is placed in at the stock location */
  stockLocationBag?: Maybe<Scalars['String']>;
  stockLocationTs?: Maybe<Scalars['Date']>;
  /** Returns a list of tags for this stockitem, use itemTags to see where the tag originated from */
  tags?: Maybe<Array<Scalars['String']>>;
  /** True if this item is a test item */
  test?: Maybe<Scalars['Boolean']>;
  /** Returns the tradein item that this branditem was made from */
  tradeInItem?: Maybe<TradeInItem>;
  /** Link to the tradein item, if applicable */
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  /** The product type of this brand item */
  typeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** This item is registered out of warehouse by the logisticspartner at the given date */
  unavailable?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Returns the VAS for this item */
  vas?: Maybe<Array<Maybe<BrandItemVas>>>;
  vasId?: Maybe<Scalars['String']>;
  /** Image references received from VAS for this item */
  vasImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The current logistics state based on VAS entries */
  vasState?: Maybe<BrandItemLogisticsStateEnum>;
  /** The VAS contract version for this item */
  vasType?: Maybe<BrandItemVasTypeEnum>;
  /** The vendor type of this brand item */
  vendor?: Maybe<Scalars['String']>;
  /** Total page views for this item across all shops */
  views?: Maybe<Scalars['Float']>;
  /** Total unique visitors for this item across all shops */
  visitors?: Maybe<Scalars['Float']>;
};


export type BrandItemResolvedImageUrlsArgs = {
  potentialImages?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedItemMetasArgs = {
  excludeAuto?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedItemTagsArgs = {
  includeAuto?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedListPriceArgs = {
  currency: Scalars['String'];
  excludeVAT?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedSalesRankArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type BrandItemResolvedSellingPriceArgs = {
  currency: Scalars['String'];
  excludeVAT?: InputMaybe<Scalars['Boolean']>;
};


export type BrandItemResolvedSizeArgs = {
  language: Scalars['String'];
};


export type BrandItemResolvedStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type BrandItemReviewInfo = {
  __typename?: 'BrandItemReviewInfo';
  type: Scalars['String'];
  value: Scalars['String'];
};

export type BrandItemReviewInfoInput = {
  type: Scalars['String'];
  value: Scalars['String'];
};

export type BrandItemSaleInterval = {
  __typename?: 'BrandItemSaleInterval';
  /** The end date of the interval */
  end?: Maybe<Scalars['Date']>;
  /** The start date of the interval */
  start: Scalars['Date'];
};

export type BrandItemShopInfo = {
  __typename?: 'BrandItemShopInfo';
  _id: Scalars['MongoID'];
  /** Whether this item should be active in the shop */
  active: Scalars['Boolean'];
  /** The branditem */
  brandItemId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  problems?: Maybe<Array<Scalars['String']>>;
  shop?: Maybe<Shop>;
  /** The shop */
  shopId: Scalars['MongoID'];
  stockItem?: Maybe<StockItemResolved>;
  stockItemId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export enum BrandItemStateEnum {
  Draft = 'DRAFT',
  None = 'NONE',
  Ready = 'READY',
  Review = 'REVIEW'
}

export type BrandItemStatistics = {
  __typename?: 'BrandItemStatistics';
  /** The total number of days the item has been for sale at the given date */
  saleDaysTotal?: Maybe<Scalars['Int']>;
  /** Intervals for this branditem */
  salePeriods?: Maybe<Array<Maybe<BrandItemSaleInterval>>>;
};

export type BrandItemTag = {
  __typename?: 'BrandItemTag';
  auto?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
};

export type BrandItemTagInput = {
  auto?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type BrandItemVas = {
  __typename?: 'BrandItemVas';
  /** If the vas is completed */
  completed: Scalars['Boolean'];
  /** The user that completed the vas */
  completedBy?: Maybe<Scalars['String']>;
  /** The date the vas was completed */
  completedDate?: Maybe<Scalars['Date']>;
  /** The sorting order of the vas */
  sortingOrder?: Maybe<Scalars['Float']>;
  /** The date the vas was started */
  startDate?: Maybe<Scalars['Date']>;
  /** The id of the vas */
  vasId: Scalars['String'];
  /** The name of the vas */
  vasName: Scalars['String'];
  /** The name of the workflow */
  workflowName?: Maybe<Scalars['String']>;
  /** The timestamp of the workflow */
  workflowTs?: Maybe<Scalars['Date']>;
};

export type BrandItemVasInput = {
  /** If the vas is completed */
  completed: Scalars['Boolean'];
  /** The user that completed the vas */
  completedBy?: InputMaybe<Scalars['String']>;
  /** The date the vas was completed */
  completedDate?: InputMaybe<Scalars['Date']>;
  /** The sorting order of the vas */
  sortingOrder?: InputMaybe<Scalars['Float']>;
  /** The date the vas was started */
  startDate?: InputMaybe<Scalars['Date']>;
  /** The id of the vas */
  vasId: Scalars['String'];
  /** The name of the vas */
  vasName: Scalars['String'];
  /** The name of the workflow */
  workflowName?: InputMaybe<Scalars['String']>;
  /** The timestamp of the workflow */
  workflowTs?: InputMaybe<Scalars['Date']>;
};

export enum BrandItemVasTypeEnum {
  Vas1_0 = 'VAS1_0',
  Vas2_0 = 'VAS2_0'
}

export type BrandLocale = {
  __typename?: 'BrandLocale';
  /** Whether the locale is for stockitems */
  activeItems?: Maybe<Scalars['Boolean']>;
  /** Whether the locale is active for tradein app */
  activeTradeIn?: Maybe<Scalars['Boolean']>;
  /** The iso alpha 2 locale code */
  locale: Scalars['String'];
};

export type BrandLocaleInput = {
  /** Whether the locale is for stockitems */
  activeItems?: InputMaybe<Scalars['Boolean']>;
  /** Whether the locale is active for tradein app */
  activeTradeIn?: InputMaybe<Scalars['Boolean']>;
  /** The iso alpha 2 locale code */
  locale: Scalars['String'];
};

export type BrandProduct = {
  __typename?: 'BrandProduct';
  _id: Scalars['MongoID'];
  /** The brand that owns this product */
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** Collections associated with this product */
  collections?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Custom data for the product */
  customData?: Maybe<Scalars['JSON']>;
  /** True if this variant has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The product description */
  description?: Maybe<Scalars['String']>;
  /** The product description localized */
  descriptionLocalized: Array<Maybe<LocalizationEntry>>;
  /** Whether to disable the RRP list price */
  disableRRPListPrice?: Maybe<Scalars['Boolean']>;
  /** Whether this product is disabled and shouldn't be used in the platform at all */
  disabled?: Maybe<Scalars['Boolean']>;
  /** A product unique external identifier */
  externalId: Scalars['String'];
  /** The group that this product belongs to */
  groupId: Scalars['MongoID'];
  /** Returns a list of image urls for this product */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Extra data about the product, localized */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Extra data about the product */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** The same of the product */
  name?: Maybe<Scalars['String']>;
  /** The name of the product localized */
  nameLocalized: Array<Maybe<LocalizationEntry>>;
  /** Whether this product is a preowned product */
  preOwned?: Maybe<Scalars['Boolean']>;
  /** Source of the brandproduct, such as imported, shopify, salesforce etc */
  source?: Maybe<Scalars['String']>;
  /** The style number should optimally be a joining identifier for a number of variants. Internally this number is not used for this purpose though */
  style?: Maybe<Scalars['String']>;
  /** Tags associated with this product */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The type of product */
  type?: Maybe<Scalars['String']>;
  /** The product type, a translateable field */
  typeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** The latest user that updated this */
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Returns a list of product variants for this product */
  variants?: Maybe<Array<Maybe<BrandProductVariant>>>;
  /** The vendor of this product */
  vendor?: Maybe<Scalars['String']>;
  /** The weight of this item in grams */
  weight?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type BrandProductBrandProductsPagination = {
  __typename?: 'BrandProductBrandProductsPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<BrandProduct>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BrandProductGroup = {
  __typename?: 'BrandProductGroup';
  _id: Scalars['MongoID'];
  /** Is the group active for everything */
  active: Scalars['Boolean'];
  /** Is the group active for potential linking */
  activePotentials?: Maybe<Scalars['Boolean']>;
  /** Is the group active for promoting brand items */
  activePromotions?: Maybe<Scalars['Boolean']>;
  brandHouseId: Scalars['MongoID'];
  /** The name of the group */
  name: Scalars['String'];
};

export type BrandProductImage = {
  __typename?: 'BrandProductImage';
  _id: Scalars['MongoID'];
  archivedImage?: Maybe<Scalars['Boolean']>;
  archivedThumb?: Maybe<Scalars['Boolean']>;
  brandHouseId: Scalars['MongoID'];
  /** The product that owns this image */
  brandProductId?: Maybe<Scalars['MongoID']>;
  /** The variant that owns this image */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  /** Colors represented by this image */
  colors?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Custom data for the image */
  customData?: Maybe<Scalars['JSON']>;
  deleted?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  errorCount?: Maybe<Scalars['Float']>;
  /** An image unique external identifier */
  externalId: Scalars['String'];
  /** The group that this product belongs to */
  groupId: Scalars['MongoID'];
  imageAltText?: Maybe<Scalars['String']>;
  /** The storage ID of the file, will be null until the image is successfully stored */
  imageId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: Maybe<Scalars['String']>;
  /**
   * If the image was processed by us / background removal, then this contains the version of the processing
   * use this to determine if the background process needs to be redone
   */
  imageRemoveBgVersion?: Maybe<Scalars['Float']>;
  /** Returns an url to the variant image */
  imageUrl?: Maybe<Scalars['String']>;
  /** An optional language tag for the image */
  language?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  /** Extra data about the image, localized */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Extra data about the image */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** The storage ID of the original image file, typically the same as imageId - but if the imageId can be modified */
  originalId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the original image, used to compare images */
  originalMd5?: Maybe<Scalars['String']>;
  perspective?: Maybe<EnumBrandProductImagePerspective>;
  sortOrder?: Maybe<Scalars['Float']>;
  sourceUrl?: Maybe<Scalars['String']>;
  /** The storage ID of the thumbnail file, will be null until the image is successfully stored */
  thumbnailId?: Maybe<Scalars['MongoID']>;
  type?: Maybe<EnumBrandProductImageType>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BrandProductImageSynchronizeInput = {
  /** Custom data for the image */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Brandhouse unique identifier for the variant */
  externalId: Scalars['String'];
  /** Optionally an image alt text for use on web */
  imageAltText?: InputMaybe<Scalars['String']>;
  /** Additional data for image */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
  /** The perspective of the image */
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  /** Images will be sorted ascending by this number, if present */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** The external URL of this image */
  sourceUrl: Scalars['String'];
  /** The type of image */
  type?: InputMaybe<ImageTypeEnum>;
};

export type BrandProductSize = {
  __typename?: 'BrandProductSize';
  _id: Scalars['MongoID'];
  /** The brand that owns this variant */
  brandHouseId: Scalars['MongoID'];
  brandProductId: Scalars['MongoID'];
  /** The variant that owns this size */
  brandProductVariantId: Scalars['MongoID'];
  /** Returns the variant that owns this size */
  brandVariant?: Maybe<BrandProductVariant>;
  createdAt?: Maybe<Scalars['Date']>;
  /** True if this product has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: Maybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId: Scalars['String'];
  /** Returns whether the size is in an active group */
  group?: Maybe<BrandProductGroup>;
  /** The group that this product belongs to */
  groupId: Scalars['MongoID'];
  /** Extra data about the size, localized */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Extra data about the variant */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** The size of this variant */
  size?: Maybe<Scalars['String']>;
  /** The size of this variant translated into the supported languages */
  sizeLocalized: Array<Maybe<LocalizationEntry>>;
  /** The SKU of this variant */
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BrandProductSizeSynchronizeInput = {
  /** Set to true in order to delete this variant */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** EAN for the product */
  ean?: InputMaybe<Scalars['String']>;
  /** Brandhouse unique identifier for the variant */
  externalId: Scalars['String'];
  /** Additional data for variant */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
  /** The size of the variant */
  size?: InputMaybe<Scalars['String']>;
  /** The size localized */
  sizeLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** SKU for the product */
  sku?: InputMaybe<Scalars['String']>;
};

export type BrandProductSynchronizeInput = {
  /** A list of collections that this product has been part of */
  collections?: InputMaybe<Array<Scalars['String']>>;
  /** Custom data for the product */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Set to true in order to delete this product */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The description of the product */
  description?: InputMaybe<Scalars['String']>;
  /** The description of the product localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Set to true in order to disable RRP list price */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** Set to true in order to disable this product */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** Brandhouse unique identifier for the product */
  externalId: Scalars['String'];
  /** Optionally the group id of the product, if no group is provided the default active group will be used */
  groupId?: InputMaybe<Scalars['MongoID']>;
  /** Localized metafields for product */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<LocalizedMetaFieldInstanceInput>>>;
  /** Additional data for product */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
  /** The name of the product */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the product localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Whether this is a preowned style */
  preOwned?: InputMaybe<Scalars['Boolean']>;
  /** Style number for the product */
  style?: InputMaybe<Scalars['String']>;
  /** A list of tags for the product */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** The type of product */
  type?: InputMaybe<Scalars['String']>;
  /** The type of the product localized */
  typeLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Variants for this product */
  variants?: InputMaybe<Array<InputMaybe<BrandProductVariantSynchronizeInput>>>;
  /** The vendor of this product */
  vendor?: InputMaybe<Scalars['String']>;
};

export type BrandProductVariant = {
  __typename?: 'BrandProductVariant';
  _id: Scalars['MongoID'];
  /** The brand that owns this variant */
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** Returns the brandProduct that owns this variant */
  brandProduct?: Maybe<BrandProduct>;
  brandProductId: Scalars['MongoID'];
  /** The color of this variant */
  color?: Maybe<Scalars['String']>;
  /** The color of this variant translated into the supported languages */
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Custom data for the product */
  customData?: Maybe<Scalars['JSON']>;
  /** True if this variant should not be used in the platform */
  deactivated?: Maybe<Scalars['Boolean']>;
  /** True if this product has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: Maybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId: Scalars['String'];
  /** The group that this product belongs to */
  groupId: Scalars['MongoID'];
  /** 712-dimensional embedding vector for the variant's packshot image */
  imageEmbedding?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Returns a list of image urls for this variant */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns a list of images for this variant */
  images?: Maybe<Array<Maybe<BrandProductImage>>>;
  /** Extra data about the variant, localized */
  localizedMetaFields?: Maybe<Array<Maybe<LocalizedMetaFieldInstance>>>;
  /** Extra data about the variant */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  /** The RRP prices for this variant */
  rrp?: Maybe<Array<Maybe<Pricing>>>;
  /** The size of this variant translated into the supported languages - DEPRECATED */
  sizeLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Returns a list of sizes for this variant */
  sizes?: Maybe<Array<Maybe<BrandProductSize>>>;
  /** The SKU of this variant */
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** The weight of this variant in grams */
  weight?: Maybe<Scalars['Float']>;
};

export type BrandProductVariantSynchronizeInput = {
  /** The color of the variant */
  color?: InputMaybe<Scalars['String']>;
  /** The color of the variant localized */
  colorLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The tariff commodity code */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The country of origin for this variant */
  countryOrigin?: InputMaybe<Scalars['String']>;
  /** Custom data for the variant */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Set to true in order to deactivate this variant */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  /** Set to true in order to delete this variant */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** EAN for the product */
  ean?: InputMaybe<Scalars['String']>;
  /** Brandhouse unique identifier for the variant */
  externalId: Scalars['String'];
  /** Images for this variant */
  images?: InputMaybe<Array<InputMaybe<BrandProductImageSynchronizeInput>>>;
  /** Additional data for variant */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
  /** Price of the variant in multiple currencies */
  rrp?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** Sizes for this variant */
  sizes?: InputMaybe<Array<InputMaybe<BrandProductSizeSynchronizeInput>>>;
  /** SKU for the product */
  sku?: InputMaybe<Scalars['String']>;
  /** The weight of the variant in kg */
  weight?: InputMaybe<Scalars['Float']>;
};

export type BrandRule = {
  __typename?: 'BrandRule';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  /** The brand */
  brand?: Maybe<Shop>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The percentage of the digital passport value, relative to the voucher value */
  digitalPassportPct?: Maybe<Scalars['Float']>;
  digitalPassportValue?: Maybe<EnumBrandRuleDigitalPassportValue>;
  expressions?: Maybe<Array<Maybe<BrandRuleTradeInSearchAmountsExpressions>>>;
  invalid?: Maybe<Scalars['Boolean']>;
  locked?: Maybe<Scalars['Boolean']>;
  marketingActive?: Maybe<Scalars['Boolean']>;
  marketingConsentRequired?: Maybe<Scalars['Boolean']>;
  marketingDelay?: Maybe<Scalars['Float']>;
  maximumAge?: Maybe<Scalars['Float']>;
  minimumAge?: Maybe<Scalars['Float']>;
  minimumPrice?: Maybe<Scalars['Float']>;
  /** The minimum price, relative to RRP or SP */
  minimumPriceType?: Maybe<EnumBrandRuleMinimumPriceType>;
  periodFrom?: Maybe<Scalars['Date']>;
  periodTo?: Maybe<Scalars['Date']>;
  priority?: Maybe<Scalars['Float']>;
  products?: Maybe<BrandRuleProducts>;
  secondhandTradeInPct: Scalars['Float'];
  secondhandVoucherValue: EnumBrandRuleSecondhandVoucherValue;
  shopId: Scalars['MongoID'];
  /** Statistics about the brandrule */
  statistics?: Maybe<BrandRuleStatistics>;
  tradeInPricePct: Scalars['Float'];
  tradeInSearchAmounts?: Maybe<Array<Maybe<BrandRuleTradeInSearchAmounts>>>;
  /** The percentage of the trade-in value that can be used when searching for a tradein product */
  tradeInSearchPct?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** The version number of this brandrule, will be incremented by one each time its changed/saved */
  version?: Maybe<Scalars['Float']>;
  voucherAmounts?: Maybe<Array<Maybe<BrandRuleTradeInSearchAmounts>>>;
  voucherStrategy: EnumBrandRuleVoucherStrategy;
  voucherValue: EnumBrandRuleVoucherValue;
};

export type BrandRuleInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The percentage of the digital passport value, relative to the voucher value */
  digitalPassportPct?: InputMaybe<Scalars['Float']>;
  digitalPassportValue?: InputMaybe<EnumBrandRuleDigitalPassportValue>;
  expressions?: InputMaybe<Array<InputMaybe<BrandRuleTradeInSearchAmountsExpressionsInput>>>;
  invalid?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  marketingActive?: InputMaybe<Scalars['Boolean']>;
  marketingConsentRequired?: InputMaybe<Scalars['Boolean']>;
  marketingDelay?: InputMaybe<Scalars['Float']>;
  maximumAge?: InputMaybe<Scalars['Float']>;
  minimumAge?: InputMaybe<Scalars['Float']>;
  minimumPrice?: InputMaybe<Scalars['Float']>;
  /** The minimum price, relative to RRP or SP */
  minimumPriceType?: InputMaybe<EnumBrandRuleMinimumPriceType>;
  periodFrom?: InputMaybe<Scalars['Date']>;
  periodTo?: InputMaybe<Scalars['Date']>;
  priority?: InputMaybe<Scalars['Float']>;
  products?: InputMaybe<BrandRuleProductsInput>;
  secondhandTradeInPct: Scalars['Float'];
  secondhandVoucherValue: EnumBrandRuleSecondhandVoucherValue;
  shopId: Scalars['MongoID'];
  /** Statistics about the brandrule */
  statistics?: InputMaybe<BrandRuleStatisticsInput>;
  tradeInPricePct: Scalars['Float'];
  tradeInSearchAmounts?: InputMaybe<Array<InputMaybe<BrandRuleTradeInSearchAmountsInput>>>;
  /** The percentage of the trade-in value that can be used when searching for a tradein product */
  tradeInSearchPct?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** The version number of this brandrule, will be incremented by one each time its changed/saved */
  version?: InputMaybe<Scalars['Float']>;
  voucherAmounts?: InputMaybe<Array<InputMaybe<BrandRuleTradeInSearchAmountsInput>>>;
  voucherStrategy: EnumBrandRuleVoucherStrategy;
  voucherValue: EnumBrandRuleVoucherValue;
};

export type BrandRuleProducts = {
  __typename?: 'BrandRuleProducts';
  collections?: Maybe<Array<Maybe<Scalars['String']>>>;
  ids?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BrandRuleProductsInput = {
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BrandRuleStatistics = {
  __typename?: 'BrandRuleStatistics';
  /** Number of consumers matching the rule */
  consumers: Scalars['Float'];
  /** Number of consumers for all rules */
  consumersTotal: Scalars['Float'];
  /** Number of items matching the rule */
  items: Scalars['Float'];
  /** Number of items matching any rule */
  itemsTotal: Scalars['Float'];
  /** Number of consumers that will receive an e-mail on future distributions */
  sendingFuture: Scalars['Float'];
  /** Number of consumers that will receive an e-mail on next distribution */
  sendingNow: Scalars['Float'];
  /** When this statistics was last updated */
  ts?: Maybe<Scalars['Date']>;
  /** Total value of vouchers */
  voucherSum: Scalars['Float'];
  /** Total value of vouchers across brandrules */
  voucherTotal: Scalars['Float'];
};

export type BrandRuleStatisticsInput = {
  /** Number of consumers matching the rule */
  consumers: Scalars['Float'];
  /** Number of consumers for all rules */
  consumersTotal: Scalars['Float'];
  /** Number of items matching the rule */
  items: Scalars['Float'];
  /** Number of items matching any rule */
  itemsTotal: Scalars['Float'];
  /** Number of consumers that will receive an e-mail on future distributions */
  sendingFuture: Scalars['Float'];
  /** Number of consumers that will receive an e-mail on next distribution */
  sendingNow: Scalars['Float'];
  /** When this statistics was last updated */
  ts?: InputMaybe<Scalars['Date']>;
  /** Total value of vouchers */
  voucherSum: Scalars['Float'];
  /** Total value of vouchers across brandrules */
  voucherTotal: Scalars['Float'];
};

export type BrandRuleTradeInSearchAmounts = {
  __typename?: 'BrandRuleTradeInSearchAmounts';
  _id?: Maybe<Scalars['MongoID']>;
  active: Scalars['Boolean'];
  expressions?: Maybe<Array<Maybe<BrandRuleTradeInSearchAmountsExpressions>>>;
  tag?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type BrandRuleTradeInSearchAmountsExpressions = {
  __typename?: 'BrandRuleTradeInSearchAmountsExpressions';
  /** Optionally a key for the valuetype */
  key?: Maybe<Scalars['String']>;
  operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
  valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType;
};

export type BrandRuleTradeInSearchAmountsExpressionsInput = {
  /** Optionally a key for the valuetype */
  key?: InputMaybe<Scalars['String']>;
  operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueType: EnumBrandRuleTradeInSearchAmountsExpressionsValueType;
};

export type BrandRuleTradeInSearchAmountsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active: Scalars['Boolean'];
  expressions?: InputMaybe<Array<InputMaybe<BrandRuleTradeInSearchAmountsExpressionsInput>>>;
  tag?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type BrandSetting = {
  __typename?: 'BrandSetting';
  _id?: Maybe<Scalars['MongoID']>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  circular?: Maybe<CircularSettings>;
  consumer?: Maybe<BrandSettingConsumer>;
  contactPerson?: Maybe<Scalars['String']>;
  contactPersonEmail?: Maybe<Scalars['String']>;
  countries?: Maybe<BrandSettingCountries>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The default tariff code for use in customs declarations. */
  defaultCommodityCode?: Maybe<Scalars['String']>;
  /** The default ISO 3166-1 alpha-2 country code of origin for stockitems. */
  defaultCountryOfOrigin?: Maybe<Scalars['String']>;
  /** If a product has an unknown EAN, then this will be used instead */
  defaultProductEAN?: Maybe<Scalars['String']>;
  /** If a product is missing an image, this will be shown instead. Fully qualified URL, e.g. https://domain.xx/imagepath */
  defaultProductImage?: Maybe<Scalars['String']>;
  /** Whether the digital passport feature is active for this brand/shop */
  digitalPassportActive?: Maybe<Scalars['Boolean']>;
  /** If true, then the RRP will not be used as list price */
  disableRRPListPrice?: Maybe<Scalars['Boolean']>;
  /** Locale used as a silent fallback when localized fields are missing entries for an active locale. Defaults to 'en' when not set. */
  fallbackLocale?: Maybe<Scalars['String']>;
  klaviyoConfig?: Maybe<BrandSettingKlaviyoConfig>;
  /** Whether the old legacy integration to shopify is disabled, only valid for shops */
  legacyIntegrationDisabled?: Maybe<Scalars['Boolean']>;
  legacyIntegrationDisabledMessages?: Maybe<Array<Maybe<EnumBrandSettingLegacyIntegrationDisabledMessages>>>;
  /** The locales / languages that texts are translated into */
  locales?: Maybe<Array<Maybe<BrandLocale>>>;
  marketingConsentDisabled?: Maybe<Scalars['Boolean']>;
  masterDataConsolidate?: Maybe<BrandSettingMasterDataConsolidate>;
  /** This is the language that we receive master data (products, variants etc) in. Should not be changed */
  masterDataLocale?: Maybe<Scalars['String']>;
  /** If true, then master data will be image processed */
  masterDataRemoveBg?: Maybe<Scalars['Boolean']>;
  /** The version number */
  masterDataRemoveBgVersion?: Maybe<Scalars['Float']>;
  /** Include product images */
  masterDataUseProductImages?: Maybe<Scalars['Boolean']>;
  /** Settings for orders */
  order?: Maybe<BrandSettingOrder>;
  plannedMailsTradeIn?: Maybe<BrandSettingPlannedMailsTradeIn>;
  plannedMailsVoucher?: Maybe<BrandSettingPlannedMailsVoucher>;
  /** List of all tags used in advanced pricing rules, can be a 0-length array */
  pricingTags?: Maybe<Array<Scalars['String']>>;
  /** List of all counties activated */
  selectedCountries?: Maybe<Array<Scalars['String']>>;
  sellPrice?: Maybe<Array<Maybe<BrandSettingSellPrice>>>;
  sellPriceAdvanced?: Maybe<Array<Maybe<BrandSettingSellPriceAdvanced>>>;
  /** The currency of the shop, not available for brandHouse */
  shopCurrency?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['MongoID']>;
  shopIdentifier?: Maybe<Scalars['String']>;
  stockItemConfig?: Maybe<BrandSettingStockItemConfig>;
  thumbnails?: Maybe<BrandSettingThumbnails>;
  tracking?: Maybe<Scalars['Boolean']>;
  tradeIn2?: Maybe<TradeInLayout>;
  tradeIn2Active?: Maybe<Scalars['Boolean']>;
  tradeIn2Analytics?: Maybe<BrandSettingTradeIn2Analytics>;
  /** If provided, the tradein-app can decide to validate that the email does not match this filter */
  tradeIn2InvalidEmailExp?: Maybe<Scalars['String']>;
  /** If true, then the trade-in app will allow comments from the previous owner */
  tradeInComments?: Maybe<Scalars['Boolean']>;
  /** If true, then the language selector will be hidden on the consumerform page */
  tradeInHideLanguageSelector?: Maybe<Scalars['Boolean']>;
  /** Whether the trade-in app should allow login when consumer has no potentials */
  tradeInLoginWithoutData?: Maybe<Scalars['Boolean']>;
  /** Whether the trade-in app should allow payout method to be selected by customer */
  tradeInPayoutEnabled?: Maybe<Scalars['Boolean']>;
  /** The percentage of the trade-in value that can be paid out (1-100%) */
  tradeInPayoutPct?: Maybe<Scalars['Float']>;
  /** Whether the trade-in app should use points instead of currency */
  tradeInPointsEnabled?: Maybe<Scalars['Boolean']>;
  /** The rate of points to currency, default is 1 */
  tradeInPointsRate?: Maybe<Scalars['Float']>;
  /** Whether the search based trade-in process is enabled */
  tradeInProductSearch?: Maybe<Scalars['Boolean']>;
  /** If provided, the product search feature will only search within this group */
  tradeInProductSearchGroupId?: Maybe<Scalars['MongoID']>;
  /** If true, only products with images will be included in the trade-in search results */
  tradeInProductSearchImagesOnly?: Maybe<Scalars['Boolean']>;
  /** If provided, the product search feature will create a masked input field */
  tradeInProductSearchMask?: Maybe<Scalars['String']>;
  /** Whether the tradein app should utilize hashes or browser address for state - default is browser */
  tradeInRouter?: Maybe<EnumBrandSettingTradeInRouter>;
  /** Whether the reward system should deduct the voucher value when a tradein item is rejected */
  tradeInVoucherDeduction?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** If enabled, only stock items on brand level is allowed */
  useBrandItems?: Maybe<Scalars['Boolean']>;
  /** Whether the brand/shop is using the return portal */
  usingReturnPortal?: Maybe<Scalars['Boolean']>;
  voucher?: Maybe<BrandSettingVoucher>;
};

export type BrandSettingConsumer = {
  __typename?: 'BrandSettingConsumer';
  authMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  lockEmail?: Maybe<Scalars['Boolean']>;
};

export type BrandSettingConsumerInput = {
  authMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lockEmail?: InputMaybe<Scalars['Boolean']>;
};

export type BrandSettingCountries = {
  __typename?: 'BrandSettingCountries';
  AT?: Maybe<BrandSettingCountriesAt>;
  BE?: Maybe<BrandSettingCountriesBe>;
  BG?: Maybe<BrandSettingCountriesBg>;
  CY?: Maybe<BrandSettingCountriesCy>;
  CZ?: Maybe<BrandSettingCountriesCz>;
  DE?: Maybe<BrandSettingCountriesDe>;
  DK?: Maybe<BrandSettingCountriesDk>;
  EE?: Maybe<BrandSettingCountriesEe>;
  ES?: Maybe<BrandSettingCountriesEs>;
  FI?: Maybe<BrandSettingCountriesFi>;
  FR?: Maybe<BrandSettingCountriesFr>;
  GB?: Maybe<BrandSettingCountriesGb>;
  GR?: Maybe<BrandSettingCountriesGr>;
  HR?: Maybe<BrandSettingCountriesHr>;
  HU?: Maybe<BrandSettingCountriesHu>;
  IE?: Maybe<BrandSettingCountriesIe>;
  IT?: Maybe<BrandSettingCountriesIt>;
  LT?: Maybe<BrandSettingCountriesLt>;
  LU?: Maybe<BrandSettingCountriesLu>;
  LV?: Maybe<BrandSettingCountriesLv>;
  MT?: Maybe<BrandSettingCountriesMt>;
  NL?: Maybe<BrandSettingCountriesNl>;
  NO?: Maybe<BrandSettingCountriesNo>;
  PL?: Maybe<BrandSettingCountriesPl>;
  PT?: Maybe<BrandSettingCountriesPt>;
  RO?: Maybe<BrandSettingCountriesRo>;
  SE?: Maybe<BrandSettingCountriesSe>;
  SI?: Maybe<BrandSettingCountriesSi>;
  SK?: Maybe<BrandSettingCountriesSk>;
  SL?: Maybe<BrandSettingCountriesSl>;
};

export type BrandSettingCountriesAt = {
  __typename?: 'BrandSettingCountriesAT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesAtInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesBe = {
  __typename?: 'BrandSettingCountriesBE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesBeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesBg = {
  __typename?: 'BrandSettingCountriesBG';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesBgInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesCy = {
  __typename?: 'BrandSettingCountriesCY';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesCyInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesCz = {
  __typename?: 'BrandSettingCountriesCZ';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesCzInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesDe = {
  __typename?: 'BrandSettingCountriesDE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesDeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesDk = {
  __typename?: 'BrandSettingCountriesDK';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesDkInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesEe = {
  __typename?: 'BrandSettingCountriesEE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesEeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesEs = {
  __typename?: 'BrandSettingCountriesES';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesEsInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesFi = {
  __typename?: 'BrandSettingCountriesFI';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesFiInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesFr = {
  __typename?: 'BrandSettingCountriesFR';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesFrInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesGb = {
  __typename?: 'BrandSettingCountriesGB';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesGbInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesGr = {
  __typename?: 'BrandSettingCountriesGR';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesGrInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesHr = {
  __typename?: 'BrandSettingCountriesHR';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesHrInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesHu = {
  __typename?: 'BrandSettingCountriesHU';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesHuInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesIe = {
  __typename?: 'BrandSettingCountriesIE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesIeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesIt = {
  __typename?: 'BrandSettingCountriesIT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesItInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesInput = {
  AT?: InputMaybe<BrandSettingCountriesAtInput>;
  BE?: InputMaybe<BrandSettingCountriesBeInput>;
  BG?: InputMaybe<BrandSettingCountriesBgInput>;
  CY?: InputMaybe<BrandSettingCountriesCyInput>;
  CZ?: InputMaybe<BrandSettingCountriesCzInput>;
  DE?: InputMaybe<BrandSettingCountriesDeInput>;
  DK?: InputMaybe<BrandSettingCountriesDkInput>;
  EE?: InputMaybe<BrandSettingCountriesEeInput>;
  ES?: InputMaybe<BrandSettingCountriesEsInput>;
  FI?: InputMaybe<BrandSettingCountriesFiInput>;
  FR?: InputMaybe<BrandSettingCountriesFrInput>;
  GB?: InputMaybe<BrandSettingCountriesGbInput>;
  GR?: InputMaybe<BrandSettingCountriesGrInput>;
  HR?: InputMaybe<BrandSettingCountriesHrInput>;
  HU?: InputMaybe<BrandSettingCountriesHuInput>;
  IE?: InputMaybe<BrandSettingCountriesIeInput>;
  IT?: InputMaybe<BrandSettingCountriesItInput>;
  LT?: InputMaybe<BrandSettingCountriesLtInput>;
  LU?: InputMaybe<BrandSettingCountriesLuInput>;
  LV?: InputMaybe<BrandSettingCountriesLvInput>;
  MT?: InputMaybe<BrandSettingCountriesMtInput>;
  NL?: InputMaybe<BrandSettingCountriesNlInput>;
  NO?: InputMaybe<BrandSettingCountriesNoInput>;
  PL?: InputMaybe<BrandSettingCountriesPlInput>;
  PT?: InputMaybe<BrandSettingCountriesPtInput>;
  RO?: InputMaybe<BrandSettingCountriesRoInput>;
  SE?: InputMaybe<BrandSettingCountriesSeInput>;
  SI?: InputMaybe<BrandSettingCountriesSiInput>;
  SK?: InputMaybe<BrandSettingCountriesSkInput>;
  SL?: InputMaybe<BrandSettingCountriesSlInput>;
};

export type BrandSettingCountriesLt = {
  __typename?: 'BrandSettingCountriesLT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesLtInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesLu = {
  __typename?: 'BrandSettingCountriesLU';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesLuInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesLv = {
  __typename?: 'BrandSettingCountriesLV';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesLvInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesMt = {
  __typename?: 'BrandSettingCountriesMT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesMtInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesNl = {
  __typename?: 'BrandSettingCountriesNL';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesNlInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesNo = {
  __typename?: 'BrandSettingCountriesNO';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesNoInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesPl = {
  __typename?: 'BrandSettingCountriesPL';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesPlInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesPt = {
  __typename?: 'BrandSettingCountriesPT';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesPtInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesRo = {
  __typename?: 'BrandSettingCountriesRO';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesRoInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesSe = {
  __typename?: 'BrandSettingCountriesSE';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesSeInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesSi = {
  __typename?: 'BrandSettingCountriesSI';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesSiInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesSk = {
  __typename?: 'BrandSettingCountriesSK';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesSkInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingCountriesSl = {
  __typename?: 'BrandSettingCountriesSL';
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BrandSettingCountriesSlInput = {
  currency?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  vat?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  circular?: InputMaybe<CircularSettingsInput>;
  consumer?: InputMaybe<BrandSettingConsumerInput>;
  contactPerson?: InputMaybe<Scalars['String']>;
  contactPersonEmail?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<BrandSettingCountriesInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The default tariff code for use in customs declarations. */
  defaultCommodityCode?: InputMaybe<Scalars['String']>;
  /** The default ISO 3166-1 alpha-2 country code of origin for stockitems. */
  defaultCountryOfOrigin?: InputMaybe<Scalars['String']>;
  /** If a product has an unknown EAN, then this will be used instead */
  defaultProductEAN?: InputMaybe<Scalars['String']>;
  /** If a product is missing an image, this will be shown instead. Fully qualified URL, e.g. https://domain.xx/imagepath */
  defaultProductImage?: InputMaybe<Scalars['String']>;
  /** Whether the digital passport feature is active for this brand/shop */
  digitalPassportActive?: InputMaybe<Scalars['Boolean']>;
  /** If true, then the RRP will not be used as list price */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** Locale used as a silent fallback when localized fields are missing entries for an active locale. Defaults to 'en' when not set. */
  fallbackLocale?: InputMaybe<Scalars['String']>;
  klaviyoConfig?: InputMaybe<BrandSettingKlaviyoConfigInput>;
  /** Whether the old legacy integration to shopify is disabled, only valid for shops */
  legacyIntegrationDisabled?: InputMaybe<Scalars['Boolean']>;
  legacyIntegrationDisabledMessages?: InputMaybe<Array<InputMaybe<EnumBrandSettingLegacyIntegrationDisabledMessages>>>;
  /** The locales / languages that texts are translated into */
  locales?: InputMaybe<Array<InputMaybe<BrandLocaleInput>>>;
  marketingConsentDisabled?: InputMaybe<Scalars['Boolean']>;
  masterDataConsolidate?: InputMaybe<BrandSettingMasterDataConsolidateInput>;
  /** This is the language that we receive master data (products, variants etc) in. Should not be changed */
  masterDataLocale?: InputMaybe<Scalars['String']>;
  /** If true, then master data will be image processed */
  masterDataRemoveBg?: InputMaybe<Scalars['Boolean']>;
  /** The version number */
  masterDataRemoveBgVersion?: InputMaybe<Scalars['Float']>;
  /** Include product images */
  masterDataUseProductImages?: InputMaybe<Scalars['Boolean']>;
  /** Settings for orders */
  order?: InputMaybe<BrandSettingOrderInput>;
  plannedMailsTradeIn?: InputMaybe<BrandSettingPlannedMailsTradeInInput>;
  plannedMailsVoucher?: InputMaybe<BrandSettingPlannedMailsVoucherInput>;
  sellPrice?: InputMaybe<Array<InputMaybe<BrandSettingSellPriceInput>>>;
  sellPriceAdvanced?: InputMaybe<Array<InputMaybe<BrandSettingSellPriceAdvancedInput>>>;
  shopIdentifier?: InputMaybe<Scalars['String']>;
  stockItemConfig?: InputMaybe<BrandSettingStockItemConfigInput>;
  thumbnails?: InputMaybe<BrandSettingThumbnailsInput>;
  tracking?: InputMaybe<Scalars['Boolean']>;
  tradeIn2?: InputMaybe<TradeInLayoutInput>;
  tradeIn2Active?: InputMaybe<Scalars['Boolean']>;
  tradeIn2Analytics?: InputMaybe<BrandSettingTradeIn2AnalyticsInput>;
  /** If provided, the tradein-app can decide to validate that the email does not match this filter */
  tradeIn2InvalidEmailExp?: InputMaybe<Scalars['String']>;
  /** If true, then the trade-in app will allow comments from the previous owner */
  tradeInComments?: InputMaybe<Scalars['Boolean']>;
  /** If true, then the language selector will be hidden on the consumerform page */
  tradeInHideLanguageSelector?: InputMaybe<Scalars['Boolean']>;
  /** Whether the trade-in app should allow login when consumer has no potentials */
  tradeInLoginWithoutData?: InputMaybe<Scalars['Boolean']>;
  /** Whether the trade-in app should allow payout method to be selected by customer */
  tradeInPayoutEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The percentage of the trade-in value that can be paid out (1-100%) */
  tradeInPayoutPct?: InputMaybe<Scalars['Float']>;
  /** Whether the trade-in app should use points instead of currency */
  tradeInPointsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The rate of points to currency, default is 1 */
  tradeInPointsRate?: InputMaybe<Scalars['Float']>;
  /** Whether the search based trade-in process is enabled */
  tradeInProductSearch?: InputMaybe<Scalars['Boolean']>;
  /** If provided, the product search feature will only search within this group */
  tradeInProductSearchGroupId?: InputMaybe<Scalars['MongoID']>;
  /** If true, only products with images will be included in the trade-in search results */
  tradeInProductSearchImagesOnly?: InputMaybe<Scalars['Boolean']>;
  /** If provided, the product search feature will create a masked input field */
  tradeInProductSearchMask?: InputMaybe<Scalars['String']>;
  /** Whether the tradein app should utilize hashes or browser address for state - default is browser */
  tradeInRouter?: InputMaybe<EnumBrandSettingTradeInRouter>;
  /** Whether the reward system should deduct the voucher value when a tradein item is rejected */
  tradeInVoucherDeduction?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** If enabled, only stock items on brand level is allowed */
  useBrandItems?: InputMaybe<Scalars['Boolean']>;
  voucher?: InputMaybe<BrandSettingVoucherInput>;
};

export type BrandSettingKlaviyoConfig = {
  __typename?: 'BrandSettingKlaviyoConfig';
  allowNewIdentities?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  exportEvents?: Maybe<Scalars['Boolean']>;
  exportOffers?: Maybe<Scalars['Boolean']>;
  failedTs?: Maybe<Scalars['Date']>;
  privateToken?: Maybe<Scalars['String']>;
  publicToken?: Maybe<Scalars['String']>;
  updatedTs?: Maybe<Scalars['Date']>;
};

export type BrandSettingKlaviyoConfigInput = {
  allowNewIdentities?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  exportEvents?: InputMaybe<Scalars['Boolean']>;
  exportOffers?: InputMaybe<Scalars['Boolean']>;
  failedTs?: InputMaybe<Scalars['Date']>;
  privateToken?: InputMaybe<Scalars['String']>;
  publicToken?: InputMaybe<Scalars['String']>;
  updatedTs?: InputMaybe<Scalars['Date']>;
};

export type BrandSettingMasterDataConsolidate = {
  __typename?: 'BrandSettingMasterDataConsolidate';
  /** Whether we should automatically merge masterdata items */
  autoMerge?: Maybe<Scalars['Boolean']>;
  /** The date from when we should start auto merging */
  autoMergeFromTs?: Maybe<Scalars['Date']>;
  /** The group id that we should use for auto merging */
  autoMergeGroupId?: Maybe<Scalars['MongoID']>;
  /** Some color strategies requires a coloridentifier, see documentation */
  colorIdentifier?: Maybe<Scalars['String']>;
  /** How to identify colors on master data */
  colorStrategy?: Maybe<EnumBrandSettingMasterDataConsolidateColorStrategy>;
  /** Whether we should try to detect languages on masterdata, or use masterDataLocale */
  enableLanguageDetect?: Maybe<Scalars['Boolean']>;
  /** Whether the automatic master data consolidation is running for this brand */
  enabled: Scalars['Boolean'];
  /** The field that we are consolidating on */
  field: EnumBrandSettingMasterDataConsolidateField;
  /** When was the last time we updated, only product updates after this will be included */
  lastUpdate?: Maybe<Scalars['Date']>;
  /** Some color strategies requires a coloridentifier, see documentation */
  secondaryColorIdentifier?: Maybe<Scalars['String']>;
  /** Secondary identify color strategy */
  secondaryColorStrategy?: Maybe<EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy>;
  /** Some color strategies requires a coloridentifier, see documentation */
  tertiaryColorIdentifier?: Maybe<Scalars['String']>;
  /** Tertiary identify color strategy */
  tertiaryColorStrategy?: Maybe<EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy>;
  /** Regular expression to extract variant id from sku */
  variantIdFromSkuRegExp?: Maybe<Scalars['String']>;
};

export type BrandSettingMasterDataConsolidateInput = {
  /** Whether we should automatically merge masterdata items */
  autoMerge?: InputMaybe<Scalars['Boolean']>;
  /** The date from when we should start auto merging */
  autoMergeFromTs?: InputMaybe<Scalars['Date']>;
  /** The group id that we should use for auto merging */
  autoMergeGroupId?: InputMaybe<Scalars['MongoID']>;
  /** Some color strategies requires a coloridentifier, see documentation */
  colorIdentifier?: InputMaybe<Scalars['String']>;
  /** How to identify colors on master data */
  colorStrategy?: InputMaybe<EnumBrandSettingMasterDataConsolidateColorStrategy>;
  /** Whether we should try to detect languages on masterdata, or use masterDataLocale */
  enableLanguageDetect?: InputMaybe<Scalars['Boolean']>;
  /** Whether the automatic master data consolidation is running for this brand */
  enabled: Scalars['Boolean'];
  /** The field that we are consolidating on */
  field: EnumBrandSettingMasterDataConsolidateField;
  /** When was the last time we updated, only product updates after this will be included */
  lastUpdate?: InputMaybe<Scalars['Date']>;
  /** Some color strategies requires a coloridentifier, see documentation */
  secondaryColorIdentifier?: InputMaybe<Scalars['String']>;
  /** Secondary identify color strategy */
  secondaryColorStrategy?: InputMaybe<EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy>;
  /** Some color strategies requires a coloridentifier, see documentation */
  tertiaryColorIdentifier?: InputMaybe<Scalars['String']>;
  /** Tertiary identify color strategy */
  tertiaryColorStrategy?: InputMaybe<EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy>;
  /** Regular expression to extract variant id from sku */
  variantIdFromSkuRegExp?: InputMaybe<Scalars['String']>;
};

export type BrandSettingOrder = {
  __typename?: 'BrandSettingOrder';
  /** Delivery note template configuration */
  deliveryNote?: Maybe<Scalars['JSON']>;
  /** Whether the brand uses an external warehouse for order handling */
  externalWarehouse?: Maybe<Scalars['Boolean']>;
  /** Whether the brand uses an external WMS for order handling */
  externalWms?: Maybe<Scalars['Boolean']>;
  /** Optionally an GB EORI vat number */
  gbEori?: Maybe<Scalars['String']>;
  refundAdjustment?: Maybe<BrandSettingOrderRefundAdjustment>;
  /** Automatic return is not possible after the given number of days, if no returnMaxDays is provided then return is always possible */
  returnMaxDays?: Maybe<Scalars['Float']>;
  /** The VAT rate for the brand, number between 0 and 1 */
  vatRate?: Maybe<Scalars['Float']>;
};

export type BrandSettingOrderInput = {
  /** Delivery note template configuration */
  deliveryNote?: InputMaybe<Scalars['JSON']>;
  /** Whether the brand uses an external warehouse for order handling */
  externalWarehouse?: InputMaybe<Scalars['Boolean']>;
  /** Whether the brand uses an external WMS for order handling */
  externalWms?: InputMaybe<Scalars['Boolean']>;
  /** Optionally an GB EORI vat number */
  gbEori?: InputMaybe<Scalars['String']>;
  refundAdjustment?: InputMaybe<BrandSettingOrderRefundAdjustmentInput>;
  /** Automatic return is not possible after the given number of days, if no returnMaxDays is provided then return is always possible */
  returnMaxDays?: InputMaybe<Scalars['Float']>;
  /** The VAT rate for the brand, number between 0 and 1 */
  vatRate?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingOrderRefundAdjustment = {
  __typename?: 'BrandSettingOrderRefundAdjustment';
  adjust?: Maybe<Array<Maybe<Pricing>>>;
  /** Whether this adjustment is done once per order, or on every refund */
  oncePerOrder: Scalars['Boolean'];
  /** Reason for adjustment */
  reason: Scalars['String'];
};

export type BrandSettingOrderRefundAdjustmentInput = {
  adjust?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** Whether this adjustment is done once per order, or on every refund */
  oncePerOrder: Scalars['Boolean'];
  /** Reason for adjustment */
  reason: Scalars['String'];
};

export type BrandSettingPlannedMailsTradeIn = {
  __typename?: 'BrandSettingPlannedMailsTradeIn';
  /** How many times the remindermail should be sent */
  repeatCount?: Maybe<Scalars['Float']>;
  /** How many days between each remindermail */
  repeatDelay?: Maybe<Scalars['Float']>;
  /** After how many days the remindermail should be sent */
  startAfter?: Maybe<Scalars['Float']>;
};

export type BrandSettingPlannedMailsTradeInInput = {
  /** How many times the remindermail should be sent */
  repeatCount?: InputMaybe<Scalars['Float']>;
  /** How many days between each remindermail */
  repeatDelay?: InputMaybe<Scalars['Float']>;
  /** After how many days the remindermail should be sent */
  startAfter?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingPlannedMailsVoucher = {
  __typename?: 'BrandSettingPlannedMailsVoucher';
  /** How many times the remindermail should be sent */
  repeatCount?: Maybe<Scalars['Float']>;
  /** How many days between each remindermail */
  repeatDelay?: Maybe<Scalars['Float']>;
  /** After how many days the remindermail should be sent */
  startAfter?: Maybe<Scalars['Float']>;
};

export type BrandSettingPlannedMailsVoucherInput = {
  /** How many times the remindermail should be sent */
  repeatCount?: InputMaybe<Scalars['Float']>;
  /** How many days between each remindermail */
  repeatDelay?: InputMaybe<Scalars['Float']>;
  /** After how many days the remindermail should be sent */
  startAfter?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingSellPrice = {
  __typename?: 'BrandSettingSellPrice';
  _id?: Maybe<Scalars['MongoID']>;
  condition?: Maybe<Scalars['Float']>;
  pct?: Maybe<Scalars['Float']>;
};

export type BrandSettingSellPriceAdvanced = {
  __typename?: 'BrandSettingSellPriceAdvanced';
  sellPrice?: Maybe<Array<Maybe<BrandSettingSellPriceAdvancedSellPrice>>>;
  type?: Maybe<EnumBrandSettingSellPriceAdvancedType>;
  /** If provided, this tag produces a special set of selling prices */
  value: Scalars['String'];
};

export type BrandSettingSellPriceAdvancedInput = {
  sellPrice?: InputMaybe<Array<InputMaybe<BrandSettingSellPriceAdvancedSellPriceInput>>>;
  type?: InputMaybe<EnumBrandSettingSellPriceAdvancedType>;
  /** If provided, this tag produces a special set of selling prices */
  value: Scalars['String'];
};

export type BrandSettingSellPriceAdvancedSellPrice = {
  __typename?: 'BrandSettingSellPriceAdvancedSellPrice';
  _id?: Maybe<Scalars['MongoID']>;
  condition?: Maybe<Scalars['Float']>;
  pct?: Maybe<Scalars['Float']>;
};

export type BrandSettingSellPriceAdvancedSellPriceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  condition?: InputMaybe<Scalars['Float']>;
  pct?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingSellPriceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  condition?: InputMaybe<Scalars['Float']>;
  pct?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingStockItemConfig = {
  __typename?: 'BrandSettingStockItemConfig';
  _id?: Maybe<Scalars['MongoID']>;
  /** If true, the stockitems color will be appended to the stockitem title. */
  appendColor?: Maybe<Scalars['Boolean']>;
  /** Optionally a seperator before the appends (color or size) */
  appendSeperator?: Maybe<Scalars['String']>;
  /** If true, the stockitems size will be appended to the stockitem title. */
  appendSize?: Maybe<Scalars['Boolean']>;
  autoData?: Maybe<Array<Maybe<BrandSettingStockItemConfigAutoData>>>;
  /** Optional strategy for resolving missing stockitem colors from product titles */
  colorStrategy?: Maybe<EnumBrandSettingStockItemConfigColorStrategy>;
  /** Optional the currencies for stockitem pricing */
  currencies?: Maybe<Array<Maybe<Currency>>>;
  /** Optional text that will be appended to the stockitems description, can contain wildcards. See documentation. */
  descriptionSuffix?: Maybe<Scalars['String']>;
  /** Localized description suffix */
  descriptionSuffixLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Extra meta about the item */
  extraMeta?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  /** Extra tags for the item */
  extraTags?: Maybe<Array<Maybe<BrandSettingStockItemConfigExtraTags>>>;
  /** Optional text that will be appended to the stockitem images alt text, can contain wildcards. See documentation. */
  imageAltText?: Maybe<Scalars['String']>;
  /** Localized image alt texts for images, can contain wildcards. */
  imageAltTextLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Optionally rotate the images by this number of degrees */
  imageRotate?: Maybe<Scalars['Float']>;
  /** Controls the order of the images, when querying on stockitems */
  imageSorting?: Maybe<EnumBrandSettingStockItemConfigImageSorting>;
  /** If true, then the stockitem must have a color */
  itemRuleColor?: Maybe<Scalars['Boolean']>;
  /** If set, then the stockitem must have at least this number of images */
  itemRuleImages?: Maybe<Scalars['Float']>;
  /** If true, then the stockitem must have a group of other standard fields */
  itemRuleOther?: Maybe<Scalars['Boolean']>;
  /** If true, then the stockitem must have a price for each currency */
  itemRulePrice?: Maybe<Scalars['Boolean']>;
  /** If true, then the stockitem must have a size */
  itemRuleSize?: Maybe<Scalars['Boolean']>;
  /** Item requirements for stockitems */
  itemRules?: Maybe<Array<Maybe<BrandSettingStockItemConfigItemRules>>>;
  /** How many (if available) masterdata product images should be included for new stockitems */
  masterImageCount?: Maybe<Scalars['Float']>;
  /** Which types of masterdata product images should be included for new stockitems */
  masterImageTypes?: Maybe<Array<Maybe<EnumBrandSettingStockItemConfigMasterImageTypes>>>;
  /** Optional text that will be appended to original images alt text, can contain wildcards. See documentation. */
  originalImageAltText?: Maybe<Scalars['String']>;
  /** Localized image alt texts for images, can contain wildcards. */
  originalImageAltTextLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  overrides?: Maybe<BrandSettingStockItemConfigOverrides>;
  /** String replacements for texts on brandItems */
  replacements?: Maybe<Array<Maybe<BrandSettingStockItemConfigReplacements>>>;
  /** Whether the brands requires to review the item before its published */
  requireReview?: Maybe<Scalars['Boolean']>;
  /** How the SKU should be generated for new stockitems */
  skuStrategy?: Maybe<EnumBrandSettingStockItemConfigSkuStrategy>;
  /** Optional a name of the template used when showing stock items in external shop. In shopify this is the templateSuffix. */
  template?: Maybe<Scalars['String']>;
  /** Optionally an advanced format for the title, this will override any data in titlePrefix and seperators. Wildcards such as {{title}} is allowed here */
  titleAdvanced?: Maybe<Scalars['String']>;
  /** Text that will be prefixed to the stockitems title, can contain wildcards. See documentation. */
  titlePrefix?: Maybe<Scalars['String']>;
  /** Optionally a seperator after the titleprefix and before the actual stockitem title */
  titleSeperator?: Maybe<Scalars['String']>;
  /** Optional a vendor for those stock items that does not define a vendor themselves */
  vendor?: Maybe<Scalars['String']>;
};

export type BrandSettingStockItemConfigAutoData = {
  __typename?: 'BrandSettingStockItemConfigAutoData';
  operator: EnumBrandSettingStockItemConfigAutoDataOperator;
  search: EnumBrandSettingStockItemConfigAutoDataSearch;
  tag: Scalars['String'];
  target: EnumBrandSettingStockItemConfigAutoDataTarget;
};

export type BrandSettingStockItemConfigAutoDataInput = {
  operator: EnumBrandSettingStockItemConfigAutoDataOperator;
  search: EnumBrandSettingStockItemConfigAutoDataSearch;
  tag: Scalars['String'];
  target: EnumBrandSettingStockItemConfigAutoDataTarget;
};

export type BrandSettingStockItemConfigExtraTags = {
  __typename?: 'BrandSettingStockItemConfigExtraTags';
  /** Whether the tag is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The tag to add */
  tag: Scalars['String'];
};

export type BrandSettingStockItemConfigExtraTagsInput = {
  /** Whether the tag is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The tag to add */
  tag: Scalars['String'];
};

export type BrandSettingStockItemConfigInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** If true, the stockitems color will be appended to the stockitem title. */
  appendColor?: InputMaybe<Scalars['Boolean']>;
  /** Optionally a seperator before the appends (color or size) */
  appendSeperator?: InputMaybe<Scalars['String']>;
  /** If true, the stockitems size will be appended to the stockitem title. */
  appendSize?: InputMaybe<Scalars['Boolean']>;
  autoData?: InputMaybe<Array<InputMaybe<BrandSettingStockItemConfigAutoDataInput>>>;
  /** Optional strategy for resolving missing stockitem colors from product titles */
  colorStrategy?: InputMaybe<EnumBrandSettingStockItemConfigColorStrategy>;
  /** Optional the currencies for stockitem pricing */
  currencies?: InputMaybe<Array<InputMaybe<CurrencyInput>>>;
  /** Optional text that will be appended to the stockitems description, can contain wildcards. See documentation. */
  descriptionSuffix?: InputMaybe<Scalars['String']>;
  /** Localized description suffix */
  descriptionSuffixLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Extra meta about the item */
  extraMeta?: InputMaybe<Array<InputMaybe<MetaFieldInstanceInput>>>;
  /** Extra tags for the item */
  extraTags?: InputMaybe<Array<InputMaybe<BrandSettingStockItemConfigExtraTagsInput>>>;
  /** Optional text that will be appended to the stockitem images alt text, can contain wildcards. See documentation. */
  imageAltText?: InputMaybe<Scalars['String']>;
  /** Localized image alt texts for images, can contain wildcards. */
  imageAltTextLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Optionally rotate the images by this number of degrees */
  imageRotate?: InputMaybe<Scalars['Float']>;
  /** Controls the order of the images, when querying on stockitems */
  imageSorting?: InputMaybe<EnumBrandSettingStockItemConfigImageSorting>;
  /** If true, then the stockitem must have a color */
  itemRuleColor?: InputMaybe<Scalars['Boolean']>;
  /** If set, then the stockitem must have at least this number of images */
  itemRuleImages?: InputMaybe<Scalars['Float']>;
  /** If true, then the stockitem must have a group of other standard fields */
  itemRuleOther?: InputMaybe<Scalars['Boolean']>;
  /** If true, then the stockitem must have a price for each currency */
  itemRulePrice?: InputMaybe<Scalars['Boolean']>;
  /** If true, then the stockitem must have a size */
  itemRuleSize?: InputMaybe<Scalars['Boolean']>;
  /** Item requirements for stockitems */
  itemRules?: InputMaybe<Array<InputMaybe<BrandSettingStockItemConfigItemRulesInput>>>;
  /** How many (if available) masterdata product images should be included for new stockitems */
  masterImageCount?: InputMaybe<Scalars['Float']>;
  /** Which types of masterdata product images should be included for new stockitems */
  masterImageTypes?: InputMaybe<Array<InputMaybe<EnumBrandSettingStockItemConfigMasterImageTypes>>>;
  /** Optional text that will be appended to original images alt text, can contain wildcards. See documentation. */
  originalImageAltText?: InputMaybe<Scalars['String']>;
  /** Localized image alt texts for images, can contain wildcards. */
  originalImageAltTextLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  overrides?: InputMaybe<BrandSettingStockItemConfigOverridesInput>;
  /** String replacements for texts on brandItems */
  replacements?: InputMaybe<Array<InputMaybe<BrandSettingStockItemConfigReplacementsInput>>>;
  /** Whether the brands requires to review the item before its published */
  requireReview?: InputMaybe<Scalars['Boolean']>;
  /** How the SKU should be generated for new stockitems */
  skuStrategy?: InputMaybe<EnumBrandSettingStockItemConfigSkuStrategy>;
  /** Optional a name of the template used when showing stock items in external shop. In shopify this is the templateSuffix. */
  template?: InputMaybe<Scalars['String']>;
  /** Optionally an advanced format for the title, this will override any data in titlePrefix and seperators. Wildcards such as {{title}} is allowed here */
  titleAdvanced?: InputMaybe<Scalars['String']>;
  /** Text that will be prefixed to the stockitems title, can contain wildcards. See documentation. */
  titlePrefix?: InputMaybe<Scalars['String']>;
  /** Optionally a seperator after the titleprefix and before the actual stockitem title */
  titleSeperator?: InputMaybe<Scalars['String']>;
  /** Optional a vendor for those stock items that does not define a vendor themselves */
  vendor?: InputMaybe<Scalars['String']>;
};

export type BrandSettingStockItemConfigItemRules = {
  __typename?: 'BrandSettingStockItemConfigItemRules';
  /** The expression to evaluate */
  expression: Scalars['String'];
  /** The message to show if the rule is not met */
  message: Scalars['String'];
};

export type BrandSettingStockItemConfigItemRulesInput = {
  /** The expression to evaluate */
  expression: Scalars['String'];
  /** The message to show if the rule is not met */
  message: Scalars['String'];
};

export type BrandSettingStockItemConfigOverrides = {
  __typename?: 'BrandSettingStockItemConfigOverrides';
  /** Optionally a producttype for those stock items that does not define a product type themselves */
  productType?: Maybe<Scalars['String']>;
  /** Optionally a vendor that will be set for all items, any vendor set on the masterdata/item will be overridden */
  vendor?: Maybe<Scalars['String']>;
};

export type BrandSettingStockItemConfigOverridesInput = {
  /** Optionally a producttype for those stock items that does not define a product type themselves */
  productType?: InputMaybe<Scalars['String']>;
  /** Optionally a vendor that will be set for all items, any vendor set on the masterdata/item will be overridden */
  vendor?: InputMaybe<Scalars['String']>;
};

export type BrandSettingStockItemConfigReplacements = {
  __typename?: 'BrandSettingStockItemConfigReplacements';
  /** The iso alpha 2 locale code */
  locales?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Replace with this string */
  replace: Scalars['String'];
  /** Search for this string */
  search: Scalars['String'];
};

export type BrandSettingStockItemConfigReplacementsInput = {
  /** The iso alpha 2 locale code */
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Replace with this string */
  replace: Scalars['String'];
  /** Search for this string */
  search: Scalars['String'];
};

export type BrandSettingThumbnails = {
  __typename?: 'BrandSettingThumbnails';
  /** Alignment bits for the generation, see https://github.com/oliver-moran/jimp/blob/master/packages/core/src/constants.js */
  align?: Maybe<Scalars['Float']>;
  /** A test replacement of the background color, will only work when the background is one color - use with care */
  background?: Maybe<Scalars['String']>;
  /** The height of the generated thumbnail, default is 200 */
  height?: Maybe<Scalars['Float']>;
  /** Contain will make sure the image is contained wihtin the size, cover will make sure the image is covered. Use alignment to control placement of image */
  strategy?: Maybe<EnumBrandSettingThumbnailsStrategy>;
  /** The width of the generated thumbnail, default is 200 */
  width?: Maybe<Scalars['Float']>;
};

export type BrandSettingThumbnailsInput = {
  /** Alignment bits for the generation, see https://github.com/oliver-moran/jimp/blob/master/packages/core/src/constants.js */
  align?: InputMaybe<Scalars['Float']>;
  /** A test replacement of the background color, will only work when the background is one color - use with care */
  background?: InputMaybe<Scalars['String']>;
  /** The height of the generated thumbnail, default is 200 */
  height?: InputMaybe<Scalars['Float']>;
  /** Contain will make sure the image is contained wihtin the size, cover will make sure the image is covered. Use alignment to control placement of image */
  strategy?: InputMaybe<EnumBrandSettingThumbnailsStrategy>;
  /** The width of the generated thumbnail, default is 200 */
  width?: InputMaybe<Scalars['Float']>;
};

export type BrandSettingTradeIn2Analytics = {
  __typename?: 'BrandSettingTradeIn2Analytics';
  /** Google Analytics 4 Property ID */
  ga4Property?: Maybe<Scalars['String']>;
  /** Universal Analytics Property ID (Deprecated) */
  uaProperty?: Maybe<Scalars['String']>;
};

export type BrandSettingTradeIn2AnalyticsInput = {
  /** Google Analytics 4 Property ID */
  ga4Property?: InputMaybe<Scalars['String']>;
  /** Universal Analytics Property ID (Deprecated) */
  uaProperty?: InputMaybe<Scalars['String']>;
};

export type BrandSettingVoucher = {
  __typename?: 'BrandSettingVoucher';
  expireDays?: Maybe<Scalars['Float']>;
  /** The maximum possible value of a single reward on a tradein. When this is exceeded the tradein cant be completed */
  maximumValue?: Maybe<Scalars['Float']>;
  minimumPurchase?: Maybe<Scalars['Float']>;
  minimumPurchaseExt?: Maybe<Array<Maybe<BrandSettingVoucherMinimumPurchaseExt>>>;
  newVoucherUsage?: Maybe<Scalars['Boolean']>;
  prefix?: Maybe<Scalars['String']>;
  refundApproval?: Maybe<Scalars['Boolean']>;
};

export type BrandSettingVoucherInput = {
  expireDays?: InputMaybe<Scalars['Float']>;
  /** The maximum possible value of a single reward on a tradein. When this is exceeded the tradein cant be completed */
  maximumValue?: InputMaybe<Scalars['Float']>;
  minimumPurchase?: InputMaybe<Scalars['Float']>;
  minimumPurchaseExt?: InputMaybe<Array<InputMaybe<BrandSettingVoucherMinimumPurchaseExtInput>>>;
  newVoucherUsage?: InputMaybe<Scalars['Boolean']>;
  prefix?: InputMaybe<Scalars['String']>;
  refundApproval?: InputMaybe<Scalars['Boolean']>;
};

export type BrandSettingVoucherMinimumPurchaseExt = {
  __typename?: 'BrandSettingVoucherMinimumPurchaseExt';
  _id?: Maybe<Scalars['MongoID']>;
  minimumPurchase?: Maybe<Scalars['Float']>;
  valueMax?: Maybe<Scalars['Float']>;
};

export type BrandSettingVoucherMinimumPurchaseExtInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  minimumPurchase?: InputMaybe<Scalars['Float']>;
  valueMax?: InputMaybe<Scalars['Float']>;
};

export enum BrandSynchronizeMode {
  Merge = 'MERGE',
  Replace = 'REPLACE',
  Updateimages = 'UPDATEIMAGES'
}

export type BrickMail = {
  __typename?: 'BrickMail';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  mails?: Maybe<Array<Maybe<BrickMailMails>>>;
  shopId: Scalars['MongoID'];
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type BrickMailMails = {
  __typename?: 'BrickMailMails';
  htmlMail?: Maybe<BrickMailMailsHtmlMail>;
  language?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['JSON']>;
  mailType?: Maybe<EnumBrickMailMailsMailType>;
};

export type BrickMailMailsHtmlMail = {
  __typename?: 'BrickMailMailsHtmlMail';
  from?: Maybe<BrickMailMailsHtmlMailFrom>;
  /** The html mail template */
  html?: Maybe<Scalars['String']>;
  /** Subject for the htmlmail */
  subject?: Maybe<Scalars['String']>;
};

export type BrickMailMailsHtmlMailFrom = {
  __typename?: 'BrickMailMailsHtmlMailFrom';
  /** Mail for the person */
  mail?: Maybe<Scalars['String']>;
  /** Name of the person */
  name?: Maybe<Scalars['String']>;
};

export type BrickMailMailsHtmlMailFromInput = {
  /** Mail for the person */
  mail?: InputMaybe<Scalars['String']>;
  /** Name of the person */
  name?: InputMaybe<Scalars['String']>;
};

export type BrickMailMailsHtmlMailInput = {
  from?: InputMaybe<BrickMailMailsHtmlMailFromInput>;
  /** The html mail template */
  html?: InputMaybe<Scalars['String']>;
  /** Subject for the htmlmail */
  subject?: InputMaybe<Scalars['String']>;
};

export type BrickMailMailsInput = {
  htmlMail?: InputMaybe<BrickMailMailsHtmlMailInput>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['JSON']>;
  mailType?: InputMaybe<EnumBrickMailMailsMailType>;
};

export type BrickMailType = {
  __typename?: 'BrickMailType';
  active: Scalars['Boolean'];
  description: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export enum BrickMailTypeEnum {
  /** The order was fulfilled, the consumer will receive this mail with information about the order and tracking */
  Fulfillment = 'FULFILLMENT',
  /** The consumer made an order that contains a secondhand styles. This mail will be sent to the consumer. */
  Orderinfo = 'ORDERINFO',
  /** The consumer tradein has been received by the logistics partner, this thank-you mail will be sent as a follow-up */
  Received = 'RECEIVED',
  /** If the consumer registers a tradein, but the package arent received at the logistics partner, then a reminder mail will be sent */
  Reminder = 'REMINDER',
  /** Mail sent to the consumer when they haven't used the voucher they received */
  Remindervoucher = 'REMINDERVOUCHER',
  /** The customer requested a return for the order, this mail will be sent to the consumer */
  Startreturn = 'STARTRETURN',
  /** The consumer requested access to the tradein platform, but the user does not exist */
  Unknown = 'UNKNOWN',
  /** Mail will be sent when there is new automatically generated trade-in offer for this consumer */
  Update = 'UPDATE',
  /** Consumer made a tradein, and will receive this mail containing information about the voucher */
  Voucher = 'VOUCHER',
  /** Reward was changed, either used in an order or was reimbursed. This mail notified the consumer about it. */
  Voucherupdated = 'VOUCHERUPDATED',
  /** The consumer requested access to the tradein platform, this mail contains access information */
  Welcome = 'WELCOME'
}

export type BrickMailValidation = {
  __typename?: 'BrickMailValidation';
  locale: Scalars['String'];
  message?: Maybe<Scalars['JSON']>;
  result?: Maybe<BrickMailValidationResultEnum>;
};

export enum BrickMailValidationResultEnum {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type Campaign = {
  __typename?: 'Campaign';
  _id: Scalars['MongoID'];
  /** The status of the campaign */
  active: Scalars['Boolean'];
  /** The brand house id of the campaign */
  brandHouseId: Scalars['MongoID'];
  /** The name of the campaign */
  campaignName: Scalars['String'];
  /** Whether the campaign is completed */
  completed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The status of the campaign */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The timestamp when the campaign ended */
  endedTs?: Maybe<Scalars['Date']>;
  /** The start date of the campaign */
  fromDate: Scalars['Date'];
  /** The percentage discount of the campaign */
  percentage: Scalars['Float'];
  /** The shop id of the campaign */
  shopId?: Maybe<Scalars['MongoID']>;
  /** The timestamp when the campaign started */
  startedTs?: Maybe<Scalars['Date']>;
  /** The end date of the campaign */
  toDate: Scalars['Date'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum CancelReason {
  ItemCancelled = 'ItemCancelled',
  ItemExcluded = 'ItemExcluded',
  ItemRefunded = 'ItemRefunded'
}

export type CircularAccount = {
  __typename?: 'CircularAccount';
  /** The ID of the account owner */
  consumerId: Scalars['MongoID'];
  /** Total number of circular points that will be added to the total when approved (trade in received) */
  pending: Scalars['Float'];
  /** A list of all circular point transactions for this account */
  points?: Maybe<Array<Maybe<CircularPoint>>>;
  /** The brand */
  shopId: Scalars['MongoID'];
  /** Total number of circular points the owner of this account can spend */
  total: Scalars['Float'];
};

export type CircularPayoutInstance = {
  __typename?: 'CircularPayoutInstance';
  _id?: Maybe<Scalars['MongoID']>;
  accountNr?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  phoneNr?: Maybe<Scalars['String']>;
  regNr?: Maybe<Scalars['String']>;
  /** Optionally a tradein that was directly converted for this payout */
  tradeInId?: Maybe<Scalars['MongoID']>;
};

export type CircularPayoutInstanceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  accountNr?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  phoneNr?: InputMaybe<Scalars['String']>;
  regNr?: InputMaybe<Scalars['String']>;
  /** Optionally a tradein that was directly converted for this payout */
  tradeInId?: InputMaybe<Scalars['MongoID']>;
};

export type CircularPayoutRatio = {
  __typename?: 'CircularPayoutRatio';
  _id?: Maybe<Scalars['MongoID']>;
  /** Whether the circular conversion is active for the brand */
  active: Scalars['Boolean'];
  /** The name of the payout */
  name: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  /** The ratio, a number >0 and <1 - 1 means full conversion, 0 means any points goes to 0 */
  ratio: Scalars['Float'];
  /** The name of the payout */
  type: Scalars['String'];
};

export type CircularPayoutRatioInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Whether the circular conversion is active for the brand */
  active: Scalars['Boolean'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  /** The ratio, a number >0 and <1 - 1 means full conversion, 0 means any points goes to 0 */
  ratio: Scalars['Float'];
};

export type CircularPayoutType = {
  __typename?: 'CircularPayoutType';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** The default payout ratio, a number between 0 and 1 */
  defaultRatio: Scalars['Float'];
  /** The name of the payout */
  name: Scalars['String'];
  /** The type of payout */
  payoutType: EnumCircularPayoutTypePayoutType;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type CircularPoint = {
  __typename?: 'CircularPoint';
  _id: Scalars['MongoID'];
  /** Whether the circularpoint point transaction has been activated for a tradein, or executed with the external service provider for a payout */
  activated: Scalars['Boolean'];
  /** The consumer id / account id, owning the points */
  consumerId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Whether this has been processed by the circular points engine */
  eventProcessed: Scalars['Boolean'];
  /** The shop */
  shopId: Scalars['MongoID'];
  /** Optionally data from the source that is relevant to the circular point */
  sourceData?: Maybe<CircularPointSourceData>;
  /** The source of the circularpoint transaction, tradein id, conversion id, etc */
  sourceObjectId: Scalars['MongoID'];
  /** The type of the transaction source, tradein or conversion */
  sourceType: EnumCircularPointSourceType;
  updatedAt?: Maybe<Scalars['Date']>;
  /** The change in points for this transaction. Can be a negative or positive value. */
  value: Scalars['Float'];
};

export type CircularPointSourceData = {
  __typename?: 'CircularPointSourceData';
  _id?: Maybe<Scalars['MongoID']>;
  actualPayout?: Maybe<CircularPayoutInstance>;
  postPayout?: Maybe<CircularPayoutInstance>;
};

export type CircularPointSourceDataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  actualPayout?: InputMaybe<CircularPayoutInstanceInput>;
  postPayout?: InputMaybe<CircularPayoutInstanceInput>;
};

export type CircularSettings = {
  __typename?: 'CircularSettings';
  _id?: Maybe<Scalars['MongoID']>;
  /** If this is non-null, then the customer will receive circular points instead of a shop voucher from the given date. The points can be converted to vouchers or real money something else entirely */
  activationDate?: Maybe<Scalars['Date']>;
  payoutTypes?: Maybe<Array<Maybe<CircularPayoutRatio>>>;
};

export type CircularSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** If this is non-null, then the customer will receive circular points instead of a shop voucher from the given date. The points can be converted to vouchers or real money something else entirely */
  activationDate?: InputMaybe<Scalars['Date']>;
  payoutTypes?: InputMaybe<Array<InputMaybe<CircularPayoutRatioInput>>>;
};

export type ConfigCompareModelSummary = {
  __typename?: 'ConfigCompareModelSummary';
  count: Scalars['Int'];
  modelName: Scalars['String'];
};

export type ConfigCompareResult = {
  __typename?: 'ConfigCompareResult';
  comparedAt: Scalars['Date'];
  differences?: Maybe<Array<Maybe<PathDifference>>>;
  nameA: Scalars['String'];
  nameB: Scalars['String'];
  refA?: Maybe<ConfigRef>;
  refB?: Maybe<ConfigRef>;
  summary?: Maybe<ConfigCompareSummary>;
};

export type ConfigCompareSummary = {
  __typename?: 'ConfigCompareSummary';
  byModel?: Maybe<Array<Maybe<ConfigCompareModelSummary>>>;
  totalDifferences: Scalars['Int'];
};

export type ConfigRef = {
  __typename?: 'ConfigRef';
  brandHouseId?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['String']>;
};

export type Consumer = {
  __typename?: 'Consumer';
  _id: Scalars['MongoID'];
  /** Whether this consumer accepts marketing mails */
  acceptsMarketing?: Maybe<Scalars['Boolean']>;
  accessToken?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  brandHouseId: Scalars['MongoID'];
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The currency of this consumer, typically based on the currency used in the consumers country */
  currency: Scalars['String'];
  /** Custom data for the consumer */
  customData?: Maybe<Scalars['JSON']>;
  /** Optionally a custom id for the consumer */
  customId?: Maybe<Scalars['String']>;
  disableContact?: Maybe<Scalars['Boolean']>;
  /** External orders for this consumer */
  externOrders?: Maybe<Array<Maybe<ExternOrder2>>>;
  /** URL to the external consumer */
  externUrl?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  /** Consumers first name */
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  journey?: Maybe<Array<Maybe<ConsumerJourney>>>;
  /** The consumers language, will default to the brands primary langauge if none is selected */
  language?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['Date']>;
  /** Consumers last name */
  lastName?: Maybe<Scalars['String']>;
  latestOfferMail?: Maybe<Scalars['Date']>;
  locale?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  /** Consumers name */
  name?: Maybe<Scalars['String']>;
  personId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** The phonenumber in E.164 format. */
  phoneE164?: Maybe<Scalars['String']>;
  /** The national part of the phone number, removes any +XX extension */
  phoneNational?: Maybe<Scalars['String']>;
  /** Whether this is a proxy account for another consumer */
  proxyAccount?: Maybe<Scalars['Boolean']>;
  /** Whether this consumer was created by a consumer himself or by a trusted source */
  selfCreated?: Maybe<Scalars['Boolean']>;
  shop?: Maybe<Shop>;
  shopId?: Maybe<Scalars['MongoID']>;
  /** Statistics for this consumer */
  statistics?: Maybe<ConsumerStatistics>;
  /** The tradein app url for this consumer */
  tradeInAppUrl: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  zipCode?: Maybe<Scalars['String']>;
};


export type ConsumerStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type ConsumerAccessRequestResult = {
  __typename?: 'ConsumerAccessRequestResult';
  messageId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ConsumerAccount = {
  __typename?: 'ConsumerAccount';
  /** The brand house this account belongs to */
  brandHouseId: Scalars['MongoID'];
  /** All consumers matching this identifier within the brandHouse */
  consumers?: Maybe<Array<Maybe<Consumer>>>;
  /** Currency from the most recently active consumer */
  currency?: Maybe<Scalars['String']>;
  /** The identifier value (email, phone, or externalId) */
  id: Scalars['String'];
  /** The type of identifier (EMAIL, PHONE, EXTERNALID) */
  idType: ConsumerIdentifierEnum;
  /** Language preference from the most recently active consumer */
  language?: Maybe<Scalars['String']>;
  /** Most recent login timestamp across all consumers */
  lastLogin?: Maybe<Scalars['Date']>;
  /** Name from the most recently active consumer */
  name?: Maybe<Scalars['String']>;
  /** All trade-ins across all matching consumers */
  tradeIns?: Maybe<Array<Maybe<TradeIn>>>;
  /** Total voucher balance across all active consumers, converted to the main currency */
  voucherBalance?: Maybe<Scalars['Float']>;
  /** List of vouchers with positive balance */
  voucherList?: Maybe<Array<Scalars['String']>>;
  /** All active vouchers across all matching consumers */
  vouchers?: Maybe<Array<Maybe<Voucher>>>;
};

export enum ConsumerAuthMethodEnum {
  MailCode = 'MAIL_CODE',
  MailLink = 'MAIL_LINK',
  SmsCode = 'SMS_CODE'
}

export type ConsumerAuthorizeResult = {
  __typename?: 'ConsumerAuthorizeResult';
  allowedCountry: Scalars['Boolean'];
  brandName: Scalars['String'];
  circularPoints: Scalars['Boolean'];
  consumerId: Scalars['String'];
  currency: Scalars['String'];
  locale: Scalars['String'];
  lockEmail: Scalars['Boolean'];
  productSearchEnabled: Scalars['Boolean'];
  requestPotentialsSupported: Scalars['Boolean'];
  shopCurrency: Scalars['String'];
  shopId: Scalars['String'];
  token: Scalars['String'];
  tradeInComments: Scalars['Boolean'];
  tradeInPayoutEnabled: Scalars['Boolean'];
  tradeInPayoutPct: Scalars['Int'];
  wholeSaleActive: Scalars['Boolean'];
};

export type ConsumerCompleteAccessResult = {
  __typename?: 'ConsumerCompleteAccessResult';
  status: Scalars['String'];
};

/** List of items with pagination. */
export type ConsumerConsumerPagination = {
  __typename?: 'ConsumerConsumerPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Consumer>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** Input for consumer creastion */
export type ConsumerCreate2Input = {
  /** Country of consumer */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Optionally some custom data for the consumer */
  customData?: InputMaybe<Scalars['String']>;
  /** Optionally a custom id for the consumer */
  customId?: InputMaybe<Scalars['String']>;
  /** Consumer email */
  email?: InputMaybe<Scalars['String']>;
  /** External system id for this consumer */
  externalId: Scalars['String'];
  /** Language of consumer */
  language?: InputMaybe<Scalars['String']>;
  /** Consumer name */
  name?: InputMaybe<Scalars['String']>;
  /** Consumer phone */
  phone?: InputMaybe<Scalars['String']>;
  /** Zipcode for consumer */
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ConsumerEvent = {
  __typename?: 'ConsumerEvent';
  _id: Scalars['MongoID'];
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['MongoID'];
  data?: Maybe<Scalars['JSON']>;
  dateTime: Scalars['Date'];
  event: Scalars['String'];
  exportedToKlaviyo?: Maybe<Scalars['Boolean']>;
  exportedToStatistics?: Maybe<Scalars['Boolean']>;
  maildata?: Maybe<ConsumerEventMaildata>;
  shopId: Scalars['MongoID'];
  subEvent?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type ConsumerEventConsumerEventPagination = {
  __typename?: 'ConsumerEventConsumerEventPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ConsumerEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ConsumerEventMaildata = {
  __typename?: 'ConsumerEventMaildata';
  bounced?: Maybe<Scalars['Boolean']>;
  clicked?: Maybe<Scalars['Boolean']>;
  delivered?: Maybe<Scalars['Boolean']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  messageId?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['Boolean']>;
  spam?: Maybe<Scalars['Boolean']>;
};

export enum ConsumerIdentifierEnum {
  Email = 'EMAIL',
  Externalid = 'EXTERNALID',
  Phone = 'PHONE'
}

export type ConsumerInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Whether this consumer accepts marketing mails */
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  accountType?: InputMaybe<Scalars['String']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the consumer */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Optionally a custom id for the consumer */
  customId?: InputMaybe<Scalars['String']>;
  disableContact?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  journey?: InputMaybe<Array<InputMaybe<ConsumerJourneyInput>>>;
  lastName?: InputMaybe<Scalars['String']>;
  latestOfferMail?: InputMaybe<Scalars['Date']>;
  locale?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Whether this is a proxy account for another consumer */
  proxyAccount?: InputMaybe<Scalars['Boolean']>;
  /** Whether this consumer was created by a consumer himself or by a trusted source */
  selfCreated?: InputMaybe<Scalars['Boolean']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ConsumerJourney = {
  __typename?: 'ConsumerJourney';
  _id?: Maybe<Scalars['MongoID']>;
  /** The date of the journey entry */
  date: Scalars['Date'];
  /** The type of journey entry */
  entryType: EnumConsumerJourneyEntryType;
};

export type ConsumerJourneyInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** The date of the journey entry */
  date: Scalars['Date'];
  /** The type of journey entry */
  entryType: EnumConsumerJourneyEntryType;
};

export type ConsumerMailUpdateInput = {
  /** Mail bounched */
  bounced?: InputMaybe<Scalars['Boolean']>;
  /** Link in mail was clicked */
  clicked?: InputMaybe<Scalars['Boolean']>;
  /** Mail has been delivered */
  delivered?: InputMaybe<Scalars['Boolean']>;
  /** The mail message ID */
  messageId: Scalars['String'];
  /** Mail was opened */
  opened?: InputMaybe<Scalars['Boolean']>;
  /** User marked the mail as spam */
  spam?: InputMaybe<Scalars['Boolean']>;
};

export type ConsumerRejectAccessResult = {
  __typename?: 'ConsumerRejectAccessResult';
  status: Scalars['String'];
};

export type ConsumerSendCode = {
  __typename?: 'ConsumerSendCode';
  status: Scalars['String'];
};

export type ConsumerSendMail = {
  __typename?: 'ConsumerSendMail';
  status: Scalars['String'];
};

export type ConsumerStatistics = {
  __typename?: 'ConsumerStatistics';
  /** The total number of orders */
  orders?: Maybe<Scalars['Int']>;
  /** The total amount of discounts applied to orders before tax */
  ordersTotalDiscountedPreTax?: Maybe<Scalars['Int']>;
  /** The total number of trade-ins */
  tradeIns?: Maybe<Scalars['Int']>;
};

/** Profile fields to merge into the synchronized consumer. */
export type ConsumerSynchronizeInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  customData?: InputMaybe<Scalars['String']>;
  customId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ConsumerVerifyCode = {
  __typename?: 'ConsumerVerifyCode';
  accessToken?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type ConsumersPaging = {
  __typename?: 'ConsumersPaging';
  data?: Maybe<Array<Maybe<Consumer>>>;
  page: Scalars['Int'];
  pages: Scalars['Int'];
  total: Scalars['Int'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  currency: Scalars['String'];
  name: Scalars['String'];
};

export type CreateOneBrandProductGroupInput = {
  /** Is the group active for everything */
  active: Scalars['Boolean'];
  /** Is the group active for potential linking */
  activePotentials?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for promoting brand items */
  activePromotions?: InputMaybe<Scalars['Boolean']>;
  brandHouseId: Scalars['MongoID'];
  /** The name of the group */
  name: Scalars['String'];
};

export type CreateOneBrandProductGroupPayload = {
  __typename?: 'CreateOneBrandProductGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<BrandProductGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneCampaignInput = {
  /** The brand house id of the campaign */
  brandHouseId: Scalars['MongoID'];
  /** The name of the campaign */
  campaignName: Scalars['String'];
  /** The status of the campaign */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The start date of the campaign */
  fromDate: Scalars['Date'];
  /** The percentage discount of the campaign */
  percentage: Scalars['Float'];
  /** The shop id of the campaign */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The end date of the campaign */
  toDate: Scalars['Date'];
};

export type CreateOneCampaignPayload = {
  __typename?: 'CreateOneCampaignPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Campaign>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneCircularPointInput = {
  /** Whether the circularpoint point transaction has been activated for a tradein, or executed with the external service provider for a payout */
  activated: Scalars['Boolean'];
  /** The consumer id / account id, owning the points */
  consumerId: Scalars['MongoID'];
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Whether this has been processed by the circular points engine */
  eventProcessed: Scalars['Boolean'];
  /** The shop */
  shopId: Scalars['MongoID'];
  /** Optionally data from the source that is relevant to the circular point */
  sourceData?: InputMaybe<CircularPointSourceDataInput>;
  /** The source of the circularpoint transaction, tradein id, conversion id, etc */
  sourceObjectId: Scalars['MongoID'];
  /** The type of the transaction source, tradein or conversion */
  sourceType: EnumCircularPointSourceType;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The change in points for this transaction. Can be a negative or positive value. */
  value: Scalars['Float'];
};

export type CreateOneCircularPointPayload = {
  __typename?: 'CreateOneCircularPointPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CircularPoint>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneIntegrationConnectorInput = {
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventbus?: InputMaybe<IntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<IntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name: Scalars['String'];
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type: EnumIntegrationConnectorType;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<IntegrationConnectorWebhookInput>;
};

export type CreateOneIntegrationConnectorPayload = {
  __typename?: 'CreateOneIntegrationConnectorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<IntegrationConnector>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneInvoiceAdjustmentInput = {
  amount: Scalars['Float'];
  brandHouseId: Scalars['MongoID'];
  description: Scalars['String'];
};

export type CreateOneInvoiceAdjustmentPayload = {
  __typename?: 'CreateOneInvoiceAdjustmentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<InvoiceAdjustment>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneParcelInput = {
  /** The brand that owns this parcel */
  brandHouseId: Scalars['MongoID'];
  /** Optional comment for the parcel */
  comment?: InputMaybe<Scalars['String']>;
  /** Items in the parcel */
  items?: InputMaybe<Array<InputMaybe<ParcelItemsInput>>>;
  /** When provided, no shipping label is created via carrier — tracking is managed externally */
  manualTracking?: InputMaybe<ParcelManualTrackingInput>;
  /** The date of the parcel creation */
  parcelDate: Scalars['Date'];
  /** The receiver of the parcel */
  receiver: AddressInfoInput;
  /** The sender of the parcel */
  sender: AddressInfoInput;
  /** The carrier of the parcel */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: InputMaybe<Scalars['MongoID']>;
};

export type CreateOneParcelPayload = {
  __typename?: 'CreateOneParcelPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Parcel>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneRespondentInput = {
  /** The answers made by this respondent */
  answers: Array<InputMaybe<RespondentAnswersInput>>;
  shopId: Scalars['MongoID'];
  surveyId: Scalars['MongoID'];
};

export type CreateOneRespondentPayload = {
  __typename?: 'CreateOneRespondentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Respondent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneScheduledEventInput = {
  /** Optionally data that will be sent with the event */
  data?: InputMaybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt: Scalars['Date'];
  /** The timestamp of when the event was executed */
  executed?: InputMaybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId: Scalars['MongoID'];
  /** The referenced object type */
  refType: EnumScheduledEventRefType;
};

export type CreateOneScheduledEventPayload = {
  __typename?: 'CreateOneScheduledEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ScheduledEvent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneShippingLabelInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<EnumShippingLabelDeliveryStatus>;
  labelCode?: InputMaybe<Scalars['String']>;
  labelExternalId?: InputMaybe<Scalars['String']>;
  labelFailed?: InputMaybe<Scalars['Boolean']>;
  labelFailedCount?: InputMaybe<Scalars['Float']>;
  labelImageId?: InputMaybe<Scalars['MongoID']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  packageCode?: InputMaybe<Scalars['String']>;
  qrImageId?: InputMaybe<Scalars['MongoID']>;
  qrPngId?: InputMaybe<Scalars['MongoID']>;
  receiver?: InputMaybe<AddressInfoInput>;
  sender?: InputMaybe<AddressInfoInput>;
  shippingCarrierId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
  tracking?: InputMaybe<ShippingLabelTrackingInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type CreateOneShippingLabelPayload = {
  __typename?: 'CreateOneShippingLabelPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ShippingLabel>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneSystemMessageInput = {
  /** The target audience (SYSADM, ADMIN, BRAND) */
  audience: EnumSystemMessageAudience;
  /** If the audience is a brandhouse, this is the brandhouse id */
  audienceBrandId?: InputMaybe<Scalars['MongoID']>;
  description: Scalars['String'];
  /** The type of message (CRITICAL, WARNING, INFORMATION) */
  messageType: EnumSystemMessageMessageType;
  /** Subject used to group repeated messages while unacknowledged */
  subject: Scalars['String'];
};

export type CreateOneSystemMessagePayload = {
  __typename?: 'CreateOneSystemMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SystemMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneVoucherAdjustmentInput = {
  /** The adjustment amount in vouchers currency */
  amount: Scalars['Float'];
  /** If this adjustment is a correction to the original voucher value */
  correction?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The adjustment date */
  date: Scalars['Date'];
  /** Reason for adjustment */
  reason: Scalars['String'];
  /** The shop that owns the usage refund */
  shopId: Scalars['MongoID'];
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** The voucher */
  voucherId: Scalars['MongoID'];
};

export type CreateOneVoucherAdjustmentPayload = {
  __typename?: 'CreateOneVoucherAdjustmentPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<VoucherAdjustment>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type CreateOneWholeSaleCategoryInput = {
  advanced?: InputMaybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  iconId?: InputMaybe<Scalars['MongoID']>;
  name: Scalars['String'];
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  rules?: InputMaybe<Array<InputMaybe<WholeSaleCategoryRulesInput>>>;
  section?: InputMaybe<Scalars['String']>;
  sectionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  shopId: Scalars['MongoID'];
  /** The other of this category */
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  value: Scalars['Float'];
  voucherStrategy?: InputMaybe<EnumWholeSaleCategoryVoucherStrategy>;
};

export type CreateOneWholeSaleCategoryPayload = {
  __typename?: 'CreateOneWholeSaleCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<WholeSaleCategory>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type Currency = {
  __typename?: 'Currency';
  /** Whether the currency is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The ISO 4217 currency code */
  currency: Scalars['String'];
};

export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type CurrencyInput = {
  /** Whether the currency is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The ISO 4217 currency code */
  currency: Scalars['String'];
};

export type DataView = {
  __typename?: 'DataView';
  _id: Scalars['MongoID'];
  createdAt: Scalars['Date'];
  expiresAt: Scalars['Date'];
  metadata?: Maybe<Scalars['JSON']>;
  rowIds: Array<Maybe<Scalars['MongoID']>>;
  /** Type of entities in this view */
  type: DataViewTypeEnum;
  viewName?: Maybe<Scalars['String']>;
};

export enum DataViewTypeEnum {
  BrandItem = 'BrandItem',
  Order = 'Order',
  TradeIn = 'TradeIn'
}

export enum DifferenceTypeEnum {
  MissingInA = 'MISSING_IN_A',
  MissingInB = 'MISSING_IN_B',
  OnlyInA = 'ONLY_IN_A',
  OnlyInB = 'ONLY_IN_B',
  ValueMismatch = 'VALUE_MISMATCH'
}

export type DigitalPassport = {
  __typename?: 'DigitalPassport';
  /** The access token */
  accessToken: Scalars['String'];
  /** The status of the digital passport */
  status: Scalars['Float'];
  /** The url to the digital passport tradein */
  url: Scalars['String'];
};

export type Dropoff = {
  __typename?: 'Dropoff';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  in_delivery?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  opening_hours?: Maybe<Array<Maybe<Scalars['String']>>>;
  out_delivery?: Maybe<Scalars['Boolean']>;
  qr_code?: Maybe<Scalars['Boolean']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** The referenced object type, Shop, BrandHouse, LogisticsPartner */
export enum EnumAddressInfoRefType {
  Brand = 'BRAND',
  Logisticspartner = 'LOGISTICSPARTNER',
  Shop = 'SHOP'
}

export enum EnumBrandItemAttributesApparentFabricType {
  Canvas = 'canvas',
  Corduroy = 'corduroy',
  Denim = 'denim',
  Fleece = 'fleece',
  Fuzzy = 'fuzzy',
  Glossy = 'glossy',
  Jersey = 'jersey',
  Knit = 'knit',
  Lace = 'lace',
  Leather = 'leather',
  Metal = 'metal',
  Nylon = 'nylon',
  Plastic = 'plastic',
  Polyester = 'polyester',
  Ribbed = 'ribbed',
  Satin = 'satin',
  Sequined = 'sequined',
  Sheer = 'sheer',
  Silk = 'silk',
  Stretch = 'stretch',
  Suede = 'suede',
  Velvet = 'velvet',
  Woven = 'woven'
}

export enum EnumBrandItemAttributesFormalityLevel {
  Athletic = 'athletic',
  BusinessCasual = 'business_casual',
  BusinessFormal = 'business_formal',
  Casual = 'casual',
  Formal = 'formal',
  Functional = 'functional',
  Loungewear = 'loungewear',
  SmartCasual = 'smart_casual'
}

export enum EnumBrandItemAttributesNeckline {
  Boat = 'boat',
  Collar = 'collar',
  Cowl = 'cowl',
  Crew = 'crew',
  Halter = 'halter',
  Hood = 'hood',
  OffShoulder = 'off_shoulder',
  Scoop = 'scoop',
  Strapless = 'strapless',
  Turtle = 'turtle',
  VNeck = 'v_neck'
}

export enum EnumBrandItemAttributesNotableFeatures {
  Belt = 'belt',
  Buttons = 'buttons',
  Cutouts = 'cutouts',
  Embellishments = 'embellishments',
  Hood = 'hood',
  Logo = 'logo',
  Pleats = 'pleats',
  Pockets = 'pockets',
  Ruffles = 'ruffles',
  Zippers = 'zippers'
}

export enum EnumBrandItemAttributesPattern {
  Abstract = 'abstract',
  AnimalPrint = 'animal_print',
  Camouflage = 'camouflage',
  Floral = 'floral',
  Geometric = 'geometric',
  Graphic = 'graphic',
  Paisley = 'paisley',
  Plaid = 'plaid',
  PolkaDots = 'polka_dots',
  Solid = 'solid',
  Stripes = 'stripes'
}

export enum EnumBrandItemAttributesPrimaryColor {
  Beige = 'beige',
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Gray = 'gray',
  Green = 'green',
  Metallic = 'metallic',
  Multicolor = 'multicolor',
  Navy = 'navy',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

export enum EnumBrandItemAttributesSeasonSuitability {
  Fall = 'fall',
  Spring = 'spring',
  Summer = 'summer',
  Winter = 'winter',
  YearRound = 'year_round'
}

export enum EnumBrandItemAttributesSecondaryColors {
  Beige = 'beige',
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Gray = 'gray',
  Green = 'green',
  Metallic = 'metallic',
  Multicolor = 'multicolor',
  Navy = 'navy',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

export enum EnumBrandItemAttributesSubType {
  Beanie = 'beanie',
  BomberJacket = 'bomber_jacket',
  Bracelet = 'bracelet',
  Brooch = 'brooch',
  Cap = 'cap',
  DenimJacket = 'denim_jacket',
  Earrings = 'earrings',
  HuntingJacket = 'hunting_jacket',
  LeatherJacket = 'leather_jacket',
  Necklace = 'necklace',
  Other = 'other',
  OtherGloves = 'other_gloves',
  PufferJacket = 'puffer_jacket',
  RainJacket = 'rain_jacket',
  RainSet = 'rain_set',
  Ring = 'ring',
  SkiGloves = 'ski_gloves',
  SummerHat = 'summer_hat',
  WinterHat = 'winter_hat'
}

export enum EnumBrandItemAttributesTextureAppearance {
  CableKnit = 'cable_knit',
  Coated = 'coated',
  Distressed = 'distressed',
  Embossed = 'embossed',
  Embroidered = 'embroidered',
  Fuzzy = 'fuzzy',
  Glossy = 'glossy',
  Lace = 'lace',
  Matte = 'matte',
  Pebbled = 'pebbled',
  Quilted = 'quilted',
  Ribbed = 'ribbed',
  Smooth = 'smooth'
}

export enum EnumBrandItemAttributesType {
  Activewear = 'activewear',
  Bag = 'bag',
  Belt = 'belt',
  Blazer = 'blazer',
  Blouse = 'blouse',
  Bodysuit = 'bodysuit',
  Boots = 'boots',
  Cardigan = 'cardigan',
  Coat = 'coat',
  Dress = 'dress',
  Flats = 'flats',
  Hat = 'hat',
  Heels = 'heels',
  Hoodie = 'hoodie',
  Jacket = 'jacket',
  Jeans = 'jeans',
  Jewelry = 'jewelry',
  Jumpsuit = 'jumpsuit',
  Leggings = 'leggings',
  Lingerie = 'lingerie',
  Loafers = 'loafers',
  Other = 'other',
  OuterwearSet = 'outerwear_set',
  Pants = 'pants',
  Romper = 'romper',
  Sandals = 'sandals',
  Scarf = 'scarf',
  Shirt = 'shirt',
  Shoes = 'shoes',
  Shorts = 'shorts',
  Skirt = 'skirt',
  Sleepingbag = 'sleepingbag',
  Slippers = 'slippers',
  Sneakers = 'sneakers',
  Suit = 'suit',
  Sunglasses = 'sunglasses',
  SupportPillow = 'support_pillow',
  Sweater = 'sweater',
  Sweatshirt = 'sweatshirt',
  Swimwear = 'swimwear',
  TShirt = 't_shirt',
  TankTop = 'tank_top',
  Tent = 'tent',
  Vest = 'vest',
  Watch = 'watch'
}

export enum EnumBrandItemImagePerspective {
  Back = 'BACK',
  Detail = 'DETAIL',
  Front = 'FRONT',
  Other = 'OTHER'
}

export enum EnumBrandItemImageType {
  Focus = 'FOCUS',
  Model = 'MODEL',
  Other = 'OTHER',
  Pack = 'PACK'
}

/** State of the branditem */
export enum EnumBrandItemItemState {
  Draft = 'DRAFT',
  None = 'NONE',
  Ready = 'READY',
  Review = 'REVIEW'
}

/** The type of source this branditem is from */
export enum EnumBrandItemSourceType {
  Claim = 'CLAIM',
  Newitem = 'NEWITEM',
  Sample = 'SAMPLE',
  Secondhand = 'SECONDHAND'
}

/** The current state of the VAS process for this item */
export enum EnumBrandItemVasState {
  Completed = 'COMPLETED',
  Discarded = 'DISCARDED',
  Progressing = 'PROGRESSING',
  Received = 'RECEIVED',
  Repairing = 'REPAIRING',
  Washing = 'WASHING'
}

/** The VAS contract version for this item */
export enum EnumBrandItemVasType {
  Vas1_0 = 'VAS1_0',
  Vas2_0 = 'VAS2_0'
}

export enum EnumBrandProductImagePerspective {
  Back = 'BACK',
  Detail = 'DETAIL',
  Front = 'FRONT',
  Other = 'OTHER'
}

export enum EnumBrandProductImageType {
  Focus = 'FOCUS',
  Model = 'MODEL',
  Other = 'OTHER',
  Pack = 'PACK'
}

export enum EnumBrandRuleDigitalPassportValue {
  Rrp = 'RRP',
  Sp = 'SP',
  Sporiginal = 'SPORIGINAL'
}

/** The minimum price, relative to RRP or SP */
export enum EnumBrandRuleMinimumPriceType {
  Rrp = 'RRP',
  Sp = 'SP',
  Sporiginal = 'SPORIGINAL'
}

export enum EnumBrandRuleSecondhandVoucherValue {
  Rrp = 'RRP',
  Sp = 'SP',
  Sporiginal = 'SPORIGINAL'
}

export enum EnumBrandRuleTradeInSearchAmountsExpressionsOperation {
  Contains = 'CONTAINS',
  Endswith = 'ENDSWITH',
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
  Startswith = 'STARTSWITH'
}

export enum EnumBrandRuleTradeInSearchAmountsExpressionsValueType {
  Collection = 'COLLECTION',
  Ean = 'EAN',
  Metafield = 'METAFIELD',
  Name = 'NAME',
  Sku = 'SKU',
  Tag = 'TAG',
  Type = 'TYPE',
  Vendor = 'VENDOR'
}

export enum EnumBrandRuleVoucherStrategy {
  Handin = 'HANDIN',
  Instant = 'INSTANT',
  Received = 'RECEIVED'
}

export enum EnumBrandRuleVoucherValue {
  Rrp = 'RRP',
  Sp = 'SP',
  Sporiginal = 'SPORIGINAL'
}

/** Enabled messages for legacy integration */
export enum EnumBrandSettingLegacyIntegrationDisabledMessages {
  Cancelled = 'CANCELLED',
  Capture = 'CAPTURE',
  Consumeractivity = 'CONSUMERACTIVITY',
  Createorder = 'CREATEORDER',
  Createparcel = 'CREATEPARCEL',
  Createshippinglabel = 'CREATESHIPPINGLABEL',
  Createtradein = 'CREATETRADEIN',
  Delete = 'DELETE',
  Fulfill = 'FULFILL',
  Init = 'INIT',
  Optimizebysalesrank = 'OPTIMIZEBYSALESRANK',
  Periodicreport = 'PERIODICREPORT',
  Refund = 'REFUND',
  Removebg = 'REMOVEBG',
  Requestaccess = 'REQUESTACCESS',
  Requestorders = 'REQUESTORDERS',
  Requestpotentials = 'REQUESTPOTENTIALS',
  Requestproducts = 'REQUESTPRODUCTS',
  Requestvouchers = 'REQUESTVOUCHERS',
  Scheduledevent = 'SCHEDULEDEVENT',
  Sendmail = 'SENDMAIL',
  Updatebrand = 'UPDATEBRAND',
  Updatebranditem = 'UPDATEBRANDITEM',
  Updatecategory = 'UPDATECATEGORY',
  Updateconfig = 'UPDATECONFIG',
  Updateinventory = 'UPDATEINVENTORY',
  Updateinvoice = 'UPDATEINVOICE',
  Updateorder = 'UPDATEORDER',
  Updateparcel = 'UPDATEPARCEL',
  Updatepotentials = 'UPDATEPOTENTIALS',
  Updateshippinglabel = 'UPDATESHIPPINGLABEL',
  Updateshop = 'UPDATESHOP',
  Updatestockitems = 'UPDATESTOCKITEMS',
  Updatetradein = 'UPDATETRADEIN',
  Updatevoucher = 'UPDATEVOUCHER'
}

/** How to identify colors on master data */
export enum EnumBrandSettingMasterDataConsolidateColorStrategy {
  ProductInternalColor = 'PRODUCT_INTERNAL_COLOR',
  ProductMetafield = 'PRODUCT_METAFIELD',
  ProductNameDashSuffix = 'PRODUCT_NAME_DASH_SUFFIX',
  ProductNameKnownColors = 'PRODUCT_NAME_KNOWN_COLORS',
  ProductNameParanthesis = 'PRODUCT_NAME_PARANTHESIS',
  ProductNamePipeSuffix = 'PRODUCT_NAME_PIPE_SUFFIX',
  ProductTagPrefix = 'PRODUCT_TAG_PREFIX',
  VariantAttribute = 'VARIANT_ATTRIBUTE',
  VariantSkuPattern = 'VARIANT_SKU_PATTERN'
}

/** The field that we are consolidating on */
export enum EnumBrandSettingMasterDataConsolidateField {
  Ean = 'EAN',
  Sku = 'SKU'
}

/** Secondary identify color strategy */
export enum EnumBrandSettingMasterDataConsolidateSecondaryColorStrategy {
  ProductInternalColor = 'PRODUCT_INTERNAL_COLOR',
  ProductMetafield = 'PRODUCT_METAFIELD',
  ProductNameDashSuffix = 'PRODUCT_NAME_DASH_SUFFIX',
  ProductNameKnownColors = 'PRODUCT_NAME_KNOWN_COLORS',
  ProductNameParanthesis = 'PRODUCT_NAME_PARANTHESIS',
  ProductNamePipeSuffix = 'PRODUCT_NAME_PIPE_SUFFIX',
  ProductTagPrefix = 'PRODUCT_TAG_PREFIX',
  VariantAttribute = 'VARIANT_ATTRIBUTE',
  VariantSkuPattern = 'VARIANT_SKU_PATTERN'
}

/** Tertiary identify color strategy */
export enum EnumBrandSettingMasterDataConsolidateTertiaryColorStrategy {
  ProductInternalColor = 'PRODUCT_INTERNAL_COLOR',
  ProductMetafield = 'PRODUCT_METAFIELD',
  ProductNameDashSuffix = 'PRODUCT_NAME_DASH_SUFFIX',
  ProductNameKnownColors = 'PRODUCT_NAME_KNOWN_COLORS',
  ProductNameParanthesis = 'PRODUCT_NAME_PARANTHESIS',
  ProductNamePipeSuffix = 'PRODUCT_NAME_PIPE_SUFFIX',
  ProductTagPrefix = 'PRODUCT_TAG_PREFIX',
  VariantAttribute = 'VARIANT_ATTRIBUTE',
  VariantSkuPattern = 'VARIANT_SKU_PATTERN'
}

export enum EnumBrandSettingSellPriceAdvancedType {
  ProductType = 'productType',
  Source = 'source',
  Tag = 'tag'
}

export enum EnumBrandSettingStockItemConfigAutoDataOperator {
  Exclucde = 'exclucde',
  Include = 'include'
}

export enum EnumBrandSettingStockItemConfigAutoDataSearch {
  Both = 'both',
  Prefix = 'prefix',
  Suffix = 'suffix'
}

export enum EnumBrandSettingStockItemConfigAutoDataTarget {
  Meta = 'meta',
  Tag = 'tag'
}

/** Optional strategy for resolving missing stockitem colors from product titles */
export enum EnumBrandSettingStockItemConfigColorStrategy {
  ProductNameDashSuffix = 'PRODUCT_NAME_DASH_SUFFIX',
  ProductNameParanthesis = 'PRODUCT_NAME_PARANTHESIS',
  ProductNamePipeSuffix = 'PRODUCT_NAME_PIPE_SUFFIX'
}

/** Controls the order of the images, when querying on stockitems */
export enum EnumBrandSettingStockItemConfigImageSorting {
  Orgfirstmiddlelast = 'ORGFIRSTMIDDLELAST',
  Originalfirst = 'ORIGINALFIRST',
  Originallast = 'ORIGINALLAST',
  Standard = 'STANDARD'
}

export enum EnumBrandSettingStockItemConfigMasterImageTypes {
  Focus = 'FOCUS',
  Model = 'MODEL',
  Other = 'OTHER',
  Pack = 'PACK'
}

/** How the SKU should be generated for new stockitems */
export enum EnumBrandSettingStockItemConfigSkuStrategy {
  Branditemsku = 'BRANDITEMSKU',
  Originalean = 'ORIGINALEAN',
  Unique = 'UNIQUE'
}

/** Contain will make sure the image is contained wihtin the size, cover will make sure the image is covered. Use alignment to control placement of image */
export enum EnumBrandSettingThumbnailsStrategy {
  Contain = 'contain',
  Cover = 'cover'
}

/** Whether the tradein app should utilize hashes or browser address for state - default is browser */
export enum EnumBrandSettingTradeInRouter {
  Browser = 'BROWSER',
  Hash = 'HASH',
  Parameter = 'PARAMETER'
}

export enum EnumBrickMailMailsMailType {
  Brick = 'BRICK',
  Html = 'HTML'
}

/** The type of payout */
export enum EnumCircularPayoutTypePayoutType {
  Creditcard = 'creditcard',
  Mobilepay = 'mobilepay',
  Voucher = 'voucher'
}

/** The type of the transaction source, tradein or conversion */
export enum EnumCircularPointSourceType {
  Payout = 'payout',
  TradeIn = 'tradeIn'
}

/** The type of journey entry */
export enum EnumConsumerJourneyEntryType {
  Outbound = 'OUTBOUND',
  Request = 'REQUEST',
  Wholesale = 'WHOLESALE'
}

export enum EnumDataViewType {
  BrandItem = 'BrandItem',
  Order = 'Order',
  TradeIn = 'TradeIn'
}

/** The message type */
export enum EnumIntegrationConfigMessage {
  Cancelled = 'CANCELLED',
  Capture = 'CAPTURE',
  Consumeractivity = 'CONSUMERACTIVITY',
  Createorder = 'CREATEORDER',
  Createparcel = 'CREATEPARCEL',
  Createshippinglabel = 'CREATESHIPPINGLABEL',
  Createtradein = 'CREATETRADEIN',
  Delete = 'DELETE',
  Fulfill = 'FULFILL',
  Init = 'INIT',
  Optimizebysalesrank = 'OPTIMIZEBYSALESRANK',
  Periodicreport = 'PERIODICREPORT',
  Refund = 'REFUND',
  Removebg = 'REMOVEBG',
  Requestaccess = 'REQUESTACCESS',
  Requestorders = 'REQUESTORDERS',
  Requestpotentials = 'REQUESTPOTENTIALS',
  Requestproducts = 'REQUESTPRODUCTS',
  Requestvouchers = 'REQUESTVOUCHERS',
  Scheduledevent = 'SCHEDULEDEVENT',
  Sendmail = 'SENDMAIL',
  Updatebrand = 'UPDATEBRAND',
  Updatebranditem = 'UPDATEBRANDITEM',
  Updatecategory = 'UPDATECATEGORY',
  Updateconfig = 'UPDATECONFIG',
  Updateinventory = 'UPDATEINVENTORY',
  Updateinvoice = 'UPDATEINVOICE',
  Updateorder = 'UPDATEORDER',
  Updateparcel = 'UPDATEPARCEL',
  Updatepotentials = 'UPDATEPOTENTIALS',
  Updateshippinglabel = 'UPDATESHIPPINGLABEL',
  Updateshop = 'UPDATESHOP',
  Updatestockitems = 'UPDATESTOCKITEMS',
  Updatetradein = 'UPDATETRADEIN',
  Updatevoucher = 'UPDATEVOUCHER'
}

/** The storefront types that will autoinstall this connector */
export enum EnumIntegrationConnectorAutoInstallFor {
  Custom = 'custom',
  Magento = 'magento',
  Salesforce = 'salesforce',
  Shopify = 'shopify',
  Shopware = 'shopware',
  Woocommerce = 'woocommerce'
}

/** The messages supported by the connector */
export enum EnumIntegrationConnectorMessages {
  Cancelled = 'CANCELLED',
  Capture = 'CAPTURE',
  Consumeractivity = 'CONSUMERACTIVITY',
  Createorder = 'CREATEORDER',
  Createparcel = 'CREATEPARCEL',
  Createshippinglabel = 'CREATESHIPPINGLABEL',
  Createtradein = 'CREATETRADEIN',
  Delete = 'DELETE',
  Fulfill = 'FULFILL',
  Init = 'INIT',
  Optimizebysalesrank = 'OPTIMIZEBYSALESRANK',
  Periodicreport = 'PERIODICREPORT',
  Refund = 'REFUND',
  Removebg = 'REMOVEBG',
  Requestaccess = 'REQUESTACCESS',
  Requestorders = 'REQUESTORDERS',
  Requestpotentials = 'REQUESTPOTENTIALS',
  Requestproducts = 'REQUESTPRODUCTS',
  Requestvouchers = 'REQUESTVOUCHERS',
  Scheduledevent = 'SCHEDULEDEVENT',
  Sendmail = 'SENDMAIL',
  Updatebrand = 'UPDATEBRAND',
  Updatebranditem = 'UPDATEBRANDITEM',
  Updatecategory = 'UPDATECATEGORY',
  Updateconfig = 'UPDATECONFIG',
  Updateinventory = 'UPDATEINVENTORY',
  Updateinvoice = 'UPDATEINVOICE',
  Updateorder = 'UPDATEORDER',
  Updateparcel = 'UPDATEPARCEL',
  Updatepotentials = 'UPDATEPOTENTIALS',
  Updateshippinglabel = 'UPDATESHIPPINGLABEL',
  Updateshop = 'UPDATESHOP',
  Updatestockitems = 'UPDATESTOCKITEMS',
  Updatetradein = 'UPDATETRADEIN',
  Updatevoucher = 'UPDATEVOUCHER'
}

/** Which messages are optionals */
export enum EnumIntegrationConnectorOptionals {
  Cancelled = 'CANCELLED',
  Capture = 'CAPTURE',
  Consumeractivity = 'CONSUMERACTIVITY',
  Createorder = 'CREATEORDER',
  Createparcel = 'CREATEPARCEL',
  Createshippinglabel = 'CREATESHIPPINGLABEL',
  Createtradein = 'CREATETRADEIN',
  Delete = 'DELETE',
  Fulfill = 'FULFILL',
  Init = 'INIT',
  Optimizebysalesrank = 'OPTIMIZEBYSALESRANK',
  Periodicreport = 'PERIODICREPORT',
  Refund = 'REFUND',
  Removebg = 'REMOVEBG',
  Requestaccess = 'REQUESTACCESS',
  Requestorders = 'REQUESTORDERS',
  Requestpotentials = 'REQUESTPOTENTIALS',
  Requestproducts = 'REQUESTPRODUCTS',
  Requestvouchers = 'REQUESTVOUCHERS',
  Scheduledevent = 'SCHEDULEDEVENT',
  Sendmail = 'SENDMAIL',
  Updatebrand = 'UPDATEBRAND',
  Updatebranditem = 'UPDATEBRANDITEM',
  Updatecategory = 'UPDATECATEGORY',
  Updateconfig = 'UPDATECONFIG',
  Updateinventory = 'UPDATEINVENTORY',
  Updateinvoice = 'UPDATEINVOICE',
  Updateorder = 'UPDATEORDER',
  Updateparcel = 'UPDATEPARCEL',
  Updatepotentials = 'UPDATEPOTENTIALS',
  Updateshippinglabel = 'UPDATESHIPPINGLABEL',
  Updateshop = 'UPDATESHOP',
  Updatestockitems = 'UPDATESTOCKITEMS',
  Updatetradein = 'UPDATETRADEIN',
  Updatevoucher = 'UPDATEVOUCHER'
}

export enum EnumIntegrationConnectorRefType {
  Brandhouse = 'BRANDHOUSE',
  Logisticspartner = 'LOGISTICSPARTNER',
  Shop = 'SHOP'
}

/** What type this connector is referenced to */
export enum EnumIntegrationConnectorRefTypes {
  Brandhouse = 'BRANDHOUSE',
  Logisticspartner = 'LOGISTICSPARTNER',
  Shop = 'SHOP'
}

/** The type of connector */
export enum EnumIntegrationConnectorType {
  Eventbus = 'EVENTBUS',
  Webhook = 'WEBHOOK'
}

/** The mode of the instance */
export enum EnumIntegrationInstanceMode {
  Development = 'development',
  Production = 'production',
  Test = 'test'
}

/** What type this connector is referenced to */
export enum EnumIntegrationInstanceRefType {
  Brandhouse = 'BRANDHOUSE',
  Logisticspartner = 'LOGISTICSPARTNER',
  Shop = 'SHOP'
}

/** The message type */
export enum EnumIntegrationMessageMessage {
  Cancelled = 'CANCELLED',
  Capture = 'CAPTURE',
  Consumeractivity = 'CONSUMERACTIVITY',
  Createorder = 'CREATEORDER',
  Createparcel = 'CREATEPARCEL',
  Createshippinglabel = 'CREATESHIPPINGLABEL',
  Createtradein = 'CREATETRADEIN',
  Delete = 'DELETE',
  Fulfill = 'FULFILL',
  Init = 'INIT',
  Optimizebysalesrank = 'OPTIMIZEBYSALESRANK',
  Periodicreport = 'PERIODICREPORT',
  Refund = 'REFUND',
  Removebg = 'REMOVEBG',
  Requestaccess = 'REQUESTACCESS',
  Requestorders = 'REQUESTORDERS',
  Requestpotentials = 'REQUESTPOTENTIALS',
  Requestproducts = 'REQUESTPRODUCTS',
  Requestvouchers = 'REQUESTVOUCHERS',
  Scheduledevent = 'SCHEDULEDEVENT',
  Sendmail = 'SENDMAIL',
  Updatebrand = 'UPDATEBRAND',
  Updatebranditem = 'UPDATEBRANDITEM',
  Updatecategory = 'UPDATECATEGORY',
  Updateconfig = 'UPDATECONFIG',
  Updateinventory = 'UPDATEINVENTORY',
  Updateinvoice = 'UPDATEINVOICE',
  Updateorder = 'UPDATEORDER',
  Updateparcel = 'UPDATEPARCEL',
  Updatepotentials = 'UPDATEPOTENTIALS',
  Updateshippinglabel = 'UPDATESHIPPINGLABEL',
  Updateshop = 'UPDATESHOP',
  Updatestockitems = 'UPDATESTOCKITEMS',
  Updatetradein = 'UPDATETRADEIN',
  Updatevoucher = 'UPDATEVOUCHER'
}

export enum EnumInvoiceLineLineType {
  Adjustment = 'adjustment',
  Item = 'item',
  OrderCommission = 'order_commission',
  OrderPickpack = 'order_pickpack',
  OrderReturn = 'order_return',
  PlatformFee = 'platform_fee',
  ShippingOrder = 'shipping_order',
  ShippingReturn = 'shipping_return',
  ShippingTradein = 'shipping_tradein'
}

export enum EnumItemIssueLocation {
  Back = 'BACK',
  Front = 'FRONT',
  Inside = 'INSIDE'
}

/** Type of the value, required */
export enum EnumMetaFieldInstanceType {
  ArrayOfString = 'ArrayOfString',
  Json = 'Json',
  LocaleString = 'LocaleString',
  Number = 'Number',
  Text = 'Text'
}

/** Type of the value, required */
export enum EnumMetaFieldType {
  ArrayOfString = 'ArrayOfString',
  Json = 'Json',
  LocaleString = 'LocaleString',
  Number = 'Number',
  Text = 'Text'
}

/** The type of the ref id */
export enum EnumOptionSetRefType {
  Brandhouse = 'BRANDHOUSE',
  Logisticspartner = 'LOGISTICSPARTNER',
  Shippingcarrier = 'SHIPPINGCARRIER',
  Shop = 'SHOP'
}

export enum EnumOptionSetTarget {
  Cancelcode = 'CANCELCODE',
  Dropoff = 'DROPOFF',
  Issuecode = 'ISSUECODE',
  Item = 'ITEM',
  ItemColor = 'ITEM_COLOR',
  Returncode = 'RETURNCODE',
  Vendor = 'VENDOR'
}

/** The value type of the option set */
export enum EnumOptionSetValueType {
  Select = 'SELECT',
  Text = 'TEXT'
}

/** Selected carrier for this package */
export enum EnumOrder2CarrierInputCarrier {
  B2C = 'B2C',
  Dao = 'DAO',
  Dhl = 'DHL',
  Dpost = 'DPOST',
  Gls = 'GLS',
  Pno = 'PNO',
  Ups = 'UPS'
}

/** Selected delivery service for this package */
export enum EnumOrder2CarrierInputDelivery {
  Business = 'BUSINESS',
  Clickcollect = 'CLICKCOLLECT',
  Home = 'HOME',
  Shop = 'SHOP'
}

export enum EnumOrder2FulState {
  Fulfilled = 'FULFILLED',
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD',
  Open = 'OPEN',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  PendingFulfillment = 'PENDING_FULFILLMENT',
  Scheduled = 'SCHEDULED',
  Unfulfilled = 'UNFULFILLED'
}

export enum EnumOrder2OrderState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Open = 'OPEN',
  Partial = 'PARTIAL'
}

export enum EnumOrder2PayState {
  Other = 'OTHER',
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export enum EnumOrder2ReturnInfoCarrier {
  B2cEurope = 'b2c_europe',
  Dao = 'dao',
  DeutschePost = 'deutsche_post',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Gls = 'gls',
  Parcelplus = 'parcelplus',
  Pdk = 'pdk',
  Ups = 'ups'
}

export enum EnumOrder2TrackingInfoCarrier {
  B2cEurope = 'b2c_europe',
  Dao = 'dao',
  DeutschePost = 'deutsche_post',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Gls = 'gls',
  Parcelplus = 'parcelplus',
  Pdk = 'pdk',
  Ups = 'ups'
}

export enum EnumOrder2TrackingOrderState {
  Error = 'ERROR',
  Notsent = 'NOTSENT',
  PickupAvailable = 'PICKUP_AVAILABLE',
  Received = 'RECEIVED',
  Transit = 'TRANSIT'
}

export enum EnumOrder2TrackingReturnState {
  Error = 'ERROR',
  Notsent = 'NOTSENT',
  PickupAvailable = 'PICKUP_AVAILABLE',
  Received = 'RECEIVED',
  Transit = 'TRANSIT'
}

export enum EnumParcelItemsRefType {
  Branditem = 'BRANDITEM',
  Parcel = 'PARCEL',
  Return = 'RETURN',
  Stockitem = 'STOCKITEM',
  Tradein = 'TRADEIN'
}

export enum EnumPotentialCancelledReason {
  ItemCancelled = 'ItemCancelled',
  ItemExcluded = 'ItemExcluded',
  ItemRefunded = 'ItemRefunded',
  Null = 'NULL'
}

/** If the owner of this potential was contacting with trade-in offers for this */
export enum EnumPotentialNotified {
  Countryinvalid = 'COUNTRYINVALID',
  Notallowed = 'NOTALLOWED',
  Notsent = 'NOTSENT',
  Sent = 'SENT'
}

/** The source of the potential, e.g. order, wholesale */
export enum EnumPotentialSourceType {
  Digitalpass = 'DIGITALPASS',
  Online = 'ONLINE',
  Reciept = 'RECIEPT',
  Search = 'SEARCH',
  Wholesale = 'WHOLESALE'
}

/** When this trade-in value is activated */
export enum EnumPotentialValueActivation {
  Handin = 'HANDIN',
  Instant = 'INSTANT',
  Received = 'RECEIVED'
}

/** If the owner of this potential was contacting with trade-in offers for this */
export enum EnumPotentialValuePotentialNotified {
  Countryinvalid = 'COUNTRYINVALID',
  Notallowed = 'NOTALLOWED',
  Notsent = 'NOTSENT',
  Sent = 'SENT'
}

export enum EnumProductImagePerspective {
  Back = 'BACK',
  Detail = 'DETAIL',
  Front = 'FRONT',
  Other = 'OTHER'
}

export enum EnumProductImageType {
  Focus = 'FOCUS',
  Model = 'MODEL',
  Other = 'OTHER',
  Pack = 'PACK'
}

/** The referenced object type */
export enum EnumScheduledEventRefType {
  Brandhouse = 'BRANDHOUSE',
  Logisticspartner = 'LOGISTICSPARTNER',
  Shop = 'SHOP'
}

export enum EnumShippingCarrierCarrier {
  B2C = 'B2C',
  Dao = 'DAO',
  Dhl = 'DHL',
  Dpost = 'DPOST',
  Gls = 'GLS',
  Pno = 'PNO',
  Ups = 'UPS'
}

/** The carrier used for the Carrier Gateway API input */
export enum EnumShippingCarrierCarrierGatewayInputCarrier {
  DhlExpress = 'DHL_EXPRESS',
  Gls = 'GLS'
}

/** The carrier that will be used to output the shipment */
export enum EnumShippingCarrierCarrierGatewayOutputCarrier {
  B2cEurope = 'b2c_europe',
  Dao = 'dao',
  DeutschePost = 'deutsche_post',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Gls = 'gls',
  Parcelplus = 'parcelplus',
  Pdk = 'pdk',
  Ups = 'ups'
}

export enum EnumShippingCarrierTypeName {
  Package = 'PACKAGE',
  Return = 'RETURN'
}

export enum EnumShippingLabelDeliveryStatus {
  Delivered = 'DELIVERED',
  Progressing = 'PROGRESSING',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING',
  Warning = 'WARNING'
}

export enum EnumShopFrontendType {
  Custom = 'custom',
  Magento = 'magento',
  Salesforce = 'salesforce',
  Shopify = 'shopify',
  Shopware = 'shopware',
  Woocommerce = 'woocommerce'
}

/** The severity of the status message */
export enum EnumStatusType {
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warn = 'WARN'
}

export enum EnumStockItemImagePerspective {
  Back = 'BACK',
  Detail = 'DETAIL',
  Front = 'FRONT',
  Other = 'OTHER'
}

export enum EnumStockItemImageType {
  Focus = 'FOCUS',
  Model = 'MODEL',
  Other = 'OTHER',
  Pack = 'PACK'
}

/** The type of source this stockitem is from */
export enum EnumStockItemSourceType {
  Claim = 'CLAIM',
  Newitem = 'NEWITEM',
  Sample = 'SAMPLE',
  Secondhand = 'SECONDHAND'
}

/** The target audience (SYSADM, ADMIN, BRAND) */
export enum EnumSystemMessageAudience {
  Admin = 'ADMIN',
  Brand = 'BRAND',
  Sysadm = 'SYSADM'
}

/** The type of message (CRITICAL, WARNING, INFORMATION) */
export enum EnumSystemMessageMessageType {
  Critical = 'CRITICAL',
  Information = 'INFORMATION',
  Warning = 'WARNING'
}

export enum EnumTradeInActivationStrategy {
  Handin = 'HANDIN',
  Instant = 'INSTANT',
  Received = 'RECEIVED'
}

/** The reason for rejecting the tradein item */
export enum EnumTradeInItemRejected {
  Itembadcondition = 'ITEMBADCONDITION',
  Itemmissingcarelabel = 'ITEMMISSINGCARELABEL',
  Itemnotinpackage = 'ITEMNOTINPACKAGE',
  Itempartofset = 'ITEMPARTOFSET',
  Itemwrongbrand = 'ITEMWRONGBRAND',
  Nosizeonitem = 'NOSIZEONITEM',
  Other = 'OTHER'
}

/** The source of the item, e.g. ONLINE, WHOLESALE, RECIEPT, SEARCH, DIGITALPASS */
export enum EnumTradeInItemSourceType {
  Digitalpass = 'DIGITALPASS',
  Online = 'ONLINE',
  Reciept = 'RECIEPT',
  Search = 'SEARCH',
  Wholesale = 'WHOLESALE'
}

/** The payout type */
export enum EnumTradeInPayoutType {
  Payout = 'PAYOUT',
  Voucher = 'VOUCHER'
}

/** The source of the tradein */
export enum EnumTradeInSource {
  Online = 'ONLINE',
  Store = 'STORE'
}

/** The type of refund */
export enum EnumVoucherUsageRefundRefundType {
  Giftcard = 'giftcard',
  Item = 'item',
  Refund = 'refund',
  Shipping = 'shipping'
}

export enum EnumVoucherVoucherStrategy {
  Handin = 'HANDIN',
  Instant = 'INSTANT',
  Received = 'RECEIVED'
}

export enum EnumWholeSaleCategoryRulesExpressionsExpressionType {
  Col = 'COL',
  Sku = 'SKU',
  Tag = 'TAG'
}

export enum EnumWholeSaleCategoryRulesExpressionsOperator {
  Excluding = 'EXCLUDING',
  Including = 'INCLUDING'
}

export enum EnumWholeSaleCategoryVoucherStrategy {
  Handin = 'HANDIN',
  Instant = 'INSTANT',
  Received = 'RECEIVED'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']>;
};

export type ExternOrder = {
  __typename?: 'ExternOrder';
  _createdAt?: Maybe<Scalars['Date']>;
  _id: Scalars['MongoID'];
  _updatedAt?: Maybe<Scalars['Date']>;
  acceptsMarketing?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  currencyCode?: Maybe<Scalars['String']>;
  customer?: Maybe<ExternOrderCustomer>;
  externOrderId?: Maybe<Scalars['String']>;
  lineItems?: Maybe<Array<Maybe<ExternOrderLineItems>>>;
  name?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<ExternOrderShippingAddress>;
  shopId: Scalars['MongoID'];
  totalDiscountSet?: Maybe<ExternOrderTotalPriceSet>;
  totalPriceSet?: Maybe<ExternOrderTotalPriceSet>;
  totalShippingPriceSet?: Maybe<ExternOrderTotalPriceSet>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** Create2STAY Voucher linked to this order */
  voucherUsage?: Maybe<VoucherUsage>;
};

export type ExternOrder2 = {
  __typename?: 'ExternOrder2';
  _createdAt?: Maybe<Scalars['Date']>;
  _id: Scalars['MongoID'];
  _updatedAt?: Maybe<Scalars['Date']>;
  acceptsMarketing?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The currency for this order, all values will be in this currency */
  currencyCode: Scalars['String'];
  customer?: Maybe<ExternOrder2Customer>;
  /** The external id of this order, must be unique */
  externOrderId: Scalars['String'];
  lineItems?: Maybe<Array<Maybe<ExternOrder2LineItems>>>;
  /** The external order name */
  name?: Maybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  /** Create2STAY Voucher linked to this order */
  voucherUsage?: Maybe<VoucherUsage>;
};

export type ExternOrder2Customer = {
  __typename?: 'ExternOrder2Customer';
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  externCustomerId?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ExternOrder2CustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  externCustomerId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ExternOrder2LineItems = {
  __typename?: 'ExternOrder2LineItems';
  /** Current items bought, refunded/returned items deducted */
  currentQuantity?: Maybe<Scalars['Float']>;
  /** The discounted price including tax */
  discountedPrice: Scalars['Float'];
  /** The discounted price excluding tax */
  discountedPricePreTax: Scalars['Float'];
  ean?: Maybe<Scalars['String']>;
  /** The primary identifier for the lineitem, must be supplied and be unique */
  externLineId: Scalars['String'];
  externProductId?: Maybe<Scalars['String']>;
  externVariantId?: Maybe<Scalars['String']>;
  /** Number of items bought */
  quantity: Scalars['Float'];
  /** The original price including tax */
  salesPrice: Scalars['Float'];
  sku?: Maybe<Scalars['String']>;
};

export type ExternOrder2LineItemsInput = {
  /** Current items bought, refunded/returned items deducted */
  currentQuantity?: InputMaybe<Scalars['Float']>;
  /** The discounted price including tax */
  discountedPrice: Scalars['Float'];
  /** The discounted price excluding tax */
  discountedPricePreTax: Scalars['Float'];
  ean?: InputMaybe<Scalars['String']>;
  /** The primary identifier for the lineitem, must be supplied and be unique */
  externLineId: Scalars['String'];
  externProductId?: InputMaybe<Scalars['String']>;
  externVariantId?: InputMaybe<Scalars['String']>;
  /** Number of items bought */
  quantity: Scalars['Float'];
  /** The original price including tax */
  salesPrice: Scalars['Float'];
  sku?: InputMaybe<Scalars['String']>;
};

export type ExternOrder2SynchronizeInput = {
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  cancelledAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The currency for this order, all values will be in this currency */
  currencyCode: Scalars['String'];
  customer?: InputMaybe<ExternOrder2CustomerInput>;
  /** The external id of this order, must be unique */
  externOrderId: Scalars['String'];
  lineItems?: InputMaybe<Array<InputMaybe<ExternOrder2LineItemsInput>>>;
  /** The external order name */
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type ExternOrderCustomer = {
  __typename?: 'ExternOrderCustomer';
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  externCustomerId?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ExternOrderCustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  externCustomerId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type ExternOrderLineItems = {
  __typename?: 'ExternOrderLineItems';
  discountedTotalSet?: Maybe<ExternOrderTotalPriceSet>;
  externLineItemId?: Maybe<Scalars['String']>;
  externProductId?: Maybe<Scalars['String']>;
  externVariantId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originalTotalSet?: Maybe<ExternOrderTotalPriceSet>;
  quantity?: Maybe<Scalars['Float']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ExternOrderLineItemsInput = {
  discountedTotalSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  externLineItemId?: InputMaybe<Scalars['String']>;
  externProductId?: InputMaybe<Scalars['String']>;
  externVariantId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  originalTotalSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  quantity?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ExternOrderShippingAddress = {
  __typename?: 'ExternOrderShippingAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ExternOrderShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ExternOrderSynchronizeInput = {
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  cancelledAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<ExternOrderCustomerInput>;
  externOrderId?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<ExternOrderLineItemsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<ExternOrderShippingAddressInput>;
  totalDiscountSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  totalPriceSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  totalShippingPriceSet?: InputMaybe<ExternOrderTotalPriceSetInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type ExternOrderTotalPriceSet = {
  __typename?: 'ExternOrderTotalPriceSet';
  amount?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
};

export type ExternOrderTotalPriceSetInput = {
  amount?: InputMaybe<Scalars['Float']>;
  currencyCode?: InputMaybe<Scalars['String']>;
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  /** The fully qualified URL */
  url?: Maybe<Scalars['String']>;
};

export type FilterCountIntegrationConnectorActiveForOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountIntegrationConnectorEventbusInput = {
  development?: InputMaybe<FilterCountIntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<FilterCountIntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<FilterCountIntegrationConnectorEventbusProductionInput>;
};

export type FilterCountIntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type FilterCountIntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<Scalars['String']>;
  /** The field */
  field?: InputMaybe<Scalars['String']>;
  /** Namespace grouping of multiple fields */
  namespace?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<FilterCountIntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type?: InputMaybe<Scalars['String']>;
};

export type FilterCountIntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label?: InputMaybe<Scalars['String']>;
  /** The value when the option is selected */
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterCountIntegrationConnectorInput = {
  AND?: InputMaybe<Array<FilterCountIntegrationConnectorInput>>;
  OR?: InputMaybe<Array<FilterCountIntegrationConnectorInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIntegrationConnectorOperatorsInput>;
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventbus?: InputMaybe<FilterCountIntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<FilterCountIntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name?: InputMaybe<Scalars['String']>;
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type?: InputMaybe<EnumIntegrationConnectorType>;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<FilterCountObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<FilterCountIntegrationConnectorWebhookInput>;
};

export type FilterCountIntegrationConnectorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIntegrationConnectorOperatorsInput = {
  _id?: InputMaybe<FilterCountIntegrationConnector_IdOperatorsInput>;
  activeFor?: InputMaybe<FilterCountIntegrationConnectorActiveForOperatorsInput>;
  name?: InputMaybe<FilterCountIntegrationConnectorNameOperatorsInput>;
  refTypes?: InputMaybe<FilterCountIntegrationConnectorRefTypesOperatorsInput>;
};

export type FilterCountIntegrationConnectorRefTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  gte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  lt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  lte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  ne?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
};

export type FilterCountIntegrationConnectorWebhookInput = {
  development?: InputMaybe<FilterCountIntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<FilterCountIntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<FilterCountIntegrationConnectorWebhookProductionInput>;
};

export type FilterCountIntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type FilterCountIntegrationConnector_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2BrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountOrder2CarrierInfoInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  carrierIdentifier?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2CarrierInputInput = {
  /** Selected carrier for this package */
  carrier?: InputMaybe<EnumOrder2CarrierInputCarrier>;
  /** Selected delivery service for this package */
  delivery?: InputMaybe<EnumOrder2CarrierInputDelivery>;
  /** Express delivery */
  express?: InputMaybe<Scalars['Boolean']>;
  /** Optionally an additional service id / pickup point information for this package */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2ConsumerInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2FulStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2FulState>;
  gte?: InputMaybe<EnumOrder2FulState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2FulState>>>;
  lt?: InputMaybe<EnumOrder2FulState>;
  lte?: InputMaybe<EnumOrder2FulState>;
  ne?: InputMaybe<EnumOrder2FulState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2FulState>>>;
};

export type FilterCountOrder2Input = {
  AND?: InputMaybe<Array<FilterCountOrder2Input>>;
  OR?: InputMaybe<Array<FilterCountOrder2Input>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountOrder2OperatorsInput>;
  billingAddress?: InputMaybe<FilterCountOrder2ShippingAddressInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  captureFailedTs?: InputMaybe<Scalars['Date']>;
  captureNotified?: InputMaybe<Scalars['Boolean']>;
  captureRequests?: InputMaybe<Scalars['Float']>;
  /** The total amount to be captured for this order */
  captureTotal?: InputMaybe<Scalars['Float']>;
  carrierInfo?: InputMaybe<FilterCountOrder2CarrierInfoInput>;
  carrierInput?: InputMaybe<FilterCountOrder2CarrierInputInput>;
  /** Comment for the order */
  comment?: InputMaybe<Scalars['String']>;
  consumer?: InputMaybe<FilterCountOrder2ConsumerInput>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Currency for this order */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: InputMaybe<Scalars['Boolean']>;
  exportedToWMS?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  fulState?: InputMaybe<EnumOrder2FulState>;
  /** Whether this is a new order */
  isNewOrder?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['String']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  notifiedConsumer?: InputMaybe<Scalars['Boolean']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderName?: InputMaybe<Scalars['String']>;
  orderState?: InputMaybe<EnumOrder2OrderState>;
  orderUrl?: InputMaybe<Scalars['String']>;
  payState?: InputMaybe<EnumOrder2PayState>;
  /** True if the order is a proforma order */
  proforma?: InputMaybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: InputMaybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: InputMaybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: InputMaybe<Scalars['Boolean']>;
  refundAdjusted?: InputMaybe<Scalars['Boolean']>;
  /** The returnDeadline for an order is typically determined by the settings, but its possible to set the returnDeadline to override that */
  returnDeadline?: InputMaybe<Scalars['Date']>;
  returnInfo?: InputMaybe<FilterCountOrder2ReturnInfoInput>;
  returnShippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shippingAddress?: InputMaybe<FilterCountOrder2ShippingAddressInput>;
  shippingAddressInternal?: InputMaybe<FilterCountOrder2ShippingAddressInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: InputMaybe<Scalars['Boolean']>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  trackingInfo?: InputMaybe<FilterCountOrder2TrackingInfoInput>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderId?: InputMaybe<Scalars['Float']>;
  trackingOrderState?: InputMaybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: InputMaybe<EnumOrder2TrackingReturnState>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterCountObjectPatchesUpdatedByInput>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountOrder2OperatorsInput = {
  _id?: InputMaybe<FilterCountOrder2_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterCountOrder2BrandHouseIdOperatorsInput>;
  fulState?: InputMaybe<FilterCountOrder2FulStateOperatorsInput>;
  orderDate?: InputMaybe<FilterCountOrder2OrderDateOperatorsInput>;
  orderName?: InputMaybe<FilterCountOrder2OrderNameOperatorsInput>;
  orderState?: InputMaybe<FilterCountOrder2OrderStateOperatorsInput>;
  payState?: InputMaybe<FilterCountOrder2PayStateOperatorsInput>;
  proforma?: InputMaybe<FilterCountOrder2ProformaOperatorsInput>;
  shopId?: InputMaybe<FilterCountOrder2ShopIdOperatorsInput>;
  silenced?: InputMaybe<FilterCountOrder2SilencedOperatorsInput>;
  splitOrder?: InputMaybe<FilterCountOrder2SplitOrderOperatorsInput>;
  trackingOrderState?: InputMaybe<FilterCountOrder2TrackingOrderStateOperatorsInput>;
  trackingReturnState?: InputMaybe<FilterCountOrder2TrackingReturnStateOperatorsInput>;
  updatedLineTs?: InputMaybe<FilterCountOrder2UpdatedLineTsOperatorsInput>;
};

export type FilterCountOrder2OrderDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountOrder2OrderNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOrder2OrderStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2OrderState>;
  gte?: InputMaybe<EnumOrder2OrderState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2OrderState>>>;
  lt?: InputMaybe<EnumOrder2OrderState>;
  lte?: InputMaybe<EnumOrder2OrderState>;
  ne?: InputMaybe<EnumOrder2OrderState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2OrderState>>>;
};

export type FilterCountOrder2PayStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2PayState>;
  gte?: InputMaybe<EnumOrder2PayState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2PayState>>>;
  lt?: InputMaybe<EnumOrder2PayState>;
  lte?: InputMaybe<EnumOrder2PayState>;
  ne?: InputMaybe<EnumOrder2PayState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2PayState>>>;
};

export type FilterCountOrder2ProformaOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountOrder2ReturnInfoInput = {
  carrier?: InputMaybe<EnumOrder2ReturnInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2ShippingAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2ShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountOrder2SilencedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountOrder2SplitOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterCountOrder2TrackingInfoInput = {
  carrier?: InputMaybe<EnumOrder2TrackingInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrder2TrackingOrderStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2TrackingOrderState>;
  gte?: InputMaybe<EnumOrder2TrackingOrderState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingOrderState>>>;
  lt?: InputMaybe<EnumOrder2TrackingOrderState>;
  lte?: InputMaybe<EnumOrder2TrackingOrderState>;
  ne?: InputMaybe<EnumOrder2TrackingOrderState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingOrderState>>>;
};

export type FilterCountOrder2TrackingReturnStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2TrackingReturnState>;
  gte?: InputMaybe<EnumOrder2TrackingReturnState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingReturnState>>>;
  lt?: InputMaybe<EnumOrder2TrackingReturnState>;
  lte?: InputMaybe<EnumOrder2TrackingReturnState>;
  ne?: InputMaybe<EnumOrder2TrackingReturnState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingReturnState>>>;
};

export type FilterCountOrder2UpdatedLineTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountOrder2_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountPricingInput = {
  /** The ISO currency code */
  currency: Scalars['String'];
  /** The pricing value */
  value: Scalars['Float'];
};

export type FilterCountStockItemColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountStockItemEanOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemInput = {
  AND?: InputMaybe<Array<FilterCountStockItemInput>>;
  OR?: InputMaybe<Array<FilterCountStockItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountStockItemOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  beforePrice?: InputMaybe<Scalars['Float']>;
  beforePrices?: InputMaybe<Array<InputMaybe<FilterCountPricingInput>>>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: InputMaybe<Scalars['Date']>;
  color?: InputMaybe<Scalars['String']>;
  colorLocalized?: InputMaybe<Array<InputMaybe<FilterCountLocalizationEntryInput>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: InputMaybe<Scalars['Float']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterCountLocalizationEntryInput>>>;
  draft?: InputMaybe<Scalars['Boolean']>;
  ean?: InputMaybe<Scalars['String']>;
  ecommerceId?: InputMaybe<Scalars['String']>;
  externId?: InputMaybe<Scalars['String']>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  hasProblems?: InputMaybe<Scalars['Boolean']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isSold?: InputMaybe<Scalars['Boolean']>;
  itemNr?: InputMaybe<Scalars['Float']>;
  itemSku?: InputMaybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  originalEan?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<FilterCountStockItemProblemsInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  review?: InputMaybe<Scalars['Boolean']>;
  reviewed?: InputMaybe<Scalars['Date']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  sellingPrices?: InputMaybe<Array<InputMaybe<FilterCountPricingInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Scalars['String']>;
  /** The type of source this stockitem is from */
  sourceType?: InputMaybe<EnumStockItemSourceType>;
  stockLocation?: InputMaybe<Scalars['String']>;
  stockLocationBag?: InputMaybe<Scalars['String']>;
  stockLocationTs?: InputMaybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleLocalized?: InputMaybe<Array<InputMaybe<FilterCountLocalizationEntryInput>>>;
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterCountObjectPatchesUpdatedByInput>;
  vendor?: InputMaybe<Scalars['String']>;
};

export type FilterCountStockItemItemNrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountStockItemItemSkuOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemMissingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountStockItemOperatorsInput = {
  _id?: InputMaybe<FilterCountStockItem_IdOperatorsInput>;
  color?: InputMaybe<FilterCountStockItemColorOperatorsInput>;
  createdAt?: InputMaybe<FilterCountStockItemCreatedAtOperatorsInput>;
  ean?: InputMaybe<FilterCountStockItemEanOperatorsInput>;
  itemNr?: InputMaybe<FilterCountStockItemItemNrOperatorsInput>;
  itemSku?: InputMaybe<FilterCountStockItemItemSkuOperatorsInput>;
  missing?: InputMaybe<FilterCountStockItemMissingOperatorsInput>;
  originalEan?: InputMaybe<FilterCountStockItemOriginalEanOperatorsInput>;
  reviewed?: InputMaybe<FilterCountStockItemReviewedOperatorsInput>;
  size?: InputMaybe<FilterCountStockItemSizeOperatorsInput>;
  sourceType?: InputMaybe<FilterCountStockItemSourceTypeOperatorsInput>;
  stockLocation?: InputMaybe<FilterCountStockItemStockLocationOperatorsInput>;
  stockLocationTs?: InputMaybe<FilterCountStockItemStockLocationTsOperatorsInput>;
  title?: InputMaybe<FilterCountStockItemTitleOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountStockItemUpdatedAtOperatorsInput>;
};

export type FilterCountStockItemOriginalEanOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemProblemsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountStockItemReviewedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountStockItemSizeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumStockItemSourceType>;
  gte?: InputMaybe<EnumStockItemSourceType>;
  in?: InputMaybe<Array<InputMaybe<EnumStockItemSourceType>>>;
  lt?: InputMaybe<EnumStockItemSourceType>;
  lte?: InputMaybe<EnumStockItemSourceType>;
  ne?: InputMaybe<EnumStockItemSourceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumStockItemSourceType>>>;
};

export type FilterCountStockItemStockLocationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemStockLocationTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountStockItemTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountStockItemUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountStockItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyAddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBrandHouseDeactivatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandHouseInitialsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandHouseInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandHouseInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandHouseInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandHouseOperatorsInput>;
  address?: InputMaybe<FilterFindManyAddressInfoInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiSecret?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Brandhouse has been deactivated */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  initials?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<Scalars['String']>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  /** When true, all configuration changes require an audit note with explanation */
  requireChangeExplanation?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

export type FilterFindManyBrandHouseNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandHouseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandHouse_IdOperatorsInput>;
  deactivated?: InputMaybe<FilterFindManyBrandHouseDeactivatedOperatorsInput>;
  initials?: InputMaybe<FilterFindManyBrandHouseInitialsOperatorsInput>;
  name?: InputMaybe<FilterFindManyBrandHouseNameOperatorsInput>;
};

export type FilterFindManyBrandHouse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemAttributesApparentFabricTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  gte?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesApparentFabricType>>>;
  lt?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  lte?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  ne?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesApparentFabricType>>>;
};

export type FilterFindManyBrandItemAttributesFormalityLevelOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  gte?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesFormalityLevel>>>;
  lt?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  lte?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  ne?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesFormalityLevel>>>;
};

export type FilterFindManyBrandItemAttributesInput = {
  apparentFabricType?: InputMaybe<EnumBrandItemAttributesApparentFabricType>;
  confidence?: InputMaybe<Scalars['Float']>;
  dataProblem?: InputMaybe<Scalars['String']>;
  dateScanned?: InputMaybe<Scalars['Date']>;
  formalityLevel?: InputMaybe<EnumBrandItemAttributesFormalityLevel>;
  graphicKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  neckline?: InputMaybe<EnumBrandItemAttributesNeckline>;
  notableFeatures?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesNotableFeatures>>>;
  pattern?: InputMaybe<EnumBrandItemAttributesPattern>;
  primaryColor?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  seasonSuitability?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSeasonSuitability>>>;
  secondaryColors?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSecondaryColors>>>;
  size?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<EnumBrandItemAttributesSubType>;
  textureAppearance?: InputMaybe<EnumBrandItemAttributesTextureAppearance>;
  type?: InputMaybe<EnumBrandItemAttributesType>;
};

export type FilterFindManyBrandItemAttributesOperatorsInput = {
  apparentFabricType?: InputMaybe<FilterFindManyBrandItemAttributesApparentFabricTypeOperatorsInput>;
  formalityLevel?: InputMaybe<FilterFindManyBrandItemAttributesFormalityLevelOperatorsInput>;
  pattern?: InputMaybe<FilterFindManyBrandItemAttributesPatternOperatorsInput>;
  primaryColor?: InputMaybe<FilterFindManyBrandItemAttributesPrimaryColorOperatorsInput>;
  seasonSuitability?: InputMaybe<FilterFindManyBrandItemAttributesSeasonSuitabilityOperatorsInput>;
  type?: InputMaybe<FilterFindManyBrandItemAttributesTypeOperatorsInput>;
};

export type FilterFindManyBrandItemAttributesPatternOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesPattern>;
  gte?: InputMaybe<EnumBrandItemAttributesPattern>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesPattern>>>;
  lt?: InputMaybe<EnumBrandItemAttributesPattern>;
  lte?: InputMaybe<EnumBrandItemAttributesPattern>;
  ne?: InputMaybe<EnumBrandItemAttributesPattern>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesPattern>>>;
};

export type FilterFindManyBrandItemAttributesPrimaryColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  gte?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesPrimaryColor>>>;
  lt?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  lte?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  ne?: InputMaybe<EnumBrandItemAttributesPrimaryColor>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesPrimaryColor>>>;
};

export type FilterFindManyBrandItemAttributesSeasonSuitabilityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  gte?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSeasonSuitability>>>;
  lt?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  lte?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  ne?: InputMaybe<EnumBrandItemAttributesSeasonSuitability>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesSeasonSuitability>>>;
};

export type FilterFindManyBrandItemAttributesTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemAttributesType>;
  gte?: InputMaybe<EnumBrandItemAttributesType>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesType>>>;
  lt?: InputMaybe<EnumBrandItemAttributesType>;
  lte?: InputMaybe<EnumBrandItemAttributesType>;
  ne?: InputMaybe<EnumBrandItemAttributesType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemAttributesType>>>;
};

export type FilterFindManyBrandItemBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemDaysOfflineOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBrandItemDiscardedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemFirstListedDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemHasCommentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemHasCustomImagesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemHasLocationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemHasTranslatedCommentOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandItemOperatorsInput>;
  /** Attributes of the clothing item */
  attributes?: InputMaybe<FilterFindManyBrandItemAttributesInput>;
  beforePrices?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The master data variant/size */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The master data variant */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: InputMaybe<Scalars['Date']>;
  /** Localized color of the item */
  colorLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** True if the comment has been approved */
  commentApproved?: InputMaybe<Scalars['Boolean']>;
  /** Previous owner comments for the item, localized */
  commentLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The commodityCode of this brand item */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** Condition of the item, between 1 and 3 */
  condition?: InputMaybe<Scalars['Float']>;
  /** The countryOrigin of this brand item */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Total days this item has been offline since firstListedDate */
  daysOffline?: InputMaybe<Scalars['Float']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Localized description of the item */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  directPrices?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  /** If true, the RRP list price is disabled */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** The date this item was discarded by the owner - a discarded item is not for sale */
  discarded?: InputMaybe<Scalars['Date']>;
  externalId?: InputMaybe<Scalars['String']>;
  /** The date when this item was first listed for sale (never recalculated) */
  firstListedDate?: InputMaybe<Scalars['Date']>;
  hasComment?: InputMaybe<Scalars['Boolean']>;
  hasCustomImages?: InputMaybe<Scalars['Boolean']>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  hasLocation?: InputMaybe<Scalars['Boolean']>;
  hasMasterData?: InputMaybe<Scalars['Boolean']>;
  hasProblems?: InputMaybe<Scalars['Boolean']>;
  hasTranslatedComment?: InputMaybe<Scalars['Boolean']>;
  /** 512-dimensional embedding vector for the primary image */
  imageEmbedding?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** If true, the manufacturer is invalid */
  invalidManufacturer?: InputMaybe<Scalars['Boolean']>;
  isSold?: InputMaybe<Scalars['Boolean']>;
  isTradeIn?: InputMaybe<Scalars['Boolean']>;
  /** Internal EAN number for this brand-item */
  itemEan?: InputMaybe<Scalars['String']>;
  /** Extra data about the brand item */
  itemMetas?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInstanceInput>>>;
  /** The itemNr is a unique number for each branditem in context of the brandhouse */
  itemNr?: InputMaybe<Scalars['Float']>;
  /** State of the branditem */
  itemState?: InputMaybe<EnumBrandItemItemState>;
  /** Tags for the brand item */
  itemTags?: InputMaybe<Array<InputMaybe<FilterFindManyBrandItemTagInput>>>;
  masterDataInfo?: InputMaybe<FilterFindManyBrandItemMasterDataInfoInput>;
  /** Localized MAS masterdata metafields used as the source for item metafield resolution */
  masterDataLocalizedMetafields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** MAS masterdata metafields used as the source for item metafield resolution */
  masterDataMetafields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** When MAS masterdata was last pulled into this item */
  masterDataPulledAt?: InputMaybe<Scalars['Date']>;
  masterDataSnapshot?: InputMaybe<FilterFindManyBrandItemMasterDataSnapshotInput>;
  /** The external MAS masterdata variant id */
  masterDataVariantId?: InputMaybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: InputMaybe<Scalars['Date']>;
  /** Localized name of the item */
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  note?: InputMaybe<Scalars['String']>;
  /** The options of this branditem */
  options?: InputMaybe<Array<InputMaybe<FilterFindManyOptionInstanceInput>>>;
  /** The originalEan of this brand item */
  originalEan?: InputMaybe<Scalars['String']>;
  /** The originalSku of this brand item */
  originalSku?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<FilterFindManyBrandItemProblemInput>>>;
  reviewInfos?: InputMaybe<Array<InputMaybe<FilterFindManyBrandItemReviewInfoInput>>>;
  /** Score indicating how sellable the item is (0-100) */
  salesScore?: InputMaybe<Scalars['Float']>;
  /** Timestamp when the sales score was last calculated */
  salesScoreTs?: InputMaybe<Scalars['Date']>;
  /** Localized size of the item */
  sizeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The date this item was sold */
  soldTs?: InputMaybe<Scalars['Date']>;
  /** The sortorder of this branditem */
  sortorder?: InputMaybe<Scalars['Float']>;
  /** The type of source this branditem is from */
  sourceType?: InputMaybe<EnumBrandItemSourceType>;
  stockLocation?: InputMaybe<Scalars['String']>;
  /** The barcode of the bag that the item is placed in at the stock location */
  stockLocationBag?: InputMaybe<Scalars['String']>;
  stockLocationTs?: InputMaybe<Scalars['Date']>;
  /** True if this item is a test item */
  test?: InputMaybe<Scalars['Boolean']>;
  /** Link to the tradein item, if applicable */
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  /** The product type of this brand item */
  typeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** This item is registered out of warehouse by the logisticspartner at the given date */
  unavailable?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  vasId?: InputMaybe<Scalars['String']>;
  /** Image references received from VAS for this item */
  vasImages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The current state of the VAS process for this item */
  vasState?: InputMaybe<EnumBrandItemVasState>;
  /** The VAS contract version for this item */
  vasType?: InputMaybe<EnumBrandItemVasType>;
  /** The vendor type of this brand item */
  vendor?: InputMaybe<Scalars['String']>;
  /** Total page views for this item across all shops */
  views?: InputMaybe<Scalars['Float']>;
  /** Total unique visitors for this item across all shops */
  visitors?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBrandItemInvalidManufacturerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemIsTradeInOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyBrandItemLayawayBrandItemIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemLayawayCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemLayawayInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandItemLayawayInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandItemLayawayInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandItemLayawayOperatorsInput>;
  /** Reference to the BrandItem */
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Stock location of the item */
  stockLocation?: InputMaybe<Scalars['String']>;
  /** Stock location bag of the item */
  stockLocationBag?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** Who made this location change */
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandItemLayawayOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandItemLayaway_IdOperatorsInput>;
  brandItemId?: InputMaybe<FilterFindManyBrandItemLayawayBrandItemIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyBrandItemLayawayCreatedAtOperatorsInput>;
  updatedBy?: InputMaybe<FilterFindManyBrandItemLayawayUpdatedByOperatorsInput>;
};

export type FilterFindManyBrandItemLayawayUpdatedByOperatorsInput = {
  ref?: InputMaybe<FilterFindManyBrandItemLayawayUpdatedByRefOperatorsInput>;
};

export type FilterFindManyBrandItemLayawayUpdatedByRefOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemLayaway_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandItemMasterDataInfoInput = {
  /** Color pf product */
  color?: InputMaybe<Scalars['String']>;
  /** Master data ean */
  ean?: InputMaybe<Scalars['String']>;
  /** External ID */
  externalId?: InputMaybe<Scalars['String']>;
  /** Name of product */
  name?: InputMaybe<Scalars['String']>;
  /** Size of product */
  size?: InputMaybe<Scalars['String']>;
  /** Master data sku */
  sku?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBrandItemMasterDataSnapshotInput = {
  /** Source BrandProduct at time of snapshot */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** Source BrandProductSize at time of snapshot */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** Source BrandProductVariant at time of snapshot */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** Localized product metafields at time of snapshot */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Product metafields at time of snapshot */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** Size metafields at time of snapshot */
  sizeMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** When the snapshot was taken */
  snapshotTs?: InputMaybe<Scalars['Date']>;
  /** Product tags at time of snapshot */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Variant weight at time of snapshot */
  weight?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBrandItemMissingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandItem_IdOperatorsInput>;
  attributes?: InputMaybe<FilterFindManyBrandItemAttributesOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandItemBrandHouseIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyBrandItemCreatedAtOperatorsInput>;
  daysOffline?: InputMaybe<FilterFindManyBrandItemDaysOfflineOperatorsInput>;
  discarded?: InputMaybe<FilterFindManyBrandItemDiscardedOperatorsInput>;
  firstListedDate?: InputMaybe<FilterFindManyBrandItemFirstListedDateOperatorsInput>;
  hasComment?: InputMaybe<FilterFindManyBrandItemHasCommentOperatorsInput>;
  hasCustomImages?: InputMaybe<FilterFindManyBrandItemHasCustomImagesOperatorsInput>;
  hasLocation?: InputMaybe<FilterFindManyBrandItemHasLocationOperatorsInput>;
  hasTranslatedComment?: InputMaybe<FilterFindManyBrandItemHasTranslatedCommentOperatorsInput>;
  invalidManufacturer?: InputMaybe<FilterFindManyBrandItemInvalidManufacturerOperatorsInput>;
  isTradeIn?: InputMaybe<FilterFindManyBrandItemIsTradeInOperatorsInput>;
  missing?: InputMaybe<FilterFindManyBrandItemMissingOperatorsInput>;
  salesScore?: InputMaybe<FilterFindManyBrandItemSalesScoreOperatorsInput>;
  soldTs?: InputMaybe<FilterFindManyBrandItemSoldTsOperatorsInput>;
  sourceType?: InputMaybe<FilterFindManyBrandItemSourceTypeOperatorsInput>;
  stockLocation?: InputMaybe<FilterFindManyBrandItemStockLocationOperatorsInput>;
  stockLocationBag?: InputMaybe<FilterFindManyBrandItemStockLocationBagOperatorsInput>;
  stockLocationTs?: InputMaybe<FilterFindManyBrandItemStockLocationTsOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyBrandItemUpdatedAtOperatorsInput>;
  vasId?: InputMaybe<FilterFindManyBrandItemVasIdOperatorsInput>;
  vasState?: InputMaybe<FilterFindManyBrandItemVasStateOperatorsInput>;
};

export type FilterFindManyBrandItemProblemInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyBrandItemReviewInfoInput = {
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBrandItemSalesScoreOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyBrandItemSoldTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemSourceType>;
  gte?: InputMaybe<EnumBrandItemSourceType>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemSourceType>>>;
  lt?: InputMaybe<EnumBrandItemSourceType>;
  lte?: InputMaybe<EnumBrandItemSourceType>;
  ne?: InputMaybe<EnumBrandItemSourceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemSourceType>>>;
};

export type FilterFindManyBrandItemStockLocationBagOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandItemStockLocationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandItemStockLocationTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemTagInput = {
  auto?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBrandItemUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyBrandItemVasIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandItemVasStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumBrandItemVasState>;
  gte?: InputMaybe<EnumBrandItemVasState>;
  in?: InputMaybe<Array<InputMaybe<EnumBrandItemVasState>>>;
  lt?: InputMaybe<EnumBrandItemVasState>;
  lte?: InputMaybe<EnumBrandItemVasState>;
  ne?: InputMaybe<EnumBrandItemVasState>;
  nin?: InputMaybe<Array<InputMaybe<EnumBrandItemVasState>>>;
};

export type FilterFindManyBrandItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductGroupBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductGroupOperatorsInput>;
  /** Is the group active for everything */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for potential linking */
  activePotentials?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for promoting brand items */
  activePromotions?: InputMaybe<Scalars['Boolean']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The name of the group */
  name?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProductGroup_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandProductGroupBrandHouseIdOperatorsInput>;
};

export type FilterFindManyBrandProductGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductImageInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductImageInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductImageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductImageOperatorsInput>;
  archivedImage?: InputMaybe<Scalars['Boolean']>;
  archivedThumb?: InputMaybe<Scalars['Boolean']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The product that owns this image */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The variant that owns this image */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** Colors represented by this image */
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the image */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['String']>;
  errorCount?: InputMaybe<Scalars['Float']>;
  /** An image unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  /** The storage ID of the file, will be null until the image is successfully stored */
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: InputMaybe<Scalars['String']>;
  /**
   * If the image was processed by us / background removal, then this contains the version of the processing
   * use this to determine if the background process needs to be redone
   */
  imageRemoveBgVersion?: InputMaybe<Scalars['Float']>;
  /** An optional language tag for the image */
  language?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  /** Extra data about the image, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the image */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** The storage ID of the original image file, typically the same as imageId - but if the imageId can be modified */
  originalId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the original image, used to compare images */
  originalMd5?: InputMaybe<Scalars['String']>;
  perspective?: InputMaybe<EnumBrandProductImagePerspective>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** The storage ID of the thumbnail file, will be null until the image is successfully stored */
  thumbnailId?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<EnumBrandProductImageType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductImageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProductImage_IdOperatorsInput>;
};

export type FilterFindManyBrandProductImage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductOperatorsInput>;
  /** The brand that owns this product */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** Collections associated with this product */
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the product */
  customData?: InputMaybe<Scalars['JSON']>;
  /** True if this variant has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The product description */
  description?: InputMaybe<Scalars['String']>;
  /** The product description localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** Whether to disable the RRP list price */
  disableRRPListPrice?: InputMaybe<Scalars['Boolean']>;
  /** Whether this product is disabled and shouldn't be used in the platform at all */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** A product unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  /** Extra data about the product, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the product */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** The same of the product */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the product localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** Whether this product is a preowned product */
  preOwned?: InputMaybe<Scalars['Boolean']>;
  /** Source of the brandproduct, such as imported, shopify, salesforce etc */
  source?: InputMaybe<Scalars['String']>;
  /** The style number should optimally be a joining identifier for a number of variants. Internally this number is not used for this purpose though */
  style?: InputMaybe<Scalars['String']>;
  /** Tags associated with this product */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The type of product */
  type?: InputMaybe<Scalars['String']>;
  /** The product type, a translateable field */
  typeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The latest user that updated this */
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** The vendor of this product */
  vendor?: InputMaybe<Scalars['String']>;
  /** The weight of this item in grams */
  weight?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProduct_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandProductBrandHouseIdOperatorsInput>;
  style?: InputMaybe<FilterFindManyBrandProductStyleOperatorsInput>;
};

export type FilterFindManyBrandProductSizeBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductSizeInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductSizeInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductSizeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductSizeOperatorsInput>;
  /** The brand that owns this variant */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The variant that owns this size */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** True if this product has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: InputMaybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  /** Extra data about the size, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the variant */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** The size of this variant */
  size?: InputMaybe<Scalars['String']>;
  /** The size of this variant translated into the supported languages */
  sizeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The SKU of this variant */
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductSizeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProductSize_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandProductSizeBrandHouseIdOperatorsInput>;
};

export type FilterFindManyBrandProductSize_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductStyleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandProductVariantBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProductVariantInput = {
  AND?: InputMaybe<Array<FilterFindManyBrandProductVariantInput>>;
  OR?: InputMaybe<Array<FilterFindManyBrandProductVariantInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBrandProductVariantOperatorsInput>;
  /** The brand that owns this variant */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The color of this variant */
  color?: InputMaybe<Scalars['String']>;
  /** The color of this variant translated into the supported languages */
  colorLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the product */
  customData?: InputMaybe<Scalars['JSON']>;
  /** True if this variant should not be used in the platform */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  /** True if this product has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: InputMaybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  /** 712-dimensional embedding vector for the variant's packshot image */
  imageEmbedding?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Extra data about the variant, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the variant */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  /** The RRP prices for this variant */
  rrp?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  /** The size of this variant translated into the supported languages - DEPRECATED */
  sizeLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The SKU of this variant */
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The weight of this variant in grams */
  weight?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBrandProductVariantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBrandProductVariant_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyBrandProductVariantBrandHouseIdOperatorsInput>;
  sku?: InputMaybe<FilterFindManyBrandProductVariantSkuOperatorsInput>;
};

export type FilterFindManyBrandProductVariantSkuOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBrandProductVariant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyBrandProduct_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCampaignBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCampaignInput = {
  AND?: InputMaybe<Array<FilterFindManyCampaignInput>>;
  OR?: InputMaybe<Array<FilterFindManyCampaignInput>>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCampaignOperatorsInput>;
  /** The brand house id of the campaign */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The name of the campaign */
  campaignName?: InputMaybe<Scalars['String']>;
  /** The status of the campaign */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The start date of the campaign */
  fromDate?: InputMaybe<Scalars['Date']>;
  /** The percentage discount of the campaign */
  percentage?: InputMaybe<Scalars['Float']>;
  /** The shop id of the campaign */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The end date of the campaign */
  toDate?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCampaignOperatorsInput = {
  brandHouseId?: InputMaybe<FilterFindManyCampaignBrandHouseIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyCampaignShopIdOperatorsInput>;
};

export type FilterFindManyCampaignShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPayoutInstanceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  accountNr?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  phoneNr?: InputMaybe<Scalars['String']>;
  regNr?: InputMaybe<Scalars['String']>;
  /** Optionally a tradein that was directly converted for this payout */
  tradeInId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyCircularPayoutTypeInput = {
  AND?: InputMaybe<Array<FilterFindManyCircularPayoutTypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyCircularPayoutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCircularPayoutTypeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The default payout ratio, a number between 0 and 1 */
  defaultRatio?: InputMaybe<Scalars['Float']>;
  /** The name of the payout */
  name?: InputMaybe<Scalars['String']>;
  /** The type of payout */
  payoutType?: InputMaybe<EnumCircularPayoutTypePayoutType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCircularPayoutTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCircularPayoutType_IdOperatorsInput>;
};

export type FilterFindManyCircularPayoutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPointConsumerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPointEventProcessedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyCircularPointInput = {
  AND?: InputMaybe<Array<FilterFindManyCircularPointInput>>;
  OR?: InputMaybe<Array<FilterFindManyCircularPointInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCircularPointOperatorsInput>;
  /** Whether the circularpoint point transaction has been activated for a tradein, or executed with the external service provider for a payout */
  activated?: InputMaybe<Scalars['Boolean']>;
  /** The consumer id / account id, owning the points */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Whether this has been processed by the circular points engine */
  eventProcessed?: InputMaybe<Scalars['Boolean']>;
  /** The shop */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** Optionally data from the source that is relevant to the circular point */
  sourceData?: InputMaybe<FilterFindManyCircularPointSourceDataInput>;
  /** The source of the circularpoint transaction, tradein id, conversion id, etc */
  sourceObjectId?: InputMaybe<Scalars['MongoID']>;
  /** The type of the transaction source, tradein or conversion */
  sourceType?: InputMaybe<EnumCircularPointSourceType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The change in points for this transaction. Can be a negative or positive value. */
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCircularPointOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCircularPoint_IdOperatorsInput>;
  consumerId?: InputMaybe<FilterFindManyCircularPointConsumerIdOperatorsInput>;
  eventProcessed?: InputMaybe<FilterFindManyCircularPointEventProcessedOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyCircularPointShopIdOperatorsInput>;
  sourceObjectId?: InputMaybe<FilterFindManyCircularPointSourceObjectIdOperatorsInput>;
};

export type FilterFindManyCircularPointShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPointSourceDataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  actualPayout?: InputMaybe<FilterFindManyCircularPayoutInstanceInput>;
  postPayout?: InputMaybe<FilterFindManyCircularPayoutInstanceInput>;
};

export type FilterFindManyCircularPointSourceObjectIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyCircularPoint_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConsumerBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConsumerEventEventOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyConsumerEventInput = {
  AND?: InputMaybe<Array<FilterFindManyConsumerEventInput>>;
  OR?: InputMaybe<Array<FilterFindManyConsumerEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyConsumerEventOperatorsInput>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  data?: InputMaybe<Scalars['JSON']>;
  dateTime?: InputMaybe<Scalars['Date']>;
  event?: InputMaybe<Scalars['String']>;
  exportedToKlaviyo?: InputMaybe<Scalars['Boolean']>;
  exportedToStatistics?: InputMaybe<Scalars['Boolean']>;
  maildata?: InputMaybe<FilterFindManyConsumerEventMaildataInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  subEvent?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyConsumerEventMaildataInput = {
  bounced?: InputMaybe<Scalars['Boolean']>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  delivered?: InputMaybe<Scalars['Boolean']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  messageId?: InputMaybe<Scalars['String']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  spam?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyConsumerEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyConsumerEvent_IdOperatorsInput>;
  event?: InputMaybe<FilterFindManyConsumerEventEventOperatorsInput>;
  subEvent?: InputMaybe<FilterFindManyConsumerEventSubEventOperatorsInput>;
};

export type FilterFindManyConsumerEventSubEventOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyConsumerEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConsumerInput = {
  AND?: InputMaybe<Array<FilterFindManyConsumerInput>>;
  OR?: InputMaybe<Array<FilterFindManyConsumerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyConsumerOperatorsInput>;
  /** Whether this consumer accepts marketing mails */
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  accessToken?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['String']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the consumer */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Optionally a custom id for the consumer */
  customId?: InputMaybe<Scalars['String']>;
  disableContact?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  journey?: InputMaybe<Array<InputMaybe<FilterFindManyConsumerJourneyInput>>>;
  lastLogin?: InputMaybe<Scalars['Date']>;
  lastName?: InputMaybe<Scalars['String']>;
  latestOfferMail?: InputMaybe<Scalars['Date']>;
  locale?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Whether this is a proxy account for another consumer */
  proxyAccount?: InputMaybe<Scalars['Boolean']>;
  /** Whether this consumer was created by a consumer himself or by a trusted source */
  selfCreated?: InputMaybe<Scalars['Boolean']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyConsumerJourneyInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** The date of the journey entry */
  date?: InputMaybe<Scalars['Date']>;
  /** The type of journey entry */
  entryType?: InputMaybe<EnumConsumerJourneyEntryType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyConsumerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyConsumer_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyConsumerBrandHouseIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyConsumerShopIdOperatorsInput>;
};

export type FilterFindManyConsumerShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyConsumer_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyDataViewExpiresAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyDataViewInput = {
  AND?: InputMaybe<Array<FilterFindManyDataViewInput>>;
  OR?: InputMaybe<Array<FilterFindManyDataViewInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDataViewOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rowIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  type?: InputMaybe<EnumDataViewType>;
  viewName?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDataViewOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDataView_IdOperatorsInput>;
  expiresAt?: InputMaybe<FilterFindManyDataViewExpiresAtOperatorsInput>;
  type?: InputMaybe<FilterFindManyDataViewTypeOperatorsInput>;
};

export type FilterFindManyDataViewTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDataViewType>;
  gte?: InputMaybe<EnumDataViewType>;
  in?: InputMaybe<Array<InputMaybe<EnumDataViewType>>>;
  lt?: InputMaybe<EnumDataViewType>;
  lte?: InputMaybe<EnumDataViewType>;
  ne?: InputMaybe<EnumDataViewType>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataViewType>>>;
};

export type FilterFindManyDataView_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyExternOrder2CustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  externCustomerId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyExternOrder2Input = {
  AND?: InputMaybe<Array<FilterFindManyExternOrder2Input>>;
  OR?: InputMaybe<Array<FilterFindManyExternOrder2Input>>;
  _createdAt?: InputMaybe<Scalars['Date']>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyExternOrder2OperatorsInput>;
  _updatedAt?: InputMaybe<Scalars['Date']>;
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  cancelledAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The currency for this order, all values will be in this currency */
  currencyCode?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<FilterFindManyExternOrder2CustomerInput>;
  /** The external id of this order, must be unique */
  externOrderId?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<FilterFindManyExternOrder2LineItemsInput>>>;
  /** The external order name */
  name?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyExternOrder2LineItemsInput = {
  /** Current items bought, refunded/returned items deducted */
  currentQuantity?: InputMaybe<Scalars['Float']>;
  /** The discounted price including tax */
  discountedPrice?: InputMaybe<Scalars['Float']>;
  /** The discounted price excluding tax */
  discountedPricePreTax?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  /** The primary identifier for the lineitem, must be supplied and be unique */
  externLineId?: InputMaybe<Scalars['String']>;
  externProductId?: InputMaybe<Scalars['String']>;
  externVariantId?: InputMaybe<Scalars['String']>;
  /** Number of items bought */
  quantity?: InputMaybe<Scalars['Float']>;
  /** The original price including tax */
  salesPrice?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyExternOrder2OperatorsInput = {
  _id?: InputMaybe<FilterFindManyExternOrder2_IdOperatorsInput>;
};

export type FilterFindManyExternOrder2_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyExternOrderCustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  externCustomerId?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyExternOrderInput = {
  AND?: InputMaybe<Array<FilterFindManyExternOrderInput>>;
  OR?: InputMaybe<Array<FilterFindManyExternOrderInput>>;
  _createdAt?: InputMaybe<Scalars['Date']>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyExternOrderOperatorsInput>;
  _updatedAt?: InputMaybe<Scalars['Date']>;
  acceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  cancelledAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<FilterFindManyExternOrderCustomerInput>;
  externOrderId?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<InputMaybe<FilterFindManyExternOrderLineItemsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<FilterFindManyExternOrderShippingAddressInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  totalDiscountSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  totalPriceSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  totalShippingPriceSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyExternOrderLineItemsInput = {
  discountedTotalSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  externLineItemId?: InputMaybe<Scalars['String']>;
  externProductId?: InputMaybe<Scalars['String']>;
  externVariantId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  originalTotalSet?: InputMaybe<FilterFindManyExternOrderTotalPriceSetInput>;
  quantity?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyExternOrderOperatorsInput = {
  _id?: InputMaybe<FilterFindManyExternOrder_IdOperatorsInput>;
};

export type FilterFindManyExternOrderShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyExternOrderTotalPriceSetInput = {
  amount?: InputMaybe<Scalars['Float']>;
  currencyCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyExternOrder_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationConnectorActiveForOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationConnectorEventbusInput = {
  development?: InputMaybe<FilterFindManyIntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<FilterFindManyIntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<FilterFindManyIntegrationConnectorEventbusProductionInput>;
};

export type FilterFindManyIntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type FilterFindManyIntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<Scalars['String']>;
  /** The field */
  field?: InputMaybe<Scalars['String']>;
  /** Namespace grouping of multiple fields */
  namespace?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyIntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyIntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label?: InputMaybe<Scalars['String']>;
  /** The value when the option is selected */
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyIntegrationConnectorInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationConnectorInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationConnectorInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationConnectorOperatorsInput>;
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventbus?: InputMaybe<FilterFindManyIntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<FilterFindManyIntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name?: InputMaybe<Scalars['String']>;
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type?: InputMaybe<EnumIntegrationConnectorType>;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<FilterFindManyIntegrationConnectorWebhookInput>;
};

export type FilterFindManyIntegrationConnectorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationConnectorOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationConnector_IdOperatorsInput>;
  activeFor?: InputMaybe<FilterFindManyIntegrationConnectorActiveForOperatorsInput>;
  name?: InputMaybe<FilterFindManyIntegrationConnectorNameOperatorsInput>;
  refTypes?: InputMaybe<FilterFindManyIntegrationConnectorRefTypesOperatorsInput>;
};

export type FilterFindManyIntegrationConnectorRefTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  gte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  lt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  lte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  ne?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
};

export type FilterFindManyIntegrationConnectorWebhookInput = {
  development?: InputMaybe<FilterFindManyIntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<FilterFindManyIntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<FilterFindManyIntegrationConnectorWebhookProductionInput>;
};

export type FilterFindManyIntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type FilterFindManyIntegrationConnector_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationInstanceInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationInstanceInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationInstanceInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationInstanceOperatorsInput>;
  /** The connector that was installed */
  connectorId?: InputMaybe<Scalars['MongoID']>;
  /** Whether the install has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Whether the install has been enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The mode of the instance */
  mode?: InputMaybe<EnumIntegrationInstanceMode>;
  /** The name of the instance */
  name?: InputMaybe<Scalars['String']>;
  /** The owner of the install */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** What type this connector is referenced to */
  refType?: InputMaybe<EnumIntegrationInstanceRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationInstanceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationInstance_IdOperatorsInput>;
  refId?: InputMaybe<FilterFindManyIntegrationInstanceRefIdOperatorsInput>;
};

export type FilterFindManyIntegrationInstanceRefIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationInstance_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationMessageInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationMessageOperatorsInput>;
  /** The timestamp of the message ackknowledgement, webhooks will set this instantly based on 200 OK response. Servicebus implementationw will need to send an ackknowledge event. */
  acknowledged?: InputMaybe<Scalars['Date']>;
  /** Timestamp of the message creation */
  created?: InputMaybe<Scalars['Date']>;
  /** The source environment of this message : production, development or test */
  env?: InputMaybe<Scalars['String']>;
  /** If the message was unable to be delivered, this will have contain a timestamp of when we gave up */
  failed?: InputMaybe<Scalars['Date']>;
  /** The instance identifier */
  instanceId?: InputMaybe<Scalars['MongoID']>;
  lockedId?: InputMaybe<Scalars['String']>;
  /** The message type */
  message?: InputMaybe<EnumIntegrationMessageMessage>;
  /** True if failure */
  messageFailed?: InputMaybe<Scalars['Boolean']>;
  /** True if ignored */
  messageIgnored?: InputMaybe<Scalars['Boolean']>;
  /** If this message is a retry message, then this points the the previous message that initiated the retry */
  parentId?: InputMaybe<Scalars['MongoID']>;
  /** Optionally a payload for the message */
  payload?: InputMaybe<Scalars['JSON']>;
  /** A token that can be used to read the message */
  readToken?: InputMaybe<Scalars['String']>;
  /** The referenced object this message originated from */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<Scalars['String']>;
  /** Optionally a result data blob for the message */
  result?: InputMaybe<Scalars['JSON']>;
  /** If a result data blob was stored, then this timestamp holds the timestamp for it - otherwise null */
  resultTs?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the message should be sent, this is typically used when retrying failed messages, but can be used for any message delaying */
  sendAt?: InputMaybe<Scalars['Date']>;
  /** Timestamp of when the message was last sent */
  sent?: InputMaybe<Scalars['Date']>;
  /** The number of times we have sent this message */
  sentCount?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIntegrationMessageLockedIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyIntegrationMessageMessageFailedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegrationMessage_IdOperatorsInput>;
  lockedId?: InputMaybe<FilterFindManyIntegrationMessageLockedIdOperatorsInput>;
  messageFailed?: InputMaybe<FilterFindManyIntegrationMessageMessageFailedOperatorsInput>;
  refId?: InputMaybe<FilterFindManyIntegrationMessageRefIdOperatorsInput>;
};

export type FilterFindManyIntegrationMessageRefIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyIntegrationMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceAdjustmentBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceAdjustmentCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyInvoiceAdjustmentInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceAdjustmentInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceAdjustmentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceAdjustmentOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceAdjustmentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoiceAdjustment_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyInvoiceAdjustmentBrandHouseIdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyInvoiceAdjustmentCreatedAtOperatorsInput>;
};

export type FilterFindManyInvoiceAdjustment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceLineBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceLineInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceLineInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceLineInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceLineOperatorsInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  cost?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['MongoID']>;
  /** The calculated date for this invoice line, and depends on when the invoicing is enabled for the customer */
  lineDate?: InputMaybe<Scalars['Date']>;
  lineId?: InputMaybe<Scalars['String']>;
  lineIndex?: InputMaybe<Scalars['Float']>;
  lineType?: InputMaybe<EnumInvoiceLineLineType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyInvoiceLineInvoiceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyInvoiceLineLineTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumInvoiceLineLineType>;
  gte?: InputMaybe<EnumInvoiceLineLineType>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceLineLineType>>>;
  lt?: InputMaybe<EnumInvoiceLineLineType>;
  lte?: InputMaybe<EnumInvoiceLineLineType>;
  ne?: InputMaybe<EnumInvoiceLineLineType>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceLineLineType>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceLineOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoiceLine_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyInvoiceLineBrandHouseIdOperatorsInput>;
  invoiceId?: InputMaybe<FilterFindManyInvoiceLineInvoiceIdOperatorsInput>;
  lineType?: InputMaybe<FilterFindManyInvoiceLineLineTypeOperatorsInput>;
};

export type FilterFindManyInvoiceLine_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyItemIssueInput = {
  AND?: InputMaybe<Array<FilterFindManyItemIssueInput>>;
  OR?: InputMaybe<Array<FilterFindManyItemIssueInput>>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  externId?: InputMaybe<Scalars['String']>;
  /** URL to the image of the issue */
  imageUrl?: InputMaybe<Scalars['String']>;
  issue?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<EnumItemIssueLocation>;
  /** Marker X position as percent (0-100) of image width, origin top-left */
  markX?: InputMaybe<Scalars['Float']>;
  /** Marker Y position as percent (0-100) of image height, origin top-left */
  markY?: InputMaybe<Scalars['Float']>;
  /** Coordinate of the issue, A1, B2, etc. */
  point?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLocalizedMetaFieldInstanceInput = {
  /** The language of the localized metafields */
  language?: InputMaybe<Scalars['String']>;
  /** The metafields */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
};

export type FilterFindManyLogisticsPartnerAutoretouchInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  expireTs?: InputMaybe<Scalars['Date']>;
  refreshToken?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLogisticsPartnerInput = {
  AND?: InputMaybe<Array<FilterFindManyLogisticsPartnerInput>>;
  OR?: InputMaybe<Array<FilterFindManyLogisticsPartnerInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLogisticsPartnerOperatorsInput>;
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  /** API KEY for the logisticspartner, use this to obtain an accessToken */
  apiKey?: InputMaybe<Scalars['String']>;
  /** API Secret for the logisticspartner, use this to obtain an accessToken */
  apiSecret?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  autoretouch?: InputMaybe<FilterFindManyLogisticsPartnerAutoretouchInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLogisticsPartnerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLogisticsPartner_IdOperatorsInput>;
};

export type FilterFindManyLogisticsPartner_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyMetaFieldInput = {
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type FilterFindManyMetaFieldInstanceInput = {
  /** If the metafield was auto added by configuration */
  auto?: InputMaybe<Scalars['Boolean']>;
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key?: InputMaybe<Scalars['String']>;
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldInstanceType>;
  /** The metafield value, JSON data */
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyNfcInput = {
  AND?: InputMaybe<Array<FilterFindManyNfcInput>>;
  OR?: InputMaybe<Array<FilterFindManyNfcInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNfcOperatorsInput>;
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  /** The NFC tag identifier */
  identifier?: InputMaybe<Scalars['String']>;
  stockItemId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNfcOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNfc_IdOperatorsInput>;
};

export type FilterFindManyNfc_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesAuditNoteIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesInput = {
  AND?: InputMaybe<Array<FilterFindManyObjectPatchesInput>>;
  OR?: InputMaybe<Array<FilterFindManyObjectPatchesInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyObjectPatchesOperatorsInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** If true, then the patch has been compacted */
  compacted?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['Date']>;
  ops?: InputMaybe<Array<InputMaybe<FilterFindManyObjectPatchesOpsInput>>>;
  ref?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyObjectPatchesOperatorsInput = {
  _id?: InputMaybe<FilterFindManyObjectPatches_IdOperatorsInput>;
  auditNoteId?: InputMaybe<FilterFindManyObjectPatchesAuditNoteIdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyObjectPatchesBrandHouseIdOperatorsInput>;
  ref?: InputMaybe<FilterFindManyObjectPatchesRefOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyObjectPatchesShopIdOperatorsInput>;
};

export type FilterFindManyObjectPatchesOpsInput = {
  op?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyObjectPatchesRefOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyObjectPatches_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOptionInstanceInput = {
  optionSetId?: InputMaybe<Scalars['MongoID']>;
  /** The value of the option value for the option set */
  optionValue?: InputMaybe<Scalars['String']>;
  /** The id of the option value for the option set */
  optionValueId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyOptionSetInput = {
  AND?: InputMaybe<Array<FilterFindManyOptionSetInput>>;
  OR?: InputMaybe<Array<FilterFindManyOptionSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOptionSetOperatorsInput>;
  /** If true, the option set is active */
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** If true, the option set is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the option set */
  externalId?: InputMaybe<Scalars['String']>;
  /** The key of the option set */
  key?: InputMaybe<Scalars['String']>;
  /** The id of the item that the option set is for */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The type of the ref id */
  refType?: InputMaybe<EnumOptionSetRefType>;
  /** If true, then the option set will be required when used with the target */
  required?: InputMaybe<Scalars['Boolean']>;
  /** The section of the target that the option set should be shown for */
  section?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<EnumOptionSetTarget>;
  /** The title of the option set */
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** The value type of the option set */
  valueType?: InputMaybe<EnumOptionSetValueType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOptionSetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOptionSet_IdOperatorsInput>;
  refId?: InputMaybe<FilterFindManyOptionSetRefIdOperatorsInput>;
};

export type FilterFindManyOptionSetRefIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOptionSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOptionValueInput = {
  AND?: InputMaybe<Array<FilterFindManyOptionValueInput>>;
  OR?: InputMaybe<Array<FilterFindManyOptionValueInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOptionValueOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the option value */
  customData?: InputMaybe<Scalars['JSON']>;
  /** If true, the option is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the option value */
  externalId?: InputMaybe<Scalars['String']>;
  /** The label of option */
  label?: InputMaybe<Scalars['String']>;
  /** The localizations of the option */
  localizations?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The option set id */
  optionSetId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the object that owns the value */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The sort order of the option */
  sortorder?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** The value of the option */
  value?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOptionValueOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOptionValue_IdOperatorsInput>;
};

export type FilterFindManyOptionValue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOrder2BrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOrder2CarrierInfoInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  carrierIdentifier?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2CarrierInputInput = {
  /** Selected carrier for this package */
  carrier?: InputMaybe<EnumOrder2CarrierInputCarrier>;
  /** Selected delivery service for this package */
  delivery?: InputMaybe<EnumOrder2CarrierInputDelivery>;
  /** Express delivery */
  express?: InputMaybe<Scalars['Boolean']>;
  /** Optionally an additional service id / pickup point information for this package */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2ConsumerInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2FulStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2FulState>;
  gte?: InputMaybe<EnumOrder2FulState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2FulState>>>;
  lt?: InputMaybe<EnumOrder2FulState>;
  lte?: InputMaybe<EnumOrder2FulState>;
  ne?: InputMaybe<EnumOrder2FulState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2FulState>>>;
};

export type FilterFindManyOrder2Input = {
  AND?: InputMaybe<Array<FilterFindManyOrder2Input>>;
  OR?: InputMaybe<Array<FilterFindManyOrder2Input>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOrder2OperatorsInput>;
  billingAddress?: InputMaybe<FilterFindManyOrder2ShippingAddressInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  captureFailedTs?: InputMaybe<Scalars['Date']>;
  captureNotified?: InputMaybe<Scalars['Boolean']>;
  captureRequests?: InputMaybe<Scalars['Float']>;
  /** The total amount to be captured for this order */
  captureTotal?: InputMaybe<Scalars['Float']>;
  carrierInfo?: InputMaybe<FilterFindManyOrder2CarrierInfoInput>;
  carrierInput?: InputMaybe<FilterFindManyOrder2CarrierInputInput>;
  /** Comment for the order */
  comment?: InputMaybe<Scalars['String']>;
  consumer?: InputMaybe<FilterFindManyOrder2ConsumerInput>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Currency for this order */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: InputMaybe<Scalars['Boolean']>;
  exportedToWMS?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  fulState?: InputMaybe<EnumOrder2FulState>;
  /** Whether this is a new order */
  isNewOrder?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['String']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  notifiedConsumer?: InputMaybe<Scalars['Boolean']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderName?: InputMaybe<Scalars['String']>;
  orderState?: InputMaybe<EnumOrder2OrderState>;
  orderUrl?: InputMaybe<Scalars['String']>;
  payState?: InputMaybe<EnumOrder2PayState>;
  /** True if the order is a proforma order */
  proforma?: InputMaybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: InputMaybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: InputMaybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: InputMaybe<Scalars['Boolean']>;
  refundAdjusted?: InputMaybe<Scalars['Boolean']>;
  /** The returnDeadline for an order is typically determined by the settings, but its possible to set the returnDeadline to override that */
  returnDeadline?: InputMaybe<Scalars['Date']>;
  returnInfo?: InputMaybe<FilterFindManyOrder2ReturnInfoInput>;
  returnShippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shippingAddress?: InputMaybe<FilterFindManyOrder2ShippingAddressInput>;
  shippingAddressInternal?: InputMaybe<FilterFindManyOrder2ShippingAddressInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: InputMaybe<Scalars['Boolean']>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  trackingInfo?: InputMaybe<FilterFindManyOrder2TrackingInfoInput>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderId?: InputMaybe<Scalars['Float']>;
  trackingOrderState?: InputMaybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: InputMaybe<EnumOrder2TrackingReturnState>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOrder2OperatorsInput = {
  _id?: InputMaybe<FilterFindManyOrder2_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyOrder2BrandHouseIdOperatorsInput>;
  fulState?: InputMaybe<FilterFindManyOrder2FulStateOperatorsInput>;
  orderDate?: InputMaybe<FilterFindManyOrder2OrderDateOperatorsInput>;
  orderName?: InputMaybe<FilterFindManyOrder2OrderNameOperatorsInput>;
  orderState?: InputMaybe<FilterFindManyOrder2OrderStateOperatorsInput>;
  payState?: InputMaybe<FilterFindManyOrder2PayStateOperatorsInput>;
  proforma?: InputMaybe<FilterFindManyOrder2ProformaOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyOrder2ShopIdOperatorsInput>;
  silenced?: InputMaybe<FilterFindManyOrder2SilencedOperatorsInput>;
  splitOrder?: InputMaybe<FilterFindManyOrder2SplitOrderOperatorsInput>;
  trackingOrderState?: InputMaybe<FilterFindManyOrder2TrackingOrderStateOperatorsInput>;
  trackingReturnState?: InputMaybe<FilterFindManyOrder2TrackingReturnStateOperatorsInput>;
  updatedLineTs?: InputMaybe<FilterFindManyOrder2UpdatedLineTsOperatorsInput>;
};

export type FilterFindManyOrder2OrderDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyOrder2OrderNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOrder2OrderStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2OrderState>;
  gte?: InputMaybe<EnumOrder2OrderState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2OrderState>>>;
  lt?: InputMaybe<EnumOrder2OrderState>;
  lte?: InputMaybe<EnumOrder2OrderState>;
  ne?: InputMaybe<EnumOrder2OrderState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2OrderState>>>;
};

export type FilterFindManyOrder2PayStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2PayState>;
  gte?: InputMaybe<EnumOrder2PayState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2PayState>>>;
  lt?: InputMaybe<EnumOrder2PayState>;
  lte?: InputMaybe<EnumOrder2PayState>;
  ne?: InputMaybe<EnumOrder2PayState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2PayState>>>;
};

export type FilterFindManyOrder2ProformaOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyOrder2ReturnInfoInput = {
  carrier?: InputMaybe<EnumOrder2ReturnInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2ShippingAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2ShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyOrder2SilencedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyOrder2SplitOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyOrder2TrackingInfoInput = {
  carrier?: InputMaybe<EnumOrder2TrackingInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrder2TrackingOrderStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2TrackingOrderState>;
  gte?: InputMaybe<EnumOrder2TrackingOrderState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingOrderState>>>;
  lt?: InputMaybe<EnumOrder2TrackingOrderState>;
  lte?: InputMaybe<EnumOrder2TrackingOrderState>;
  ne?: InputMaybe<EnumOrder2TrackingOrderState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingOrderState>>>;
};

export type FilterFindManyOrder2TrackingReturnStateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumOrder2TrackingReturnState>;
  gte?: InputMaybe<EnumOrder2TrackingReturnState>;
  in?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingReturnState>>>;
  lt?: InputMaybe<EnumOrder2TrackingReturnState>;
  lte?: InputMaybe<EnumOrder2TrackingReturnState>;
  ne?: InputMaybe<EnumOrder2TrackingReturnState>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrder2TrackingReturnState>>>;
};

export type FilterFindManyOrder2UpdatedLineTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyOrder2_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyParcelBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyParcelInput = {
  AND?: InputMaybe<Array<FilterFindManyParcelInput>>;
  OR?: InputMaybe<Array<FilterFindManyParcelInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyParcelOperatorsInput>;
  /** The brand that owns this parcel */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** Optional comment for the parcel */
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Items in the parcel */
  items?: InputMaybe<Array<InputMaybe<FilterFindManyParcelItemsInput>>>;
  /** The date of the parcel creation */
  parcelDate?: InputMaybe<Scalars['Date']>;
  /** The receiver of the parcel */
  receiver?: InputMaybe<FilterFindManyAddressInfoInput>;
  /** The sender of the parcel */
  sender?: InputMaybe<FilterFindManyAddressInfoInput>;
  /** The carrier of the parcel */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyParcelItemsInput = {
  refId?: InputMaybe<Scalars['MongoID']>;
  refType?: InputMaybe<EnumParcelItemsRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyParcelOperatorsInput = {
  _id?: InputMaybe<FilterFindManyParcel_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyParcelBrandHouseIdOperatorsInput>;
};

export type FilterFindManyParcel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPlannedMailInput = {
  AND?: InputMaybe<Array<FilterFindManyPlannedMailInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlannedMailInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlannedMailOperatorsInput>;
  mailType?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['Date']>;
  sent?: InputMaybe<Scalars['Date']>;
  sentStatus?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlannedMailOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlannedMail_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyPlannedMailShopIdOperatorsInput>;
};

export type FilterFindManyPlannedMailShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPlannedMail_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPotentialBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPotentialInput = {
  AND?: InputMaybe<Array<FilterFindManyPotentialInput>>;
  OR?: InputMaybe<Array<FilterFindManyPotentialInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPotentialOperatorsInput>;
  batchSerial?: InputMaybe<Scalars['String']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product that this potential is related to */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product size that this potential is related to */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product variant that this potential is related to */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  cancelled?: InputMaybe<Scalars['Boolean']>;
  cancelledReason?: InputMaybe<EnumPotentialCancelledReason>;
  color?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  externDate?: InputMaybe<Scalars['Date']>;
  externGroupId?: InputMaybe<Scalars['String']>;
  externUrl?: InputMaybe<Scalars['String']>;
  /** True if this potential is free to be added to anyones tradein */
  freePotential?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isUsingFakeProduct?: InputMaybe<Scalars['Boolean']>;
  /** If present, then this contains the last timestamp of when we tried linking this potential to masterdata */
  linkTs?: InputMaybe<Scalars['Date']>;
  lockedTs?: InputMaybe<Scalars['Date']>;
  /** The MAS masterdata variant id this potential is related to */
  masterVariantId?: InputMaybe<Scalars['String']>;
  masterVariantImageId?: InputMaybe<Scalars['String']>;
  masterVariantImageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Whether this potential has no "date", its not actually bought, or we dont know the date - means that any date check in the tradein rules will be voided */
  noDate?: InputMaybe<Scalars['Boolean']>;
  /** If the owner of this potential was contacting with trade-in offers for this */
  notified?: InputMaybe<EnumPotentialNotified>;
  /** When was the owner of this potential contacting regarding trade-in offers */
  notifiedTs?: InputMaybe<Scalars['Date']>;
  /** The id of the product this potential is related to */
  productId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  rrp?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The source of the potential, e.g. order, wholesale */
  sourceType?: InputMaybe<EnumPotentialSourceType>;
  sp?: InputMaybe<Scalars['Float']>;
  spOriginal?: InputMaybe<Scalars['Float']>;
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  wholeSale?: InputMaybe<FilterFindManyPotentialWholeSaleInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPotentialOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPotential_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyPotentialBrandHouseIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyPotentialShopIdOperatorsInput>;
};

export type FilterFindManyPotentialShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPotentialWholeSaleInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  categoryId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPotential_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyPricingInput = {
  /** The ISO currency code */
  currency: Scalars['String'];
  /** The pricing value */
  value: Scalars['Float'];
};

export type FilterFindManyProductBatchSerialOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProductBrandProductIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductInput = {
  AND?: InputMaybe<Array<FilterFindManyProductInput>>;
  OR?: InputMaybe<Array<FilterFindManyProductInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProductOperatorsInput>;
  batchSerial?: InputMaybe<Scalars['String']>;
  /** The brandproduct that is the master data for this product */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  isPotential?: InputMaybe<Scalars['Boolean']>;
  isPreOwned?: InputMaybe<Scalars['Boolean']>;
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  productVendor?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  style?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyProductIsPreOwnedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyProductNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProductOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProduct_IdOperatorsInput>;
  batchSerial?: InputMaybe<FilterFindManyProductBatchSerialOperatorsInput>;
  brandProductId?: InputMaybe<FilterFindManyProductBrandProductIdOperatorsInput>;
  isPreOwned?: InputMaybe<FilterFindManyProductIsPreOwnedOperatorsInput>;
  name?: InputMaybe<FilterFindManyProductNameOperatorsInput>;
  productType?: InputMaybe<FilterFindManyProductProductTypeOperatorsInput>;
  productVendor?: InputMaybe<FilterFindManyProductProductVendorOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyProductShopIdOperatorsInput>;
  style?: InputMaybe<FilterFindManyProductStyleOperatorsInput>;
};

export type FilterFindManyProductProductTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProductProductVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProductShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductStyleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyProductVariantInput = {
  AND?: InputMaybe<Array<FilterFindManyProductVariantInput>>;
  OR?: InputMaybe<Array<FilterFindManyProductVariantInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProductVariantOperatorsInput>;
  batchSerial?: InputMaybe<Scalars['String']>;
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  color?: InputMaybe<Scalars['String']>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  ean?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  imageUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isPotential?: InputMaybe<Scalars['Boolean']>;
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  productId?: InputMaybe<Scalars['MongoID']>;
  rrp?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProductVariantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProductVariant_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyProductVariantShopIdOperatorsInput>;
};

export type FilterFindManyProductVariantShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductVariantSizeInput = {
  AND?: InputMaybe<Array<FilterFindManyProductVariantSizeInput>>;
  OR?: InputMaybe<Array<FilterFindManyProductVariantSizeInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProductVariantSizeOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** True if this product has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: InputMaybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** Extra data about the variant */
  metaFields?: InputMaybe<Array<InputMaybe<FilterFindManyMetaFieldInput>>>;
  productId?: InputMaybe<Scalars['MongoID']>;
  /** The variant that owns this size */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this variant */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The size */
  size?: InputMaybe<Scalars['String']>;
  /** The SKU of this variant */
  sku?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProductVariantSizeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProductVariantSize_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyProductVariantSizeShopIdOperatorsInput>;
};

export type FilterFindManyProductVariantSizeShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductVariantSize_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProductVariant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyProduct_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyRespondentAnswersInput = {
  /** The id of the question */
  questionId?: InputMaybe<Scalars['String']>;
  /** The choice answer id */
  valueC?: InputMaybe<Scalars['String']>;
  /** The text answer */
  valueT?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyRespondentInput = {
  AND?: InputMaybe<Array<FilterFindManyRespondentInput>>;
  OR?: InputMaybe<Array<FilterFindManyRespondentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRespondentOperatorsInput>;
  /** The answers made by this respondent */
  answers?: InputMaybe<Array<InputMaybe<FilterFindManyRespondentAnswersInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  surveyId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRespondentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRespondent_IdOperatorsInput>;
};

export type FilterFindManyRespondent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyScheduledEventExecutedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyScheduledEventInput = {
  AND?: InputMaybe<Array<FilterFindManyScheduledEventInput>>;
  OR?: InputMaybe<Array<FilterFindManyScheduledEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyScheduledEventOperatorsInput>;
  /** Optionally data that will be sent with the event */
  data?: InputMaybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the event was executed */
  executed?: InputMaybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type */
  refType?: InputMaybe<EnumScheduledEventRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyScheduledEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyScheduledEvent_IdOperatorsInput>;
  executed?: InputMaybe<FilterFindManyScheduledEventExecutedOperatorsInput>;
};

export type FilterFindManyScheduledEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyShopInput = {
  AND?: InputMaybe<Array<FilterFindManyShopInput>>;
  OR?: InputMaybe<Array<FilterFindManyShopInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyShopOperatorsInput>;
  address?: InputMaybe<FilterFindManyAddressInfoInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  configuration?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  disableContactResetDate?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  frontendType?: InputMaybe<EnumShopFrontendType>;
  generateThumbnails?: InputMaybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: InputMaybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: InputMaybe<Scalars['Date']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveDate?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ressourceRedirectUrl?: InputMaybe<Scalars['String']>;
  shopCollectionUrl?: InputMaybe<Scalars['String']>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: InputMaybe<Scalars['Date']>;
  synchronizeActions?: InputMaybe<Scalars['Date']>;
  synchronizeHooks?: InputMaybe<Scalars['Date']>;
  synchronizeOrders?: InputMaybe<Scalars['Date']>;
  synchronizeProducts?: InputMaybe<Scalars['Date']>;
  tradeInBaseUrl?: InputMaybe<Scalars['String']>;
  updateVouchers?: InputMaybe<Scalars['Boolean']>;
  updateVouchersDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  wholeSaleActive?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyShopOperatorsInput = {
  _id?: InputMaybe<FilterFindManyShop_IdOperatorsInput>;
};

export type FilterFindManyShop_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyStockItemColorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStockItemEanOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemInput = {
  AND?: InputMaybe<Array<FilterFindManyStockItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyStockItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStockItemOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  beforePrice?: InputMaybe<Scalars['Float']>;
  beforePrices?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: InputMaybe<Scalars['Date']>;
  color?: InputMaybe<Scalars['String']>;
  colorLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: InputMaybe<Scalars['Float']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  draft?: InputMaybe<Scalars['Boolean']>;
  ean?: InputMaybe<Scalars['String']>;
  ecommerceId?: InputMaybe<Scalars['String']>;
  externId?: InputMaybe<Scalars['String']>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  hasProblems?: InputMaybe<Scalars['Boolean']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isSold?: InputMaybe<Scalars['Boolean']>;
  itemNr?: InputMaybe<Scalars['Float']>;
  itemSku?: InputMaybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  originalEan?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<FilterFindManyStockItemProblemsInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  review?: InputMaybe<Scalars['Boolean']>;
  reviewed?: InputMaybe<Scalars['Date']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  sellingPrices?: InputMaybe<Array<InputMaybe<FilterFindManyPricingInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Scalars['String']>;
  /** The type of source this stockitem is from */
  sourceType?: InputMaybe<EnumStockItemSourceType>;
  stockLocation?: InputMaybe<Scalars['String']>;
  stockLocationBag?: InputMaybe<Scalars['String']>;
  stockLocationTs?: InputMaybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  vendor?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyStockItemItemNrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyStockItemItemSkuOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemMissingOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStockItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStockItem_IdOperatorsInput>;
  color?: InputMaybe<FilterFindManyStockItemColorOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManyStockItemCreatedAtOperatorsInput>;
  ean?: InputMaybe<FilterFindManyStockItemEanOperatorsInput>;
  itemNr?: InputMaybe<FilterFindManyStockItemItemNrOperatorsInput>;
  itemSku?: InputMaybe<FilterFindManyStockItemItemSkuOperatorsInput>;
  missing?: InputMaybe<FilterFindManyStockItemMissingOperatorsInput>;
  originalEan?: InputMaybe<FilterFindManyStockItemOriginalEanOperatorsInput>;
  reviewed?: InputMaybe<FilterFindManyStockItemReviewedOperatorsInput>;
  size?: InputMaybe<FilterFindManyStockItemSizeOperatorsInput>;
  sourceType?: InputMaybe<FilterFindManyStockItemSourceTypeOperatorsInput>;
  stockLocation?: InputMaybe<FilterFindManyStockItemStockLocationOperatorsInput>;
  stockLocationTs?: InputMaybe<FilterFindManyStockItemStockLocationTsOperatorsInput>;
  title?: InputMaybe<FilterFindManyStockItemTitleOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyStockItemUpdatedAtOperatorsInput>;
};

export type FilterFindManyStockItemOriginalEanOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemProblemsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyStockItemReviewedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStockItemSizeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemSourceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumStockItemSourceType>;
  gte?: InputMaybe<EnumStockItemSourceType>;
  in?: InputMaybe<Array<InputMaybe<EnumStockItemSourceType>>>;
  lt?: InputMaybe<EnumStockItemSourceType>;
  lte?: InputMaybe<EnumStockItemSourceType>;
  ne?: InputMaybe<EnumStockItemSourceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumStockItemSourceType>>>;
};

export type FilterFindManyStockItemStockLocationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemStockLocationTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStockItemTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyStockItemUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyStockItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManySystemMessageEntriesInput = {
  /** The occurrence message */
  text?: InputMaybe<Scalars['String']>;
  /** When this occurrence was recorded */
  timestamp?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManySystemMessageInput = {
  AND?: InputMaybe<Array<FilterFindManySystemMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManySystemMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySystemMessageOperatorsInput>;
  /** The timestamp when the message was acknowledged */
  acknowledgedTs?: InputMaybe<Scalars['Date']>;
  /** The target audience (SYSADM, ADMIN, BRAND) */
  audience?: InputMaybe<EnumSystemMessageAudience>;
  /** If the audience is a brandhouse, this is the brandhouse id */
  audienceBrandId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Collected occurrences of this message */
  entries?: InputMaybe<Array<InputMaybe<FilterFindManySystemMessageEntriesInput>>>;
  /** When the message was last appended to - drives the 30 day TTL */
  lastActivityTs?: InputMaybe<Scalars['Date']>;
  /** The type of message (CRITICAL, WARNING, INFORMATION) */
  messageType?: InputMaybe<EnumSystemMessageMessageType>;
  /** Subject used to group repeated messages while unacknowledged */
  subject?: InputMaybe<Scalars['String']>;
  /** When the message was first created */
  timestamp?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManySystemMessageLastActivityTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySystemMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManySystemMessage_IdOperatorsInput>;
  lastActivityTs?: InputMaybe<FilterFindManySystemMessageLastActivityTsOperatorsInput>;
  subject?: InputMaybe<FilterFindManySystemMessageSubjectOperatorsInput>;
};

export type FilterFindManySystemMessageSubjectOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySystemMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTrackingBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTrackingInput = {
  AND?: InputMaybe<Array<FilterFindManyTrackingInput>>;
  OR?: InputMaybe<Array<FilterFindManyTrackingInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTrackingOperatorsInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  browser?: InputMaybe<Scalars['String']>;
  endpoint?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectPayload?: InputMaybe<Scalars['JSON']>;
  objectType?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  ts?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyTrackingObjectIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTracking_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyTrackingBrandHouseIdOperatorsInput>;
  objectId?: InputMaybe<FilterFindManyTrackingObjectIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyTrackingShopIdOperatorsInput>;
};

export type FilterFindManyTrackingShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTracking_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTradeInBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTradeInDateTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTradeInDeletedTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTradeInInput = {
  AND?: InputMaybe<Array<FilterFindManyTradeInInput>>;
  OR?: InputMaybe<Array<FilterFindManyTradeInInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTradeInOperatorsInput>;
  activationStrategy?: InputMaybe<EnumTradeInActivationStrategy>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** A comment about the tradein */
  comment?: InputMaybe<Scalars['String']>;
  /** The consumer id */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  dateTime?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  /** The payout type */
  payoutType?: InputMaybe<EnumTradeInPayoutType>;
  pickupNotified?: InputMaybe<Scalars['Boolean']>;
  pickupProcessed?: InputMaybe<Scalars['Boolean']>;
  /** We got the package? */
  registered?: InputMaybe<Scalars['Boolean']>;
  /** The date we got the package */
  registeredTs?: InputMaybe<Scalars['Date']>;
  remindedCount?: InputMaybe<Scalars['Float']>;
  remindedTs?: InputMaybe<Scalars['Date']>;
  /** The shipping carrier used for this tradein */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The source of the tradein */
  source?: InputMaybe<EnumTradeInSource>;
  /** Optionally a note about the source of the tradein */
  sourceNote?: InputMaybe<Scalars['String']>;
  tradeInNr?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTradeInOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTradeIn_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyTradeInBrandHouseIdOperatorsInput>;
  dateTime?: InputMaybe<FilterFindManyTradeInDateTimeOperatorsInput>;
  deletedTs?: InputMaybe<FilterFindManyTradeInDeletedTsOperatorsInput>;
  payoutType?: InputMaybe<FilterFindManyTradeInPayoutTypeOperatorsInput>;
  registered?: InputMaybe<FilterFindManyTradeInRegisteredOperatorsInput>;
  registeredTs?: InputMaybe<FilterFindManyTradeInRegisteredTsOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyTradeInShopIdOperatorsInput>;
  tradeInNr?: InputMaybe<FilterFindManyTradeInTradeInNrOperatorsInput>;
};

export type FilterFindManyTradeInPayoutTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTradeInPayoutType>;
  gte?: InputMaybe<EnumTradeInPayoutType>;
  in?: InputMaybe<Array<InputMaybe<EnumTradeInPayoutType>>>;
  lt?: InputMaybe<EnumTradeInPayoutType>;
  lte?: InputMaybe<EnumTradeInPayoutType>;
  ne?: InputMaybe<EnumTradeInPayoutType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTradeInPayoutType>>>;
};

export type FilterFindManyTradeInRegisteredOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindManyTradeInRegisteredTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyTradeInShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyTradeInTradeInNrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyTradeIn_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  /** If true, then user has access to everything */
  administrator?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** True if the user has been disabled */
  disabled?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  lastIp?: InputMaybe<Scalars['String']>;
  lastLoginAt?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  /** Link to OAuth2 user ID */
  oauthSubject?: InputMaybe<Scalars['String']>;
  /** Can contain any reference to another object, that the user is linked to - this has no effect on the users access whatsoever */
  parentId?: InputMaybe<Scalars['MongoID']>;
  resetToken?: InputMaybe<Scalars['String']>;
  resetTokenTs?: InputMaybe<Scalars['Date']>;
  /** If true, then user has a simplified view */
  simplified?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyUserOauthSubjectOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
  email?: InputMaybe<FilterFindManyUserEmailOperatorsInput>;
  oauthSubject?: InputMaybe<FilterFindManyUserOauthSubjectOperatorsInput>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherAdjustmentInput = {
  AND?: InputMaybe<Array<FilterFindManyVoucherAdjustmentInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoucherAdjustmentInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoucherAdjustmentOperatorsInput>;
  /** The adjustment amount in vouchers currency */
  amount?: InputMaybe<Scalars['Float']>;
  /** If this adjustment is a correction to the original voucher value */
  correction?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The adjustment date */
  date?: InputMaybe<Scalars['Date']>;
  /** Reason for adjustment */
  reason?: InputMaybe<Scalars['String']>;
  /** The shop that owns the usage refund */
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  /** The voucher */
  voucherId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoucherAdjustmentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVoucherAdjustment_IdOperatorsInput>;
  voucherId?: InputMaybe<FilterFindManyVoucherAdjustmentVoucherIdOperatorsInput>;
};

export type FilterFindManyVoucherAdjustmentVoucherIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherAdjustment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherCodeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyVoucherExternIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyVoucherInput = {
  AND?: InputMaybe<Array<FilterFindManyVoucherInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoucherInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoucherOperatorsInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  code?: InputMaybe<Scalars['String']>;
  /** An alias for the voucher, this alias is typically used when an external voucher service produces other codes than C2S */
  codeAlias?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the voucher */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Date']>;
  /** If there is a date, then this voucher is disabled since this date. It should not exist in external shop and should not be useable. It should still be monitored and updated. */
  disabled?: InputMaybe<Scalars['Date']>;
  expireDate?: InputMaybe<Scalars['Date']>;
  /** ID of the voucher in any external storefront. The existence of this ID indicates that the voucher has been created at the storefront */
  externId?: InputMaybe<Scalars['String']>;
  minimumPurchase?: InputMaybe<Scalars['Float']>;
  /** The value of the voucher, as it was last communicated to the customer */
  notificationValue?: InputMaybe<Scalars['Float']>;
  /** Whether this reward is handled completely by an external system. If true, then we will not try to calculate the remaining value of the voucher - and we expect the value to be updated by external integration */
  passive?: InputMaybe<Scalars['Boolean']>;
  /** The value to be paid out to the customer, after applying payout percentage or rules */
  payoutValue?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  tradeInId?: InputMaybe<Scalars['MongoID']>;
  /** Will be updated to reflect the registration timestamp from connected tradeins */
  tradeInReceivedTs?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  used?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['Float']>;
  voucherPdf?: InputMaybe<Array<InputMaybe<FilterFindManyVoucherPdfInput>>>;
  voucherStrategy?: InputMaybe<EnumVoucherVoucherStrategy>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoucherOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVoucher_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindManyVoucherBrandHouseIdOperatorsInput>;
  code?: InputMaybe<FilterFindManyVoucherCodeOperatorsInput>;
  externId?: InputMaybe<FilterFindManyVoucherExternIdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyVoucherShopIdOperatorsInput>;
  tradeInId?: InputMaybe<FilterFindManyVoucherTradeInIdOperatorsInput>;
};

export type FilterFindManyVoucherPdfInput = {
  /** The language of the pdf */
  language?: InputMaybe<Scalars['String']>;
  /** If set, then this points to the storage file that contains the voucher as a PDF (english) */
  pdfId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyVoucherShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherTradeInIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherUsageInput = {
  AND?: InputMaybe<Array<FilterFindManyVoucherUsageInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoucherUsageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoucherUsageOperatorsInput>;
  /** The date of the usage cancellation, if cancelled - this usage will be ignored when calculating voucher balance */
  cancelDate?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The external ID of the order that triggered a voucher action. There can be multiple actions for the same order. */
  externOrderId?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<FilterFindManyVoucherUsageItemsInput>>>;
  /** Shipping cost */
  shippingAmount?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The date of usage */
  usageDate?: InputMaybe<Scalars['Date']>;
  voucherId?: InputMaybe<Scalars['MongoID']>;
};

export type FilterFindManyVoucherUsageItemsInput = {
  /** The discounted price for item(s) in shop currency */
  discountedPrice?: InputMaybe<Scalars['Float']>;
  /** The discounted price before tax for item(s) in shop currency */
  discountedPricePreTax?: InputMaybe<Scalars['Float']>;
  /** The external ID of the lineitem */
  externLineItemId?: InputMaybe<Scalars['String']>;
  /** The original price for item(s) in shop currency */
  price?: InputMaybe<Scalars['Float']>;
  /** The number of items bought */
  quantity?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoucherUsageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVoucherUsage_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyVoucherUsageShopIdOperatorsInput>;
  usageDate?: InputMaybe<FilterFindManyVoucherUsageUsageDateOperatorsInput>;
};

export type FilterFindManyVoucherUsageRefundInput = {
  AND?: InputMaybe<Array<FilterFindManyVoucherUsageRefundInput>>;
  OR?: InputMaybe<Array<FilterFindManyVoucherUsageRefundInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVoucherUsageRefundOperatorsInput>;
  /** The refund amount */
  amount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Refund ID */
  externRefundId?: InputMaybe<Scalars['String']>;
  /** Whether the refund has been processed by the platform */
  processed?: InputMaybe<Scalars['Boolean']>;
  /** The date of the refund */
  refundDate?: InputMaybe<Scalars['Date']>;
  refundItems?: InputMaybe<Array<InputMaybe<FilterFindManyVoucherUsageRefundRefundItemsInput>>>;
  /** The type of refund */
  refundType?: InputMaybe<EnumVoucherUsageRefundRefundType>;
  /** The shop that owns the usage refund */
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The voucher usage that this refund is related to */
  voucherUsageId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVoucherUsageRefundOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVoucherUsageRefund_IdOperatorsInput>;
  refundDate?: InputMaybe<FilterFindManyVoucherUsageRefundRefundDateOperatorsInput>;
  voucherUsageId?: InputMaybe<FilterFindManyVoucherUsageRefundVoucherUsageIdOperatorsInput>;
};

export type FilterFindManyVoucherUsageRefundRefundDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyVoucherUsageRefundRefundItemsInput = {
  /** Line item ID */
  externLineItemId?: InputMaybe<Scalars['String']>;
  /** Number of items refunded */
  quantity?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVoucherUsageRefundVoucherUsageIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherUsageRefund_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherUsageShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucherUsageUsageDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyVoucherUsage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyVoucher_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyWholeSaleCategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyWholeSaleCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyWholeSaleCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWholeSaleCategoryOperatorsInput>;
  advanced?: InputMaybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  iconId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindManyWholeSaleCategoryRulesInput>>>;
  section?: InputMaybe<Scalars['String']>;
  sectionLocalized?: InputMaybe<Array<InputMaybe<FilterFindManyLocalizationEntryInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The other of this category */
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<FilterFindManyObjectPatchesUpdatedByInput>;
  value?: InputMaybe<Scalars['Float']>;
  voucherStrategy?: InputMaybe<EnumWholeSaleCategoryVoucherStrategy>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWholeSaleCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWholeSaleCategory_IdOperatorsInput>;
  shopId?: InputMaybe<FilterFindManyWholeSaleCategoryShopIdOperatorsInput>;
  sortOrder?: InputMaybe<FilterFindManyWholeSaleCategorySortOrderOperatorsInput>;
};

export type FilterFindManyWholeSaleCategoryRulesExpressionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: InputMaybe<Scalars['String']>;
  expressionType?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsExpressionType>;
  operator?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsOperator>;
  sku?: InputMaybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyWholeSaleCategoryRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expressions?: InputMaybe<Array<InputMaybe<FilterFindManyWholeSaleCategoryRulesExpressionsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyWholeSaleCategoryShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyWholeSaleCategorySortOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyWholeSaleCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneBrandApiAutoretouchInput = {
  autoProcess?: InputMaybe<Scalars['Boolean']>;
  autoRotate?: InputMaybe<Scalars['Float']>;
  workflowId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiB2ceuropeInput = {
  password?: InputMaybe<Scalars['String']>;
  userid?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiBurdInput = {
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiExternShopInput = {
  serviceBus?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiInput = {
  AND?: InputMaybe<Array<FilterFindOneBrandApiInput>>;
  OR?: InputMaybe<Array<FilterFindOneBrandApiInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneBrandApiOperatorsInput>;
  autoPublish?: InputMaybe<Scalars['Boolean']>;
  autoretouch?: InputMaybe<FilterFindOneBrandApiAutoretouchInput>;
  b2ceurope?: InputMaybe<FilterFindOneBrandApiB2ceuropeInput>;
  burd?: InputMaybe<FilterFindOneBrandApiBurdInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  externShop?: InputMaybe<FilterFindOneBrandApiExternShopInput>;
  googleTrackingId?: InputMaybe<Scalars['String']>;
  sendgrid?: InputMaybe<FilterFindOneBrandApiSendgridInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  shopify?: InputMaybe<FilterFindOneBrandApiShopifyInput>;
  spy?: InputMaybe<FilterFindOneBrandApiSpyInput>;
  traede?: InputMaybe<FilterFindOneBrandApiTraedeInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindOneObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneBrandApiOperatorsInput = {
  _id?: InputMaybe<FilterFindOneBrandApi_IdOperatorsInput>;
};

export type FilterFindOneBrandApiSendgridInput = {
  from?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiShopifyInput = {
  capture?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<FilterFindOneBrandApiShopifyOptionsInput>;
  refund?: InputMaybe<Scalars['Boolean']>;
  shopifyLocationId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiShopifyOptionsInput = {
  color?: InputMaybe<Scalars['Boolean']>;
  colorName?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Boolean']>;
  sizeName?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiSpyInput = {
  captureUrl?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  refundUrl?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApiTraedeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  itemNumberPrefix?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBrandApi_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneTradeInBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTradeInDateTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTradeInDeletedTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTradeInInput = {
  AND?: InputMaybe<Array<FilterFindOneTradeInInput>>;
  OR?: InputMaybe<Array<FilterFindOneTradeInInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTradeInOperatorsInput>;
  activationStrategy?: InputMaybe<EnumTradeInActivationStrategy>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** A comment about the tradein */
  comment?: InputMaybe<Scalars['String']>;
  /** The consumer id */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  dateTime?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  /** The payout type */
  payoutType?: InputMaybe<EnumTradeInPayoutType>;
  pickupNotified?: InputMaybe<Scalars['Boolean']>;
  pickupProcessed?: InputMaybe<Scalars['Boolean']>;
  /** We got the package? */
  registered?: InputMaybe<Scalars['Boolean']>;
  /** The date we got the package */
  registeredTs?: InputMaybe<Scalars['Date']>;
  remindedCount?: InputMaybe<Scalars['Float']>;
  remindedTs?: InputMaybe<Scalars['Date']>;
  /** The shipping carrier used for this tradein */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The source of the tradein */
  source?: InputMaybe<EnumTradeInSource>;
  /** Optionally a note about the source of the tradein */
  sourceNote?: InputMaybe<Scalars['String']>;
  tradeInNr?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterFindOneObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTradeInOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTradeIn_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterFindOneTradeInBrandHouseIdOperatorsInput>;
  dateTime?: InputMaybe<FilterFindOneTradeInDateTimeOperatorsInput>;
  deletedTs?: InputMaybe<FilterFindOneTradeInDeletedTsOperatorsInput>;
  payoutType?: InputMaybe<FilterFindOneTradeInPayoutTypeOperatorsInput>;
  registered?: InputMaybe<FilterFindOneTradeInRegisteredOperatorsInput>;
  registeredTs?: InputMaybe<FilterFindOneTradeInRegisteredTsOperatorsInput>;
  shopId?: InputMaybe<FilterFindOneTradeInShopIdOperatorsInput>;
  tradeInNr?: InputMaybe<FilterFindOneTradeInTradeInNrOperatorsInput>;
};

export type FilterFindOneTradeInPayoutTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumTradeInPayoutType>;
  gte?: InputMaybe<EnumTradeInPayoutType>;
  in?: InputMaybe<Array<InputMaybe<EnumTradeInPayoutType>>>;
  lt?: InputMaybe<EnumTradeInPayoutType>;
  lte?: InputMaybe<EnumTradeInPayoutType>;
  ne?: InputMaybe<EnumTradeInPayoutType>;
  nin?: InputMaybe<Array<InputMaybe<EnumTradeInPayoutType>>>;
};

export type FilterFindOneTradeInRegisteredOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type FilterFindOneTradeInRegisteredTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOneTradeInShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneTradeInTradeInNrOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneTradeIn_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterRemoveOneIntegrationConnectorActiveForOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterRemoveOneIntegrationConnectorEventbusInput = {
  development?: InputMaybe<FilterRemoveOneIntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<FilterRemoveOneIntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<FilterRemoveOneIntegrationConnectorEventbusProductionInput>;
};

export type FilterRemoveOneIntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type FilterRemoveOneIntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<Scalars['String']>;
  /** The field */
  field?: InputMaybe<Scalars['String']>;
  /** Namespace grouping of multiple fields */
  namespace?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<FilterRemoveOneIntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type?: InputMaybe<Scalars['String']>;
};

export type FilterRemoveOneIntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label?: InputMaybe<Scalars['String']>;
  /** The value when the option is selected */
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterRemoveOneIntegrationConnectorInput = {
  AND?: InputMaybe<Array<FilterRemoveOneIntegrationConnectorInput>>;
  OR?: InputMaybe<Array<FilterRemoveOneIntegrationConnectorInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterRemoveOneIntegrationConnectorOperatorsInput>;
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventbus?: InputMaybe<FilterRemoveOneIntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<FilterRemoveOneIntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name?: InputMaybe<Scalars['String']>;
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type?: InputMaybe<EnumIntegrationConnectorType>;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<FilterRemoveOneObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<FilterRemoveOneIntegrationConnectorWebhookInput>;
};

export type FilterRemoveOneIntegrationConnectorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveOneIntegrationConnectorOperatorsInput = {
  _id?: InputMaybe<FilterRemoveOneIntegrationConnector_IdOperatorsInput>;
  activeFor?: InputMaybe<FilterRemoveOneIntegrationConnectorActiveForOperatorsInput>;
  name?: InputMaybe<FilterRemoveOneIntegrationConnectorNameOperatorsInput>;
  refTypes?: InputMaybe<FilterRemoveOneIntegrationConnectorRefTypesOperatorsInput>;
};

export type FilterRemoveOneIntegrationConnectorRefTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  gte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  lt?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  lte?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  ne?: InputMaybe<EnumIntegrationConnectorRefTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
};

export type FilterRemoveOneIntegrationConnectorWebhookInput = {
  development?: InputMaybe<FilterRemoveOneIntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<FilterRemoveOneIntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<FilterRemoveOneIntegrationConnectorWebhookProductionInput>;
};

export type FilterRemoveOneIntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type FilterRemoveOneIntegrationConnector_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterRemoveOneObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneAddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneParcelBrandHouseIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneParcelInput = {
  AND?: InputMaybe<Array<FilterUpdateOneParcelInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneParcelInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneParcelOperatorsInput>;
  /** The brand that owns this parcel */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** Optional comment for the parcel */
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Items in the parcel */
  items?: InputMaybe<Array<InputMaybe<FilterUpdateOneParcelItemsInput>>>;
  /** The date of the parcel creation */
  parcelDate?: InputMaybe<Scalars['Date']>;
  /** The receiver of the parcel */
  receiver?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  /** The sender of the parcel */
  sender?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  /** The carrier of the parcel */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterUpdateOneParcelItemsInput = {
  refId?: InputMaybe<Scalars['MongoID']>;
  refType?: InputMaybe<EnumParcelItemsRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneParcelOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneParcel_IdOperatorsInput>;
  brandHouseId?: InputMaybe<FilterUpdateOneParcelBrandHouseIdOperatorsInput>;
};

export type FilterUpdateOneParcel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOnePlannedMailInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePlannedMailInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePlannedMailInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePlannedMailOperatorsInput>;
  mailType?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['Date']>;
  sent?: InputMaybe<Scalars['Date']>;
  sentStatus?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePlannedMailOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePlannedMail_IdOperatorsInput>;
  shopId?: InputMaybe<FilterUpdateOnePlannedMailShopIdOperatorsInput>;
};

export type FilterUpdateOnePlannedMailShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOnePlannedMail_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneScheduledEventExecutedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterUpdateOneScheduledEventInput = {
  AND?: InputMaybe<Array<FilterUpdateOneScheduledEventInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneScheduledEventInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneScheduledEventOperatorsInput>;
  /** Optionally data that will be sent with the event */
  data?: InputMaybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the event was executed */
  executed?: InputMaybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type */
  refType?: InputMaybe<EnumScheduledEventRefType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneScheduledEventOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneScheduledEvent_IdOperatorsInput>;
  executed?: InputMaybe<FilterUpdateOneScheduledEventExecutedOperatorsInput>;
};

export type FilterUpdateOneScheduledEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneShippingLabelInput = {
  AND?: InputMaybe<Array<FilterUpdateOneShippingLabelInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneShippingLabelInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneShippingLabelOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<EnumShippingLabelDeliveryStatus>;
  labelCode?: InputMaybe<Scalars['String']>;
  labelExternalId?: InputMaybe<Scalars['String']>;
  labelFailed?: InputMaybe<Scalars['Boolean']>;
  labelFailedCount?: InputMaybe<Scalars['Float']>;
  labelImageId?: InputMaybe<Scalars['MongoID']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  packageCode?: InputMaybe<Scalars['String']>;
  qrImageId?: InputMaybe<Scalars['MongoID']>;
  qrPngId?: InputMaybe<Scalars['MongoID']>;
  receiver?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  sender?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  tracking?: InputMaybe<FilterUpdateOneShippingLabelTrackingInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterUpdateOneObjectPatchesUpdatedByInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneShippingLabelOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneShippingLabel_IdOperatorsInput>;
};

export type FilterUpdateOneShippingLabelTrackingInput = {
  carrierCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusFailed?: InputMaybe<Scalars['Boolean']>;
  statusText?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Date']>;
  trackingCode?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneShippingLabel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneShopInput = {
  AND?: InputMaybe<Array<FilterUpdateOneShopInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneShopInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneShopOperatorsInput>;
  address?: InputMaybe<FilterUpdateOneAddressInfoInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  configuration?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  disableContactResetDate?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  frontendType?: InputMaybe<EnumShopFrontendType>;
  generateThumbnails?: InputMaybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: InputMaybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: InputMaybe<Scalars['Date']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveDate?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ressourceRedirectUrl?: InputMaybe<Scalars['String']>;
  shopCollectionUrl?: InputMaybe<Scalars['String']>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: InputMaybe<Scalars['Date']>;
  synchronizeActions?: InputMaybe<Scalars['Date']>;
  synchronizeHooks?: InputMaybe<Scalars['Date']>;
  synchronizeOrders?: InputMaybe<Scalars['Date']>;
  synchronizeProducts?: InputMaybe<Scalars['Date']>;
  tradeInBaseUrl?: InputMaybe<Scalars['String']>;
  updateVouchers?: InputMaybe<Scalars['Boolean']>;
  updateVouchersDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<FilterUpdateOneObjectPatchesUpdatedByInput>;
  wholeSaleActive?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneShopOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneShop_IdOperatorsInput>;
};

export type FilterUpdateOneShop_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneSystemMessageEntriesInput = {
  /** The occurrence message */
  text?: InputMaybe<Scalars['String']>;
  /** When this occurrence was recorded */
  timestamp?: InputMaybe<Scalars['Date']>;
};

export type FilterUpdateOneSystemMessageInput = {
  AND?: InputMaybe<Array<FilterUpdateOneSystemMessageInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneSystemMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneSystemMessageOperatorsInput>;
  /** The timestamp when the message was acknowledged */
  acknowledgedTs?: InputMaybe<Scalars['Date']>;
  /** The target audience (SYSADM, ADMIN, BRAND) */
  audience?: InputMaybe<EnumSystemMessageAudience>;
  /** If the audience is a brandhouse, this is the brandhouse id */
  audienceBrandId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Collected occurrences of this message */
  entries?: InputMaybe<Array<InputMaybe<FilterUpdateOneSystemMessageEntriesInput>>>;
  /** When the message was last appended to - drives the 30 day TTL */
  lastActivityTs?: InputMaybe<Scalars['Date']>;
  /** The type of message (CRITICAL, WARNING, INFORMATION) */
  messageType?: InputMaybe<EnumSystemMessageMessageType>;
  /** Subject used to group repeated messages while unacknowledged */
  subject?: InputMaybe<Scalars['String']>;
  /** When the message was first created */
  timestamp?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type FilterUpdateOneSystemMessageLastActivityTsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneSystemMessageOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneSystemMessage_IdOperatorsInput>;
  lastActivityTs?: InputMaybe<FilterUpdateOneSystemMessageLastActivityTsOperatorsInput>;
  subject?: InputMaybe<FilterUpdateOneSystemMessageSubjectOperatorsInput>;
};

export type FilterUpdateOneSystemMessageSubjectOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterUpdateOneSystemMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneWholeSaleCategoryInput = {
  AND?: InputMaybe<Array<FilterUpdateOneWholeSaleCategoryInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneWholeSaleCategoryInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneWholeSaleCategoryOperatorsInput>;
  advanced?: InputMaybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  iconId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<FilterUpdateOneLocalizationEntryInput>>>;
  rules?: InputMaybe<Array<InputMaybe<FilterUpdateOneWholeSaleCategoryRulesInput>>>;
  section?: InputMaybe<Scalars['String']>;
  sectionLocalized?: InputMaybe<Array<InputMaybe<FilterUpdateOneLocalizationEntryInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The other of this category */
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<FilterUpdateOneObjectPatchesUpdatedByInput>;
  value?: InputMaybe<Scalars['Float']>;
  voucherStrategy?: InputMaybe<EnumWholeSaleCategoryVoucherStrategy>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneWholeSaleCategoryOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneWholeSaleCategory_IdOperatorsInput>;
  shopId?: InputMaybe<FilterUpdateOneWholeSaleCategoryShopIdOperatorsInput>;
  sortOrder?: InputMaybe<FilterUpdateOneWholeSaleCategorySortOrderOperatorsInput>;
};

export type FilterUpdateOneWholeSaleCategoryRulesExpressionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: InputMaybe<Scalars['String']>;
  expressionType?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsExpressionType>;
  operator?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsOperator>;
  sku?: InputMaybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: InputMaybe<Scalars['String']>;
};

export type FilterUpdateOneWholeSaleCategoryRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expressions?: InputMaybe<Array<InputMaybe<FilterUpdateOneWholeSaleCategoryRulesExpressionsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterUpdateOneWholeSaleCategoryShopIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterUpdateOneWholeSaleCategorySortOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterUpdateOneWholeSaleCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export enum ImagePerspectiveEnum {
  Back = 'BACK',
  Detail = 'DETAIL',
  Front = 'FRONT',
  Other = 'OTHER'
}

export enum ImageTypeEnum {
  Focus = 'FOCUS',
  Model = 'MODEL',
  Other = 'OTHER',
  Pack = 'PACK'
}

export type ImageUpload = {
  __typename?: 'ImageUpload';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  imageId: Scalars['MongoID'];
  /** The md5 hash of the image, used when comparing images */
  imageMd5?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['MongoID']>;
  /** URL to the uploaded image */
  url: Scalars['String'];
};

export enum InstanceModeEnum {
  Development = 'development',
  Production = 'production',
  Test = 'test'
}

export type IntegrationConfig = {
  __typename?: 'IntegrationConfig';
  _id: Scalars['MongoID'];
  /** Whether the message for the connector is enabled */
  enabled: Scalars['Boolean'];
  /** The instance */
  instanceId: Scalars['MongoID'];
  /** The message type */
  message: EnumIntegrationConfigMessage;
  /** The referenced object that owns this message configuration */
  refId: Scalars['MongoID'];
};

export type IntegrationConnector = {
  __typename?: 'IntegrationConnector';
  _id: Scalars['MongoID'];
  activeFor?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  autoInstallFor?: Maybe<Array<Maybe<EnumIntegrationConnectorAutoInstallFor>>>;
  /** Whether this connector has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  eventbus?: Maybe<IntegrationConnectorEventbus>;
  fields?: Maybe<Array<Maybe<IntegrationConnectorFields>>>;
  /** Icon for the connector */
  icon?: Maybe<Scalars['String']>;
  /** Installs of this connector */
  instances?: Maybe<Array<Maybe<IntegrationInstance>>>;
  messages?: Maybe<Array<Maybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name: Scalars['String'];
  optionals?: Maybe<Array<Maybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: Maybe<Array<Maybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type: EnumIntegrationConnectorType;
  /** The latest entity that updated this connector */
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  webhook?: Maybe<IntegrationConnectorWebhook>;
};

export type IntegrationConnectorEventbus = {
  __typename?: 'IntegrationConnectorEventbus';
  development?: Maybe<IntegrationConnectorEventbusProduction>;
  production?: Maybe<IntegrationConnectorEventbusProduction>;
  test?: Maybe<IntegrationConnectorEventbusProduction>;
};

export type IntegrationConnectorEventbusInput = {
  development?: InputMaybe<IntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<IntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<IntegrationConnectorEventbusProductionInput>;
};

export type IntegrationConnectorEventbusProduction = {
  __typename?: 'IntegrationConnectorEventbusProduction';
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type IntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type IntegrationConnectorFields = {
  __typename?: 'IntegrationConnectorFields';
  _id?: Maybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: Maybe<Scalars['String']>;
  /** Description of the field */
  description: Scalars['String'];
  /** The field */
  field: Scalars['String'];
  /** Namespace grouping of multiple fields */
  namespace: Scalars['String'];
  options?: Maybe<Array<Maybe<IntegrationConnectorFieldsOptions>>>;
  /** Whether the field is required */
  required?: Maybe<Scalars['Boolean']>;
  /** text, number, json */
  type: Scalars['String'];
};

export type IntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description: Scalars['String'];
  /** The field */
  field: Scalars['String'];
  /** Namespace grouping of multiple fields */
  namespace: Scalars['String'];
  options?: InputMaybe<Array<InputMaybe<IntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type: Scalars['String'];
};

export type IntegrationConnectorFieldsOptions = {
  __typename?: 'IntegrationConnectorFieldsOptions';
  /** Option label */
  label: Scalars['String'];
  /** The value when the option is selected */
  value: Scalars['JSON'];
};

export type IntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label: Scalars['String'];
  /** The value when the option is selected */
  value: Scalars['JSON'];
};

export type IntegrationConnectorWebhook = {
  __typename?: 'IntegrationConnectorWebhook';
  development?: Maybe<IntegrationConnectorWebhookProduction>;
  production?: Maybe<IntegrationConnectorWebhookProduction>;
  test?: Maybe<IntegrationConnectorWebhookProduction>;
};

export type IntegrationConnectorWebhookInput = {
  development?: InputMaybe<IntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<IntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<IntegrationConnectorWebhookProductionInput>;
};

export type IntegrationConnectorWebhookProduction = {
  __typename?: 'IntegrationConnectorWebhookProduction';
  /** Custom headers to include in the webhook request */
  headers?: Maybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type IntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type IntegrationInstance = {
  __typename?: 'IntegrationInstance';
  _id: Scalars['MongoID'];
  /** List of configs for this instance */
  configs?: Maybe<Array<Maybe<IntegrationConfig>>>;
  /** The connector */
  connector?: Maybe<IntegrationConnector>;
  /** The connector that was installed */
  connectorId: Scalars['MongoID'];
  /** Whether the install has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Whether the install has been enabled */
  enabled: Scalars['Boolean'];
  /** The mode of the instance */
  mode: EnumIntegrationInstanceMode;
  /** Name of the instance */
  name: Scalars['String'];
  /** The brandHouse referenced object */
  refBrandHouse?: Maybe<BrandHouse>;
  /** The owner of the install */
  refId: Scalars['MongoID'];
  /** The logisticspartner referenced object */
  refLogisticsPartner?: Maybe<LogisticsPartner>;
  /** Name of the object that owns this instance */
  refName?: Maybe<Scalars['String']>;
  /** The shop referenced object */
  refShop?: Maybe<Shop>;
  /** What type this connector is referenced to */
  refType: EnumIntegrationInstanceRefType;
  /** List of settings for this instance */
  settings?: Maybe<Array<Maybe<IntegrationSetting>>>;
};

export type IntegrationMessage = {
  __typename?: 'IntegrationMessage';
  _id: Scalars['MongoID'];
  /** The timestamp of the message ackknowledgement, webhooks will set this instantly based on 200 OK response. Servicebus implementationw will need to send an ackknowledge event. */
  acknowledged?: Maybe<Scalars['Date']>;
  /** Timestamp of the message creation */
  created: Scalars['Date'];
  /** The source environment of this message : production, development or test */
  env?: Maybe<Scalars['String']>;
  /** If the message was unable to be delivered, this will have contain a timestamp of when we gave up */
  failed?: Maybe<Scalars['Date']>;
  /** The instance for this message */
  instance?: Maybe<IntegrationInstance>;
  /** The instance identifier */
  instanceId: Scalars['MongoID'];
  lockedId?: Maybe<Scalars['String']>;
  /** The message type */
  message: EnumIntegrationMessageMessage;
  /** True if failure */
  messageFailed?: Maybe<Scalars['Boolean']>;
  /** True if ignored */
  messageIgnored?: Maybe<Scalars['Boolean']>;
  /** If this message is a retry message, then this points the the previous message that initiated the retry */
  parentId?: Maybe<Scalars['MongoID']>;
  /** Optionally a payload for the message */
  payload?: Maybe<Scalars['JSON']>;
  /** The brandHouse referenced object */
  refBrandHouse?: Maybe<BrandHouse>;
  /** The referenced object this message originated from */
  refId: Scalars['MongoID'];
  /** The logisticspartner referenced object */
  refLogisticsPartner?: Maybe<LogisticsPartner>;
  /** The shop referenced object */
  refShop?: Maybe<Shop>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType: Scalars['String'];
  /** Optionally a result data blob for the message */
  result?: Maybe<Scalars['JSON']>;
  /** If a result data blob was stored, then this timestamp holds the timestamp for it - otherwise null */
  resultTs?: Maybe<Scalars['Date']>;
  /** The timestamp of when the message should be sent, this is typically used when retrying failed messages, but can be used for any message delaying */
  sendAt?: Maybe<Scalars['Date']>;
  /** Timestamp of when the message was last sent */
  sent?: Maybe<Scalars['Date']>;
  /** The number of times we have sent this message */
  sentCount: Scalars['Float'];
};

export enum IntegrationMessageEnum {
  Cancelled = 'CANCELLED',
  Capture = 'CAPTURE',
  Consumeractivity = 'CONSUMERACTIVITY',
  Createorder = 'CREATEORDER',
  Createparcel = 'CREATEPARCEL',
  Createshippinglabel = 'CREATESHIPPINGLABEL',
  Createtradein = 'CREATETRADEIN',
  Delete = 'DELETE',
  Fulfill = 'FULFILL',
  Init = 'INIT',
  Optimizebysalesrank = 'OPTIMIZEBYSALESRANK',
  Periodicreport = 'PERIODICREPORT',
  Refund = 'REFUND',
  Removebg = 'REMOVEBG',
  Requestaccess = 'REQUESTACCESS',
  Requestorders = 'REQUESTORDERS',
  Requestpotentials = 'REQUESTPOTENTIALS',
  Requestproducts = 'REQUESTPRODUCTS',
  Requestvouchers = 'REQUESTVOUCHERS',
  Scheduledevent = 'SCHEDULEDEVENT',
  Sendmail = 'SENDMAIL',
  Updatebrand = 'UPDATEBRAND',
  Updatebranditem = 'UPDATEBRANDITEM',
  Updatecategory = 'UPDATECATEGORY',
  Updateconfig = 'UPDATECONFIG',
  Updateinventory = 'UPDATEINVENTORY',
  Updateinvoice = 'UPDATEINVOICE',
  Updateorder = 'UPDATEORDER',
  Updateparcel = 'UPDATEPARCEL',
  Updatepotentials = 'UPDATEPOTENTIALS',
  Updateshippinglabel = 'UPDATESHIPPINGLABEL',
  Updateshop = 'UPDATESHOP',
  Updatestockitems = 'UPDATESTOCKITEMS',
  Updatetradein = 'UPDATETRADEIN',
  Updatevoucher = 'UPDATEVOUCHER'
}

/** List of items with pagination. */
export type IntegrationMessageIntegrationMessagePagination = {
  __typename?: 'IntegrationMessageIntegrationMessagePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<IntegrationMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IntegrationMessageResult = {
  __typename?: 'IntegrationMessageResult';
  messageFailed?: Maybe<Scalars['Boolean']>;
  result?: Maybe<Scalars['JSON']>;
  resultTs?: Maybe<Scalars['Date']>;
};

export type IntegrationSetting = {
  __typename?: 'IntegrationSetting';
  _id: Scalars['MongoID'];
  /** The instance */
  instanceId: Scalars['MongoID'];
  /** The key of the setting */
  key: Scalars['String'];
  /** The referenced object, owner of this setting */
  refId: Scalars['MongoID'];
  /** The value of the setting */
  value?: Maybe<Scalars['JSON']>;
};

export type IntegrationSettingInInput = {
  /** The key of the setting */
  key: Scalars['String'];
  /** The value of the setting */
  value?: InputMaybe<Scalars['JSON']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['MongoID'];
  /** The brandhouse */
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  currency?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['Date']>;
  invoiceId: Scalars['String'];
  locked?: Maybe<Scalars['Boolean']>;
  paid?: Maybe<Scalars['Boolean']>;
  /** Total amount of this invoice */
  total?: Maybe<InvoiceTotal>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type InvoiceAdjustment = {
  __typename?: 'InvoiceAdjustment';
  _id: Scalars['MongoID'];
  amount: Scalars['Float'];
  /** The brandhouse */
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  /** The current invoice settings for this brandhouse. */
  settings?: Maybe<InvoiceSetting>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  _id: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
  cost: Scalars['Float'];
  createdAt?: Maybe<Scalars['Date']>;
  currency: Scalars['String'];
  /** The invoice this line belongs to */
  invoice?: Maybe<Invoice>;
  invoiceId: Scalars['MongoID'];
  /** The calculated date for this invoice line, and depends on when the invoicing is enabled for the customer */
  lineDate: Scalars['Date'];
  lineId: Scalars['String'];
  lineIndex: Scalars['Float'];
  lineType: EnumInvoiceLineLineType;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type InvoiceSetting = {
  __typename?: 'InvoiceSetting';
  _id: Scalars['MongoID'];
  /** The brandhouse for this invoice settings */
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  costPerItem?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  /** Custom data for the invoice settings */
  customData?: Maybe<Scalars['JSON']>;
  fee?: Maybe<Scalars['Float']>;
  minPlatformCost?: Maybe<Scalars['Float']>;
  shops?: Maybe<Array<Maybe<InvoiceSettingShops>>>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type InvoiceSettingInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  brandHouseId: Scalars['MongoID'];
  costPerItem?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the invoice settings */
  customData?: InputMaybe<Scalars['JSON']>;
  fee?: InputMaybe<Scalars['Float']>;
  minPlatformCost?: InputMaybe<Scalars['Float']>;
  shops?: InputMaybe<Array<InputMaybe<InvoiceSettingShopsInput>>>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type InvoiceSettingShops = {
  __typename?: 'InvoiceSettingShops';
  _id?: Maybe<Scalars['MongoID']>;
  comment?: Maybe<Scalars['String']>;
  costPerItem: Scalars['Float'];
  pickPackFee: Scalars['Float'];
  saleCommisionPct: Scalars['Float'];
  shippingOrder: Scalars['Float'];
  shippingReturn: Scalars['Float'];
  shippingTradeIn: Scalars['Float'];
  shopId: Scalars['MongoID'];
};

export type InvoiceSettingShopsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  comment?: InputMaybe<Scalars['String']>;
  costPerItem: Scalars['Float'];
  pickPackFee: Scalars['Float'];
  saleCommisionPct: Scalars['Float'];
  shippingOrder: Scalars['Float'];
  shippingReturn: Scalars['Float'];
  shippingTradeIn: Scalars['Float'];
  shopId: Scalars['MongoID'];
};

export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  sections?: Maybe<Array<Maybe<InvoiceTotalSection>>>;
  total: Scalars['Float'];
};

export type InvoiceTotalSection = {
  __typename?: 'InvoiceTotalSection';
  lines?: Maybe<Array<Maybe<InvoiceTotalValue>>>;
  title: Scalars['String'];
  total: Scalars['Float'];
};

export type InvoiceTotalValue = {
  __typename?: 'InvoiceTotalValue';
  count: Scalars['Int'];
  lineType: EnumInvoiceLineLineType;
  sum: Scalars['Float'];
  title: Scalars['String'];
};

export type ItemImageInfo = {
  __typename?: 'ItemImageInfo';
  altText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageMd5?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  localImagePath?: Maybe<Scalars['String']>;
  masterDataImage: Scalars['Boolean'];
  version: Scalars['Float'];
};

export type ItemIssue = {
  __typename?: 'ItemIssue';
  _id: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
  /** The brand item this issue belongs to */
  brandItem?: Maybe<BrandItemResolved>;
  brandItemId: Scalars['MongoID'];
  /** The date when the issue was created */
  createdAt?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  externId?: Maybe<Scalars['String']>;
  /** URL to the image of the issue */
  imageUrl?: Maybe<Scalars['String']>;
  issue: Scalars['String'];
  location?: Maybe<EnumItemIssueLocation>;
  /** Marker X position as percent (0-100) of image width, origin top-left */
  markX?: Maybe<Scalars['Float']>;
  /** Marker Y position as percent (0-100) of image height, origin top-left */
  markY?: Maybe<Scalars['Float']>;
  /** Coordinate of the issue, A1, B2, etc. */
  point?: Maybe<Scalars['String']>;
  processedId?: Maybe<Scalars['MongoID']>;
  /** The processed image url of the issue, will return null until the image is processed */
  processedUrl?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};


export type ItemIssueProcessedUrlArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};

export type ItemIssueInput = {
  externId?: InputMaybe<Scalars['String']>;
  /** URL to the image of the issue */
  imageUrl?: InputMaybe<Scalars['String']>;
  issue: Scalars['String'];
  location?: InputMaybe<EnumItemIssueLocation>;
  /** Marker X position as percent (0-100) of image width, origin top-left */
  markX?: InputMaybe<Scalars['Float']>;
  /** Marker Y position as percent (0-100) of image height, origin top-left */
  markY?: InputMaybe<Scalars['Float']>;
  /** Coordinate of the issue, A1, B2, etc. */
  point?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type ItemIssueItemIssuesPagination = {
  __typename?: 'ItemIssueItemIssuesPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ItemIssue>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum ItemSourceType {
  Claim = 'CLAIM',
  Newitem = 'NEWITEM',
  Sample = 'SAMPLE',
  Secondhand = 'SECONDHAND'
}

export type Localization = {
  __typename?: 'Localization';
  /** The default value of this key */
  default?: Maybe<Scalars['String']>;
  /** Whether this value was inherited from the brand */
  inherited: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type LocalizationEntry = {
  __typename?: 'LocalizationEntry';
  /** ISO Locale code */
  locale: Scalars['String'];
  /** The localized text */
  value: Scalars['String'];
};

export type LocalizationEntryInput = {
  /** ISO Locale code */
  locale: Scalars['String'];
  /** The localized text */
  value: Scalars['String'];
};

export type LocalizationInput = {
  key?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type LocalizedMetaFieldInstance = {
  __typename?: 'LocalizedMetaFieldInstance';
  /** The language of the localized metafields */
  language?: Maybe<Scalars['String']>;
  /** The metafields */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
};

export type LocalizedMetaFieldInstanceInput = {
  /** The language of the localized metafields */
  language?: InputMaybe<Scalars['String']>;
  /** The metafields */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  simplified: Scalars['Boolean'];
  token: Scalars['String'];
  userType: Scalars['String'];
};

export type LogisticsPartner = {
  __typename?: 'LogisticsPartner';
  _id: Scalars['MongoID'];
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** API KEY for the logisticspartner, use this to obtain an accessToken */
  apiKey?: Maybe<Scalars['String']>;
  /** API Secret for the logisticspartner, use this to obtain an accessToken */
  apiSecret?: Maybe<Scalars['String']>;
  attention?: Maybe<Scalars['String']>;
  autoretouch?: Maybe<LogisticsPartnerAutoretouch>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type LogisticsPartnerAutoretouch = {
  __typename?: 'LogisticsPartnerAutoretouch';
  accessToken?: Maybe<Scalars['String']>;
  expireTs?: Maybe<Scalars['Date']>;
  refreshToken?: Maybe<Scalars['String']>;
};

export type MasterDataImage = {
  __typename?: 'MasterDataImage';
  _id?: Maybe<Scalars['String']>;
  perspective?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  thumbUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MasterDataKeyValue = {
  __typename?: 'MasterDataKeyValue';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type MasterDataLocalizedValue = {
  __typename?: 'MasterDataLocalizedValue';
  locale: Scalars['String'];
  value: Scalars['String'];
};

export type MasterDataProduct = {
  __typename?: 'MasterDataProduct';
  _id: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<MasterDataImage>>>;
  name?: Maybe<Array<Maybe<MasterDataLocalizedValue>>>;
  options?: Maybe<Array<Maybe<MasterDataProductOption>>>;
  style?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Array<Maybe<MasterDataLocalizedValue>>>;
  variants?: Maybe<Array<Maybe<MasterDataVariant>>>;
  vendor?: Maybe<Array<Maybe<MasterDataLocalizedValue>>>;
};

export type MasterDataProductOption = {
  __typename?: 'MasterDataProductOption';
  key: Scalars['String'];
  name?: Maybe<Array<Maybe<MasterDataLocalizedValue>>>;
  type?: Maybe<Scalars['String']>;
};

export type MasterDataVariant = {
  __typename?: 'MasterDataVariant';
  _id: Scalars['String'];
  ean?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<MasterDataImage>>>;
  options?: Maybe<Array<Maybe<MasterDataKeyValue>>>;
  sku?: Maybe<Scalars['String']>;
};

export type MasterDataVisualSearchHit = {
  __typename?: 'MasterDataVisualSearchHit';
  imageUrl?: Maybe<Scalars['String']>;
  product?: Maybe<MasterDataProduct>;
  score: Scalars['Float'];
};

export type MetaField = {
  __typename?: 'MetaField';
  /** Custom data to the metafield */
  customData?: Maybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: Maybe<Scalars['String']>;
  /** Type of the value, required */
  type?: Maybe<EnumMetaFieldType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type MetaFieldInput = {
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type MetaFieldInstance = {
  __typename?: 'MetaFieldInstance';
  /** If the metafield was auto added by configuration */
  auto?: Maybe<Scalars['Boolean']>;
  /** Custom data to the metafield */
  customData?: Maybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: Maybe<Scalars['String']>;
  /** Type of the value, required */
  type?: Maybe<EnumMetaFieldInstanceType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type MetaFieldInstanceInput = {
  /** If the metafield was auto added by configuration */
  auto?: InputMaybe<Scalars['Boolean']>;
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldInstanceType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ApproveImageAudit?: Maybe<BrandItemImage>;
  /** Create an audit note with explanation. Required before making configuration changes when requireChangeExplanation is enabled on the brand. */
  AuditNoteCreate?: Maybe<AuditNote>;
  BrandApiUpdate?: Maybe<BrandApi>;
  BrandCarrierActivate?: Maybe<BrandCarrier>;
  BrandHouseAuthorize?: Maybe<AuthorizeResult>;
  BrandHouseCreate?: Maybe<BrandHouse>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  BrandHouseUpdate?: Maybe<UpdateByIdBrandHousePayload>;
  /** Updates the branditem caches */
  BrandItemAdjustAutoImages?: Maybe<Scalars['Boolean']>;
  /** Links a BrandItem to a masterdata (MAS) variant: sets masterDataVariantId, unsets the legacy brandProductSize/snapshot fields, and pulls fresh MAS data. Replaces any legacy snapshot link. */
  BrandItemAttachMasterDataVariant?: Maybe<BrandItem>;
  /** Attaches masterdata to a branditem by copying (snapshotting) all masterdata fields into the item's own fields. The item will NOT have a live reference to masterdata, making it immune to future masterdata changes. */
  BrandItemAttachSnapshot?: Maybe<BrandItem>;
  /** Updates the branditem caches */
  BrandItemCalculatePrices?: Maybe<Array<Maybe<Pricing>>>;
  /** Updates the inventory checked and missing flag for this branditem */
  BrandItemChecked?: Maybe<BrandItem>;
  /** Will delete the branditem */
  BrandItemDelete?: Maybe<BrandItem>;
  /** Will update the group for the given branditems, only brandItems that as updated will be returned */
  BrandItemGroupUpdate?: Maybe<Array<Maybe<BrandItem>>>;
  BrandItemImageClearRemoveBgResult?: Maybe<BrandItemImage>;
  /** Updates the branditem caches */
  BrandItemImageRotate?: Maybe<BrandItemImage>;
  /** Triggers integration updates for the provided brand items */
  BrandItemIntegrationUpdate: Scalars['Boolean'];
  /** Triggers the OPTIMIZEBYSALESRANK integration message to all shops belonging to the specified brandHouse */
  BrandItemOptimizeBySalesRank: Scalars['Boolean'];
  /** Promotes a branditem to being a source for a new masterdata */
  BrandItemPromote?: Maybe<BrandItem>;
  /** This mutation will ensure that a stockitem in the specific shop exists for the given brandItem. If the stockitem already exists, nothing will be done */
  BrandItemPush?: Maybe<Array<Maybe<BrandItemShopInfo>>>;
  /** This mutation will trigger a new retouch on all images that needs a retouch */
  BrandItemRetouch?: Maybe<Array<Maybe<BrandItem>>>;
  /** This mutation will either save an existing branditem or create a new one */
  BrandItemUpdate?: Maybe<BrandItem>;
  /** Updates the branditem caches */
  BrandItemUpdateCache: Scalars['Boolean'];
  /** Updates the branditem identifiers */
  BrandItemUpdateIdentifiers: Scalars['Boolean'];
  /** Will update the price for any currency configured on the brandhouse, that is not set on the item - as long as one price is set */
  BrandItemUpdatePrices?: Maybe<Array<Maybe<BrandItem>>>;
  /** Queues a missing-only MAS masterdata backfill for linked BrandItems */
  BrandItemsBackfillMasterData?: Maybe<BrandItemMasterDataBackfillResult>;
  /** Queues an admin-approved BrandItem migration to MAS masterDataVariantId */
  BrandItemsMigrateToMasterDataVariant?: Maybe<BrandItemMasterDataMigrationRun>;
  /** Queues an admin-only preview for migrating BrandItems to MAS masterDataVariantId */
  BrandItemsPreviewMasterDataVariantMigration?: Maybe<BrandItemMasterDataMigrationRun>;
  /** Queues a fresh MAS masterdata refresh for linked BrandItems */
  BrandItemsRefreshMasterData?: Maybe<BrandItemMasterDataRefreshResult>;
  BrandLocalizationsUpdate?: Maybe<Array<Maybe<Localization>>>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  BrandProductGroupCreate?: Maybe<CreateOneBrandProductGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  BrandProductGroupUpdate?: Maybe<UpdateByIdBrandProductGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  BrandProductImageUpdate?: Maybe<UpdateByIdBrandProductImagePayload>;
  BrandProductImport: Scalars['Boolean'];
  BrandProductReset: Scalars['Boolean'];
  BrandProductSynchronize?: Maybe<BrandProduct>;
  BrandProductVariantRebuildIndex: Scalars['Int'];
  BrandRuleActivation?: Maybe<BrandRule>;
  BrandRuleCreate?: Maybe<BrandRule>;
  BrandRuleDelete?: Maybe<BrandRule>;
  BrandRuleUpdate?: Maybe<BrandRule>;
  BrandRuleUpdateStatistics: Scalars['Boolean'];
  /** Copy BrandSetting fields from sourceShopId to targetShopId. Both shops must belong to the same brand house. Identity, language, country, contact, and external-integration fields are not copied. */
  BrandSettingsCopy?: Maybe<BrandSetting>;
  BrandSettingsUpdate?: Maybe<BrandSetting>;
  BrickMailActivate?: Maybe<BrickMail>;
  BrickMailCopy: Scalars['Boolean'];
  BrickMailReset: Scalars['Boolean'];
  BrickMailReset2: Scalars['Boolean'];
  BrickMailTest: Scalars['String'];
  BrickMailUpdate?: Maybe<Array<Maybe<BrickMailValidation>>>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  CampaignCreate?: Maybe<CreateOneCampaignPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CampaignUpdate?: Maybe<UpdateByIdCampaignPayload>;
  CircularPayout?: Maybe<CircularPoint>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CircularPayoutUpdateById?: Maybe<UpdateByIdCircularPayoutTypePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  CircularPointCreate?: Maybe<CreateOneCircularPointPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  CircularPointUpdate?: Maybe<UpdateByIdCircularPointPayload>;
  /** Mutation that will update the synchronization timestamps for the given services */
  CompleteSynchronize?: Maybe<SyncCompleteResult>;
  /** Unified consumer access request. When an integration handles REQUESTACCESS, it must either: (1) create the consumer and call ConsumerCompleteAccess, or (2) call ConsumerRejectAccess if the consumer is not found. */
  ConsumerAccessRequest?: Maybe<ConsumerAccessRequestResult>;
  ConsumerActivitySetup: Scalars['String'];
  /** Completes the consumer access flow after integration processing. The backend derives authMethod from the stored integration message. */
  ConsumerCompleteAccess?: Maybe<ConsumerCompleteAccessResult>;
  ConsumerCreate?: Maybe<Consumer>;
  ConsumerCreate2?: Maybe<Consumer>;
  ConsumerJourneyRebuild?: Maybe<Scalars['Boolean']>;
  ConsumerLogin?: Maybe<ConsumerAuthorizeResult>;
  /** Updates mail state */
  ConsumerMailUpdate: Scalars['Boolean'];
  ConsumerMerge?: Maybe<Consumer>;
  /** Called by integrations when the consumer is not found. Sends an 'unknown' email if sendMail was true in the original request. */
  ConsumerRejectAccess?: Maybe<ConsumerRejectAccessResult>;
  ConsumerRequestAccess?: Maybe<ConsumerSendMail>;
  /** Will trigger the request for access flow, and return the tokens for the messages sent - these tokens can be used to query for status */
  ConsumerRequestAccessFlow?: Maybe<Array<Scalars['String']>>;
  /** Will trigger the request for potentials, and return the tokens for the messages sent - these tokens can be used to query for status */
  ConsumerRequestPotentials?: Maybe<Array<Scalars['String']>>;
  ConsumerSendCode?: Maybe<ConsumerSendCode>;
  ConsumerSendEmail: Scalars['Boolean'];
  /** Idempotent get-or-create for non-selfCreated consumers, keyed by the given identifier+identifierType. Returns the existing consumer (merging in non-null input fields) or creates a new one with selfCreated=false and personId set to the identifier. */
  ConsumerSynchronize?: Maybe<Consumer>;
  ConsumerUpdate?: Maybe<Consumer>;
  ConsumerVerifyCode?: Maybe<ConsumerVerifyCode>;
  CurrencyConvert?: Maybe<CurrencyConversion>;
  DataViewCreate?: Maybe<DataView>;
  DigitalPassportInit?: Maybe<DigitalPassport>;
  ExternOrder2Synchronize?: Maybe<ExternOrder2>;
  ExternOrderSynchronize?: Maybe<ExternOrder>;
  /** Snooze an audit result out of the queue for 24 hours; it reappears once the hide window passes. Does not change audit/go-live state. */
  HideImageAudit?: Maybe<BrandItemImage>;
  ImageRotate?: Maybe<ImageUpload>;
  IntegrationConfigUpdate?: Maybe<IntegrationConfig>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  IntegrationConnectorCreate?: Maybe<CreateOneIntegrationConnectorPayload>;
  /** Remove one document: 1) Remove with hooks via findOneAndRemove. 2) Return removed document. */
  IntegrationConnectorDelete?: Maybe<RemoveOneIntegrationConnectorPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  IntegrationConnectorUpdate?: Maybe<UpdateByIdIntegrationConnectorPayload>;
  IntegrationDelete?: Maybe<Array<Maybe<IntegrationConfig>>>;
  /** Will install the given connector and enable all its currently supported messages. */
  IntegrationInstall?: Maybe<IntegrationInstance>;
  /** Will execute the given integration function and return tokens that can be used by IntegrationMessage to query for status and results */
  IntegrationMessageExecute?: Maybe<Array<Scalars['String']>>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  IntegrationMessageUpdate?: Maybe<UpdateByIdIntegrationMessagePayload>;
  /** Re-initializes the integration instance by sending an init message. */
  IntegrationReInitialize?: Maybe<IntegrationInstance>;
  IntegrationSettingUpdate?: Maybe<Array<Maybe<IntegrationSetting>>>;
  /** Will uninstall the given connector. */
  IntegrationUnInstall?: Maybe<IntegrationInstance>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  InvoiceAdjustmentCreate?: Maybe<CreateOneInvoiceAdjustmentPayload>;
  InvoiceDelete: Scalars['Boolean'];
  InvoiceRebuild: Scalars['Boolean'];
  /** Resets all invoices newer than the provided invoice, will return a list of reset invoices */
  InvoiceReset?: Maybe<Array<Maybe<Invoice>>>;
  InvoiceSettingUpdate?: Maybe<InvoiceSetting>;
  InvoiceUpdate?: Maybe<Invoice>;
  /** Synchronizes the option set with the given input */
  ItemIssueSynchronize?: Maybe<Array<Maybe<ItemIssue>>>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ItemIssueUpdate?: Maybe<UpdateByIdItemIssuePayload>;
  /** Will start the klaviyo synchronization. */
  KlaviyoSynchronize?: Maybe<Scalars['String']>;
  LogisticsPartnerAuthorize?: Maybe<AuthorizeResult>;
  /** Resets the checked flag on all stock items- used when counting stock */
  LogisticsStockItemsCheckedReset?: Maybe<Scalars['Boolean']>;
  /** Synchronizes the option set with the given input */
  OptionSynchronize?: Maybe<OptionSet>;
  OrderCapture?: Maybe<Order2>;
  /** Mutation that will create and register a return label for the order */
  OrderCreateReturn: ShippingLabel;
  /** Extend the return deadline for orders placed within a date range. Only updates orders where the new deadline actually extends beyond their normal deadline. If brandHouseId is not provided, admin access is required and all active brandHouses are processed. */
  OrderExtendReturnDeadline?: Maybe<OrderExtendReturnDeadlineResult>;
  OrderFulfill?: Maybe<Order2>;
  /** Mutation that registers externally provided tracking information for a return without creating a shipping label */
  OrderRegisterReturn: Order2;
  /** Clears return data on an order (returnShippingLabelId, returnInfo, and all OrderLineReturn records), allowing a new return to be created */
  OrderResetReturn: Order2;
  OrderSetTracking?: Maybe<Order2>;
  /** Use this to update an order from an external system. */
  OrderSynchronize?: Maybe<Order2>;
  /** Use this to update the order in create2STAY. */
  OrderUpdate?: Maybe<Order2>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  ParcelCreate?: Maybe<CreateOneParcelPayload>;
  /** Will update the tracking status of a parcel, return true if successful, false if not. Requires admin access. */
  ParcelTrackingUpdate?: Maybe<Scalars['Boolean']>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ParcelUpdate?: Maybe<UpdateOneParcelPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  PlannedMailUpdate?: Maybe<UpdateOnePlannedMailPayload>;
  PotentialCreate?: Maybe<Potential>;
  PotentialDelete?: Maybe<Potential>;
  PotentialDistribute: Scalars['Boolean'];
  PotentialSynchronize?: Maybe<Array<Maybe<Potential>>>;
  PotentialSynchronize2?: Maybe<Array<Maybe<Potential>>>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  PotentialUpdate?: Maybe<UpdateByIdPotentialPayload>;
  ProductDisable?: Maybe<Product>;
  ProductImageCreate?: Maybe<Array<Maybe<ProductImage>>>;
  ProductSynchronize?: Maybe<Product>;
  ProductSynchronizeTranslations?: Maybe<Product>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ProductUpdateById?: Maybe<UpdateByIdProductPayload>;
  ProductsAutocomplete?: Maybe<Array<Maybe<Product>>>;
  QRSessionCreate?: Maybe<QrSession>;
  QRSessionUpdate?: Maybe<QrSession>;
  RejectImageAudit?: Maybe<BrandItemImage>;
  /** Reject a background-removal audit result and pause the brand item by adding a 'Retake photos' problem. The item is blocked from go-live in every shop until that problem is solved. */
  RejectImageAuditRetake?: Maybe<BrandItemImage>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  ScheduledEventCreate?: Maybe<CreateOneScheduledEventPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ScheduledEventUpdate?: Maybe<UpdateOneScheduledEventPayload>;
  SendSystemMail: Scalars['Boolean'];
  ShippingCarrierUpdate?: Maybe<ShippingCarrier>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  ShippingLabelCreate?: Maybe<CreateOneShippingLabelPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ShippingLabelUpdate?: Maybe<UpdateOneShippingLabelPayload>;
  /** Mutation that will create and register a shop given its license key and some required info */
  ShopCreate?: Maybe<Shop>;
  /** Mutation that will create and register an external shop given its license key and some required info */
  ShopCreate2?: Maybe<Shop>;
  /** Deletes the shop and ALL its data from the service. This cant be undone, so be careful. Cant delete LIVE shops */
  ShopDelete?: Maybe<Shop>;
  /** Will trigger a maintainance of the shop and mark the it as live */
  ShopLaunch?: Maybe<Shop>;
  /** Resets the shop and its data */
  ShopReset?: Maybe<Shop>;
  /** Updates core shop properties */
  ShopUpdate?: Maybe<Shop>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ShopUpdateOne?: Maybe<UpdateOneShopPayload>;
  /** Will initiate a synchronization with the external shop. This will trigger a webhook/eventbus call to the external shop */
  StartSynchronize?: Maybe<SyncResult>;
  /** Updates the inventory checked and missing flag for this stockitem */
  StockItemChecked?: Maybe<StockItem>;
  StockItemCreate?: Maybe<StockItem>;
  StockItemCreateEmpty?: Maybe<StockItem>;
  StockItemDelete?: Maybe<StockItem>;
  StockItemImageAutoRetouch?: Maybe<StockItemImage>;
  StockItemImageAutoRetouch2?: Maybe<Array<Maybe<StockItemImage>>>;
  StockItemImageAutoRetouchAll?: Maybe<Array<Maybe<StockItemImage>>>;
  StockItemImageCreate?: Maybe<StockItemImage>;
  StockItemImageCreate2?: Maybe<StockItemImage>;
  StockItemImageDelete?: Maybe<StockItemImage>;
  StockItemImageRotate?: Maybe<StockItemImage>;
  StockItemImageSetOrder?: Maybe<Array<Maybe<StockItemImage>>>;
  /** Synchronizes the images of the stockitem */
  StockItemImageSynchronize?: Maybe<StockItem>;
  StockItemImageUpdate?: Maybe<StockItemImage>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  StockItemImageUpdateById?: Maybe<UpdateByIdStockItemImagePayload>;
  /** Updates the stockitem inventory, 0 */
  StockItemInventoryUpdate?: Maybe<StockItem>;
  /** Pushes a notification to the external shop that it should update our version of the stockitem with their data */
  StockItemPull?: Maybe<Scalars['Boolean']>;
  /** Resets the itemSku of all stockitems */
  StockItemResetSKU?: Maybe<Array<Maybe<StockItem>>>;
  StockItemUpdate?: Maybe<StockItem>;
  /** Calculates the selling price of the input stockitem */
  StockItemsRecalculatePrice?: Maybe<Scalars['Float']>;
  /** Updates the stockitems selling prices */
  StockItemsRecalculatePrices?: Maybe<Array<Maybe<StockItem>>>;
  /** Registration of an already stored file. The file must be located in one of the designated directories */
  StorageFileRegister?: Maybe<StorageFile>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  SurveyRespondentCreate?: Maybe<CreateOneRespondentPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  SurveyUpdate?: Maybe<UpdateByIdSurveyPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  SystemMessageAcknowledge?: Maybe<UpdateOneSystemMessagePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  SystemMessageCreate?: Maybe<CreateOneSystemMessagePayload>;
  TradeInCreate?: Maybe<TradeIn>;
  TradeInDelete?: Maybe<TradeIn>;
  /** Deletes the tradein */
  TradeInDelete2?: Maybe<TradeIn>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  TradeInItemUpdateById?: Maybe<UpdateByIdTradeInItemPayload>;
  /** Will remove the items from the tradein, and will rebalance the vouchers issued. Make sure the vouchers hasnt been used before running this mutation. */
  TradeInItemsReject?: Maybe<Array<Maybe<TradeInItem>>>;
  /** Resync all tradeins for a brand house by triggering handleTradeInUpdated for each */
  TradeInResync?: Maybe<TradeInResyncResult>;
  /** Synchronize a tradein with the system, this will create a new tradein if the ID is not provided, or update the tradein if the ID is provided. If the delete flag is set to true, the tradein will be deleted. */
  TradeInSynchronize?: Maybe<TradeIn>;
  /** Will update the tradein */
  TradeInUpdate?: Maybe<TradeIn>;
  /** Toggle the disable bit of a users access to brand / logisticspartner */
  UserAccessToggle?: Maybe<UserAccess>;
  /** Invites the user identified by the email to access either a brandhouse or a logisticspartner at the platform. If the user does not exist, then the user will be able to create an account before accepting the actual access */
  UserInvite?: Maybe<UserAccess>;
  /** The current user accepts the invitation to access a ressource on the platform */
  UserInviteAccept?: Maybe<UserAccess>;
  /** The user joins the platform */
  UserInviteJoin?: Maybe<LoginResult>;
  UserLogin?: Maybe<LoginResult>;
  /** Recovers the password of the user and sends a mail with a link */
  UserRecoverPassword?: Maybe<Scalars['Boolean']>;
  UserRefresh?: Maybe<RefreshResult>;
  /** Resets the account password */
  UserResetPassword?: Maybe<Scalars['Boolean']>;
  /** Updates the password of the user */
  UserUpdatePassword?: Maybe<User>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  VoucherAdjustmentCreate?: Maybe<CreateOneVoucherAdjustmentPayload>;
  VoucherDelete?: Maybe<Voucher>;
  /** Enable / disable voucher */
  VoucherEnable?: Maybe<Voucher>;
  /** Called by the integration when the voucher has been generated in the storefront. The storefront must supply a externId in order to activate the voucher flow. The storefront can remove the externId to signal that the voucher has been removed. */
  VoucherFrontUpdate?: Maybe<Voucher>;
  /** Deletes the vouchers and generates a new one with a total sum matching the input vouchers */
  VoucherMerge?: Maybe<Voucher>;
  /** Instantly sends reminders to all customers that has unused vouchers */
  VoucherSendReminder: Scalars['Boolean'];
  VoucherSynchronize?: Maybe<Voucher>;
  /** This mutation will synchronize the voucher usage */
  VoucherUsageSynchronize?: Maybe<VoucherUsage>;
  /** Copy all non-deleted WholeSaleCategory documents from one shop to another within the same brand house. Refuses if the target already has categories. */
  WholeSaleCategoryCopy?: Maybe<Array<Maybe<WholeSaleCategory>>>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  WholeSaleCategoryCreate?: Maybe<CreateOneWholeSaleCategoryPayload>;
  WholeSaleCategoryDelete?: Maybe<WholeSaleCategory>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  WholeSaleCategoryUpdate?: Maybe<UpdateOneWholeSaleCategoryPayload>;
};


export type MutationApproveImageAuditArgs = {
  brandItemImageId: Scalars['MongoID'];
};


export type MutationAuditNoteCreateArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  explanation: Scalars['String'];
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandApiUpdateArgs = {
  api?: InputMaybe<BrandApiInput>;
  shopId: Scalars['String'];
};


export type MutationBrandCarrierActivateArgs = {
  active: Scalars['Boolean'];
  brandHouseId: Scalars['MongoID'];
  shippingCarrierId: Scalars['MongoID'];
};


export type MutationBrandHouseAuthorizeArgs = {
  license: Scalars['String'];
  shopId?: InputMaybe<Scalars['String']>;
};


export type MutationBrandHouseCreateArgs = {
  logisticsPartnerId: Scalars['String'];
  name: Scalars['String'];
};


export type MutationBrandHouseUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdBrandHouseInput;
};


export type MutationBrandItemAdjustAutoImagesArgs = {
  brandItemId: Scalars['MongoID'];
};


export type MutationBrandItemAttachMasterDataVariantArgs = {
  brandItemId: Scalars['MongoID'];
  masterDataVariantId: Scalars['String'];
};


export type MutationBrandItemAttachSnapshotArgs = {
  brandItemId: Scalars['MongoID'];
  brandProductSizeId: Scalars['MongoID'];
};


export type MutationBrandItemCalculatePricesArgs = {
  brandHouseId: Scalars['MongoID'];
  item?: InputMaybe<BrandItemInputInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandItemCheckedArgs = {
  brandItemId: Scalars['MongoID'];
  checked?: InputMaybe<Scalars['Boolean']>;
  missing?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandItemDeleteArgs = {
  brandItemId: Scalars['MongoID'];
};


export type MutationBrandItemGroupUpdateArgs = {
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type MutationBrandItemImageClearRemoveBgResultArgs = {
  brandItemImageId: Scalars['MongoID'];
};


export type MutationBrandItemImageRotateArgs = {
  brandHouseId: Scalars['MongoID'];
  imageId: Scalars['MongoID'];
  rotate: Scalars['Float'];
};


export type MutationBrandItemIntegrationUpdateArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
  instanceId: Scalars['MongoID'];
};


export type MutationBrandItemOptimizeBySalesRankArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type MutationBrandItemPromoteArgs = {
  brandItemId: Scalars['MongoID'];
};


export type MutationBrandItemPushArgs = {
  active: Scalars['Boolean'];
  brandItemId: Scalars['MongoID'];
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandItemRetouchArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
};


export type MutationBrandItemUpdateArgs = {
  brandHouseId: Scalars['MongoID'];
  input?: InputMaybe<BrandItemInputInput>;
  silent?: InputMaybe<Scalars['Boolean']>;
  snapshotAfter?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandItemUpdateCacheArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  silent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandItemUpdateIdentifiersArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type MutationBrandItemUpdatePricesArgs = {
  brandItemIds?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type MutationBrandItemsBackfillMasterDataArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
};


export type MutationBrandItemsMigrateToMasterDataVariantArgs = {
  selections: Array<BrandItemMasterDataMigrationSelectionInput>;
  sourcePreviewRunId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandItemsPreviewMasterDataVariantMigrationArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
};


export type MutationBrandItemsRefreshMasterDataArgs = {
  brandItemIds: Array<Scalars['MongoID']>;
  refreshImages?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandLocalizationsUpdateArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  localizations?: InputMaybe<Array<InputMaybe<LocalizationInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  type: Scalars['String'];
};


export type MutationBrandProductGroupCreateArgs = {
  record: CreateOneBrandProductGroupInput;
};


export type MutationBrandProductGroupUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdBrandProductGroupInput;
};


export type MutationBrandProductImageUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdBrandProductImageInput;
};


export type MutationBrandProductImportArgs = {
  brandHouseId: Scalars['MongoID'];
  productId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrandProductResetArgs = {
  brandHouseId: Scalars['MongoID'];
  groupId: Scalars['MongoID'];
  potentials?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBrandProductSynchronizeArgs = {
  brandHouseId: Scalars['MongoID'];
  input?: InputMaybe<BrandProductSynchronizeInput>;
  mode?: InputMaybe<BrandSynchronizeMode>;
  source?: InputMaybe<Scalars['String']>;
};


export type MutationBrandProductVariantRebuildIndexArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type MutationBrandRuleActivationArgs = {
  active: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  ruleId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
};


export type MutationBrandRuleCreateArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  shopId: Scalars['MongoID'];
};


export type MutationBrandRuleDeleteArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  ruleId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
};


export type MutationBrandRuleUpdateArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  rule?: InputMaybe<BrandRuleInput>;
};


export type MutationBrandRuleUpdateStatisticsArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationBrandSettingsCopyArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  sourceShopId: Scalars['MongoID'];
  targetShopId: Scalars['MongoID'];
};


export type MutationBrandSettingsUpdateArgs = {
  api?: InputMaybe<BrandSettingInput>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationBrickMailActivateArgs = {
  active: Scalars['Boolean'];
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  mailType: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationBrickMailCopyArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  defaultLocale: Scalars['String'];
  sourceShopId: Scalars['MongoID'];
  targetShopId: Scalars['MongoID'];
};


export type MutationBrickMailResetArgs = {
  alignText?: InputMaybe<Scalars['String']>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  backgroundColor: Scalars['String'];
  bodyPadding: Scalars['String'];
  boxBackgroundColor: Scalars['String'];
  boxBorderColor: Scalars['String'];
  boxTextColor: Scalars['String'];
  color: Scalars['String'];
  conceptName: Scalars['String'];
  conceptPrefix: Scalars['String'];
  configHeader?: InputMaybe<Scalars['String']>;
  disableTitle: Scalars['Boolean'];
  font: Scalars['String'];
  fontSize?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  frame: Scalars['String'];
  frameColor: Scalars['String'];
  fromMail: Scalars['String'];
  header?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  logoBackgroundColor: Scalars['String'];
  logoUrl: Scalars['String'];
  mailType?: InputMaybe<Scalars['String']>;
  resetAll: Scalars['Boolean'];
  resetBasics: Scalars['Boolean'];
  resetBricks: Scalars['Boolean'];
  resetFooter: Scalars['Boolean'];
  resetHeader: Scalars['Boolean'];
  shopId: Scalars['String'];
  shopName: Scalars['String'];
  shopUrl: Scalars['String'];
  textBackgroundColor: Scalars['String'];
};


export type MutationBrickMailReset2Args = {
  alignText?: InputMaybe<Scalars['String']>;
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  bodyPadding?: InputMaybe<Scalars['String']>;
  boxBackgroundColor?: InputMaybe<Scalars['String']>;
  boxBorderColor?: InputMaybe<Scalars['String']>;
  boxTextColor?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  frame?: InputMaybe<Scalars['String']>;
  frameColor?: InputMaybe<Scalars['String']>;
  fromMail?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  logoBackgroundColor?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  shopUrl?: InputMaybe<Scalars['String']>;
  textBackgroundColor?: InputMaybe<Scalars['String']>;
};


export type MutationBrickMailTestArgs = {
  activations: Scalars['Boolean'];
  consumerEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  language: Scalars['String'];
  mailType: Scalars['String'];
  onlyConnectors?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
};


export type MutationBrickMailUpdateArgs = {
  auditNoteId?: InputMaybe<Scalars['MongoID']>;
  input?: InputMaybe<Array<InputMaybe<BrickMailMailsInput>>>;
  mailType: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type MutationCampaignCreateArgs = {
  record: CreateOneCampaignInput;
};


export type MutationCampaignUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdCampaignInput;
};


export type MutationCircularPayoutArgs = {
  amount: Scalars['Float'];
  consumerId: Scalars['MongoID'];
  options?: InputMaybe<CircularPayoutInstanceInput>;
};


export type MutationCircularPayoutUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdCircularPayoutTypeInput;
};


export type MutationCircularPointCreateArgs = {
  record: CreateOneCircularPointInput;
};


export type MutationCircularPointUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdCircularPointInput;
};


export type MutationCompleteSynchronizeArgs = {
  service: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationConsumerAccessRequestArgs = {
  authMethod: ConsumerAuthMethodEnum;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  identifier: Scalars['String'];
  onlyDefaultFlow?: InputMaybe<Scalars['Boolean']>;
  sendMail?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerActivitySetupArgs = {
  email: Scalars['String'];
  instanceId: Scalars['MongoID'];
};


export type MutationConsumerCompleteAccessArgs = {
  consumerId: Scalars['MongoID'];
  messageId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
};


export type MutationConsumerCreateArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationConsumerCreate2Args = {
  input: ConsumerCreate2Input;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerLoginArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  multiLogin?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationConsumerMailUpdateArgs = {
  input?: InputMaybe<ConsumerMailUpdateInput>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerMergeArgs = {
  consumerIds: Array<Scalars['MongoID']>;
};


export type MutationConsumerRejectAccessArgs = {
  messageId: Scalars['MongoID'];
};


export type MutationConsumerRequestAccessArgs = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
  mail?: InputMaybe<Scalars['String']>;
  onlyDefaultFlow?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerRequestAccessFlowArgs = {
  identifier: Scalars['String'];
  identifierType: ConsumerIdentifierEnum;
  parameters?: InputMaybe<Scalars['JSON']>;
  sendMail?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerRequestPotentialsArgs = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
  identifier?: InputMaybe<Scalars['String']>;
  identifierType?: InputMaybe<ConsumerIdentifierEnum>;
  parameters?: InputMaybe<Scalars['JSON']>;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerSendCodeArgs = {
  onlyDefaultFlow?: InputMaybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type MutationConsumerSendEmailArgs = {
  mailtype?: InputMaybe<BrickMailTypeEnum>;
  options: Scalars['JSON'];
  shopId: Scalars['MongoID'];
};


export type MutationConsumerSynchronizeArgs = {
  identifier: Scalars['String'];
  identifierType: ConsumerIdentifierEnum;
  input: ConsumerSynchronizeInput;
  shopId: Scalars['MongoID'];
};


export type MutationConsumerUpdateArgs = {
  consumer: ConsumerInput;
};


export type MutationConsumerVerifyCodeArgs = {
  code: Scalars['String'];
  phoneNumber: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type MutationCurrencyConvertArgs = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationDataViewCreateArgs = {
  metadata?: InputMaybe<Scalars['JSON']>;
  rowIds: Array<Scalars['MongoID']>;
  ttlHours?: InputMaybe<Scalars['Int']>;
  type: DataViewTypeEnum;
  viewName?: InputMaybe<Scalars['String']>;
};


export type MutationDigitalPassportInitArgs = {
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  rrp?: InputMaybe<Scalars['Float']>;
  shopId: Scalars['MongoID'];
  size?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationExternOrder2SynchronizeArgs = {
  order?: InputMaybe<ExternOrder2SynchronizeInput>;
  shopId: Scalars['MongoID'];
};


export type MutationExternOrderSynchronizeArgs = {
  order?: InputMaybe<ExternOrderSynchronizeInput>;
  shopId: Scalars['MongoID'];
};


export type MutationHideImageAuditArgs = {
  brandItemImageId: Scalars['MongoID'];
};


export type MutationImageRotateArgs = {
  imageId: Scalars['MongoID'];
  rotate: Scalars['Int'];
};


export type MutationIntegrationConfigUpdateArgs = {
  enabled: Scalars['Boolean'];
  instanceId: Scalars['MongoID'];
  message?: InputMaybe<IntegrationMessageEnum>;
};


export type MutationIntegrationConnectorCreateArgs = {
  record: CreateOneIntegrationConnectorInput;
};


export type MutationIntegrationConnectorDeleteArgs = {
  filter?: InputMaybe<FilterRemoveOneIntegrationConnectorInput>;
  sort?: InputMaybe<SortRemoveOneIntegrationConnectorInput>;
};


export type MutationIntegrationConnectorUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdIntegrationConnectorInput;
};


export type MutationIntegrationDeleteArgs = {
  connectorId: Scalars['MongoID'];
  enabled: Scalars['Boolean'];
  message?: InputMaybe<IntegrationMessageEnum>;
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type MutationIntegrationInstallArgs = {
  connectorId: Scalars['MongoID'];
  mode?: InputMaybe<InstanceModeEnum>;
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type MutationIntegrationMessageExecuteArgs = {
  arguments?: InputMaybe<Array<Scalars['JSON']>>;
  name: Scalars['String'];
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type MutationIntegrationMessageUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdIntegrationMessageInput;
};


export type MutationIntegrationReInitializeArgs = {
  instanceId: Scalars['MongoID'];
};


export type MutationIntegrationSettingUpdateArgs = {
  input?: InputMaybe<Array<InputMaybe<IntegrationSettingInInput>>>;
  instanceId: Scalars['MongoID'];
};


export type MutationIntegrationUnInstallArgs = {
  instanceId: Scalars['MongoID'];
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type MutationInvoiceAdjustmentCreateArgs = {
  record: CreateOneInvoiceAdjustmentInput;
};


export type MutationInvoiceDeleteArgs = {
  brandHouseId: Scalars['MongoID'];
  invoiceId: Scalars['String'];
};


export type MutationInvoiceRebuildArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type MutationInvoiceResetArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  invoiceId: Scalars['String'];
};


export type MutationInvoiceSettingUpdateArgs = {
  record?: InputMaybe<InvoiceSettingInput>;
};


export type MutationInvoiceUpdateArgs = {
  brandHouseId: Scalars['MongoID'];
  invoiceId: Scalars['String'];
  locked?: InputMaybe<Scalars['Boolean']>;
  paid?: InputMaybe<Scalars['Boolean']>;
};


export type MutationItemIssueSynchronizeArgs = {
  brandItemId: Scalars['MongoID'];
  input?: InputMaybe<Array<InputMaybe<ItemIssueInput>>>;
};


export type MutationItemIssueUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdItemIssueInput;
};


export type MutationKlaviyoSynchronizeArgs = {
  full?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type MutationLogisticsPartnerAuthorizeArgs = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
};


export type MutationLogisticsStockItemsCheckedResetArgs = {
  logisticsPartnerId: Scalars['String'];
};


export type MutationOptionSynchronizeArgs = {
  input?: InputMaybe<OptionSetInput>;
  mode?: InputMaybe<SynchronizeMode>;
};


export type MutationOrderCaptureArgs = {
  forced?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationOrderCreateReturnArgs = {
  carrierId: Scalars['MongoID'];
  orderId: Scalars['MongoID'];
  returnLines?: InputMaybe<Array<OrderLineReturnInput>>;
  sender?: InputMaybe<AddressInfoInput>;
};


export type MutationOrderExtendReturnDeadlineArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  ordersPlacedAfter: Scalars['Date'];
  ordersPlacedBefore?: InputMaybe<Scalars['Date']>;
  returnDeadline: Scalars['Date'];
};


export type MutationOrderFulfillArgs = {
  orderId: Scalars['String'];
  returnCarrier?: InputMaybe<Scalars['String']>;
  returnNumber?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  trackingCarrier?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};


export type MutationOrderRegisterReturnArgs = {
  carrier: EnumOrder2ReturnInfoCarrier;
  orderId: Scalars['MongoID'];
  returnLines?: InputMaybe<Array<OrderLineReturnInput>>;
  trackingNos: Array<Scalars['String']>;
};


export type MutationOrderResetReturnArgs = {
  orderId: Scalars['MongoID'];
};


export type MutationOrderSetTrackingArgs = {
  orderId: Scalars['MongoID'];
  silent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderId: Scalars['Float'];
};


export type MutationOrderSynchronizeArgs = {
  mode?: InputMaybe<SynchronizeMode>;
  order?: InputMaybe<OrderSynchronizeInput>;
};


export type MutationOrderUpdateArgs = {
  order?: InputMaybe<OrderUpdateInput2>;
  shopId: Scalars['String'];
};


export type MutationParcelCreateArgs = {
  record: CreateOneParcelInput;
};


export type MutationParcelTrackingUpdateArgs = {
  deliveryDate?: InputMaybe<Scalars['Date']>;
  input?: InputMaybe<ParcelTrackingInput>;
  orderId?: InputMaybe<Scalars['MongoID']>;
  tradeInId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationParcelUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOneParcelInput>;
  record: UpdateOneParcelInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneParcelInput>;
};


export type MutationPlannedMailUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOnePlannedMailInput>;
  record: UpdateOnePlannedMailInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOnePlannedMailInput>;
};


export type MutationPotentialCreateArgs = {
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  categoryId?: InputMaybe<Scalars['MongoID']>;
  consumerId: Scalars['MongoID'];
  currency?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['MongoID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  masterVariantId?: InputMaybe<Scalars['String']>;
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  ruleId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationPotentialDeleteArgs = {
  potentialId: Scalars['MongoID'];
};


export type MutationPotentialDistributeArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationPotentialSynchronizeArgs = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
  shopId: Scalars['MongoID'];
  tradeIn?: InputMaybe<PotentialSynchronize2Input>;
  updateOffers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPotentialSynchronize2Args = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
  shopId: Scalars['String'];
  tradeIn?: InputMaybe<PotentialSynchronize2Input>;
  updateOffers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPotentialUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdPotentialInput;
};


export type MutationProductDisableArgs = {
  disable: Scalars['Boolean'];
  id: Scalars['MongoID'];
};


export type MutationProductImageCreateArgs = {
  altText?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  productId?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
  variantId?: InputMaybe<Scalars['String']>;
};


export type MutationProductSynchronizeArgs = {
  mode: ProductSynchronizeMode;
  product?: InputMaybe<ProductSynchronizeInput>;
  shopId: Scalars['MongoID'];
};


export type MutationProductSynchronizeTranslationsArgs = {
  shopId: Scalars['MongoID'];
  translations?: InputMaybe<ProductSynchronizeTranslationsInput>;
};


export type MutationProductUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdProductInput;
};


export type MutationProductsAutocompleteArgs = {
  query: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationQrSessionCreateArgs = {
  logisticsPartnerId: Scalars['String'];
};


export type MutationQrSessionUpdateArgs = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationRejectImageAuditArgs = {
  brandItemImageId: Scalars['MongoID'];
  uploadId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationRejectImageAuditRetakeArgs = {
  brandItemImageId: Scalars['MongoID'];
};


export type MutationScheduledEventCreateArgs = {
  record: CreateOneScheduledEventInput;
};


export type MutationScheduledEventUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOneScheduledEventInput>;
  record: UpdateOneScheduledEventInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneScheduledEventInput>;
};


export type MutationSendSystemMailArgs = {
  cc?: InputMaybe<Array<Scalars['String']>>;
  content: Scalars['String'];
  from?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  to: Scalars['String'];
};


export type MutationShippingCarrierUpdateArgs = {
  id: Scalars['MongoID'];
  input?: InputMaybe<ShippingCarrierInput>;
};


export type MutationShippingLabelCreateArgs = {
  record: CreateOneShippingLabelInput;
};


export type MutationShippingLabelUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOneShippingLabelInput>;
  record: UpdateOneShippingLabelInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneShippingLabelInput>;
};


export type MutationShopCreateArgs = {
  currency: Scalars['String'];
  frontendType: EnumShopFrontendType;
  license: Scalars['String'];
  mainCountryCode: Scalars['String'];
  name: Scalars['String'];
  primaryLocale: Scalars['String'];
  secondaryLocales?: InputMaybe<Array<Scalars['String']>>;
  serviceBus?: InputMaybe<Scalars['String']>;
  serviceBusTopic?: InputMaybe<Scalars['String']>;
  shop: Scalars['String'];
  tradeInBaseUrl: Scalars['String'];
};


export type MutationShopCreate2Args = {
  configuration?: InputMaybe<Scalars['JSON']>;
  externId: Scalars['String'];
  frontendType: EnumShopFrontendType;
  license: Scalars['String'];
  name: Scalars['String'];
};


export type MutationShopDeleteArgs = {
  shopId: Scalars['String'];
};


export type MutationShopLaunchArgs = {
  shopId: Scalars['String'];
};


export type MutationShopResetArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationShopUpdateArgs = {
  shop?: InputMaybe<ShopUpdateInput>;
  shopId: Scalars['String'];
};


export type MutationShopUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneShopInput>;
  record: UpdateOneShopInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneShopInput>;
};


export type MutationStartSynchronizeArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  service: Scalars['String'];
  shopId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationStockItemCheckedArgs = {
  checked?: InputMaybe<Scalars['Boolean']>;
  missing?: InputMaybe<Scalars['Boolean']>;
  stockItemId: Scalars['String'];
};


export type MutationStockItemCreateArgs = {
  shopId: Scalars['String'];
  tradeInItemId: Scalars['String'];
};


export type MutationStockItemCreateEmptyArgs = {
  shopId: Scalars['String'];
  stockItem?: InputMaybe<StockItemUpdateInput>;
};


export type MutationStockItemDeleteArgs = {
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
};


export type MutationStockItemImageAutoRetouchArgs = {
  process: Scalars['Boolean'];
  shopId: Scalars['String'];
  stockItemImageId: Scalars['String'];
};


export type MutationStockItemImageAutoRetouch2Args = {
  process: Scalars['Boolean'];
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
};


export type MutationStockItemImageAutoRetouchAllArgs = {
  shopId: Scalars['String'];
};


export type MutationStockItemImageCreateArgs = {
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  process?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
  silent?: InputMaybe<Scalars['Boolean']>;
  stockItemId: Scalars['String'];
  type?: InputMaybe<ImageTypeEnum>;
  uploadId: Scalars['String'];
};


export type MutationStockItemImageCreate2Args = {
  autoretouch?: InputMaybe<Scalars['Boolean']>;
  imageUrl: Scalars['String'];
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  publish?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['String'];
  silent?: InputMaybe<Scalars['Boolean']>;
  stockItemId: Scalars['String'];
  type?: InputMaybe<ImageTypeEnum>;
};


export type MutationStockItemImageDeleteArgs = {
  shopId: Scalars['String'];
  stockItemImageId: Scalars['String'];
};


export type MutationStockItemImageRotateArgs = {
  imageId: Scalars['String'];
  rotate: Scalars['Float'];
  shopId: Scalars['String'];
};


export type MutationStockItemImageSetOrderArgs = {
  imageIds?: InputMaybe<Array<Scalars['String']>>;
  shopId: Scalars['String'];
  stockItemId: Scalars['String'];
};


export type MutationStockItemImageSynchronizeArgs = {
  stockItemId: Scalars['MongoID'];
};


export type MutationStockItemImageUpdateArgs = {
  imageId: Scalars['String'];
  shopId: Scalars['String'];
  sortOrder: Scalars['Float'];
};


export type MutationStockItemImageUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdStockItemImageInput;
};


export type MutationStockItemInventoryUpdateArgs = {
  stockItemId: Scalars['MongoID'];
};


export type MutationStockItemPullArgs = {
  stockItemId: Scalars['String'];
};


export type MutationStockItemResetSkuArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationStockItemUpdateArgs = {
  shopId: Scalars['String'];
  silent?: InputMaybe<Scalars['Boolean']>;
  stockItem?: InputMaybe<StockItemUpdateInput>;
};


export type MutationStockItemsRecalculatePriceArgs = {
  shopId: Scalars['String'];
  stockItem?: InputMaybe<StockItemUpdateInput>;
};


export type MutationStockItemsRecalculatePricesArgs = {
  shopId: Scalars['String'];
};


export type MutationStorageFileRegisterArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  input?: InputMaybe<StorageFileCreateInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationSurveyRespondentCreateArgs = {
  record: CreateOneRespondentInput;
};


export type MutationSurveyUpdateArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdSurveyInput;
};


export type MutationSystemMessageAcknowledgeArgs = {
  filter?: InputMaybe<FilterUpdateOneSystemMessageInput>;
  record: UpdateOneSystemMessageInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneSystemMessageInput>;
};


export type MutationSystemMessageCreateArgs = {
  record: CreateOneSystemMessageInput;
};


export type MutationTradeInCreateArgs = {
  brandCarrierId?: InputMaybe<Scalars['MongoID']>;
  comments?: InputMaybe<Array<InputMaybe<TradeInCommentInput>>>;
  consumerId: Scalars['MongoID'];
  payout?: InputMaybe<EnumTradeInPayoutType>;
  potentialIds?: InputMaybe<Array<Scalars['MongoID']>>;
  received?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<EnumTradeInSource>;
  sourceNote?: InputMaybe<Scalars['String']>;
};


export type MutationTradeInDeleteArgs = {
  shopId: Scalars['String'];
  tradeInId: Scalars['String'];
};


export type MutationTradeInDelete2Args = {
  tradeInId: Scalars['MongoID'];
};


export type MutationTradeInItemUpdateByIdArgs = {
  _id: Scalars['MongoID'];
  record: UpdateByIdTradeInItemInput;
};


export type MutationTradeInItemsRejectArgs = {
  rejected: TradeInItemRejectReasonEnum;
  tradeInId: Scalars['MongoID'];
  tradeInItemIds?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type MutationTradeInResyncArgs = {
  brandHouseId: Scalars['MongoID'];
  instanceId?: InputMaybe<Scalars['String']>;
};


export type MutationTradeInSynchronizeArgs = {
  input: TradeInSynchronizeInput;
};


export type MutationTradeInUpdateArgs = {
  input?: InputMaybe<TradeInUpdateInput>;
  potentialIds?: InputMaybe<Array<Scalars['MongoID']>>;
  tradeInId: Scalars['MongoID'];
};


export type MutationUserAccessToggleArgs = {
  accessId: Scalars['MongoID'];
  disabled: Scalars['Boolean'];
};


export type MutationUserInviteArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  email: Scalars['String'];
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
};


export type MutationUserInviteAcceptArgs = {
  inviteToken: Scalars['String'];
};


export type MutationUserInviteJoinArgs = {
  name: Scalars['String'];
  password: Scalars['String'];
  resetToken: Scalars['String'];
};


export type MutationUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUserRecoverPasswordArgs = {
  email: Scalars['String'];
};


export type MutationUserRefreshArgs = {
  token: Scalars['String'];
};


export type MutationUserResetPasswordArgs = {
  password: Scalars['String'];
  resetToken: Scalars['String'];
};


export type MutationUserUpdatePasswordArgs = {
  newPassword: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationVoucherAdjustmentCreateArgs = {
  record: CreateOneVoucherAdjustmentInput;
};


export type MutationVoucherDeleteArgs = {
  id: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationVoucherEnableArgs = {
  enable: Scalars['Boolean'];
  voucherId: Scalars['MongoID'];
};


export type MutationVoucherFrontUpdateArgs = {
  code: Scalars['String'];
  input?: InputMaybe<VoucherFrontUpdateInput>;
  shopId: Scalars['MongoID'];
};


export type MutationVoucherMergeArgs = {
  shopId: Scalars['String'];
  targetTradeIn: Scalars['String'];
  voucherIds: Array<Scalars['String']>;
};


export type MutationVoucherSendReminderArgs = {
  shopId: Scalars['MongoID'];
};


export type MutationVoucherSynchronizeArgs = {
  code: Scalars['String'];
  shopId: Scalars['String'];
  silent?: InputMaybe<Scalars['Boolean']>;
  used?: InputMaybe<Scalars['String']>;
};


export type MutationVoucherUsageSynchronizeArgs = {
  input?: InputMaybe<VoucherUsageInput>;
  shopId: Scalars['MongoID'];
};


export type MutationWholeSaleCategoryCopyArgs = {
  convertCurrency?: InputMaybe<Scalars['Boolean']>;
  sourceShopId: Scalars['MongoID'];
  targetShopId: Scalars['MongoID'];
  translate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationWholeSaleCategoryCreateArgs = {
  record: CreateOneWholeSaleCategoryInput;
};


export type MutationWholeSaleCategoryDeleteArgs = {
  categoryId: Scalars['String'];
  shopId: Scalars['String'];
};


export type MutationWholeSaleCategoryUpdateArgs = {
  filter?: InputMaybe<FilterUpdateOneWholeSaleCategoryInput>;
  record: UpdateOneWholeSaleCategoryInput;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortUpdateOneWholeSaleCategoryInput>;
};

export type Nfc = {
  __typename?: 'NFC';
  _id: Scalars['MongoID'];
  /** The BrandItem for this NFC Tag */
  brandItem?: Maybe<BrandItem>;
  brandItemId?: Maybe<Scalars['MongoID']>;
  /** The NFC tag identifier */
  identifier: Scalars['String'];
  /** The StockItem for this NFC Tag */
  stockItem?: Maybe<StockItem>;
  stockItemId?: Maybe<Scalars['MongoID']>;
};

export type ObjectPatches = {
  __typename?: 'ObjectPatches';
  _id: Scalars['MongoID'];
  auditNoteId?: Maybe<Scalars['MongoID']>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** If true, then the patch has been compacted */
  compacted?: Maybe<Scalars['Boolean']>;
  date: Scalars['Date'];
  ops?: Maybe<Array<Maybe<ObjectPatchesOps>>>;
  ref: Scalars['MongoID'];
  shopId?: Maybe<Scalars['MongoID']>;
  type: Scalars['String'];
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type ObjectPatchesOps = {
  __typename?: 'ObjectPatchesOps';
  op?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type ObjectPatchesPatchItem = {
  __typename?: 'ObjectPatchesPatchItem';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ObjectPatches>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ObjectPatchesUpdatedBy = {
  __typename?: 'ObjectPatchesUpdatedBy';
  ref?: Maybe<Scalars['MongoID']>;
  type: Scalars['String'];
};

export type ObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type: Scalars['String'];
};

export type OneOfInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  externalId?: InputMaybe<Scalars['String']>;
};

export type OptionInstance = {
  __typename?: 'OptionInstance';
  key: Scalars['String'];
  keyExternalId?: Maybe<Scalars['String']>;
  optionSetId: Scalars['MongoID'];
  /** The value of the option value for the option set */
  optionValue?: Maybe<Scalars['String']>;
  /** The id of the option value for the option set */
  optionValueId?: Maybe<Scalars['MongoID']>;
  value: Scalars['String'];
  valueExternalId?: Maybe<Scalars['String']>;
  valueLocalizations?: Maybe<Array<Maybe<LocalizationEntry>>>;
};

export type OptionInstanceInput = {
  optionSetId: Scalars['MongoID'];
  /** The value of the option value for the option set */
  optionValue?: InputMaybe<Scalars['String']>;
  /** The id of the option value for the option set */
  optionValueId?: InputMaybe<Scalars['MongoID']>;
};

export type OptionSet = {
  __typename?: 'OptionSet';
  _id: Scalars['MongoID'];
  /** If true, the option set is active */
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** If true, the option set is deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The external id of the option set */
  externalId?: Maybe<Scalars['String']>;
  /** The key of the option set */
  key: Scalars['String'];
  /** The id of the item that the option set is for */
  refId: Scalars['MongoID'];
  /** The type of the ref id */
  refType: EnumOptionSetRefType;
  /** If true, then the option set will be required when used with the target */
  required?: Maybe<Scalars['Boolean']>;
  /** The section of the target that the option set should be shown for */
  section?: Maybe<Scalars['String']>;
  target: EnumOptionSetTarget;
  /** The title of the option set */
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** The value type of the option set */
  valueType: EnumOptionSetValueType;
  values?: Maybe<Array<Maybe<OptionValue>>>;
};

/** Input data for option sets */
export type OptionSetInput = {
  /** If true, the option set is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** If true, the option set is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The external identifier of the option set, use it to reference this set later */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<OneOfInput>;
  /** The key of the option set */
  key?: InputMaybe<Scalars['String']>;
  /** The id of the item that the option set is for */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The type of the ref id */
  refType: EnumOptionSetRefType;
  /** The target of the option set */
  target: EnumOptionSetTarget;
  /** The title of the option set */
  title?: InputMaybe<Scalars['String']>;
  /** The value type of the option set */
  valueType: EnumOptionSetValueType;
  /** The values of the option set */
  values?: InputMaybe<Array<InputMaybe<OptionValueInput>>>;
};

export type OptionValue = {
  __typename?: 'OptionValue';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Custom data for the option value */
  customData?: Maybe<Scalars['JSON']>;
  /** If true, the option is deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The external id of the option value */
  externalId?: Maybe<Scalars['String']>;
  /** The label of option */
  label: Scalars['String'];
  /** The localizations of the option */
  localizations?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The option set id */
  optionSetId: Scalars['MongoID'];
  /** The id of the object that owns the value */
  refId: Scalars['MongoID'];
  /** The sort order of the option */
  sortorder: Scalars['Float'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** The value of the option */
  value: Scalars['String'];
};

/** Input values for option sets */
export type OptionValueInput = {
  /** Custom data for the option value */
  customData?: InputMaybe<Scalars['JSON']>;
  /** If true, the option is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The external identifier of the option value, use it to reference this value later */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<OneOfInput>;
  /** The label of the option */
  label?: InputMaybe<Scalars['String']>;
  /** The localizations of the option */
  localizations?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The sortorder of the option */
  sortorder?: InputMaybe<Scalars['Int']>;
  /** The value of the option */
  value?: InputMaybe<Scalars['String']>;
};

export type Order2 = {
  __typename?: 'Order2';
  _id: Scalars['MongoID'];
  billingAddress?: Maybe<Order2ShippingAddress>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  captureFailedTs?: Maybe<Scalars['Date']>;
  captureNotified?: Maybe<Scalars['Boolean']>;
  captureRequests?: Maybe<Scalars['Float']>;
  /** The total amount to be captured for this order */
  captureTotal?: Maybe<Scalars['Float']>;
  carrierInfo?: Maybe<Order2CarrierInfo>;
  carrierInput?: Maybe<Order2CarrierInput>;
  /** Comment for the order */
  comment?: Maybe<Scalars['String']>;
  consumer: Order2Consumer;
  /** The email of the consumer */
  consumerEmail?: Maybe<Scalars['String']>;
  consumerId?: Maybe<Scalars['MongoID']>;
  /** The name of the consumer */
  consumerName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Currency for this order */
  currency?: Maybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: Maybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Delivery note for this order */
  deliveryNoteUrl: Scalars['String'];
  exportedToWMS?: Maybe<Scalars['Boolean']>;
  /** External order data */
  externOrder?: Maybe<ExternOrder2>;
  externalId: Scalars['String'];
  fulState?: Maybe<EnumOrder2FulState>;
  /** The internal consumer */
  internalConsumer?: Maybe<Consumer>;
  /** Whether this is a new order */
  isNewOrder?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<StockItem>>>;
  lines?: Maybe<Array<Maybe<Order2Item>>>;
  locked?: Maybe<Scalars['String']>;
  notified?: Maybe<Scalars['Boolean']>;
  notifiedConsumer?: Maybe<Scalars['Boolean']>;
  orderDate: Scalars['Date'];
  orderName?: Maybe<Scalars['String']>;
  orderState: EnumOrder2OrderState;
  orderUrl?: Maybe<Scalars['String']>;
  payState: EnumOrder2PayState;
  /** True if the order is a proforma order */
  proforma?: Maybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: Maybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: Maybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: Maybe<Scalars['Boolean']>;
  refundAdjusted?: Maybe<Scalars['Boolean']>;
  /** Whether returns are allowed for this order */
  returnAllowed: Scalars['Boolean'];
  /** The deadline for returns, null if no deadline exists */
  returnDeadline?: Maybe<Scalars['Date']>;
  returnInfo?: Maybe<Order2ReturnInfo>;
  returnLabelToken: Scalars['String'];
  /** URL for the return label */
  returnLabelUrl?: Maybe<Scalars['String']>;
  /** The return lines for this order */
  returnLines?: Maybe<Array<Maybe<Order2ItemReturn>>>;
  /** The return shipping label */
  returnShippingLabel?: Maybe<ShippingLabel>;
  returnShippingLabelId?: Maybe<Scalars['MongoID']>;
  shippingAddress?: Maybe<Order2ShippingAddress>;
  shippingAddressInternal?: Maybe<Order2ShippingAddress>;
  /** The shop that owns this order */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: Maybe<Scalars['Boolean']>;
  splitOrder?: Maybe<Scalars['Boolean']>;
  /** Statistics for the order */
  statistics?: Maybe<OrderStatistics>;
  trackingInfo?: Maybe<Order2TrackingInfo>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: Maybe<Scalars['Boolean']>;
  trackingOrderId?: Maybe<Scalars['Float']>;
  trackingOrderState?: Maybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: Maybe<EnumOrder2TrackingReturnState>;
  /** URL for the tracking */
  trackingUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: Maybe<Scalars['Date']>;
};


export type Order2StatisticsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type Order2CarrierInfo = {
  __typename?: 'Order2CarrierInfo';
  _id?: Maybe<Scalars['MongoID']>;
  carrierIdentifier?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Order2CarrierInfoInput = {
  carrierIdentifier?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Order2CarrierInput = {
  __typename?: 'Order2CarrierInput';
  /** Selected carrier for this package */
  carrier: EnumOrder2CarrierInputCarrier;
  /** Selected delivery service for this package */
  delivery: EnumOrder2CarrierInputDelivery;
  /** Express delivery */
  express: Scalars['Boolean'];
  /** Optionally an additional service id / pickup point information for this package */
  serviceId?: Maybe<Scalars['String']>;
};

export type Order2CarrierInputInput = {
  /** Selected carrier for this package */
  carrier: EnumOrder2CarrierInputCarrier;
  /** Selected delivery service for this package */
  delivery: EnumOrder2CarrierInputDelivery;
  /** Express delivery */
  express: Scalars['Boolean'];
  /** Optionally an additional service id / pickup point information for this package */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type Order2Consumer = {
  __typename?: 'Order2Consumer';
  _id?: Maybe<Scalars['MongoID']>;
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Order2ConsumerInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Order2Item = {
  __typename?: 'Order2Item';
  _id: Scalars['MongoID'];
  cancelled?: Maybe<Scalars['Boolean']>;
  cancelledNr?: Maybe<Scalars['Float']>;
  /** Reason for cancellation, customer specific code */
  cancelledReason?: Maybe<Scalars['String']>;
  cancelledTs?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  /** Custom data for the orderline */
  customData?: Maybe<Scalars['JSON']>;
  deleted?: Maybe<Scalars['Boolean']>;
  discountedPrice?: Maybe<Scalars['Float']>;
  discountedPricePreTax?: Maybe<Scalars['Float']>;
  /** The external id of the order line */
  externalLineId: Scalars['String'];
  fulfilled?: Maybe<Scalars['Boolean']>;
  item?: Maybe<StockItem>;
  /** The order that owns this line */
  order?: Maybe<Order2>;
  orderId: Scalars['MongoID'];
  /** The quantity of the orderline, if not present then 1 is assumed */
  quantity?: Maybe<Scalars['Float']>;
  /** True if the orderline should be refunded, see the refunded field that indicates whether an actual refund has been issued */
  refund?: Maybe<Scalars['Boolean']>;
  refunded?: Maybe<Scalars['Date']>;
  returned?: Maybe<Scalars['Boolean']>;
  returnedNr?: Maybe<Scalars['Float']>;
  /** Reason for return, customer specific code */
  returnedReason?: Maybe<Scalars['String']>;
  returnedTs?: Maybe<Scalars['Date']>;
  /** The sales price, if not provided then order currency */
  salesPrice?: Maybe<Scalars['Float']>;
  /** The sales price before tax in selected currency, if not provided then shop currency */
  salesPricePreTax?: Maybe<Scalars['Float']>;
  /** The shop that owns this order */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  /** Statistics for the order line */
  statistics?: Maybe<OrderLineStatistics>;
  /** The stock item that this line is for */
  stockItem?: Maybe<StockItemResolved>;
  stockItemId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};


export type Order2ItemSalesPriceArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type Order2ItemSalesPricePreTaxArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type Order2ItemStatisticsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type Order2ItemReturn = {
  __typename?: 'Order2ItemReturn';
  _id: Scalars['MongoID'];
  brandHouseId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  orderId: Scalars['MongoID'];
  orderLineId: Scalars['MongoID'];
  /** Reason for the return */
  returnReason: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

/** List of items with pagination. */
export type Order2OrderPagination = {
  __typename?: 'Order2OrderPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Order2>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Order2ReturnInfo = {
  __typename?: 'Order2ReturnInfo';
  carrier?: Maybe<EnumOrder2ReturnInfoCarrier>;
  number?: Maybe<Scalars['String']>;
};

export type Order2ReturnInfoInput = {
  carrier?: InputMaybe<EnumOrder2ReturnInfoCarrier>;
  number?: InputMaybe<Scalars['String']>;
};

export type Order2ShippingAddress = {
  __typename?: 'Order2ShippingAddress';
  _id?: Maybe<Scalars['MongoID']>;
  add1?: Maybe<Scalars['String']>;
  add2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Order2ShippingAddressInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Order2TrackingInfo = {
  __typename?: 'Order2TrackingInfo';
  carrier?: Maybe<EnumOrder2TrackingInfoCarrier>;
  number?: Maybe<Scalars['String']>;
};

export type OrderExtendReturnDeadlineResult = {
  __typename?: 'OrderExtendReturnDeadlineResult';
  matchedCount: Scalars['Int'];
  modifiedCount: Scalars['Int'];
};

export type OrderLineReturnInput = {
  orderLineId: Scalars['MongoID'];
  /** Reason for the return */
  returnReason: Scalars['String'];
};

export type OrderLineStatistics = {
  __typename?: 'OrderLineStatistics';
  /** Whether the orderline was cancelled */
  cancelled: Scalars['Boolean'];
  /** Whether the customer is ordering for the first time */
  firstTimeCustomer?: Maybe<Scalars['Boolean']>;
  /** Whether the orderline was refunded */
  refunded: Scalars['Boolean'];
  /** The percentage saved on the order */
  savingPercent?: Maybe<Scalars['Float']>;
  /** The total value of the order */
  value?: Maybe<Scalars['Float']>;
  /** The currency of the total value */
  valueCurrency?: Maybe<Scalars['String']>;
  /** The number of visitors to the item in the shop */
  views: Scalars['Float'];
};

export type OrderLineSynchronizeInput = {
  cancelled?: InputMaybe<Scalars['Boolean']>;
  cancelledNr?: InputMaybe<Scalars['Float']>;
  /** Reason for cancellation, customer specific code */
  cancelledReason?: InputMaybe<Scalars['String']>;
  cancelledTs?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the orderline */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  discountedPrice?: InputMaybe<Scalars['Float']>;
  discountedPricePreTax?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  /** The external id of the order line */
  externalLineId?: InputMaybe<Scalars['String']>;
  fulfilled?: InputMaybe<Scalars['Boolean']>;
  /** If provided, then exactly one of the id or externalLineId must be set and will be used to identify an existing line */
  id?: InputMaybe<OneOfInput>;
  /** The quantity of the orderline, if not present then 1 is assumed */
  quantity?: InputMaybe<Scalars['Float']>;
  /** True if the orderline should be refunded, see the refunded field that indicates whether an actual refund has been issued */
  refund?: InputMaybe<Scalars['Boolean']>;
  refunded?: InputMaybe<Scalars['Date']>;
  returned?: InputMaybe<Scalars['Boolean']>;
  /** Reason for return, customer specific code */
  returnedReason?: InputMaybe<Scalars['String']>;
  salesPrice?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type OrderStatistics = {
  __typename?: 'OrderStatistics';
  /** Whether the customer is ordering for the first time */
  firstTimeCustomer?: Maybe<Scalars['Boolean']>;
  /** The number of items in the order */
  items?: Maybe<Scalars['Int']>;
  /** The percentage saved on the order */
  savingPercent?: Maybe<Scalars['Float']>;
  /** The total value of the order */
  value?: Maybe<Scalars['Float']>;
  /** The currency of the total value */
  valueCurrency?: Maybe<Scalars['String']>;
};

export type OrderSynchronizeInput = {
  billingAddress?: InputMaybe<Order2ShippingAddressInput>;
  captureFailedTs?: InputMaybe<Scalars['Date']>;
  captureNotified?: InputMaybe<Scalars['Boolean']>;
  /** The total amount to be captured for this order */
  captureTotal?: InputMaybe<Scalars['Float']>;
  carrierInfo?: InputMaybe<Order2CarrierInfoInput>;
  carrierInput?: InputMaybe<Order2CarrierInputInput>;
  /** Comment for the order */
  comment?: InputMaybe<Scalars['String']>;
  consumer?: InputMaybe<Order2ConsumerInput>;
  /** Currency for this order */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  fulState?: InputMaybe<EnumOrder2FulState>;
  /** If provided, then exactly one of the id or externalId must be set, and will be used to identify an existing order */
  id?: InputMaybe<OneOfInput>;
  /** Whether this is a new order */
  isNewOrder?: InputMaybe<Scalars['Boolean']>;
  lines?: InputMaybe<Array<InputMaybe<OrderLineSynchronizeInput>>>;
  locked?: InputMaybe<Scalars['String']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderName?: InputMaybe<Scalars['String']>;
  orderState?: InputMaybe<EnumOrder2OrderState>;
  orderUrl?: InputMaybe<Scalars['String']>;
  payState?: InputMaybe<EnumOrder2PayState>;
  /** True if the order is a proforma order */
  proforma?: InputMaybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: InputMaybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: InputMaybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: InputMaybe<Scalars['Boolean']>;
  /** The returnDeadline for an order is typically determined by the settings, but its possible to set the returnDeadline to override that */
  returnDeadline?: InputMaybe<Scalars['Date']>;
  returnInfo?: InputMaybe<Order2ReturnInfoInput>;
  returnShippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shippingAddress?: InputMaybe<Order2ShippingAddressInput>;
  shippingAddressInternal?: InputMaybe<Order2ShippingAddressInput>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: InputMaybe<Scalars['Boolean']>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderState?: InputMaybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: InputMaybe<EnumOrder2TrackingReturnState>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: InputMaybe<Scalars['Date']>;
};

export type OrderUpdateInput2 = {
  billingAddress?: InputMaybe<Order2ShippingAddressInput>;
  captureFailedTs?: InputMaybe<Scalars['Date']>;
  captureNotified?: InputMaybe<Scalars['Boolean']>;
  /** The total amount to be captured for this order */
  captureTotal?: InputMaybe<Scalars['Float']>;
  carrierInfo?: InputMaybe<Order2CarrierInfoInput>;
  carrierInput?: InputMaybe<Order2CarrierInputInput>;
  /** Comment for the order */
  comment?: InputMaybe<Scalars['String']>;
  consumer?: InputMaybe<Order2ConsumerInput>;
  /** Currency for this order */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the order */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Soft delete */
  deleted?: InputMaybe<Scalars['Boolean']>;
  externalId: Scalars['String'];
  fulState?: InputMaybe<EnumOrder2FulState>;
  /** Whether this is a new order */
  isNewOrder?: InputMaybe<Scalars['Boolean']>;
  lines?: InputMaybe<Array<InputMaybe<OrderUpdateLineInput2>>>;
  locked?: InputMaybe<Scalars['String']>;
  orderDate?: InputMaybe<Scalars['Date']>;
  orderName?: InputMaybe<Scalars['String']>;
  orderState?: InputMaybe<EnumOrder2OrderState>;
  orderUrl?: InputMaybe<Scalars['String']>;
  payState?: InputMaybe<EnumOrder2PayState>;
  /** True if the order is a proforma order */
  proforma?: InputMaybe<Scalars['Boolean']>;
  /** True if the order commission can be invoiced, even if it is a proforma order */
  proformaInvoiceCommission?: InputMaybe<Scalars['Boolean']>;
  /** True if the order pickpack can be invoiced, even if it is a proforma order */
  proformaInvoicePickPack?: InputMaybe<Scalars['Boolean']>;
  /** True if the order shipping can be invoiced, even if it is a proforma order */
  proformaInvoiceShipping?: InputMaybe<Scalars['Boolean']>;
  /** The returnDeadline for an order is typically determined by the settings, but its possible to set the returnDeadline to override that */
  returnDeadline?: InputMaybe<Scalars['Date']>;
  returnInfo?: InputMaybe<Order2ReturnInfoInput>;
  returnShippingLabelId?: InputMaybe<Scalars['MongoID']>;
  shippingAddress?: InputMaybe<Order2ShippingAddressInput>;
  shippingAddressInternal?: InputMaybe<Order2ShippingAddressInput>;
  /** A silenced order will not show as unfulfilled or active in statistics */
  silenced?: InputMaybe<Scalars['Boolean']>;
  splitOrder?: InputMaybe<Scalars['Boolean']>;
  /** If the tracking mail has been sent to the consumer */
  trackingMailSent?: InputMaybe<Scalars['Boolean']>;
  trackingOrderState?: InputMaybe<EnumOrder2TrackingOrderState>;
  trackingReturnState?: InputMaybe<EnumOrder2TrackingReturnState>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  /** Timestamp of the latest orderline that has been updated */
  updatedLineTs?: InputMaybe<Scalars['Date']>;
};

export type OrderUpdateLineInput2 = {
  cancelled?: InputMaybe<Scalars['Boolean']>;
  cancelledNr?: InputMaybe<Scalars['Float']>;
  /** Reason for cancellation, customer specific code */
  cancelledReason?: InputMaybe<Scalars['String']>;
  cancelledTs?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the orderline */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  discountedPrice?: InputMaybe<Scalars['Float']>;
  discountedPricePreTax?: InputMaybe<Scalars['Float']>;
  ean?: InputMaybe<Scalars['String']>;
  /** The external id of the order line */
  externalLineId: Scalars['String'];
  fulfilled?: InputMaybe<Scalars['Boolean']>;
  /** The quantity of the orderline, if not present then 1 is assumed */
  quantity?: InputMaybe<Scalars['Float']>;
  /** True if the orderline should be refunded, see the refunded field that indicates whether an actual refund has been issued */
  refund?: InputMaybe<Scalars['Boolean']>;
  refunded?: InputMaybe<Scalars['Date']>;
  /** Reason for return, customer specific code */
  returnedReason?: InputMaybe<Scalars['String']>;
  salesPrice?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int'];
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  itemCount?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  perPage: Scalars['Int'];
};

export type Parcel = {
  __typename?: 'Parcel';
  _id: Scalars['MongoID'];
  /** The brand that owns this parcel */
  brandHouseId: Scalars['MongoID'];
  /** Optional comment for the parcel */
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  /** Items in the parcel */
  items?: Maybe<Array<Maybe<ParcelItems>>>;
  /** The date of the parcel creation */
  parcelDate: Scalars['Date'];
  /** The receiver of the parcel */
  receiver: AddressInfo;
  /** The sender of the parcel */
  sender: AddressInfo;
  /** The shipping carrier for this parcel */
  shippingCarrier?: Maybe<ShippingCarrier>;
  /** The carrier of the parcel */
  shippingCarrierId?: Maybe<Scalars['MongoID']>;
  /** The shipping label for this parcel */
  shippingLabel?: Maybe<ShippingLabel>;
  shippingLabelId?: Maybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ParcelItems = {
  __typename?: 'ParcelItems';
  refId: Scalars['MongoID'];
  refType: EnumParcelItemsRefType;
};

export type ParcelItemsInput = {
  refId: Scalars['MongoID'];
  refType: EnumParcelItemsRefType;
};

export type ParcelManualTrackingInput = {
  packageCode: Scalars['String'];
};

/** List of items with pagination. */
export type ParcelParcelPagination = {
  __typename?: 'ParcelParcelPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Parcel>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum ParcelTrackingCarrier {
  B2cEurope = 'b2c_europe',
  Dao = 'dao',
  DeutschePost = 'deutsche_post',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Gls = 'gls',
  Parcelplus = 'parcelplus',
  Pdk = 'pdk',
  Ups = 'ups'
}

export type ParcelTrackingInput = {
  /** The carrier */
  carrier: ParcelTrackingCarrier;
  /** The tracking code */
  code: Scalars['String'];
  /** The status of the parcel */
  status: ParcelTrackingStatus;
};

export enum ParcelTrackingStatus {
  Availableforpickup = 'AVAILABLEFORPICKUP',
  Delivered = 'DELIVERED',
  Exception = 'EXCEPTION',
  Expired = 'EXPIRED',
  Failedattempt = 'FAILEDATTEMPT',
  Inforeceived = 'INFORECEIVED',
  Intransit = 'INTRANSIT',
  Outfordelivery = 'OUTFORDELIVERY',
  Pending = 'PENDING'
}

export type PathDifference = {
  __typename?: 'PathDifference';
  differenceType?: Maybe<DifferenceTypeEnum>;
  modelName: Scalars['String'];
  path: Scalars['String'];
  valueA?: Maybe<Scalars['JSON']>;
  valueB?: Maybe<Scalars['JSON']>;
};

export type PlannedMail = {
  __typename?: 'PlannedMail';
  _id: Scalars['MongoID'];
  mailType: Scalars['String'];
  objectId: Scalars['String'];
  objectType: Scalars['String'];
  sendAt: Scalars['Date'];
  sent?: Maybe<Scalars['Date']>;
  sentStatus?: Maybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
};

/** List of items with pagination. */
export type PlannedMailPlannedMailPagination = {
  __typename?: 'PlannedMailPlannedMailPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlannedMail>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Potential = {
  __typename?: 'Potential';
  _id: Scalars['MongoID'];
  batchSerial?: Maybe<Scalars['String']>;
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** The brand product that this potential is related to */
  brandProductId?: Maybe<Scalars['MongoID']>;
  /** The brand product size that this potential is related to */
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** The brand product variant that this potential is derived from */
  brandProductVariant?: Maybe<BrandProductVariant>;
  /** The brand product variant that this potential is related to */
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  cancelledReason?: Maybe<EnumPotentialCancelledReason>;
  color?: Maybe<Scalars['String']>;
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  ean?: Maybe<Scalars['String']>;
  externDate?: Maybe<Scalars['Date']>;
  externGroupId?: Maybe<Scalars['String']>;
  externUrl?: Maybe<Scalars['String']>;
  /** True if this potential is free to be added to anyones tradein */
  freePotential?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  imageIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  isUsingFakeProduct?: Maybe<Scalars['Boolean']>;
  /** If present, then this contains the last timestamp of when we tried linking this potential to masterdata */
  linkTs?: Maybe<Scalars['Date']>;
  lockedTs?: Maybe<Scalars['Date']>;
  /** The MAS masterdata variant id this potential is related to */
  masterVariantId?: Maybe<Scalars['String']>;
  masterVariantImageId?: Maybe<Scalars['String']>;
  masterVariantImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Whether this potential has no "date", its not actually bought, or we dont know the date - means that any date check in the tradein rules will be voided */
  noDate?: Maybe<Scalars['Boolean']>;
  /** If the owner of this potential was contacting with trade-in offers for this */
  notified?: Maybe<EnumPotentialNotified>;
  /** When was the owner of this potential contacting regarding trade-in offers */
  notifiedTs?: Maybe<Scalars['Date']>;
  /** The trade-in value for this potential */
  offer?: Maybe<PotentialValue>;
  /** DEPRECATED. The product this potential trade-in is derived from */
  product?: Maybe<Product>;
  /** The id of the product this potential is related to */
  productId?: Maybe<Scalars['MongoID']>;
  /** The product variant that this potential is derived from */
  productVariant?: Maybe<ProductVariant>;
  /** The id of the product variant this potential is related to */
  productVariantId?: Maybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantSizeId?: Maybe<Scalars['MongoID']>;
  rrp?: Maybe<Scalars['Float']>;
  /** The shop that owns this potential */
  shop?: Maybe<Shop>;
  shopId?: Maybe<Scalars['MongoID']>;
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** The source of the potential */
  sourceType?: Maybe<PotentialSourceTypeEnum>;
  sp?: Maybe<Scalars['Float']>;
  spOriginal?: Maybe<Scalars['Float']>;
  /** Status of this potential */
  status?: Maybe<Status>;
  /** The tradeIn item for this potential */
  tradeInItem?: Maybe<TradeInItem>;
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  wholeSale?: Maybe<PotentialWholeSale>;
};


export type PotentialOfferArgs = {
  brandRuleId?: InputMaybe<Scalars['MongoID']>;
  live?: InputMaybe<Scalars['Boolean']>;
};


export type PotentialStatusArgs = {
  brandRuleId?: InputMaybe<Scalars['MongoID']>;
  live?: InputMaybe<Scalars['Boolean']>;
};

export enum PotentialAccountEnum {
  Customid = 'CUSTOMID',
  Email = 'EMAIL',
  Externalid = 'EXTERNALID',
  Personid = 'PERSONID',
  Phone = 'PHONE'
}

/** Potentials by account */
export type PotentialByAccount = {
  __typename?: 'PotentialByAccount';
  /** The email of the customer */
  email?: Maybe<Scalars['String']>;
  /** The potentials that cant be traded back */
  exclusions?: Maybe<Array<PotentialByAccountItem>>;
  /** The customer identifier */
  id: Scalars['MongoID'];
  /** The name of the customer */
  name?: Maybe<Scalars['String']>;
  /** The phone of the customer */
  phone?: Maybe<Scalars['String']>;
  /** The potentials that can be traded back */
  potentials?: Maybe<Array<PotentialByAccountItem>>;
  /** Type of account */
  type: PotentialAccountEnum;
};

/** Item in an account */
export type PotentialByAccountItem = {
  __typename?: 'PotentialByAccountItem';
  /** The currency of the tradein value */
  currency: Scalars['String'];
  /** The ID of the potential */
  id: Scalars['String'];
  /** An image of the product */
  image?: Maybe<Scalars['String']>;
  /** Name of the product */
  name?: Maybe<Scalars['String']>;
  /** The date of the order */
  orderDate?: Maybe<Scalars['Date']>;
  /** The type of the item */
  type: Scalars['String'];
  /** The tradein value of the potential */
  value?: Maybe<Scalars['Float']>;
};

/** Item for a consumer */
export type PotentialOfferItem = {
  __typename?: 'PotentialOfferItem';
  /** The potential external id */
  externalId: Scalars['String'];
  /** An image of the product */
  image?: Maybe<Scalars['String']>;
  /** The date of the order */
  orderDate?: Maybe<Scalars['Date']>;
  /** The DE date of the order */
  orderDateDE?: Maybe<Scalars['String']>;
  /** The DK date of the order */
  orderDateDK?: Maybe<Scalars['String']>;
  /** The UK date of the order */
  orderDateUK?: Maybe<Scalars['String']>;
  /** The ID of the potential */
  title: Scalars['String'];
  /** Name of the product */
  voucher?: Maybe<Scalars['String']>;
  /** The tradein value of the potential */
  voucherCurrency?: Maybe<Scalars['String']>;
  /** The tradein value of the potential */
  voucherValue?: Maybe<Scalars['Float']>;
};

/** Potential offers for consumer */
export type PotentialOffers = {
  __typename?: 'PotentialOffers';
  /** The brand house id */
  brandHouseId: Scalars['MongoID'];
  /** The date of the latest offer */
  daysLatestOrder?: Maybe<Scalars['Int']>;
  /** The customer email / identifier */
  email: Scalars['String'];
  /** The customer external id */
  externalId?: Maybe<Scalars['String']>;
  /** The customer email / identifier */
  login: Scalars['String'];
  /** The date of the oldest offer */
  offerDate?: Maybe<Scalars['Date']>;
  /** The date of the latest offer */
  offerLatest?: Maybe<Scalars['Date']>;
  /** The  that can be traded back */
  offers?: Maybe<Array<PotentialOfferItem>>;
  /** The customer email / identifier */
  offersCount: Scalars['Int'];
  /** The date of the latest offer */
  timestamp?: Maybe<Scalars['Date']>;
  /** The total value of the offers */
  value?: Maybe<Scalars['Int']>;
  /** The currency of the total value */
  valueCurrency?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type PotentialPotentialDtcPagination = {
  __typename?: 'PotentialPotentialDTCPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Potential>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type PotentialPotentialPagination = {
  __typename?: 'PotentialPotentialPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Potential>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export enum PotentialSourceTypeEnum {
  Digitalpass = 'DIGITALPASS',
  Online = 'ONLINE',
  Reciept = 'RECIEPT',
  Search = 'SEARCH',
  Wholesale = 'WHOLESALE'
}

/** Data for potential synchronization of 1 item */
export type PotentialSynchronize2Input = {
  consumer?: InputMaybe<PotentialSynchronize2InputConsumer>;
  currency?: InputMaybe<Scalars['String']>;
  dateTime: Scalars['Date'];
  externId: Scalars['String'];
  externUrl?: InputMaybe<Scalars['String']>;
  freePotentials?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<PotentialSynchronize2InputItem>>>;
  /** Whether its an online item or pos item */
  sourceType?: InputMaybe<PotentialSourceTypeEnum>;
};

/** Consumer information for Synchronization of items */
export type PotentialSynchronize2InputConsumer = {
  acceptsMarketing: Scalars['Boolean'];
  accountType?: InputMaybe<Scalars['String']>;
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Item information for Synchronization of items */
export type PotentialSynchronize2InputItem = {
  cancelled: Scalars['Boolean'];
  cancelledReason?: InputMaybe<CancelReason>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  /** A brand unique identifier, must identify this concrete potential and none other */
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  noDate?: InputMaybe<Scalars['Boolean']>;
  /** Price of the item, if no currency is provided then shop currency is assumed */
  price?: InputMaybe<Scalars['Float']>;
  /** Original price of the item, before any discounts */
  priceOriginal?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['String']>;
  wholeSaleCategoryId?: InputMaybe<Scalars['String']>;
  wholeSaleImageId?: InputMaybe<Scalars['String']>;
  wholeSaleValue?: InputMaybe<Scalars['Int']>;
};

export type PotentialValue = {
  __typename?: 'PotentialValue';
  _id: Scalars['MongoID'];
  /** When this trade-in value is activated */
  activation?: Maybe<EnumPotentialValueActivation>;
  /** Whether the brandrule that generated this value is/was active */
  brandRuleActive: Scalars['Boolean'];
  /** The id of the brandrule that generated this value */
  brandRuleId: Scalars['MongoID'];
  /** Whether the brandrule that generated this value matched */
  brandRuleMatches: Scalars['Boolean'];
  /** The version of the brandrule that generated this value */
  brandRuleVersion: Scalars['Float'];
  /** The consumer that gets this offer */
  consumerId: Scalars['MongoID'];
  /** The currency */
  currency: Scalars['String'];
  /** The value that was exported to external systems, used to detect required updates */
  exportedValue?: Maybe<Scalars['Float']>;
  /** The values exported to different marketing integrations, instanceId -> value */
  exportedValues?: Maybe<Scalars['JSON']>;
  /** The date that this offer can be sent to the consumer */
  notifyDate?: Maybe<Scalars['Date']>;
  /** The potential item that this value is linked to */
  potentialId: Scalars['MongoID'];
  /** If the owner of this potential was contacting with trade-in offers for this */
  potentialNotified: EnumPotentialValuePotentialNotified;
  /** The shop that owns this value */
  shopId?: Maybe<Scalars['MongoID']>;
  /** The timestamp of the last update to this potentialvalue */
  ts: Scalars['Date'];
  /** Whether this offer is valid for tradein */
  validForTradeIn?: Maybe<Scalars['Boolean']>;
  /** The value of the potential */
  value?: Maybe<Scalars['Float']>;
  /** Whether this is a wholesale potential value */
  wholeSale: Scalars['Boolean'];
};

export type PotentialWholeSale = {
  __typename?: 'PotentialWholeSale';
  _id?: Maybe<Scalars['MongoID']>;
  categoryId?: Maybe<Scalars['MongoID']>;
  name?: Maybe<Scalars['String']>;
  ruleId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  /** The ISO currency code */
  currency: Scalars['String'];
  /** The pricing value */
  value: Scalars['Float'];
};

export type PricingInput = {
  /** The ISO currency code */
  currency: Scalars['String'];
  /** The pricing value */
  value: Scalars['Float'];
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['MongoID'];
  batchSerial?: Maybe<Scalars['String']>;
  /** The brandproduct that is the master data for this product */
  brandProductId?: Maybe<Scalars['MongoID']>;
  collections?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  disabled?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  /** Images for this product */
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  isPotential?: Maybe<Scalars['Boolean']>;
  isPreOwned?: Maybe<Scalars['Boolean']>;
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  name: Scalars['String'];
  nameLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  productType?: Maybe<Scalars['String']>;
  productVariants?: Maybe<Array<Maybe<ProductVariant>>>;
  productVendor?: Maybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
  style?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  _id: Scalars['MongoID'];
  archivedImage?: Maybe<Scalars['Boolean']>;
  archivedThumb?: Maybe<Scalars['Boolean']>;
  /** The master data image for this */
  brandImageId?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Indicates if this is the default image for the variant */
  defaultImage?: Maybe<Scalars['Boolean']>;
  deleted?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  errorCount?: Maybe<Scalars['Float']>;
  /** An image unique external identifier for the variant */
  externalId?: Maybe<Scalars['String']>;
  imageAltText?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: Maybe<Scalars['String']>;
  /** Image url */
  imageUrl?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  perspective?: Maybe<EnumProductImagePerspective>;
  productId?: Maybe<Scalars['MongoID']>;
  productVariantId?: Maybe<Scalars['MongoID']>;
  shopId: Scalars['MongoID'];
  sortOrder?: Maybe<Scalars['Float']>;
  sourceUrl?: Maybe<Scalars['String']>;
  /** Contains a hash of the settings that was used to generate the thumbnail. Used to detect changes to actual thumbnail settings and the generated thumbnails */
  thumbnailHash?: Maybe<Scalars['Float']>;
  thumbnailId?: Maybe<Scalars['MongoID']>;
  type?: Maybe<EnumProductImageType>;
  updatedAt?: Maybe<Scalars['Date']>;
  watermarkedId?: Maybe<Scalars['MongoID']>;
};

export type ProductImageSynchronizeInput = {
  /** Whether this is the default image for the variant */
  defaultImage?: InputMaybe<Scalars['Boolean']>;
  /** Shop unique identifier for the variant, should always be provided - the sourceUrl will be used if not */
  externalId?: InputMaybe<Scalars['String']>;
  /** Image alt text */
  imageAltText?: InputMaybe<Scalars['String']>;
  /** The perspective of the image */
  perspective?: InputMaybe<ImagePerspectiveEnum>;
  /** Images will be sorted ascending by this number */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** The external URL of this image */
  sourceUrl: Scalars['String'];
  /** The type of image */
  type?: InputMaybe<ImageTypeEnum>;
};

export type ProductPaging = {
  __typename?: 'ProductPaging';
  data?: Maybe<Array<Maybe<Product>>>;
  page: Scalars['Int'];
  pages: Scalars['Int'];
  total: Scalars['Int'];
};

/** List of items with pagination. */
export type ProductProductPagination = {
  __typename?: 'ProductProductPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Product>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProductStatistic = {
  __typename?: 'ProductStatistic';
  productsNoImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  variants: Scalars['Int'];
  variantsImages: Scalars['Int'];
  variantsNoImages: Scalars['Int'];
  variantsNoThumbnails: Scalars['Int'];
  variantsThumbnails: Scalars['Int'];
};

export type ProductSynchronizeInput = {
  /** Source of the synchronize */
  batchSerial?: InputMaybe<Scalars['String']>;
  /** A list of collections that this product has been part of */
  collections?: InputMaybe<Array<Scalars['String']>>;
  /** The description of the product localized */
  description?: InputMaybe<Scalars['String']>;
  /** The description of the product localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Shop Unique identifier for the product */
  externalId: Scalars['String'];
  /** Whether this is a preowned style */
  isPreOwned?: InputMaybe<Scalars['Boolean']>;
  /** Additional data for product */
  metaFields?: InputMaybe<Array<MetaFieldInput>>;
  /** The name of the product */
  name?: InputMaybe<Scalars['String']>;
  /** The name of the product localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Type of product */
  productType?: InputMaybe<Scalars['String']>;
  /** Vendor of product */
  productVendor?: InputMaybe<Scalars['String']>;
  /** Style number for the product */
  style?: InputMaybe<Scalars['String']>;
  /** A list of tags for the product */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Variants for this product */
  variants?: InputMaybe<Array<ProductVariantSynchronizeInput>>;
};

export enum ProductSynchronizeMode {
  Merge = 'MERGE',
  Replace = 'REPLACE',
  Updateimages = 'UPDATEIMAGES'
}

export type ProductSynchronizeTranslationsInput = {
  /** The description of the product localized */
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** Shop Unique identifier for the product */
  externalId: Scalars['String'];
  /** The name of the product localized */
  nameLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The product type localizations */
  productType?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  _id: Scalars['MongoID'];
  batchSerial?: Maybe<Scalars['String']>;
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  color?: Maybe<Scalars['String']>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  deleted?: Maybe<Scalars['Boolean']>;
  ean?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns a list of images for this variant */
  images?: Maybe<Array<Maybe<ProductImage>>>;
  isPotential?: Maybe<Scalars['Boolean']>;
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  product?: Maybe<Product>;
  productId: Scalars['MongoID'];
  rrp?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  size?: Maybe<Scalars['String']>;
  /** Returns a list of sizes for this variant */
  sizes?: Maybe<Array<Maybe<ProductVariantSize>>>;
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

/** List of items with pagination. */
export type ProductVariantProductVariantPagination = {
  __typename?: 'ProductVariantProductVariantPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ProductVariant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProductVariantSize = {
  __typename?: 'ProductVariantSize';
  _id: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** True if this product has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The EAN-13 of this variant */
  ean?: Maybe<Scalars['String']>;
  /** A variant unique external identifier */
  externalId: Scalars['String'];
  /** Extra data about the variant */
  metaFields?: Maybe<Array<Maybe<MetaField>>>;
  productId: Scalars['MongoID'];
  /** Returns the product variant that owns this size */
  productVariant?: Maybe<ProductVariant>;
  /** The variant that owns this size */
  productVariantId: Scalars['MongoID'];
  /** The shop that owns this variant */
  shopId: Scalars['MongoID'];
  /** The size */
  size: Scalars['String'];
  /** The SKU of this variant */
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ProductVariantSizeSynchronizeInput = {
  /** Whether this size is deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** The EAN number */
  ean?: InputMaybe<Scalars['String']>;
  /** Shop unique identifier for the variant, should always be provided - the sourceUrl will be used if not */
  externalId?: InputMaybe<Scalars['String']>;
  /** Additional data */
  metaFields?: InputMaybe<Array<MetaFieldInput>>;
  /** The size */
  size: Scalars['String'];
  /** SKU */
  sku?: InputMaybe<Scalars['String']>;
};

export type ProductVariantSynchronizeInput = {
  /** Color for the variant */
  color?: InputMaybe<Scalars['String']>;
  /** The tariff code for use in customs declarations */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin */
  countryOrigin?: InputMaybe<Scalars['String']>;
  /** Whether this variant is deactivated for use */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  /** The EAN number of the variant */
  ean?: InputMaybe<Scalars['String']>;
  /** Shop Unique identifier for the variant */
  externalId: Scalars['String'];
  /** Images for this variant */
  images?: InputMaybe<Array<ProductImageSynchronizeInput>>;
  /** RRP for this variant */
  rrp?: InputMaybe<Array<PricingInput>>;
  /** Size for the variant */
  size?: InputMaybe<Scalars['String']>;
  /** Size for the variant */
  sizes?: InputMaybe<Array<ProductVariantSizeSynchronizeInput>>;
  /** SKU for the variant */
  sku?: InputMaybe<Scalars['String']>;
};

export type QrSession = {
  __typename?: 'QRSession';
  _id: Scalars['MongoID'];
  code?: Maybe<Scalars['String']>;
  logisticsPartnerId: Scalars['MongoID'];
  updateTs?: Maybe<Scalars['Date']>;
  userId: Scalars['MongoID'];
};

export type Query = {
  __typename?: 'Query';
  /** Get a single audit note by ID */
  AuditNote?: Maybe<AuditNote>;
  /** List recent audit notes for a brand house */
  AuditNotes?: Maybe<Array<Maybe<AuditNote>>>;
  /** Lists the workflow schema from the autoretouch service */
  AutoRetouchWorkflows?: Maybe<Array<Maybe<AutoRetouchWorkflow>>>;
  BrandApiGet?: Maybe<BrandApi>;
  BrandCarrier?: Maybe<BrandCarrier>;
  BrandCircular?: Maybe<CircularSettings>;
  BrandHouse?: Maybe<BrandHouse>;
  /** Searches the masterdata (MAS) catalog for a BrandHouse by SKU, EAN or name. Returns matching styles with their variants. Empty when the BrandHouse has no MAS brand. */
  BrandHouseMasterDataSearch?: Maybe<Array<Maybe<MasterDataProduct>>>;
  /** Visual-similarity masterdata (MAS) search for a BrandHouse. The masterdata service classifies the supplied image and returns the best-matching styles with a score. Empty when the BrandHouse has no MAS brand. */
  BrandHouseMasterDataVisualSearch?: Maybe<Array<Maybe<MasterDataVisualSearchHit>>>;
  BrandHouses: Array<BrandHouse>;
  BrandItem?: Maybe<BrandItem>;
  BrandItemImage?: Maybe<BrandItemImage>;
  BrandItemImagesRequireAudit?: Maybe<Array<BrandItemImage>>;
  BrandItemLayaway?: Maybe<BrandItemLayaway>;
  /** Get all layaway history for a specific brand item */
  BrandItemLayawayHistory?: Maybe<Array<Maybe<BrandItemLayaway>>>;
  BrandItemLayawayMany: Array<BrandItemLayaway>;
  BrandItemLayawayPagination?: Maybe<BrandItemLayawayBrandItemLayawayPagination>;
  BrandItemMany: Array<BrandItem>;
  /** Gets item results for a BrandItem MAS migration run */
  BrandItemMasterDataMigrationItems?: Maybe<Array<Maybe<BrandItemMasterDataMigrationItem>>>;
  /** Gets a BrandItem MAS migration run */
  BrandItemMasterDataMigrationRun?: Maybe<BrandItemMasterDataMigrationRun>;
  /** Will return master images for this item */
  BrandItemMasterImages?: Maybe<Array<Maybe<BrandItemMasterImage>>>;
  BrandItemPagination?: Maybe<BrandItemBrandItemPagination>;
  /** Will detect any problems with this branditem, optionally for a given storefront/shop */
  BrandItemProblems?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Returns up to 10 unique identifiers (EAN, SKU, or externalId) from different BrandProducts for brand items matching type AND primaryColor, scored by additional attribute matches including notable features */
  BrandItemRelatedIdentifiers: Array<Scalars['String']>;
  /** Returns unique identifiers (EAN, SKU, or externalId) from BrandProductVariants with similar images based on image embeddings using MongoDB Atlas Vector Search. Items are sorted by similarity score (most similar first). */
  BrandItemSimilarByImage: Array<Scalars['String']>;
  /** Will return branditems by their ids */
  BrandItems?: Maybe<Array<Maybe<BrandItem>>>;
  BrandLayout?: Maybe<TradeInLayout>;
  BrandLocalizations?: Maybe<Array<Maybe<Localization>>>;
  BrandProduct?: Maybe<BrandProduct>;
  BrandProductGroup?: Maybe<BrandProductGroup>;
  BrandProductGroups: Array<BrandProductGroup>;
  BrandProductImage?: Maybe<BrandProductImage>;
  BrandProductImages: Array<BrandProductImage>;
  BrandProductSize?: Maybe<BrandProductSize>;
  BrandProductSizes: Array<BrandProductSize>;
  BrandProductVariant?: Maybe<BrandProductVariant>;
  BrandProductVariants: Array<BrandProductVariant>;
  BrandProducts: Array<BrandProduct>;
  BrandProductsPagination?: Maybe<BrandProductBrandProductsPagination>;
  BrandRule?: Maybe<BrandRule>;
  BrandRules?: Maybe<Array<Maybe<BrandRule>>>;
  BrandSettings?: Maybe<BrandSetting>;
  BrandTrackingId?: Maybe<Scalars['String']>;
  BrickMail?: Maybe<BrickMail>;
  BrickMailTypeByID?: Maybe<BrickMailType>;
  BrickMailTypes?: Maybe<Array<Maybe<BrickMailType>>>;
  BrickMails?: Maybe<Array<Maybe<BrickMail>>>;
  Campaign?: Maybe<Campaign>;
  Campaigns: Array<Campaign>;
  CircularAccountById?: Maybe<CircularAccount>;
  CircularPayoutById?: Maybe<CircularPayoutType>;
  CircularPayoutMany: Array<CircularPayoutType>;
  CircularPointById?: Maybe<CircularPoint>;
  CircularPointMany: Array<CircularPoint>;
  ConfigCompare?: Maybe<ConfigCompareResult>;
  /** Find a ConsumerAccount by identifier across all shops in a brandHouse */
  ConsumerAccount?: Maybe<ConsumerAccount>;
  ConsumerById?: Maybe<Consumer>;
  /** Returns a consumer given its personId - the personId can be mail in some cases, but also external identifiers */
  ConsumerByIdentifier?: Maybe<Array<Maybe<Consumer>>>;
  /** Returns a list of carriers that are active for this consumer */
  ConsumerCarriers?: Maybe<Array<Maybe<BrandCarrier>>>;
  ConsumerDropoffs?: Maybe<Array<Maybe<Dropoff>>>;
  ConsumerEventPagination?: Maybe<ConsumerEventConsumerEventPagination>;
  ConsumerPagination?: Maybe<ConsumerConsumerPagination>;
  ConsumerPotentials?: Maybe<Array<Maybe<Potential>>>;
  ConsumerTradeIns?: Maybe<Array<Maybe<TradeIn>>>;
  /** Returns consumers, meant to be used in paged lists */
  Consumers?: Maybe<ConsumersPaging>;
  ConsumersFindMany: Array<Consumer>;
  ConvertCurrency?: Maybe<Pricing>;
  ConvertCurrencyForConsumer?: Maybe<Pricing>;
  Countries?: Maybe<Array<Maybe<Country>>>;
  CurrentConsumer?: Maybe<Consumer>;
  CurrentUser?: Maybe<User>;
  DataView?: Maybe<DataView>;
  DataViewList: Array<DataView>;
  ExternOrder2ByID?: Maybe<ExternOrder2>;
  ExternOrderByID?: Maybe<ExternOrder>;
  ExternOrders2Many: Array<ExternOrder2>;
  ExternOrdersMany: Array<ExternOrder>;
  Image?: Maybe<ImageUpload>;
  IntegrationConfig?: Maybe<Array<Maybe<IntegrationConfig>>>;
  IntegrationConnector?: Maybe<IntegrationConnector>;
  IntegrationConnectors: Array<IntegrationConnector>;
  IntegrationConnectorsCount?: Maybe<Scalars['Int']>;
  IntegrationInstance?: Maybe<IntegrationInstance>;
  IntegrationInstances: Array<IntegrationInstance>;
  IntegrationMessage?: Maybe<Array<Maybe<IntegrationMessageResult>>>;
  IntegrationMessageById?: Maybe<IntegrationMessage>;
  IntegrationMessages?: Maybe<IntegrationMessageIntegrationMessagePagination>;
  Invoice?: Maybe<Invoice>;
  InvoiceAdjustment?: Maybe<InvoiceAdjustment>;
  InvoiceAdjustments: Array<InvoiceAdjustment>;
  InvoiceIds?: Maybe<Array<Scalars['String']>>;
  InvoiceLines: Array<InvoiceLine>;
  InvoiceSetting?: Maybe<InvoiceSetting>;
  Invoices?: Maybe<Array<Maybe<Invoice>>>;
  ItemIssue?: Maybe<ItemIssue>;
  ItemIssues?: Maybe<ItemIssueItemIssuesPagination>;
  LogisticsPartner?: Maybe<LogisticsPartner>;
  LogisticsPartners: Array<LogisticsPartner>;
  /** Returns (potentially) all stockitems, useable by logisticspartners */
  LogisticsStockItems?: Maybe<Array<Maybe<StockItem>>>;
  NFCMany: Array<Nfc>;
  Option?: Maybe<OptionSet>;
  OptionValue?: Maybe<OptionValue>;
  OptionValues: Array<OptionValue>;
  Options: Array<OptionSet>;
  Order?: Maybe<Order2>;
  OrderById?: Maybe<Order2>;
  OrderCount?: Maybe<Scalars['Int']>;
  OrderLineById?: Maybe<Order2Item>;
  OrderPagination?: Maybe<Order2OrderPagination>;
  Orders?: Maybe<Array<Maybe<Order2>>>;
  Parcel?: Maybe<Parcel>;
  Parcels: Array<Parcel>;
  ParcelsPagination?: Maybe<ParcelParcelPagination>;
  PatchMany: Array<ObjectPatches>;
  PatchPagination?: Maybe<ObjectPatchesPatchItem>;
  PlannedMailById?: Maybe<PlannedMail>;
  PlannedMailsPagination?: Maybe<PlannedMailPlannedMailPagination>;
  Potential?: Maybe<Potential>;
  PotentialOffers?: Maybe<PotentialOffers>;
  Potentials: Array<Potential>;
  PotentialsByAccount?: Maybe<Array<PotentialByAccount>>;
  PotentialsByShop?: Maybe<Array<PotentialByAccount>>;
  PotentialsDTCPagination?: Maybe<PotentialPotentialPagination>;
  PotentialsPagination?: Maybe<PotentialPotentialDtcPagination>;
  ProductById?: Maybe<Product>;
  /** Returns the images we have stored for the given product variant */
  ProductImages?: Maybe<Array<Maybe<ProductImage>>>;
  ProductMany: Array<Product>;
  /** Returns statistics about products */
  ProductStatistics?: Maybe<ProductStatistic>;
  ProductVariant?: Maybe<ProductVariant>;
  ProductVariantById?: Maybe<ProductVariant>;
  ProductVariantMany: Array<ProductVariant>;
  ProductVariantSize?: Maybe<ProductVariantSize>;
  ProductVariantSizes: Array<ProductVariantSize>;
  ProductVariantsPagination?: Maybe<ProductVariantProductVariantPagination>;
  /** Returns products, meant to be used in paged lists, use ProductMany to query on all products */
  Products?: Maybe<ProductPaging>;
  ProductsByIDS: Array<Product>;
  ProductsPagination?: Maybe<ProductProductPagination>;
  PublicVoucherValue?: Maybe<Pricing>;
  PublicVoucherValue2?: Maybe<Pricing>;
  QRSession?: Maybe<QrSession>;
  QRSessions?: Maybe<Array<Maybe<QrSession>>>;
  ScheduledEventById?: Maybe<ScheduledEvent>;
  ScheduledEventsPagination?: Maybe<ScheduledEventScheduledEventPagination>;
  ShippingCarrier?: Maybe<ShippingCarrier>;
  ShippingCarriers?: Maybe<Array<Maybe<ShippingCarrier>>>;
  ShippingCarriersActive?: Maybe<Array<Maybe<ShippingCarrier>>>;
  ShippingCarriersForParcel?: Maybe<Array<Maybe<ShippingCarrier>>>;
  ShippingCarriersLP?: Maybe<Array<Maybe<ShippingCarrier>>>;
  ShippingCosts?: Maybe<Array<Maybe<ShippingCostOutput>>>;
  ShippingLabel?: Maybe<ShippingLabel>;
  Shop?: Maybe<Shop>;
  ShopById?: Maybe<Shop>;
  /** Returns a list of countries active for the given shop */
  ShopCountries?: Maybe<Array<Maybe<Country>>>;
  /** Returns a list of languages active for the given shop */
  ShopLanguages?: Maybe<Array<Scalars['String']>>;
  ShopMany: Array<Shop>;
  Shops: Array<Shop>;
  StockItem?: Maybe<StockItem>;
  StockItemById?: Maybe<StockItem>;
  StockItemCount?: Maybe<Scalars['Int']>;
  StockItemImage?: Maybe<StockItemImage>;
  StockItemImageById?: Maybe<StockItemImage>;
  StockItemImages?: Maybe<Array<Maybe<StockItemImage>>>;
  StockItemMany: Array<StockItem>;
  StockItemPagination?: Maybe<StockItemStockItemPagination>;
  StockItems: Array<StockItem>;
  /** Will return stockitems by their ids */
  StockItems2?: Maybe<Array<Maybe<StockItem>>>;
  /** Returns a list of c2s stockitems that are available for creation in the external shop */
  StockItemsForShop?: Maybe<Array<Maybe<StockItemForSale>>>;
  /** Returns a list of c2s stockitems that are available for creation in the external shop */
  StockItemsForShop2?: Maybe<Array<Maybe<StockItemForSale2>>>;
  StorageFileById?: Maybe<StorageFile>;
  Survey?: Maybe<Survey>;
  SurveyRespondent?: Maybe<Respondent>;
  SurveyRespondents: Array<Respondent>;
  SystemMessage?: Maybe<SystemMessage>;
  SystemMessages: Array<SystemMessage>;
  TrackingCount: Scalars['Int'];
  TrackingMany: Array<Tracking>;
  TrackingPagination?: Maybe<TrackingTrackingPagination>;
  TradeIn?: Maybe<TradeIn>;
  TradeInById?: Maybe<TradeIn>;
  TradeInConfig?: Maybe<TradeInConfig>;
  TradeInItemById?: Maybe<TradeInItem>;
  /** Returns TradeInItems */
  TradeInItems?: Maybe<Array<Maybe<TradeInItem>>>;
  /** Returns TradeInItems, meant to be used in paged lists, use TradeInItems to query on all tradeinitems */
  TradeInItems2?: Maybe<TradeInItemPaging>;
  /** Returns TradeInItems for the given tradein */
  TradeInItems3?: Maybe<Array<Maybe<TradeInItem>>>;
  TradeInMany: Array<TradeIn>;
  TradeInOne?: Maybe<TradeIn>;
  TradeInPagination?: Maybe<TradeInTradeInPagination>;
  TradeInURL?: Maybe<ExternalLink>;
  TradeIns: Array<TradeIn>;
  User?: Maybe<User>;
  UserAccesses?: Maybe<Array<Maybe<UserAccess>>>;
  UserInviteVerify?: Maybe<Scalars['String']>;
  /** Verifies the quality of the password */
  UserVerifyPassword?: Maybe<VerifyResult>;
  UserVerifyResetToken?: Maybe<Scalars['String']>;
  Users: Array<User>;
  Voucher?: Maybe<Voucher>;
  VoucherAdjustment?: Maybe<VoucherAdjustment>;
  VoucherAdjustments: Array<VoucherAdjustment>;
  VoucherByExternId?: Maybe<Voucher>;
  VoucherById?: Maybe<Voucher>;
  VoucherByIds?: Maybe<Array<Maybe<Voucher>>>;
  VoucherPagination?: Maybe<VoucherVoucherPagination>;
  VoucherTransactions?: Maybe<Array<Maybe<VoucherTransaction>>>;
  VoucherUsageRefunds: Array<VoucherUsageRefund>;
  VoucherUsages: Array<VoucherUsage>;
  Vouchers: Array<Voucher>;
  WarehouseLocations?: Maybe<Array<Maybe<WarehouseLocation>>>;
  WholeSaleCategories: Array<WholeSaleCategory>;
  WholeSaleCategory?: Maybe<WholeSaleCategory>;
  WholeSaleConfig?: Maybe<WholeSaleConfigType>;
  WholeSaleProducts?: Maybe<Array<Maybe<WholeSaleProduct>>>;
  WholeSaleRuleStatistics?: Maybe<WholeSaleStatistics>;
};


export type QueryAuditNoteArgs = {
  id: Scalars['MongoID'];
};


export type QueryAuditNotesArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type QueryAutoRetouchWorkflowsArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryBrandApiGetArgs = {
  filter?: InputMaybe<FilterFindOneBrandApiInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneBrandApiInput>;
};


export type QueryBrandCarrierArgs = {
  brandHouseId: Scalars['MongoID'];
  shippingCarrierId: Scalars['MongoID'];
};


export type QueryBrandCircularArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryBrandHouseArgs = {
  id: Scalars['MongoID'];
};


export type QueryBrandHouseMasterDataSearchArgs = {
  brandHouseId: Scalars['MongoID'];
  search: Scalars['String'];
};


export type QueryBrandHouseMasterDataVisualSearchArgs = {
  brandHouseId: Scalars['MongoID'];
  imageUrl: Scalars['String'];
  maxResults?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandHousesArgs = {
  filter?: InputMaybe<FilterFindManyBrandHouseInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandHouseInput>;
};


export type QueryBrandItemArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandItemImageArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandItemLayawayArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandItemLayawayHistoryArgs = {
  brandItemId: Scalars['MongoID'];
};


export type QueryBrandItemLayawayManyArgs = {
  filter?: InputMaybe<FilterFindManyBrandItemLayawayInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandItemLayawayInput>;
};


export type QueryBrandItemLayawayPaginationArgs = {
  filter?: InputMaybe<FilterFindManyBrandItemLayawayInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyBrandItemLayawayInput>;
};


export type QueryBrandItemManyArgs = {
  filter?: InputMaybe<FilterFindManyBrandItemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandItemInput>;
};


export type QueryBrandItemMasterDataMigrationItemsArgs = {
  runId: Scalars['MongoID'];
};


export type QueryBrandItemMasterDataMigrationRunArgs = {
  id: Scalars['MongoID'];
};


export type QueryBrandItemMasterImagesArgs = {
  brandItemId: Scalars['MongoID'];
};


export type QueryBrandItemPaginationArgs = {
  filter?: InputMaybe<FilterFindManyBrandItemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyBrandItemInput>;
  viewId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryBrandItemProblemsArgs = {
  brandItemId: Scalars['MongoID'];
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryBrandItemRelatedIdentifiersArgs = {
  brandItemId: Scalars['MongoID'];
};


export type QueryBrandItemSimilarByImageArgs = {
  brandItemId: Scalars['MongoID'];
  includeCategories?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandItemsArgs = {
  ids?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type QueryBrandLayoutArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryBrandLocalizationsArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  language?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  type: Scalars['String'];
};


export type QueryBrandProductArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductGroupArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductGroupsArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductGroupInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductGroupInput>;
};


export type QueryBrandProductImageArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductImagesArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductImageInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductImageInput>;
};


export type QueryBrandProductSizeArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductSizesArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductSizeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductSizeInput>;
};


export type QueryBrandProductVariantArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandProductVariantsArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductVariantInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductVariantInput>;
};


export type QueryBrandProductsArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBrandProductInput>;
};


export type QueryBrandProductsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyBrandProductInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyBrandProductInput>;
};


export type QueryBrandRuleArgs = {
  _id: Scalars['MongoID'];
};


export type QueryBrandRulesArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryBrandSettingsArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  refId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryBrandTrackingIdArgs = {
  shopId: Scalars['MongoID'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryBrickMailArgs = {
  mailType: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type QueryBrickMailTypeByIdArgs = {
  mailType: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type QueryBrickMailTypesArgs = {
  shopId: Scalars['String'];
};


export type QueryBrickMailsArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryCampaignArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCampaignsArgs = {
  filter?: InputMaybe<FilterFindManyCampaignInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCampaignInput>;
};


export type QueryCircularAccountByIdArgs = {
  consumerId: Scalars['MongoID'];
};


export type QueryCircularPayoutByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCircularPayoutManyArgs = {
  filter?: InputMaybe<FilterFindManyCircularPayoutTypeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCircularPayoutTypeInput>;
};


export type QueryCircularPointByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryCircularPointManyArgs = {
  filter?: InputMaybe<FilterFindManyCircularPointInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCircularPointInput>;
};


export type QueryConfigCompareArgs = {
  brandHouseIdA?: InputMaybe<Scalars['MongoID']>;
  brandHouseIdB?: InputMaybe<Scalars['MongoID']>;
  models?: InputMaybe<Array<Scalars['String']>>;
  shopIdA?: InputMaybe<Scalars['MongoID']>;
  shopIdB?: InputMaybe<Scalars['MongoID']>;
};


export type QueryConsumerAccountArgs = {
  brandHouseId: Scalars['MongoID'];
  id: Scalars['String'];
  idType: ConsumerIdentifierEnum;
};


export type QueryConsumerByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryConsumerByIdentifierArgs = {
  identifier: Scalars['String'];
  identifierType: ConsumerIdentifierEnum;
  selfCreated?: InputMaybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
};


export type QueryConsumerCarriersArgs = {
  consumerId: Scalars['String'];
  shopId: Scalars['String'];
};


export type QueryConsumerEventPaginationArgs = {
  filter?: InputMaybe<FilterFindManyConsumerEventInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyConsumerEventInput>;
};


export type QueryConsumerPaginationArgs = {
  filter?: InputMaybe<FilterFindManyConsumerInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyConsumerInput>;
};


export type QueryConsumerPotentialsArgs = {
  consumerId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryConsumersArgs = {
  filter?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  shopId: Scalars['String'];
};


export type QueryConsumersFindManyArgs = {
  filter?: InputMaybe<FilterFindManyConsumerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyConsumerInput>;
};


export type QueryConvertCurrencyArgs = {
  inputCurrency: Scalars['String'];
  inputValue: Scalars['Float'];
  outputCurrency: Scalars['String'];
  ratesFromShopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryConvertCurrencyForConsumerArgs = {
  consumerId: Scalars['MongoID'];
  inputCurrency: Scalars['String'];
  inputValue: Scalars['Float'];
};


export type QueryDataViewArgs = {
  _id: Scalars['MongoID'];
};


export type QueryDataViewListArgs = {
  filter?: InputMaybe<FilterFindManyDataViewInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDataViewInput>;
};


export type QueryExternOrder2ByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryExternOrderByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryExternOrders2ManyArgs = {
  filter?: InputMaybe<FilterFindManyExternOrder2Input>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyExternOrder2Input>;
};


export type QueryExternOrdersManyArgs = {
  filter?: InputMaybe<FilterFindManyExternOrderInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyExternOrderInput>;
};


export type QueryImageArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIntegrationConfigArgs = {
  refId: Scalars['MongoID'];
  refType?: InputMaybe<EnumIntegrationConnectorRefType>;
};


export type QueryIntegrationConnectorArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIntegrationConnectorsArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationConnectorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIntegrationConnectorInput>;
};


export type QueryIntegrationConnectorsCountArgs = {
  filter?: InputMaybe<FilterCountIntegrationConnectorInput>;
};


export type QueryIntegrationInstanceArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIntegrationInstancesArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInstanceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIntegrationInstanceInput>;
};


export type QueryIntegrationMessageArgs = {
  tokens?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryIntegrationMessageByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryIntegrationMessagesArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationMessageInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyIntegrationMessageInput>;
};


export type QueryInvoiceArgs = {
  _id: Scalars['MongoID'];
};


export type QueryInvoiceAdjustmentArgs = {
  _id: Scalars['MongoID'];
};


export type QueryInvoiceAdjustmentsArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceAdjustmentInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyInvoiceAdjustmentInput>;
};


export type QueryInvoiceIdsArgs = {
  brandHouseId?: InputMaybe<Scalars['String']>;
};


export type QueryInvoiceLinesArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceLineInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyInvoiceLineInput>;
};


export type QueryInvoiceSettingArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type QueryInvoicesArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryItemIssueArgs = {
  _id: Scalars['MongoID'];
};


export type QueryItemIssuesArgs = {
  filter?: InputMaybe<FilterFindManyItemIssueInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyItemIssueInput>;
};


export type QueryLogisticsPartnerArgs = {
  _id: Scalars['MongoID'];
};


export type QueryLogisticsPartnersArgs = {
  filter?: InputMaybe<FilterFindManyLogisticsPartnerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyLogisticsPartnerInput>;
};


export type QueryLogisticsStockItemsArgs = {
  hideChecked?: InputMaybe<Scalars['Boolean']>;
  hideSold?: InputMaybe<Scalars['Boolean']>;
  hideWithLocation?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  logisticsPartnerId: Scalars['String'];
};


export type QueryNfcManyArgs = {
  filter?: InputMaybe<FilterFindManyNfcInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyNfcInput>;
};


export type QueryOptionArgs = {
  _id: Scalars['MongoID'];
};


export type QueryOptionValueArgs = {
  _id: Scalars['MongoID'];
};


export type QueryOptionValuesArgs = {
  filter?: InputMaybe<FilterFindManyOptionValueInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOptionValueInput>;
};


export type QueryOptionsArgs = {
  filter?: InputMaybe<FilterFindManyOptionSetInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOptionSetInput>;
};


export type QueryOrderArgs = {
  id: Scalars['String'];
};


export type QueryOrderByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryOrderCountArgs = {
  filter?: InputMaybe<FilterCountOrder2Input>;
};


export type QueryOrderLineByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryOrderPaginationArgs = {
  filter?: InputMaybe<FilterFindManyOrder2Input>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyOrder2Input>;
  viewId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryOrdersArgs = {
  consumerId?: InputMaybe<Scalars['String']>;
  shopId: Scalars['String'];
};


export type QueryParcelArgs = {
  _id: Scalars['MongoID'];
};


export type QueryParcelsArgs = {
  filter?: InputMaybe<FilterFindManyParcelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyParcelInput>;
};


export type QueryParcelsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyParcelInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyParcelInput>;
};


export type QueryPatchManyArgs = {
  filter?: InputMaybe<FilterFindManyObjectPatchesInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyObjectPatchesInput>;
};


export type QueryPatchPaginationArgs = {
  filter?: InputMaybe<FilterFindManyObjectPatchesInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyObjectPatchesInput>;
};


export type QueryPlannedMailByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryPlannedMailsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPlannedMailInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyPlannedMailInput>;
};


export type QueryPotentialArgs = {
  _id: Scalars['MongoID'];
};


export type QueryPotentialOffersArgs = {
  consumerId: Scalars['MongoID'];
};


export type QueryPotentialsArgs = {
  filter?: InputMaybe<FilterFindManyPotentialInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPotentialInput>;
};


export type QueryPotentialsByAccountArgs = {
  brandId: Scalars['MongoID'];
  identifier: Scalars['String'];
  type: PotentialAccountEnum;
};


export type QueryPotentialsByShopArgs = {
  identifier: Scalars['String'];
  shopId: Scalars['MongoID'];
  type: PotentialAccountEnum;
};


export type QueryPotentialsDtcPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPotentialInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyPotentialInput>;
};


export type QueryPotentialsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPotentialInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyPotentialInput>;
};


export type QueryProductByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryProductImagesArgs = {
  shopId: Scalars['String'];
  variantId: Scalars['String'];
};


export type QueryProductManyArgs = {
  filter?: InputMaybe<FilterFindManyProductInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyProductInput>;
};


export type QueryProductStatisticsArgs = {
  shopId: Scalars['String'];
};


export type QueryProductVariantArgs = {
  id: Scalars['String'];
};


export type QueryProductVariantByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryProductVariantManyArgs = {
  filter?: InputMaybe<FilterFindManyProductVariantInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyProductVariantInput>;
};


export type QueryProductVariantSizeArgs = {
  _id: Scalars['MongoID'];
};


export type QueryProductVariantSizesArgs = {
  filter?: InputMaybe<FilterFindManyProductVariantSizeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyProductVariantSizeInput>;
};


export type QueryProductVariantsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProductVariantInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyProductVariantInput>;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  shopId: Scalars['String'];
};


export type QueryProductsByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsProductInput>;
};


export type QueryProductsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProductInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyProductInput>;
};


export type QueryPublicVoucherValueArgs = {
  actualSalesPrice: Scalars['Int'];
  actualSalesPriceOriginal?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['MongoID']>;
  compareAtPrice?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  externProductId: Scalars['String'];
  externVariantId: Scalars['String'];
  shopId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryPublicVoucherValue2Args = {
  actualSalesPrice: Scalars['Int'];
  actualSalesPriceOriginal?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['String']>;
  compareAtPrice?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  externProductId: Scalars['String'];
  externVariantId: Scalars['String'];
  shopId?: InputMaybe<Scalars['String']>;
};


export type QueryQrSessionArgs = {
  id: Scalars['String'];
};


export type QueryQrSessionsArgs = {
  logisticsPartnerId: Scalars['String'];
};


export type QueryScheduledEventByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryScheduledEventsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyScheduledEventInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyScheduledEventInput>;
};


export type QueryShippingCarrierArgs = {
  id: Scalars['MongoID'];
};


export type QueryShippingCarriersArgs = {
  brandHouseId: Scalars['MongoID'];
};


export type QueryShippingCarriersActiveArgs = {
  orderId: Scalars['MongoID'];
};


export type QueryShippingCarriersForParcelArgs = {
  receiver?: InputMaybe<ShippingCarriersForParcelReceiverInput>;
  shopId: Scalars['MongoID'];
};


export type QueryShippingCarriersLpArgs = {
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryShippingCostsArgs = {
  currency: Scalars['String'];
  includeVat?: InputMaybe<Scalars['Boolean']>;
  queries: Array<ShippingCostInput>;
};


export type QueryShippingLabelArgs = {
  _id: Scalars['MongoID'];
};


export type QueryShopArgs = {
  _id: Scalars['MongoID'];
};


export type QueryShopByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryShopCountriesArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryShopLanguagesArgs = {
  shopId: Scalars['MongoID'];
  type?: InputMaybe<Scalars['String']>;
};


export type QueryShopManyArgs = {
  filter?: InputMaybe<FilterFindManyShopInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyShopInput>;
};


export type QueryShopsArgs = {
  filter?: InputMaybe<FilterFindManyShopInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyShopInput>;
};


export type QueryStockItemArgs = {
  _id: Scalars['MongoID'];
};


export type QueryStockItemByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryStockItemCountArgs = {
  filter?: InputMaybe<FilterCountStockItemInput>;
};


export type QueryStockItemImageArgs = {
  shopId?: InputMaybe<Scalars['String']>;
  stockItemImageId?: InputMaybe<Scalars['String']>;
};


export type QueryStockItemImageByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryStockItemImagesArgs = {
  shopId?: InputMaybe<Scalars['String']>;
  stockItemId?: InputMaybe<Scalars['String']>;
};


export type QueryStockItemManyArgs = {
  filter?: InputMaybe<FilterFindManyStockItemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStockItemInput>;
};


export type QueryStockItemPaginationArgs = {
  filter?: InputMaybe<FilterFindManyStockItemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyStockItemInput>;
};


export type QueryStockItemsArgs = {
  filter?: InputMaybe<FilterFindManyStockItemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyStockItemInput>;
};


export type QueryStockItems2Args = {
  ids?: InputMaybe<Array<Scalars['MongoID']>>;
};


export type QueryStockItemsForShopArgs = {
  shopId: Scalars['String'];
};


export type QueryStockItemsForShop2Args = {
  shopId: Scalars['MongoID'];
};


export type QueryStorageFileByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySurveyArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySurveyRespondentArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySurveyRespondentsArgs = {
  filter?: InputMaybe<FilterFindManyRespondentInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRespondentInput>;
};


export type QuerySystemMessageArgs = {
  _id: Scalars['MongoID'];
};


export type QuerySystemMessagesArgs = {
  filter?: InputMaybe<FilterFindManySystemMessageInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySystemMessageInput>;
};


export type QueryTrackingCountArgs = {
  objectType: Scalars['String'];
  periodFrom: Scalars['Date'];
  periodTo: Scalars['Date'];
  shopId: Scalars['MongoID'];
};


export type QueryTrackingManyArgs = {
  filter?: InputMaybe<FilterFindManyTrackingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTrackingInput>;
};


export type QueryTrackingPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTrackingInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyTrackingInput>;
};


export type QueryTradeInArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTradeInByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTradeInConfigArgs = {
  shopId: Scalars['MongoID'];
};


export type QueryTradeInItemByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryTradeInItemsArgs = {
  includeRegistered?: InputMaybe<Scalars['Boolean']>;
  includeRejected?: InputMaybe<Scalars['Boolean']>;
  includeStocked?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['String']>;
};


export type QueryTradeInItems2Args = {
  filter?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  shopId?: InputMaybe<Scalars['String']>;
};


export type QueryTradeInItems3Args = {
  tradeInId: Scalars['MongoID'];
};


export type QueryTradeInManyArgs = {
  filter?: InputMaybe<FilterFindManyTradeInInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTradeInInput>;
};


export type QueryTradeInOneArgs = {
  filter?: InputMaybe<FilterFindOneTradeInInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneTradeInInput>;
};


export type QueryTradeInPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTradeInInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyTradeInInput>;
  viewId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryTradeInUrlArgs = {
  consumerId: Scalars['MongoID'];
};


export type QueryTradeInsArgs = {
  filter?: InputMaybe<FilterFindManyTradeInInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyTradeInInput>;
};


export type QueryUserArgs = {
  _id: Scalars['MongoID'];
};


export type QueryUserAccessesArgs = {
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryUserInviteVerifyArgs = {
  token: Scalars['String'];
};


export type QueryUserVerifyPasswordArgs = {
  password: Scalars['String'];
};


export type QueryUserVerifyResetTokenArgs = {
  token: Scalars['String'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryVoucherArgs = {
  code: Scalars['String'];
  shopId: Scalars['String'];
};


export type QueryVoucherAdjustmentArgs = {
  _id: Scalars['MongoID'];
};


export type QueryVoucherAdjustmentsArgs = {
  filter?: InputMaybe<FilterFindManyVoucherAdjustmentInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVoucherAdjustmentInput>;
};


export type QueryVoucherByExternIdArgs = {
  externId: Scalars['String'];
  shopId: Scalars['MongoID'];
};


export type QueryVoucherByIdArgs = {
  _id: Scalars['MongoID'];
};


export type QueryVoucherByIdsArgs = {
  ids: Array<Scalars['MongoID']>;
};


export type QueryVoucherPaginationArgs = {
  filter?: InputMaybe<FilterFindManyVoucherInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortFindManyVoucherInput>;
};


export type QueryVoucherTransactionsArgs = {
  currency?: InputMaybe<Scalars['String']>;
  voucherId: Scalars['MongoID'];
};


export type QueryVoucherUsageRefundsArgs = {
  filter?: InputMaybe<FilterFindManyVoucherUsageRefundInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVoucherUsageRefundInput>;
};


export type QueryVoucherUsagesArgs = {
  filter?: InputMaybe<FilterFindManyVoucherUsageInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVoucherUsageInput>;
};


export type QueryVouchersArgs = {
  filter?: InputMaybe<FilterFindManyVoucherInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVoucherInput>;
};


export type QueryWarehouseLocationsArgs = {
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
};


export type QueryWholeSaleCategoriesArgs = {
  filter?: InputMaybe<FilterFindManyWholeSaleCategoryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyWholeSaleCategoryInput>;
};


export type QueryWholeSaleCategoryArgs = {
  _id: Scalars['MongoID'];
};


export type QueryWholeSaleConfigArgs = {
  language?: InputMaybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
};


export type QueryWholeSaleProductsArgs = {
  categoryId: Scalars['String'];
  consumerId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryWholeSaleRuleStatisticsArgs = {
  rule?: InputMaybe<WholeSaleCategoryRulesInput>;
  shopId: Scalars['String'];
};

export type RefreshResult = {
  __typename?: 'RefreshResult';
  token: Scalars['String'];
};

export type RemoveOneIntegrationConnectorPayload = {
  __typename?: 'RemoveOneIntegrationConnectorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<IntegrationConnector>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type Respondent = {
  __typename?: 'Respondent';
  _id: Scalars['MongoID'];
  /** The answers made by this respondent */
  answers: Array<Maybe<RespondentAnswers>>;
  shopId: Scalars['MongoID'];
  surveyId: Scalars['MongoID'];
};

export type RespondentAnswers = {
  __typename?: 'RespondentAnswers';
  /** The id of the question */
  questionId: Scalars['String'];
  /** The choice answer id */
  valueC?: Maybe<Scalars['String']>;
  /** The text answer */
  valueT?: Maybe<Scalars['String']>;
};

export type RespondentAnswersInput = {
  /** The id of the question */
  questionId: Scalars['String'];
  /** The choice answer id */
  valueC?: InputMaybe<Scalars['String']>;
  /** The text answer */
  valueT?: InputMaybe<Scalars['String']>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']>;
};

export type ScheduledEvent = {
  __typename?: 'ScheduledEvent';
  _id: Scalars['MongoID'];
  /** Optionally data that will be sent with the event */
  data?: Maybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt: Scalars['Date'];
  /** The timestamp of when the event was executed */
  executed?: Maybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId: Scalars['MongoID'];
  /** The referenced object type */
  refType: EnumScheduledEventRefType;
};

/** List of items with pagination. */
export type ScheduledEventScheduledEventPagination = {
  __typename?: 'ScheduledEventScheduledEventPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ScheduledEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ShippingCarrier = {
  __typename?: 'ShippingCarrier';
  _id: Scalars['MongoID'];
  activeFor?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  b2ceurope?: Maybe<Scalars['Boolean']>;
  carrier?: Maybe<EnumShippingCarrierCarrier>;
  carrierGateway?: Maybe<ShippingCarrierCarrierGateway>;
  carrierId?: Maybe<Scalars['String']>;
  /** Whether this carrier is a custom carrier */
  customCarrier?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  expression?: Maybe<Scalars['String']>;
  externalCode?: Maybe<Scalars['String']>;
  externalName?: Maybe<Scalars['String']>;
  localizationKey?: Maybe<Scalars['String']>;
  logisticsPartnerId?: Maybe<Scalars['MongoID']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shipmondo?: Maybe<ShippingCarrierShipmondo>;
  typeName?: Maybe<EnumShippingCarrierTypeName>;
};

export type ShippingCarrierCarrierGateway = {
  __typename?: 'ShippingCarrierCarrierGateway';
  apiKey?: Maybe<Scalars['String']>;
  /** The carrier used for the Carrier Gateway API input */
  inputCarrier?: Maybe<EnumShippingCarrierCarrierGatewayInputCarrier>;
  /** The carrier that will be used to output the shipment */
  outputCarrier?: Maybe<EnumShippingCarrierCarrierGatewayOutputCarrier>;
  /** Whether the carrier supports QR codes */
  supportQR?: Maybe<Scalars['Boolean']>;
};

export type ShippingCarrierCarrierGatewayInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  /** The carrier used for the Carrier Gateway API input */
  inputCarrier?: InputMaybe<EnumShippingCarrierCarrierGatewayInputCarrier>;
  /** The carrier that will be used to output the shipment */
  outputCarrier?: InputMaybe<EnumShippingCarrierCarrierGatewayOutputCarrier>;
  /** Whether the carrier supports QR codes */
  supportQR?: InputMaybe<Scalars['Boolean']>;
};

export type ShippingCarrierInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  b2ceurope?: InputMaybe<Scalars['Boolean']>;
  carrier?: InputMaybe<EnumShippingCarrierCarrier>;
  carrierGateway?: InputMaybe<ShippingCarrierCarrierGatewayInput>;
  carrierId?: InputMaybe<Scalars['String']>;
  /** Whether this carrier is a custom carrier */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  expression?: InputMaybe<Scalars['String']>;
  externalCode?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  localizationKey?: InputMaybe<Scalars['String']>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  shipmondo?: InputMaybe<ShippingCarrierShipmondoInput>;
  typeName?: InputMaybe<EnumShippingCarrierTypeName>;
};

export type ShippingCarrierShipmondo = {
  __typename?: 'ShippingCarrierShipmondo';
  carrier?: Maybe<Scalars['String']>;
  carrierCode?: Maybe<Scalars['String']>;
  carrierSecondary?: Maybe<Scalars['String']>;
  customerNumber?: Maybe<Scalars['JSON']>;
  customs?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  ownAgreement?: Maybe<Scalars['Boolean']>;
  qrSize?: Maybe<Scalars['Float']>;
  qrX?: Maybe<Scalars['String']>;
  qrY?: Maybe<Scalars['String']>;
  serviceCodes?: Maybe<Scalars['String']>;
  testMode?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type ShippingCarrierShipmondoInput = {
  carrier?: InputMaybe<Scalars['String']>;
  carrierCode?: InputMaybe<Scalars['String']>;
  carrierSecondary?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['JSON']>;
  customs?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  length?: InputMaybe<Scalars['Float']>;
  ownAgreement?: InputMaybe<Scalars['Boolean']>;
  qrSize?: InputMaybe<Scalars['Float']>;
  qrX?: InputMaybe<Scalars['String']>;
  qrY?: InputMaybe<Scalars['String']>;
  serviceCodes?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type ShippingCarriersForParcelReceiverInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum ShippingCostCarrier {
  B2cEurope = 'b2c_europe',
  Dao = 'dao',
  DeutschePost = 'deutsche_post',
  Dhl = 'dhl',
  DhlExpress = 'dhl_express',
  Gls = 'gls',
  Parcelplus = 'parcelplus',
  Pdk = 'pdk',
  Ups = 'ups'
}

export enum ShippingCostDirection {
  Outbound = 'outbound',
  Return = 'return'
}

export type ShippingCostInput = {
  carrier: ShippingCostCarrier;
  country: Scalars['String'];
  direction?: InputMaybe<ShippingCostDirection>;
  weight: Scalars['Float'];
};

export type ShippingCostOutput = {
  __typename?: 'ShippingCostOutput';
  carrier: ShippingCostCarrier;
  cost?: Maybe<Scalars['Float']>;
  country: Scalars['String'];
  currency: Scalars['String'];
  direction: ShippingCostDirection;
  weight: Scalars['Float'];
};

export type ShippingLabel = {
  __typename?: 'ShippingLabel';
  _id: Scalars['MongoID'];
  archived?: Maybe<Scalars['Boolean']>;
  /** The carrier for this shipping label */
  carrier?: Maybe<ShippingCarrier>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedBy?: Maybe<Scalars['String']>;
  deletedTs?: Maybe<Scalars['Date']>;
  deliveryDate?: Maybe<Scalars['Date']>;
  deliveryStatus?: Maybe<EnumShippingLabelDeliveryStatus>;
  labelCode?: Maybe<Scalars['String']>;
  labelExternalId?: Maybe<Scalars['String']>;
  labelFailed?: Maybe<Scalars['Boolean']>;
  labelFailedCount?: Maybe<Scalars['Float']>;
  labelImageId?: Maybe<Scalars['MongoID']>;
  lastUpdate?: Maybe<Scalars['Date']>;
  /** The package code for this shipping label */
  packageCode?: Maybe<Scalars['String']>;
  /** The parcel that this shipping label is for */
  parcel?: Maybe<Parcel>;
  qrImageId?: Maybe<Scalars['MongoID']>;
  /** URL for the QR code image */
  qrImageUrl?: Maybe<Scalars['String']>;
  qrPngId?: Maybe<Scalars['MongoID']>;
  /** URL for the QR code */
  qrUrl?: Maybe<Scalars['String']>;
  receiver?: Maybe<AddressInfo>;
  /** The return order that this shipping label is for */
  returnOrder?: Maybe<Order2>;
  sender?: Maybe<AddressInfo>;
  shippingCarrierId: Scalars['MongoID'];
  shopId: Scalars['MongoID'];
  tracking?: Maybe<ShippingLabelTracking>;
  /** URL for tracking the package */
  trackingUrl?: Maybe<Scalars['String']>;
  /** The trade-in that this shipping label is for */
  tradeIn?: Maybe<TradeIn>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** URL for the packaging label, not applicable to code based solutions */
  url?: Maybe<Scalars['String']>;
};

export type ShippingLabelTracking = {
  __typename?: 'ShippingLabelTracking';
  carrierCode?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusFailed?: Maybe<Scalars['Boolean']>;
  statusText?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Date']>;
  trackingCode?: Maybe<Scalars['String']>;
};

export type ShippingLabelTrackingInput = {
  carrierCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusFailed?: InputMaybe<Scalars['Boolean']>;
  statusText?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Date']>;
  trackingCode?: InputMaybe<Scalars['String']>;
};

export type Shop = {
  __typename?: 'Shop';
  _id: Scalars['MongoID'];
  address?: Maybe<AddressInfo>;
  /** The API settings for the shop */
  api?: Maybe<BrandApi>;
  /** The brandhouse this shop resides below */
  brandHouse?: Maybe<BrandHouse>;
  brandHouseId: Scalars['MongoID'];
  /** All BrickMail configurations for this shop */
  brickMails?: Maybe<Array<Maybe<BrickMail>>>;
  /** Wholesale categories for this shop */
  categories?: Maybe<Array<Maybe<WholeSaleCategory>>>;
  closeDate?: Maybe<Scalars['Date']>;
  /** List of all colors found on variants for this shop */
  colors?: Maybe<Array<Scalars['String']>>;
  /** Conditions */
  conditions?: Maybe<Array<Maybe<ShopConditionPublic>>>;
  configuration?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  disableContactResetDate?: Maybe<Scalars['Date']>;
  disabled?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  externalName?: Maybe<Scalars['String']>;
  frontendType: EnumShopFrontendType;
  generateThumbnails?: Maybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: Maybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: Maybe<Scalars['Date']>;
  live?: Maybe<Scalars['Boolean']>;
  liveDate?: Maybe<Scalars['Date']>;
  locales?: Maybe<Array<Maybe<Scalars['String']>>>;
  logisticsPartnerId: Scalars['MongoID'];
  logo?: Maybe<Scalars['String']>;
  /** The locale that masterdata from shop comes in */
  masterDataLocale: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** The primary locale for this shop */
  primaryLocale: Scalars['String'];
  /** List of all product batches for this shop */
  productBatches?: Maybe<Array<Scalars['String']>>;
  /** List of all collections found on products for this shop */
  productCollections?: Maybe<Array<Scalars['String']>>;
  /** List of all metafield values found on the given key */
  productMetaFieldValues?: Maybe<Array<Scalars['String']>>;
  /** List of all tags found on products for this shop */
  productTags?: Maybe<Array<Scalars['String']>>;
  /** List of all product types found on products for this shop */
  productTypes?: Maybe<Array<Scalars['String']>>;
  /** List of all product vendors found on products for this shop */
  productVendors?: Maybe<Array<Scalars['String']>>;
  ressourceRedirectUrl?: Maybe<Scalars['String']>;
  /** List of brandrules for shop */
  rules?: Maybe<Array<Maybe<BrandRule>>>;
  /** Brand settings */
  settings?: Maybe<BrandSetting>;
  shopCollectionUrl?: Maybe<Scalars['String']>;
  /** List of all sizes found on variants for this shop */
  sizes?: Maybe<Array<Scalars['String']>>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: Maybe<Scalars['Date']>;
  /** Statistics for this shop */
  statistics?: Maybe<ShopStatistics>;
  /** The primary locale for stockitems */
  stockItemLocalePrimary: Scalars['String'];
  /** List of active locales for stockitem translations */
  stockItemLocales: Array<Scalars['String']>;
  synchronizeActions?: Maybe<Scalars['Date']>;
  synchronizeHooks?: Maybe<Scalars['Date']>;
  synchronizeOrders?: Maybe<Scalars['Date']>;
  synchronizeProducts?: Maybe<Scalars['Date']>;
  tradeInBaseUrl?: Maybe<Scalars['String']>;
  /** The primary locale for tradeins */
  tradeInLocalePrimary: Scalars['String'];
  /** List of locales for tradeIn app */
  tradeInLocales: Array<Scalars['String']>;
  updateVouchers?: Maybe<Scalars['Boolean']>;
  updateVouchersDate?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  wholeSaleActive?: Maybe<Scalars['Boolean']>;
};


export type ShopProductMetaFieldValuesArgs = {
  key: Scalars['String'];
};


export type ShopStatisticsArgs = {
  periodFrom: Scalars['Date'];
  periodTo: Scalars['Date'];
};

/** Conditions for the public */
export type ShopConditionPublic = {
  __typename?: 'ShopConditionPublic';
  condition: Scalars['Int'];
  description: Scalars['String'];
  name: Scalars['String'];
};

export type ShopStatistics = {
  __typename?: 'ShopStatistics';
  /** Total number of orders in the external shop for a given period. */
  externOrders: Scalars['Int'];
  /** The total number of views for stockitems, including bots and crawlers. */
  stockItemViews: Scalars['Int'];
  /** The number of actual visitors for stockitems, bots and crawlers are excluded and grouped by identifiable information such as IP / UserAgent. */
  stockItemVisitors: Scalars['Int'];
  /** Total number of stockitems for sale in the shop. */
  stockItemsForSale: Scalars['Int'];
};

/** The shop fields that can be updated using mutation ShopUpdate */
export type ShopUpdateInput = {
  address?: InputMaybe<AddressInfoInput>;
  closeDate?: InputMaybe<Scalars['Date']>;
  configuration?: InputMaybe<Scalars['JSON']>;
  currency?: InputMaybe<Scalars['String']>;
  disableContactResetDate?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalName?: InputMaybe<Scalars['String']>;
  frontendType: EnumShopFrontendType;
  generateThumbnails?: InputMaybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: InputMaybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: InputMaybe<Scalars['Date']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveDate?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logo?: InputMaybe<Scalars['String']>;
  ressourceRedirectUrl?: InputMaybe<Scalars['String']>;
  shopCollectionUrl?: InputMaybe<Scalars['String']>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: InputMaybe<Scalars['Date']>;
  tradeInBaseUrl?: InputMaybe<Scalars['String']>;
  updateVouchers?: InputMaybe<Scalars['Boolean']>;
  updateVouchersDate?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export enum SortFindByIdsProductInput {
  BatchserialAsc = 'BATCHSERIAL_ASC',
  BatchserialDesc = 'BATCHSERIAL_DESC',
  BrandproductidAsc = 'BRANDPRODUCTID_ASC',
  BrandproductidDesc = 'BRANDPRODUCTID_DESC',
  IspreownedAsc = 'ISPREOWNED_ASC',
  IspreownedDesc = 'ISPREOWNED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ProducttypeAsc = 'PRODUCTTYPE_ASC',
  ProducttypeDesc = 'PRODUCTTYPE_DESC',
  ProductvendorAsc = 'PRODUCTVENDOR_ASC',
  ProductvendorDesc = 'PRODUCTVENDOR_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  StyleAsc = 'STYLE_ASC',
  StyleDesc = 'STYLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBrandHouseInput {
  DeactivatedAsc = 'DEACTIVATED_ASC',
  DeactivatedDesc = 'DEACTIVATED_DESC',
  InitialsAsc = 'INITIALS_ASC',
  InitialsDesc = 'INITIALS_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBrandItemInput {
  AttributesApparentfabrictypeAsc = 'ATTRIBUTES__APPARENTFABRICTYPE_ASC',
  AttributesApparentfabrictypeDesc = 'ATTRIBUTES__APPARENTFABRICTYPE_DESC',
  AttributesFormalitylevelAsc = 'ATTRIBUTES__FORMALITYLEVEL_ASC',
  AttributesFormalitylevelDesc = 'ATTRIBUTES__FORMALITYLEVEL_DESC',
  AttributesPatternAsc = 'ATTRIBUTES__PATTERN_ASC',
  AttributesPatternDesc = 'ATTRIBUTES__PATTERN_DESC',
  AttributesPrimarycolorAsc = 'ATTRIBUTES__PRIMARYCOLOR_ASC',
  AttributesPrimarycolorDesc = 'ATTRIBUTES__PRIMARYCOLOR_DESC',
  AttributesSeasonsuitabilityAsc = 'ATTRIBUTES__SEASONSUITABILITY_ASC',
  AttributesSeasonsuitabilityDesc = 'ATTRIBUTES__SEASONSUITABILITY_DESC',
  AttributesTypeAsc = 'ATTRIBUTES__TYPE_ASC',
  AttributesTypeDesc = 'ATTRIBUTES__TYPE_DESC',
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidAttributesFormalitylevelAsc = 'BRANDHOUSEID__ATTRIBUTES__FORMALITYLEVEL_ASC',
  BrandhouseidAttributesFormalitylevelDesc = 'BRANDHOUSEID__ATTRIBUTES__FORMALITYLEVEL_DESC',
  BrandhouseidAttributesPrimarycolorAsc = 'BRANDHOUSEID__ATTRIBUTES__PRIMARYCOLOR_ASC',
  BrandhouseidAttributesPrimarycolorDesc = 'BRANDHOUSEID__ATTRIBUTES__PRIMARYCOLOR_DESC',
  BrandhouseidAttributesTypeAsc = 'BRANDHOUSEID__ATTRIBUTES__TYPE_ASC',
  BrandhouseidAttributesTypeDesc = 'BRANDHOUSEID__ATTRIBUTES__TYPE_DESC',
  BrandhouseidDaysofflineAsc = 'BRANDHOUSEID__DAYSOFFLINE_ASC',
  BrandhouseidDaysofflineDesc = 'BRANDHOUSEID__DAYSOFFLINE_DESC',
  BrandhouseidDiscardedAsc = 'BRANDHOUSEID__DISCARDED_ASC',
  BrandhouseidDiscardedDesc = 'BRANDHOUSEID__DISCARDED_DESC',
  BrandhouseidExternalidAsc = 'BRANDHOUSEID__EXTERNALID_ASC',
  BrandhouseidExternalidDesc = 'BRANDHOUSEID__EXTERNALID_DESC',
  BrandhouseidFirstlisteddateAsc = 'BRANDHOUSEID__FIRSTLISTEDDATE_ASC',
  BrandhouseidFirstlisteddateDesc = 'BRANDHOUSEID__FIRSTLISTEDDATE_DESC',
  BrandhouseidHasmasterdataAsc = 'BRANDHOUSEID__HASMASTERDATA_ASC',
  BrandhouseidHasmasterdataDesc = 'BRANDHOUSEID__HASMASTERDATA_DESC',
  BrandhouseidHasmasterdataHascustomimagesAsc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES_ASC',
  BrandhouseidHasmasterdataHascustomimagesDesc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES_DESC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationAsc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION_ASC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationDesc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION_DESC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingAsc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING_ASC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingDesc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING_DESC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationAsc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION_ASC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationDesc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION_DESC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationCreatedatAsc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT_ASC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationCreatedatDesc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT_DESC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationCreatedatUpdatedatAsc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT_ASC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationCreatedatUpdatedatDesc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT_DESC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationCreatedatUpdatedatStocklocationtsAsc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS_ASC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationCreatedatUpdatedatStocklocationtsDesc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS_DESC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationCreatedatUpdatedatStocklocationtsSoldtsAsc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS__SOLDTS_ASC',
  BrandhouseidHasmasterdataHascustomimagesStocklocationMissingHaslocationCreatedatUpdatedatStocklocationtsSoldtsDesc = 'BRANDHOUSEID__HASMASTERDATA__HASCUSTOMIMAGES__STOCKLOCATION__MISSING__HASLOCATION__CREATEDAT__UPDATEDAT__STOCKLOCATIONTS__SOLDTS_DESC',
  BrandhouseidIstradeinAsc = 'BRANDHOUSEID__ISTRADEIN_ASC',
  BrandhouseidIstradeinDesc = 'BRANDHOUSEID__ISTRADEIN_DESC',
  BrandhouseidMasterdatavariantidAsc = 'BRANDHOUSEID__MASTERDATAVARIANTID_ASC',
  BrandhouseidMasterdatavariantidDesc = 'BRANDHOUSEID__MASTERDATAVARIANTID_DESC',
  BrandhouseidSalesscoreAsc = 'BRANDHOUSEID__SALESSCORE_ASC',
  BrandhouseidSalesscoreDesc = 'BRANDHOUSEID__SALESSCORE_DESC',
  BrandhouseidVasidAsc = 'BRANDHOUSEID__VASID_ASC',
  BrandhouseidVasidDesc = 'BRANDHOUSEID__VASID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DaysofflineAsc = 'DAYSOFFLINE_ASC',
  DaysofflineDesc = 'DAYSOFFLINE_DESC',
  DiscardedAsc = 'DISCARDED_ASC',
  DiscardedDesc = 'DISCARDED_DESC',
  FirstlisteddateAsc = 'FIRSTLISTEDDATE_ASC',
  FirstlisteddateDesc = 'FIRSTLISTEDDATE_DESC',
  HascommentAsc = 'HASCOMMENT_ASC',
  HascommentDesc = 'HASCOMMENT_DESC',
  HascustomimagesAsc = 'HASCUSTOMIMAGES_ASC',
  HascustomimagesDesc = 'HASCUSTOMIMAGES_DESC',
  HaslocationAsc = 'HASLOCATION_ASC',
  HaslocationDesc = 'HASLOCATION_DESC',
  HastranslatedcommentAsc = 'HASTRANSLATEDCOMMENT_ASC',
  HastranslatedcommentDesc = 'HASTRANSLATEDCOMMENT_DESC',
  InvalidmanufacturerAsc = 'INVALIDMANUFACTURER_ASC',
  InvalidmanufacturerDesc = 'INVALIDMANUFACTURER_DESC',
  IstradeinAsc = 'ISTRADEIN_ASC',
  IstradeinDesc = 'ISTRADEIN_DESC',
  MissingAsc = 'MISSING_ASC',
  MissingDesc = 'MISSING_DESC',
  SalesscoreAsc = 'SALESSCORE_ASC',
  SalesscoreDesc = 'SALESSCORE_DESC',
  SoldtsAsc = 'SOLDTS_ASC',
  SoldtsDesc = 'SOLDTS_DESC',
  SourcetypeAsc = 'SOURCETYPE_ASC',
  SourcetypeDesc = 'SOURCETYPE_DESC',
  StocklocationbagAsc = 'STOCKLOCATIONBAG_ASC',
  StocklocationbagDesc = 'STOCKLOCATIONBAG_DESC',
  StocklocationbagUpdatedatAsc = 'STOCKLOCATIONBAG__UPDATEDAT_ASC',
  StocklocationbagUpdatedatDesc = 'STOCKLOCATIONBAG__UPDATEDAT_DESC',
  StocklocationtsAsc = 'STOCKLOCATIONTS_ASC',
  StocklocationtsDesc = 'STOCKLOCATIONTS_DESC',
  StocklocationAsc = 'STOCKLOCATION_ASC',
  StocklocationDesc = 'STOCKLOCATION_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  VasidAsc = 'VASID_ASC',
  VasidDesc = 'VASID_DESC',
  VasstateAsc = 'VASSTATE_ASC',
  VasstateDesc = 'VASSTATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBrandItemLayawayInput {
  BranditemidAsc = 'BRANDITEMID_ASC',
  BranditemidDesc = 'BRANDITEMID_DESC',
  BranditemidCreatedatAsc = 'BRANDITEMID__CREATEDAT_ASC',
  BranditemidCreatedatDesc = 'BRANDITEMID__CREATEDAT_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  UpdatedbyRefAsc = 'UPDATEDBY__REF_ASC',
  UpdatedbyRefDesc = 'UPDATEDBY__REF_DESC',
  UpdatedbyRefCreatedatAsc = 'UPDATEDBY__REF__CREATEDAT_ASC',
  UpdatedbyRefCreatedatDesc = 'UPDATEDBY__REF__CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBrandProductGroupInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidActiveAsc = 'BRANDHOUSEID__ACTIVE_ASC',
  BrandhouseidActiveDesc = 'BRANDHOUSEID__ACTIVE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBrandProductImageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBrandProductInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidGroupidAsc = 'BRANDHOUSEID__GROUPID_ASC',
  BrandhouseidGroupidDesc = 'BRANDHOUSEID__GROUPID_DESC',
  BrandhouseidGroupidExternalidAsc = 'BRANDHOUSEID__GROUPID__EXTERNALID_ASC',
  BrandhouseidGroupidExternalidDesc = 'BRANDHOUSEID__GROUPID__EXTERNALID_DESC',
  StyleAsc = 'STYLE_ASC',
  StyleDesc = 'STYLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBrandProductSizeInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidBrandproductidAsc = 'BRANDHOUSEID__BRANDPRODUCTID_ASC',
  BrandhouseidBrandproductidDesc = 'BRANDHOUSEID__BRANDPRODUCTID_DESC',
  BrandhouseidBrandproductidBrandproductvariantidAsc = 'BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID_ASC',
  BrandhouseidBrandproductidBrandproductvariantidDesc = 'BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID_DESC',
  BrandhouseidBrandproductidBrandproductvariantidExternalidAsc = 'BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID__EXTERNALID_ASC',
  BrandhouseidBrandproductidBrandproductvariantidExternalidDesc = 'BRANDHOUSEID__BRANDPRODUCTID__BRANDPRODUCTVARIANTID__EXTERNALID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBrandProductVariantInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidGroupidAsc = 'BRANDHOUSEID__GROUPID_ASC',
  BrandhouseidGroupidDesc = 'BRANDHOUSEID__GROUPID_DESC',
  SkuAsc = 'SKU_ASC',
  SkuDesc = 'SKU_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCampaignInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidFromdateAsc = 'BRANDHOUSEID__FROMDATE_ASC',
  BrandhouseidFromdateDesc = 'BRANDHOUSEID__FROMDATE_DESC',
  BrandhouseidFromdateTodateAsc = 'BRANDHOUSEID__FROMDATE__TODATE_ASC',
  BrandhouseidFromdateTodateDesc = 'BRANDHOUSEID__FROMDATE__TODATE_DESC',
  CompletedAsc = 'COMPLETED_ASC',
  CompletedDesc = 'COMPLETED_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  ShopidBrandhouseidAsc = 'SHOPID__BRANDHOUSEID_ASC',
  ShopidBrandhouseidDesc = 'SHOPID__BRANDHOUSEID_DESC',
  ShopidBrandhouseidFromdateAsc = 'SHOPID__BRANDHOUSEID__FROMDATE_ASC',
  ShopidBrandhouseidFromdateDesc = 'SHOPID__BRANDHOUSEID__FROMDATE_DESC',
  ShopidBrandhouseidFromdateTodateAsc = 'SHOPID__BRANDHOUSEID__FROMDATE__TODATE_ASC',
  ShopidBrandhouseidFromdateTodateDesc = 'SHOPID__BRANDHOUSEID__FROMDATE__TODATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCircularPayoutTypeInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCircularPointInput {
  ConsumeridAsc = 'CONSUMERID_ASC',
  ConsumeridDesc = 'CONSUMERID_DESC',
  EventprocessedAsc = 'EVENTPROCESSED_ASC',
  EventprocessedDesc = 'EVENTPROCESSED_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  SourceobjectidAsc = 'SOURCEOBJECTID_ASC',
  SourceobjectidDesc = 'SOURCEOBJECTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyConsumerEventInput {
  EventAsc = 'EVENT_ASC',
  EventDesc = 'EVENT_DESC',
  SubeventAsc = 'SUBEVENT_ASC',
  SubeventDesc = 'SUBEVENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyConsumerInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  ShopidCustomidAsc = 'SHOPID__CUSTOMID_ASC',
  ShopidCustomidDesc = 'SHOPID__CUSTOMID_DESC',
  ShopidExternalidAsc = 'SHOPID__EXTERNALID_ASC',
  ShopidExternalidDesc = 'SHOPID__EXTERNALID_DESC',
  ShopidMailAsc = 'SHOPID__MAIL_ASC',
  ShopidMailDesc = 'SHOPID__MAIL_DESC',
  ShopidPersonidAsc = 'SHOPID__PERSONID_ASC',
  ShopidPersonidDesc = 'SHOPID__PERSONID_DESC',
  ShopidPhoneAsc = 'SHOPID__PHONE_ASC',
  ShopidPhoneDesc = 'SHOPID__PHONE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDataViewInput {
  ExpiresatAsc = 'EXPIRESAT_ASC',
  ExpiresatDesc = 'EXPIRESAT_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyExternOrder2Input {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyExternOrderInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationConnectorInput {
  ActiveforAsc = 'ACTIVEFOR_ASC',
  ActiveforDesc = 'ACTIVEFOR_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ReftypesAsc = 'REFTYPES_ASC',
  ReftypesDesc = 'REFTYPES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationInstanceInput {
  RefidAsc = 'REFID_ASC',
  RefidDesc = 'REFID_DESC',
  RefidConnectoridAsc = 'REFID__CONNECTORID_ASC',
  RefidConnectoridDesc = 'REFID__CONNECTORID_DESC',
  RefidConnectoridDeletedAsc = 'REFID__CONNECTORID__DELETED_ASC',
  RefidConnectoridDeletedDesc = 'REFID__CONNECTORID__DELETED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationMessageInput {
  LockedidAsc = 'LOCKEDID_ASC',
  LockedidDesc = 'LOCKEDID_DESC',
  MessagefailedAsc = 'MESSAGEFAILED_ASC',
  MessagefailedDesc = 'MESSAGEFAILED_DESC',
  RefidAsc = 'REFID_ASC',
  RefidDesc = 'REFID_DESC',
  RefidMessageidAsc = 'REFID__MESSAGEID_ASC',
  RefidMessageidDesc = 'REFID__MESSAGEID_DESC',
  RefidMessageidSentAsc = 'REFID__MESSAGEID__SENT_ASC',
  RefidMessageidSentDesc = 'REFID__MESSAGEID__SENT_DESC',
  RefidMessageidSentAcknowledgedAsc = 'REFID__MESSAGEID__SENT__ACKNOWLEDGED_ASC',
  RefidMessageidSentAcknowledgedDesc = 'REFID__MESSAGEID__SENT__ACKNOWLEDGED_DESC',
  RefidMessageidSentAcknowledgedFailedAsc = 'REFID__MESSAGEID__SENT__ACKNOWLEDGED__FAILED_ASC',
  RefidMessageidSentAcknowledgedFailedDesc = 'REFID__MESSAGEID__SENT__ACKNOWLEDGED__FAILED_DESC',
  RefidMessageAsc = 'REFID__MESSAGE_ASC',
  RefidMessageDesc = 'REFID__MESSAGE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInvoiceAdjustmentInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInvoiceLineInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  InvoiceidAsc = 'INVOICEID_ASC',
  InvoiceidDesc = 'INVOICEID_DESC',
  LinetypeAsc = 'LINETYPE_ASC',
  LinetypeDesc = 'LINETYPE_DESC',
  LinetypeLineidAsc = 'LINETYPE__LINEID_ASC',
  LinetypeLineidDesc = 'LINETYPE__LINEID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyItemIssueInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BranditemidAsc = 'BRANDITEMID_ASC',
  BranditemidDesc = 'BRANDITEMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyLogisticsPartnerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNfcInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyObjectPatchesInput {
  AuditnoteidAsc = 'AUDITNOTEID_ASC',
  AuditnoteidDesc = 'AUDITNOTEID_DESC',
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  RefAsc = 'REF_ASC',
  RefDesc = 'REF_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyOptionSetInput {
  RefidAsc = 'REFID_ASC',
  RefidDesc = 'REFID_DESC',
  RefidTargetAsc = 'REFID__TARGET_ASC',
  RefidTargetDesc = 'REFID__TARGET_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyOptionValueInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyOrder2Input {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  FulstateAsc = 'FULSTATE_ASC',
  FulstateDesc = 'FULSTATE_DESC',
  OrderdateAsc = 'ORDERDATE_ASC',
  OrderdateDesc = 'ORDERDATE_DESC',
  OrdernameAsc = 'ORDERNAME_ASC',
  OrdernameDesc = 'ORDERNAME_DESC',
  OrderstateAsc = 'ORDERSTATE_ASC',
  OrderstateDesc = 'ORDERSTATE_DESC',
  PaystateAsc = 'PAYSTATE_ASC',
  PaystateDesc = 'PAYSTATE_DESC',
  ProformaAsc = 'PROFORMA_ASC',
  ProformaDesc = 'PROFORMA_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  SilencedAsc = 'SILENCED_ASC',
  SilencedDesc = 'SILENCED_DESC',
  SplitorderAsc = 'SPLITORDER_ASC',
  SplitorderDesc = 'SPLITORDER_DESC',
  TrackingorderstateAsc = 'TRACKINGORDERSTATE_ASC',
  TrackingorderstateDesc = 'TRACKINGORDERSTATE_DESC',
  TrackingreturnstateAsc = 'TRACKINGRETURNSTATE_ASC',
  TrackingreturnstateDesc = 'TRACKINGRETURNSTATE_DESC',
  UpdatedlinetsAsc = 'UPDATEDLINETS_ASC',
  UpdatedlinetsDesc = 'UPDATEDLINETS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyParcelInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidShopidAsc = 'BRANDHOUSEID__SHOPID_ASC',
  BrandhouseidShopidDesc = 'BRANDHOUSEID__SHOPID_DESC',
  BrandhouseidShopidParceldateAsc = 'BRANDHOUSEID__SHOPID__PARCELDATE_ASC',
  BrandhouseidShopidParceldateDesc = 'BRANDHOUSEID__SHOPID__PARCELDATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPlannedMailInput {
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  ShopidObjecttypeAsc = 'SHOPID__OBJECTTYPE_ASC',
  ShopidObjecttypeDesc = 'SHOPID__OBJECTTYPE_DESC',
  ShopidObjecttypeObjectidAsc = 'SHOPID__OBJECTTYPE__OBJECTID_ASC',
  ShopidObjecttypeObjectidDesc = 'SHOPID__OBJECTTYPE__OBJECTID_DESC',
  ShopidSendatAsc = 'SHOPID__SENDAT_ASC',
  ShopidSendatDesc = 'SHOPID__SENDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPotentialInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  ShopidBrandproductvariantidAsc = 'SHOPID__BRANDPRODUCTVARIANTID_ASC',
  ShopidBrandproductvariantidDesc = 'SHOPID__BRANDPRODUCTVARIANTID_DESC',
  ShopidExterndateAsc = 'SHOPID__EXTERNDATE_ASC',
  ShopidExterndateDesc = 'SHOPID__EXTERNDATE_DESC',
  ShopidNameAsc = 'SHOPID__NAME_ASC',
  ShopidNameDesc = 'SHOPID__NAME_DESC',
  ShopidProductvariantidAsc = 'SHOPID__PRODUCTVARIANTID_ASC',
  ShopidProductvariantidDesc = 'SHOPID__PRODUCTVARIANTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProductInput {
  BatchserialAsc = 'BATCHSERIAL_ASC',
  BatchserialDesc = 'BATCHSERIAL_DESC',
  BrandproductidAsc = 'BRANDPRODUCTID_ASC',
  BrandproductidDesc = 'BRANDPRODUCTID_DESC',
  IspreownedAsc = 'ISPREOWNED_ASC',
  IspreownedDesc = 'ISPREOWNED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ProducttypeAsc = 'PRODUCTTYPE_ASC',
  ProducttypeDesc = 'PRODUCTTYPE_DESC',
  ProductvendorAsc = 'PRODUCTVENDOR_ASC',
  ProductvendorDesc = 'PRODUCTVENDOR_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  StyleAsc = 'STYLE_ASC',
  StyleDesc = 'STYLE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProductVariantInput {
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProductVariantSizeInput {
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  ShopidProductidAsc = 'SHOPID__PRODUCTID_ASC',
  ShopidProductidDesc = 'SHOPID__PRODUCTID_DESC',
  ShopidProductidProductvariantidAsc = 'SHOPID__PRODUCTID__PRODUCTVARIANTID_ASC',
  ShopidProductidProductvariantidDesc = 'SHOPID__PRODUCTID__PRODUCTVARIANTID_DESC',
  ShopidProductidProductvariantidExternalidAsc = 'SHOPID__PRODUCTID__PRODUCTVARIANTID__EXTERNALID_ASC',
  ShopidProductidProductvariantidExternalidDesc = 'SHOPID__PRODUCTID__PRODUCTVARIANTID__EXTERNALID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyRespondentInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyScheduledEventInput {
  ExecutedAsc = 'EXECUTED_ASC',
  ExecutedDesc = 'EXECUTED_DESC',
  ExecutedExecuteatAsc = 'EXECUTED__EXECUTEAT_ASC',
  ExecutedExecuteatDesc = 'EXECUTED__EXECUTEAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyShopInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStockItemInput {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  EanAsc = 'EAN_ASC',
  EanDesc = 'EAN_DESC',
  ItemnrAsc = 'ITEMNR_ASC',
  ItemnrDesc = 'ITEMNR_DESC',
  ItemskuAsc = 'ITEMSKU_ASC',
  ItemskuDesc = 'ITEMSKU_DESC',
  MissingAsc = 'MISSING_ASC',
  MissingDesc = 'MISSING_DESC',
  OriginaleanAsc = 'ORIGINALEAN_ASC',
  OriginaleanDesc = 'ORIGINALEAN_DESC',
  ReviewedAsc = 'REVIEWED_ASC',
  ReviewedDesc = 'REVIEWED_DESC',
  SizeAsc = 'SIZE_ASC',
  SizeDesc = 'SIZE_DESC',
  SourcetypeAsc = 'SOURCETYPE_ASC',
  SourcetypeDesc = 'SOURCETYPE_DESC',
  StocklocationtsAsc = 'STOCKLOCATIONTS_ASC',
  StocklocationtsDesc = 'STOCKLOCATIONTS_DESC',
  StocklocationAsc = 'STOCKLOCATION_ASC',
  StocklocationDesc = 'STOCKLOCATION_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManySystemMessageInput {
  LastactivitytsAsc = 'LASTACTIVITYTS_ASC',
  LastactivitytsDesc = 'LASTACTIVITYTS_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC',
  SubjectAudienceAsc = 'SUBJECT__AUDIENCE_ASC',
  SubjectAudienceDesc = 'SUBJECT__AUDIENCE_DESC',
  SubjectAudienceAudiencebrandidAsc = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID_ASC',
  SubjectAudienceAudiencebrandidDesc = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID_DESC',
  SubjectAudienceAudiencebrandidMessagetypeAsc = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_ASC',
  SubjectAudienceAudiencebrandidMessagetypeDesc = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTrackingInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidObjectidAsc = 'BRANDHOUSEID__OBJECTID_ASC',
  BrandhouseidObjectidDesc = 'BRANDHOUSEID__OBJECTID_DESC',
  ObjectidAsc = 'OBJECTID_ASC',
  ObjectidDesc = 'OBJECTID_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTradeInInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  DatetimeAsc = 'DATETIME_ASC',
  DatetimeDesc = 'DATETIME_DESC',
  DeletedtsAsc = 'DELETEDTS_ASC',
  DeletedtsDesc = 'DELETEDTS_DESC',
  PayouttypeAsc = 'PAYOUTTYPE_ASC',
  PayouttypeDesc = 'PAYOUTTYPE_DESC',
  RegisteredtsAsc = 'REGISTEREDTS_ASC',
  RegisteredtsDesc = 'REGISTEREDTS_DESC',
  RegisteredAsc = 'REGISTERED_ASC',
  RegisteredDesc = 'REGISTERED_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  TradeinnrAsc = 'TRADEINNR_ASC',
  TradeinnrDesc = 'TRADEINNR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyUserInput {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  OauthsubjectAsc = 'OAUTHSUBJECT_ASC',
  OauthsubjectDesc = 'OAUTHSUBJECT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVoucherAdjustmentInput {
  VoucheridAsc = 'VOUCHERID_ASC',
  VoucheridDesc = 'VOUCHERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVoucherInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidShopidAsc = 'BRANDHOUSEID__SHOPID_ASC',
  BrandhouseidShopidDesc = 'BRANDHOUSEID__SHOPID_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  ExternidAsc = 'EXTERNID_ASC',
  ExternidDesc = 'EXTERNID_DESC',
  ExternidActivatedAsc = 'EXTERNID__ACTIVATED_ASC',
  ExternidActivatedDesc = 'EXTERNID__ACTIVATED_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  ShopidActivatevoucherAsc = 'SHOPID__ACTIVATEVOUCHER_ASC',
  ShopidActivatevoucherDesc = 'SHOPID__ACTIVATEVOUCHER_DESC',
  ShopidActivatevoucherActivatevouchertsAsc = 'SHOPID__ACTIVATEVOUCHER__ACTIVATEVOUCHERTS_ASC',
  ShopidActivatevoucherActivatevouchertsDesc = 'SHOPID__ACTIVATEVOUCHER__ACTIVATEVOUCHERTS_DESC',
  ShopidCodeAsc = 'SHOPID__CODE_ASC',
  ShopidCodeDesc = 'SHOPID__CODE_DESC',
  ShopidPassiveAsc = 'SHOPID__PASSIVE_ASC',
  ShopidPassiveDesc = 'SHOPID__PASSIVE_DESC',
  ShopidPassiveUpdatedatAsc = 'SHOPID__PASSIVE__UPDATEDAT_ASC',
  ShopidPassiveUpdatedatDesc = 'SHOPID__PASSIVE__UPDATEDAT_DESC',
  TradeinidAsc = 'TRADEINID_ASC',
  TradeinidDesc = 'TRADEINID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVoucherUsageInput {
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  ShopidVoucheridAsc = 'SHOPID__VOUCHERID_ASC',
  ShopidVoucheridDesc = 'SHOPID__VOUCHERID_DESC',
  ShopidVoucheridExternorderidAsc = 'SHOPID__VOUCHERID__EXTERNORDERID_ASC',
  ShopidVoucheridExternorderidDesc = 'SHOPID__VOUCHERID__EXTERNORDERID_DESC',
  UsagedateAsc = 'USAGEDATE_ASC',
  UsagedateDesc = 'USAGEDATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVoucherUsageRefundInput {
  RefunddateAsc = 'REFUNDDATE_ASC',
  RefunddateDesc = 'REFUNDDATE_DESC',
  VoucherusageidAsc = 'VOUCHERUSAGEID_ASC',
  VoucherusageidDesc = 'VOUCHERUSAGEID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyWholeSaleCategoryInput {
  /** The order of the categories when presented to a user */
  Presentation = 'PRESENTATION',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  SortorderAsc = 'SORTORDER_ASC',
  SortorderDesc = 'SORTORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneBrandApiInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneTradeInInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  DatetimeAsc = 'DATETIME_ASC',
  DatetimeDesc = 'DATETIME_DESC',
  DeletedtsAsc = 'DELETEDTS_ASC',
  DeletedtsDesc = 'DELETEDTS_DESC',
  PayouttypeAsc = 'PAYOUTTYPE_ASC',
  PayouttypeDesc = 'PAYOUTTYPE_DESC',
  RegisteredtsAsc = 'REGISTEREDTS_ASC',
  RegisteredtsDesc = 'REGISTEREDTS_DESC',
  RegisteredAsc = 'REGISTERED_ASC',
  RegisteredDesc = 'REGISTERED_DESC',
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  TradeinnrAsc = 'TRADEINNR_ASC',
  TradeinnrDesc = 'TRADEINNR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortRemoveOneIntegrationConnectorInput {
  ActiveforAsc = 'ACTIVEFOR_ASC',
  ActiveforDesc = 'ACTIVEFOR_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ReftypesAsc = 'REFTYPES_ASC',
  ReftypesDesc = 'REFTYPES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneParcelInput {
  BrandhouseidAsc = 'BRANDHOUSEID_ASC',
  BrandhouseidDesc = 'BRANDHOUSEID_DESC',
  BrandhouseidShopidAsc = 'BRANDHOUSEID__SHOPID_ASC',
  BrandhouseidShopidDesc = 'BRANDHOUSEID__SHOPID_DESC',
  BrandhouseidShopidParceldateAsc = 'BRANDHOUSEID__SHOPID__PARCELDATE_ASC',
  BrandhouseidShopidParceldateDesc = 'BRANDHOUSEID__SHOPID__PARCELDATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePlannedMailInput {
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  ShopidObjecttypeAsc = 'SHOPID__OBJECTTYPE_ASC',
  ShopidObjecttypeDesc = 'SHOPID__OBJECTTYPE_DESC',
  ShopidObjecttypeObjectidAsc = 'SHOPID__OBJECTTYPE__OBJECTID_ASC',
  ShopidObjecttypeObjectidDesc = 'SHOPID__OBJECTTYPE__OBJECTID_DESC',
  ShopidSendatAsc = 'SHOPID__SENDAT_ASC',
  ShopidSendatDesc = 'SHOPID__SENDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneScheduledEventInput {
  ExecutedAsc = 'EXECUTED_ASC',
  ExecutedDesc = 'EXECUTED_DESC',
  ExecutedExecuteatAsc = 'EXECUTED__EXECUTEAT_ASC',
  ExecutedExecuteatDesc = 'EXECUTED__EXECUTEAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneShippingLabelInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneShopInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneSystemMessageInput {
  LastactivitytsAsc = 'LASTACTIVITYTS_ASC',
  LastactivitytsDesc = 'LASTACTIVITYTS_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC',
  SubjectAudienceAsc = 'SUBJECT__AUDIENCE_ASC',
  SubjectAudienceDesc = 'SUBJECT__AUDIENCE_DESC',
  SubjectAudienceAudiencebrandidAsc = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID_ASC',
  SubjectAudienceAudiencebrandidDesc = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID_DESC',
  SubjectAudienceAudiencebrandidMessagetypeAsc = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_ASC',
  SubjectAudienceAudiencebrandidMessagetypeDesc = 'SUBJECT__AUDIENCE__AUDIENCEBRANDID__MESSAGETYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneWholeSaleCategoryInput {
  ShopidAsc = 'SHOPID_ASC',
  ShopidDesc = 'SHOPID_DESC',
  SortorderAsc = 'SORTORDER_ASC',
  SortorderDesc = 'SORTORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type Status = {
  __typename?: 'Status';
  /** The date of the message */
  date?: Maybe<Scalars['Date']>;
  /** The status message */
  message: Scalars['String'];
  /** The severity of the status message */
  type: EnumStatusType;
};

export type StockItem = {
  __typename?: 'StockItem';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  beforePrice?: Maybe<Scalars['Float']>;
  beforePrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The branditem for this stockitem */
  brandItem?: Maybe<BrandItem>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: Maybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: Maybe<Scalars['Date']>;
  color?: Maybe<Scalars['String']>;
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: Maybe<Scalars['Float']>;
  /** The condition description */
  conditionDescription?: Maybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Returns a list of data problems */
  dataErrors?: Maybe<Array<Scalars['String']>>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  draft?: Maybe<Scalars['Boolean']>;
  ean?: Maybe<Scalars['String']>;
  ecommerceId?: Maybe<Scalars['String']>;
  /** Whether the logistics partner has checked this stockitem since last recount */
  effectiveChecked: Scalars['Boolean'];
  /** The effective color of this stockitem */
  effectiveColor?: Maybe<Scalars['String']>;
  /** The effective colors of this stockitem */
  effectiveColors?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The effective description that ensures the description appendage will be added, if present */
  effectiveDescription?: Maybe<Scalars['String']>;
  /** The effective descriptions */
  effectiveDescriptions?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Whether the logistics partner has marked this this stockitem as lost */
  effectiveMissing: Scalars['Boolean'];
  /** The effective title, that will ensure titleprefix and optionally the color will be added */
  effectiveTitle: Scalars['String'];
  /** The effective titles */
  effectiveTitles?: Maybe<Array<Maybe<LocalizationEntry>>>;
  externId?: Maybe<Scalars['String']>;
  /** URL to the external product ressource */
  externUrl?: Maybe<Scalars['String']>;
  /** True if this item has errors */
  hasErrors: Scalars['Boolean'];
  hasProblems?: Maybe<Scalars['Boolean']>;
  imageIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  /** Returns a list of imageurls, deprecated - use imageInfo */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns an array of images for this stockitem */
  images?: Maybe<Array<Maybe<StockItemImage>>>;
  /** Returns a list of image info */
  imagesInfo?: Maybe<Array<Maybe<ItemImageInfo>>>;
  /** Whether this stockitem is in-season */
  isInSeason: Scalars['Boolean'];
  isSold?: Maybe<Scalars['Boolean']>;
  /** The issues for this item */
  issues?: Maybe<Array<Maybe<ItemIssue>>>;
  /** Will calculate the item age based on the tradein, if it exists, otherwise based on creation date - returns number of days old */
  itemAge?: Maybe<Scalars['Float']>;
  /** The metas for this stockitem */
  itemMetas?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  itemNr?: Maybe<Scalars['Float']>;
  /** Whether the itemNr is broken */
  itemNrBroken: Scalars['Boolean'];
  /** The SKU for this stockitem */
  itemSku: Scalars['String'];
  /** Will return a status of this item */
  itemStatus: StockItemStatus;
  /** The tags for this stockitem */
  itemTags?: Maybe<Array<Maybe<StockItemTag>>>;
  /** List price for this stockitem in shop currencyy */
  listPrice?: Maybe<Scalars['Float']>;
  /** List prices for this stockitem */
  listPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: Maybe<Scalars['Date']>;
  /** The NFC Tag for this stockitem */
  nfcTag?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  /** The options for this item */
  options?: Maybe<Array<Maybe<OptionInstance>>>;
  /** If this stockitem has an active orderline (its been sold) then this will be returned here */
  orderline?: Maybe<Order2Item>;
  /** Will return all historic orderlines (including returns) for this stockitem */
  orderlines?: Maybe<Array<Maybe<Order2Item>>>;
  originalEan?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<StockItemProblems>>>;
  /** The product this stockitem is based on */
  product?: Maybe<Product>;
  productType?: Maybe<Scalars['String']>;
  /** The productvariant this stockitem is based on */
  productVariant?: Maybe<ProductVariant>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: Maybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: Maybe<Scalars['MongoID']>;
  published?: Maybe<Scalars['Boolean']>;
  resolved?: Maybe<StockItemResolved>;
  review?: Maybe<Scalars['Boolean']>;
  reviewed?: Maybe<Scalars['Date']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  sellingPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  /** The source type for this item */
  sourceType?: Maybe<ItemSourceType>;
  /** Statistics for this stockitem */
  statistics?: Maybe<StockItemStatistics>;
  stockLocation?: Maybe<Scalars['String']>;
  /** The stock location bag for this stockitem */
  stockLocationBag?: Maybe<Scalars['String']>;
  stockLocationTs?: Maybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: Maybe<Scalars['String']>;
  /** Returns a list of tags for this stockitem, use itemTags to see where the tag originated from */
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  titleLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Returns the tradein item that this stockitem was made from */
  tradeInItem?: Maybe<TradeInItem>;
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  vendor?: Maybe<Scalars['String']>;
};


export type StockItemEffectiveColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type StockItemEffectiveDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
  removeHtml?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemEffectiveTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type StockItemImageUrlsArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemImagesInfoArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemResolvedArgs = {
  applyFallbackLocale?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemStatisticsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};

export type StockItemForSale = {
  __typename?: 'StockItemForSale';
  item?: Maybe<StockItem>;
  soldTs?: Maybe<Scalars['Date']>;
  status?: Maybe<StockItemStatus>;
};

export type StockItemForSale2 = {
  __typename?: 'StockItemForSale2';
  isForSale: Scalars['Boolean'];
  isInSeason: Scalars['Boolean'];
  item?: Maybe<StockItem>;
  status: Scalars['String'];
};

export type StockItemImage = {
  __typename?: 'StockItemImage';
  _id: Scalars['MongoID'];
  /** Alternative descriptive text for the image */
  altText?: Maybe<Scalars['String']>;
  brandItemImageId?: Maybe<Scalars['MongoID']>;
  /** True if this image has been deleted */
  deleted?: Maybe<Scalars['Boolean']>;
  /** The alt text for the image, can be undefined */
  effectiveAltText?: Maybe<Scalars['String']>;
  externId?: Maybe<Scalars['String']>;
  failed?: Maybe<Scalars['Boolean']>;
  imageId?: Maybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: Maybe<Scalars['String']>;
  /** URL to the processed image */
  imageUrl?: Maybe<Scalars['String']>;
  lockedTs?: Maybe<Scalars['Date']>;
  perspective?: Maybe<EnumStockItemImagePerspective>;
  process?: Maybe<Scalars['Boolean']>;
  shopId: Scalars['MongoID'];
  sortOrder?: Maybe<Scalars['Float']>;
  sourceId: Scalars['MongoID'];
  /** The md5 hash of the image, used to compare images */
  sourceMd5?: Maybe<Scalars['String']>;
  /** URL to the original uploaded image */
  sourceUrl: Scalars['String'];
  stockItemId: Scalars['MongoID'];
  type?: Maybe<EnumStockItemImageType>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
};

export type StockItemProblems = {
  __typename?: 'StockItemProblems';
  _id?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  solved?: Maybe<Scalars['Boolean']>;
};

export type StockItemProblemsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  solved?: InputMaybe<Scalars['Boolean']>;
};

export type StockItemResolved = {
  __typename?: 'StockItemResolved';
  _id: Scalars['MongoID'];
  active?: Maybe<Scalars['Boolean']>;
  beforePrice?: Maybe<Scalars['Float']>;
  beforePrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The branditem for this stockitem */
  brandItem?: Maybe<BrandItem>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: Maybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: Maybe<Scalars['Date']>;
  color?: Maybe<Scalars['String']>;
  colorLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: Maybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: Maybe<Scalars['Float']>;
  /** The condition description */
  conditionDescription?: Maybe<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Returns a list of data problems */
  dataErrors?: Maybe<Array<Scalars['String']>>;
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  descriptionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  draft?: Maybe<Scalars['Boolean']>;
  ean?: Maybe<Scalars['String']>;
  ecommerceId?: Maybe<Scalars['String']>;
  /** Whether the logistics partner has checked this stockitem since last recount */
  effectiveChecked: Scalars['Boolean'];
  /** The effective color of this stockitem */
  effectiveColor?: Maybe<Scalars['String']>;
  /** The effective colors of this stockitem */
  effectiveColors?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** The effective description that ensures the description appendage will be added, if present */
  effectiveDescription?: Maybe<Scalars['String']>;
  /** The effective descriptions */
  effectiveDescriptions?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Whether the logistics partner has marked this this stockitem as lost */
  effectiveMissing: Scalars['Boolean'];
  /** The effective title, that will ensure titleprefix and optionally the color will be added */
  effectiveTitle: Scalars['String'];
  /** The effective titles */
  effectiveTitles?: Maybe<Array<Maybe<LocalizationEntry>>>;
  externId?: Maybe<Scalars['String']>;
  /** URL to the external product ressource */
  externUrl?: Maybe<Scalars['String']>;
  /** True if this item has errors */
  hasErrors: Scalars['Boolean'];
  hasProblems?: Maybe<Scalars['Boolean']>;
  imageIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  /** Returns a list of imageurls, deprecated - use imageInfo */
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Returns an array of images for this stockitem */
  images?: Maybe<Array<Maybe<StockItemImage>>>;
  /** Returns a list of image info */
  imagesInfo?: Maybe<Array<Maybe<ItemImageInfo>>>;
  /** Whether this stockitem is in-season */
  isInSeason: Scalars['Boolean'];
  isSold?: Maybe<Scalars['Boolean']>;
  /** The issues for this item */
  issues?: Maybe<Array<Maybe<ItemIssue>>>;
  /** Will calculate the item age based on the tradein, if it exists, otherwise based on creation date - returns number of days old */
  itemAge?: Maybe<Scalars['Float']>;
  /** The metas for this stockitem */
  itemMetas?: Maybe<Array<Maybe<MetaFieldInstance>>>;
  itemNr?: Maybe<Scalars['Float']>;
  /** Whether the itemNr is broken */
  itemNrBroken: Scalars['Boolean'];
  /** The SKU for this stockitem */
  itemSku: Scalars['String'];
  /** Will return a status of this item */
  itemStatus: StockItemStatus;
  /** The tags for this stockitem */
  itemTags?: Maybe<Array<Maybe<StockItemTag>>>;
  /** List price for this stockitem in shop currencyy */
  listPrice?: Maybe<Scalars['Float']>;
  /** List prices for this stockitem */
  listPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: Maybe<Scalars['Date']>;
  /** The NFC Tag for this stockitem */
  nfcTag?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  /** The options for this item */
  options?: Maybe<Array<Maybe<OptionInstance>>>;
  /** If this stockitem has an active orderline (its been sold) then this will be returned here */
  orderline?: Maybe<Order2Item>;
  /** Will return all historic orderlines (including returns) for this stockitem */
  orderlines?: Maybe<Array<Maybe<Order2Item>>>;
  originalEan?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<StockItemProblems>>>;
  /** The product this stockitem is based on */
  product?: Maybe<Product>;
  productType?: Maybe<Scalars['String']>;
  /** The productvariant this stockitem is based on */
  productVariant?: Maybe<ProductVariant>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: Maybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: Maybe<Scalars['MongoID']>;
  published?: Maybe<Scalars['Boolean']>;
  review?: Maybe<Scalars['Boolean']>;
  reviewed?: Maybe<Scalars['Date']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  sellingPrices?: Maybe<Array<Maybe<Pricing>>>;
  /** The shop */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  /** The source type for this item */
  sourceType?: Maybe<ItemSourceType>;
  stockLocation?: Maybe<Scalars['String']>;
  /** The stock location bag for this stockitem */
  stockLocationBag?: Maybe<Scalars['String']>;
  stockLocationTs?: Maybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: Maybe<Scalars['String']>;
  /** Returns a list of tags for this stockitem, use itemTags to see where the tag originated from */
  tags?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  titleLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  /** Returns the tradein item that this stockitem was made from */
  tradeInItem?: Maybe<TradeInItem>;
  tradeInItemId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  vendor?: Maybe<Scalars['String']>;
};


export type StockItemResolvedEffectiveColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type StockItemResolvedEffectiveDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
  removeHtml?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemResolvedEffectiveTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type StockItemResolvedImageUrlsArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};


export type StockItemResolvedImagesInfoArgs = {
  failOnError?: InputMaybe<Scalars['Boolean']>;
};

export type StockItemStatistics = {
  __typename?: 'StockItemStatistics';
  /** The number of cancellations of the stock item */
  cancelled?: Maybe<Scalars['Int']>;
  /** The number of refunds of the stock item */
  refunds?: Maybe<Scalars['Int']>;
  /** The number of sales of the stock item */
  sales?: Maybe<Scalars['Int']>;
  /** The number of visitors to the stock item */
  views?: Maybe<Scalars['Int']>;
};

export enum StockItemStatus {
  Draft = 'DRAFT',
  Review = 'REVIEW',
  Sale = 'SALE',
  Sold = 'SOLD'
}

/** List of items with pagination. */
export type StockItemStockItemPagination = {
  __typename?: 'StockItemStockItemPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<StockItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type StockItemTag = {
  __typename?: 'StockItemTag';
  _id?: Maybe<Scalars['MongoID']>;
  auto?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
};

export type StockItemUpdateInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  beforePrice?: InputMaybe<Scalars['Float']>;
  beforePrices?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  /** This is the branditem that is the parent for this shop / stockitem */
  brandItemId?: InputMaybe<Scalars['MongoID']>;
  /** This item has been confirmed at the logisticspartner at the given date */
  checked?: InputMaybe<Scalars['Date']>;
  color?: InputMaybe<Scalars['String']>;
  colorLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  /** The tariff code for use in customs declarations. */
  commodityCode?: InputMaybe<Scalars['String']>;
  /** The condition of the item 1-3 */
  condition?: InputMaybe<Scalars['Float']>;
  /** The ISO 3166-1 alpha-2 country code of origin. */
  countryOrigin?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  draft?: InputMaybe<Scalars['Boolean']>;
  ean?: InputMaybe<Scalars['String']>;
  ecommerceId?: InputMaybe<Scalars['String']>;
  externId?: InputMaybe<Scalars['String']>;
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  hasProblems?: InputMaybe<Scalars['Boolean']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isSold?: InputMaybe<Scalars['Boolean']>;
  itemSku?: InputMaybe<Scalars['String']>;
  /** This item is registered missing by the logisticspartner at the given date */
  missing?: InputMaybe<Scalars['Date']>;
  /** The NFC tag for this stockitem */
  nfcTag?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  originalEan?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<StockItemProblemsInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  /** This is the master data product variant that this stockitem is connected to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** This is the master data product variant size that this stockitem is connected to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  published?: InputMaybe<Scalars['Boolean']>;
  review?: InputMaybe<Scalars['Boolean']>;
  reviewed?: InputMaybe<Scalars['Date']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  sellingPrices?: InputMaybe<Array<InputMaybe<PricingInput>>>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The sortorder of the stockitem */
  sortorder?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Scalars['String']>;
  /** Source type for this stockitem */
  sourceType?: InputMaybe<ItemSourceType>;
  stockLocation?: InputMaybe<Scalars['String']>;
  stockLocationBag?: InputMaybe<Scalars['String']>;
  stockLocationTs?: InputMaybe<Scalars['Date']>;
  /** The url to the product in the shop */
  storeFrontUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleLocalized?: InputMaybe<Array<InputMaybe<LocalizationEntryInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
  vendor?: InputMaybe<Scalars['String']>;
};

export enum StorageContainerEnum {
  BrandproductImages = 'BRANDPRODUCT_IMAGES',
  DocumentContainer = 'DOCUMENT_CONTAINER',
  ProductImages = 'PRODUCT_IMAGES',
  ShippingLabels = 'SHIPPING_LABELS',
  StockitemImages = 'STOCKITEM_IMAGES',
  UploadImages = 'UPLOAD_IMAGES',
  VoucherContainer = 'VOUCHER_CONTAINER'
}

export type StorageFile = {
  __typename?: 'StorageFile';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  directory?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  /** The md5 hash of the file, used when comparing files */
  md5?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  /** URL to the stored file */
  url: Scalars['String'];
  validated?: Maybe<Scalars['Boolean']>;
};

/** Input for a storage file createion */
export type StorageFileCreateInput = {
  /** The directory for the storage file */
  container?: InputMaybe<StorageContainerEnum>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  filename?: InputMaybe<Scalars['String']>;
  /** The md5 hash of the file, used when comparing files */
  md5?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type Survey = {
  __typename?: 'Survey';
  _id: Scalars['MongoID'];
  /** The questions in this survey */
  questions: Array<Maybe<SurveyQuestions>>;
  /** Title of this survey */
  title: Scalars['String'];
};

export type SurveyQuestions = {
  __typename?: 'SurveyQuestions';
  choices?: Maybe<Array<Maybe<SurveyQuestionsChoices>>>;
  /** A survey unique identifier for this question */
  id: Scalars['String'];
  /** The question text */
  question: Scalars['String'];
  surveyId: Scalars['MongoID'];
};

export type SurveyQuestionsChoices = {
  __typename?: 'SurveyQuestionsChoices';
  /** The choice text */
  choice: Scalars['String'];
  /** Unique choice ID for the question */
  id: Scalars['String'];
  /** Numeric representation of this choice */
  value: Scalars['Float'];
};

export type SyncCompleteResult = {
  __typename?: 'SyncCompleteResult';
  status: Scalars['String'];
};

export type SyncResult = {
  __typename?: 'SyncResult';
  status: Scalars['String'];
};

export enum SynchronizeMode {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type SystemMessage = {
  __typename?: 'SystemMessage';
  _id: Scalars['MongoID'];
  /** The timestamp when the message was acknowledged */
  acknowledgedTs?: Maybe<Scalars['Date']>;
  /** The target audience (SYSADM, ADMIN, BRAND) */
  audience: EnumSystemMessageAudience;
  /** If the audience is a brandhouse, this is the brandhouse id */
  audienceBrandId?: Maybe<Scalars['MongoID']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Collected occurrences of this message */
  entries: Array<Maybe<SystemMessageEntries>>;
  /** When the message was last appended to - drives the 30 day TTL */
  lastActivityTs: Scalars['Date'];
  /** The type of message (CRITICAL, WARNING, INFORMATION) */
  messageType: EnumSystemMessageMessageType;
  /** Subject used to group repeated messages while unacknowledged */
  subject: Scalars['String'];
  /** When the message was first created */
  timestamp: Scalars['Date'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SystemMessageEntries = {
  __typename?: 'SystemMessageEntries';
  /** The occurrence message */
  text: Scalars['String'];
  /** When this occurrence was recorded */
  timestamp: Scalars['Date'];
};

export type Tracking = {
  __typename?: 'Tracking';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  browser?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  objectId?: Maybe<Scalars['String']>;
  objectPayload?: Maybe<Scalars['JSON']>;
  objectType?: Maybe<Scalars['String']>;
  shopId: Scalars['MongoID'];
  ts?: Maybe<Scalars['Date']>;
};

/** List of items with pagination. */
export type TrackingTrackingPagination = {
  __typename?: 'TrackingTrackingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Tracking>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TradeIn = {
  __typename?: 'TradeIn';
  _id: Scalars['MongoID'];
  activationStrategy?: Maybe<EnumTradeInActivationStrategy>;
  brandCarrier?: Maybe<BrandCarrier>;
  brandHouseId: Scalars['MongoID'];
  /** Circular points for this tradein */
  circularPoints?: Maybe<Array<Maybe<CircularPoint>>>;
  /** A comment about the tradein */
  comment?: Maybe<Scalars['String']>;
  /** The consumer that created this tradein */
  consumer?: Maybe<Consumer>;
  /** The consumer id */
  consumerId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: Maybe<Scalars['Boolean']>;
  dateTime: Scalars['Date'];
  deletedBy?: Maybe<Scalars['String']>;
  deletedTs?: Maybe<Scalars['Date']>;
  /** Trade-in note PDF for this tradein */
  deliveryNoteUrl: Scalars['String'];
  /** Dropoff points for the consumer that made this tradein */
  dropOffPoints?: Maybe<Array<Maybe<Dropoff>>>;
  /** Whether this tradein has a bonus */
  hasBonus?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<TradeInItem>>>;
  /** Optionally a shipping label for this tradein */
  label?: Maybe<ShippingLabel>;
  notified?: Maybe<Scalars['Boolean']>;
  /** The payout type */
  payoutType?: Maybe<EnumTradeInPayoutType>;
  pickupNotified?: Maybe<Scalars['Boolean']>;
  pickupProcessed?: Maybe<Scalars['Boolean']>;
  /** We got the package? */
  registered?: Maybe<Scalars['Boolean']>;
  /** The date we got the package */
  registeredTs?: Maybe<Scalars['Date']>;
  remindedCount?: Maybe<Scalars['Float']>;
  remindedTs?: Maybe<Scalars['Date']>;
  /** The shipping carrier selected for this tradein */
  shippingCarrier?: Maybe<ShippingCarrier>;
  /** The shipping carrier used for this tradein */
  shippingCarrierId?: Maybe<Scalars['MongoID']>;
  shippingLabelId?: Maybe<Scalars['MongoID']>;
  /** @deprecated Deprecated, see shippingCarrier */
  shippingType?: Maybe<Scalars['String']>;
  /** The shop that owns this tradein */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  /** The source of the tradein */
  source: EnumTradeInSource;
  /** Optionally a note about the source of the tradein */
  sourceNote?: Maybe<Scalars['String']>;
  /** Statistics for this tradein */
  statistics?: Maybe<TradeInStatistics>;
  /** The status of the tradein */
  status?: Maybe<TradeInStatusEnum>;
  tradeInNr?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Vouchers for this tradein */
  vouchers?: Maybe<Array<Maybe<Voucher>>>;
};


export type TradeInStatisticsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type TradeInCommentInput = {
  comment: Scalars['String'];
  potentialId: Scalars['MongoID'];
};

/** Configuration for the tradein app */
export type TradeInConfig = {
  __typename?: 'TradeInConfig';
  /** The enabled consumer authentication methods for this shop */
  authMethods: Array<Scalars['String']>;
  /** The brand house ID */
  brandHouseId: Scalars['MongoID'];
  /** The default image for the shop */
  defaultImage?: Maybe<Scalars['String']>;
  /** Whether to hide the language selector */
  hideLanguageSelector?: Maybe<Scalars['Boolean']>;
  /** An expression that will, if provided, need to evaluate to false on email in order to allow tradein */
  invalidEmailReg?: Maybe<Scalars['String']>;
  /** The maximum allowed voucher given from a trade-in, 0 is no maxiumum */
  maximumVoucher: Scalars['Float'];
  /** Whether product search is enabled */
  productSearchEnabled: Scalars['Boolean'];
  /** The mask to use for product search */
  productSearchMask?: Maybe<Scalars['String']>;
  /** The currency of the shop / storefront */
  shopCurrency: Scalars['String'];
  /** The calculated voucher activation strategy for the shop */
  voucherStrategy: EnumTradeInActivationStrategy;
  /** Whether tradeins by category is allowed */
  wholeSaleActive: Scalars['Boolean'];
};

export type TradeInItem = {
  __typename?: 'TradeInItem';
  _id: Scalars['MongoID'];
  /** The bonus value of the trade-in item in shop currency */
  bonus?: Maybe<Scalars['Float']>;
  /** Will return the stockitem for this tradein, might return null */
  brandItem?: Maybe<BrandItem>;
  /** Will return the brandproduct size for this tradein, can return null if no brand variant is assigned */
  brandProductSize?: Maybe<BrandProductSize>;
  brandProductSizeId?: Maybe<Scalars['MongoID']>;
  /** Will return the brand productvariant for this tradein, can return null if no brand variant is assigned */
  brandProductVariant?: Maybe<BrandProductVariant>;
  brandProductVariantId?: Maybe<Scalars['MongoID']>;
  color?: Maybe<Scalars['String']>;
  /** A comment from the previous owner  */
  comment?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['Float']>;
  consumer?: Maybe<Consumer>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The currency of the tradein item value */
  currency?: Maybe<Scalars['String']>;
  /** Custom data for the tradein item */
  customData?: Maybe<Scalars['JSON']>;
  deletedBy?: Maybe<Scalars['String']>;
  deletedTs?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  /** The purchase/order date from the originating system */
  externDate?: Maybe<Scalars['Date']>;
  /** The external order line id from the originating system (e.g. order line item id) */
  externLineId?: Maybe<Scalars['String']>;
  /** The external order id that groups multiple line items (e.g. order id) */
  externOrderId?: Maybe<Scalars['String']>;
  /** The actual sales price paid by the consumer */
  externPurchasePrice?: Maybe<Scalars['Float']>;
  externUrl?: Maybe<Scalars['String']>;
  /** The external id of the tradein item, use this to match with external systems */
  externalId?: Maybe<Scalars['String']>;
  /** Returns the identifier information for this trade-in item */
  identifier?: Maybe<TradeInItemIdentifier>;
  imageIds?: Maybe<Array<Maybe<Scalars['MongoID']>>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  /** Value of the item in voucher/tradein currency */
  itemValue?: Maybe<Scalars['Float']>;
  /** The MAS masterdata variant id this trade-in item is related to */
  masterVariantId?: Maybe<Scalars['String']>;
  masterVariantImageId?: Maybe<Scalars['String']>;
  masterVariantImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  potential?: Maybe<Potential>;
  /** Will return the shop productvariant for this tradein, can return null if no shop variant is assigned */
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['MongoID']>;
  /** Will return the shop productvariant size for this tradein, can return null if no shop variant is assigned */
  productVariantSize?: Maybe<ProductVariantSize>;
  productVariantSizeId?: Maybe<Scalars['MongoID']>;
  /** The reason for rejecting the tradein item */
  rejected?: Maybe<EnumTradeInItemRejected>;
  /** Price calculation */
  resellPrice?: Maybe<Pricing>;
  shop?: Maybe<Shop>;
  shopId?: Maybe<Scalars['MongoID']>;
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** The source of the item, e.g. ONLINE, WHOLESALE, RECIEPT, SEARCH, DIGITALPASS */
  sourceType?: Maybe<EnumTradeInItemSourceType>;
  /** Will return the stockitem for this tradein, might return null */
  stockItem?: Maybe<StockItem>;
  tradeIn?: Maybe<TradeIn>;
  tradeInId?: Maybe<Scalars['MongoID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** Value of the item, by default in shop currency */
  value?: Maybe<Scalars['Float']>;
  wholeSale?: Maybe<PotentialWholeSale>;
  /** The whole sale section of the item, if applicable */
  wholeSaleSection?: Maybe<Scalars['String']>;
};


export type TradeInItemValueArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type TradeInItemIdentifier = {
  __typename?: 'TradeInItemIdentifier';
  /** The color of the item, if available */
  color?: Maybe<Scalars['String']>;
  /** The identity string (SKU, style, or category name) */
  identity: Scalars['String'];
  /** The origin of the trade-in item */
  origin?: Maybe<TradeInItemIdentifierOrigin>;
  /** The type of identifier */
  type?: Maybe<TradeInItemIdentifierType>;
};

export enum TradeInItemIdentifierOrigin {
  Online = 'online',
  Wholesale = 'wholesale'
}

export enum TradeInItemIdentifierType {
  Category = 'category',
  Sku = 'sku',
  Style = 'style'
}

export type TradeInItemPaging = {
  __typename?: 'TradeInItemPaging';
  data?: Maybe<Array<Maybe<TradeInItem>>>;
  page: Scalars['Int'];
  pages: Scalars['Int'];
  total: Scalars['Int'];
};

export enum TradeInItemRejectReasonEnum {
  Itembadcondition = 'ITEMBADCONDITION',
  Itemmissingcarelabel = 'ITEMMISSINGCARELABEL',
  Itemnotinpackage = 'ITEMNOTINPACKAGE',
  Itempartofset = 'ITEMPARTOFSET',
  Itemwrongbrand = 'ITEMWRONGBRAND',
  Nosizeonitem = 'NOSIZEONITEM',
  Other = 'OTHER'
}

export type TradeInLayout = {
  __typename?: 'TradeInLayout';
  _id?: Maybe<Scalars['MongoID']>;
  additionalCss?: Maybe<Scalars['String']>;
  contrastPanel?: Maybe<TradeInLayoutMainPanel>;
  disableIcons?: Maybe<Scalars['Boolean']>;
  fontFamily?: Maybe<Scalars['String']>;
  frontPanel?: Maybe<TradeInLayoutMainPanel>;
  h1?: Maybe<TradeInLayoutH1>;
  h2?: Maybe<TradeInLayoutH1>;
  mainPanel?: Maybe<TradeInLayoutMainPanel>;
  subtext?: Maybe<TradeInLayoutH1>;
  text?: Maybe<TradeInLayoutH1>;
  widgets?: Maybe<TradeInLayoutWidgets>;
};

export type TradeInLayoutH1 = {
  __typename?: 'TradeInLayoutH1';
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['String']>;
  fontWeight?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  uppercase?: Maybe<Scalars['Boolean']>;
};

export type TradeInLayoutH1Input = {
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
  uppercase?: InputMaybe<Scalars['Boolean']>;
};

export type TradeInLayoutInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  additionalCss?: InputMaybe<Scalars['String']>;
  contrastPanel?: InputMaybe<TradeInLayoutMainPanelInput>;
  disableIcons?: InputMaybe<Scalars['Boolean']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  frontPanel?: InputMaybe<TradeInLayoutMainPanelInput>;
  h1?: InputMaybe<TradeInLayoutH1Input>;
  h2?: InputMaybe<TradeInLayoutH1Input>;
  mainPanel?: InputMaybe<TradeInLayoutMainPanelInput>;
  subtext?: InputMaybe<TradeInLayoutH1Input>;
  text?: InputMaybe<TradeInLayoutH1Input>;
  widgets?: InputMaybe<TradeInLayoutWidgetsInput>;
};

export type TradeInLayoutMainPanel = {
  __typename?: 'TradeInLayoutMainPanel';
  backgroundColor?: Maybe<Scalars['String']>;
  mainButton?: Maybe<TradeInLayoutMainPanelMainButton>;
  secondaryButton?: Maybe<TradeInLayoutMainPanelMainButton>;
  textColor?: Maybe<Scalars['String']>;
};

export type TradeInLayoutMainPanelInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  mainButton?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  secondaryButton?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  textColor?: InputMaybe<Scalars['String']>;
};

export type TradeInLayoutMainPanelMainButton = {
  __typename?: 'TradeInLayoutMainPanelMainButton';
  border?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  disabledButtonColor?: Maybe<Scalars['String']>;
  disabledTextColor?: Maybe<Scalars['String']>;
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['String']>;
  fontWeight?: Maybe<Scalars['String']>;
  hoverButtonColor?: Maybe<Scalars['String']>;
  hoverTextColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
};

export type TradeInLayoutMainPanelMainButtonInput = {
  border?: InputMaybe<Scalars['String']>;
  buttonColor?: InputMaybe<Scalars['String']>;
  disabledButtonColor?: InputMaybe<Scalars['String']>;
  disabledTextColor?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  hoverButtonColor?: InputMaybe<Scalars['String']>;
  hoverTextColor?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
};

export type TradeInLayoutWidgets = {
  __typename?: 'TradeInLayoutWidgets';
  accessBoxBorder?: Maybe<Scalars['String']>;
  actionItemBorderColor?: Maybe<Scalars['String']>;
  addItemButton?: Maybe<TradeInLayoutMainPanelMainButton>;
  addItemButtonBlank?: Maybe<TradeInLayoutMainPanelMainButton>;
  addItemIconColor?: Maybe<Scalars['String']>;
  addItemIconColorBlank?: Maybe<Scalars['String']>;
  addItemIconHide?: Maybe<Scalars['Boolean']>;
  borderRadius?: Maybe<Scalars['String']>;
  cartBackgroundColor?: Maybe<Scalars['String']>;
  cartTextColor?: Maybe<Scalars['String']>;
  categoryBorderColor?: Maybe<Scalars['String']>;
  categoryIconPadding?: Maybe<Scalars['Float']>;
  categoryIconSize?: Maybe<Scalars['Float']>;
  categoryRadius?: Maybe<Scalars['String']>;
  continueButton?: Maybe<TradeInLayoutMainPanelMainButton>;
  returnItem?: Maybe<TradeInLayoutWidgetsReturnItem>;
  selectionColor?: Maybe<Scalars['String']>;
  selectionTextColor?: Maybe<Scalars['String']>;
  stepperBorderWidth?: Maybe<Scalars['String']>;
  uploadPhoto?: Maybe<TradeInLayoutWidgetsUploadPhoto>;
};

export type TradeInLayoutWidgetsInput = {
  accessBoxBorder?: InputMaybe<Scalars['String']>;
  actionItemBorderColor?: InputMaybe<Scalars['String']>;
  addItemButton?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  addItemButtonBlank?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  addItemIconColor?: InputMaybe<Scalars['String']>;
  addItemIconColorBlank?: InputMaybe<Scalars['String']>;
  addItemIconHide?: InputMaybe<Scalars['Boolean']>;
  borderRadius?: InputMaybe<Scalars['String']>;
  cartBackgroundColor?: InputMaybe<Scalars['String']>;
  cartTextColor?: InputMaybe<Scalars['String']>;
  categoryBorderColor?: InputMaybe<Scalars['String']>;
  categoryIconPadding?: InputMaybe<Scalars['Float']>;
  categoryIconSize?: InputMaybe<Scalars['Float']>;
  categoryRadius?: InputMaybe<Scalars['String']>;
  continueButton?: InputMaybe<TradeInLayoutMainPanelMainButtonInput>;
  returnItem?: InputMaybe<TradeInLayoutWidgetsReturnItemInput>;
  selectionColor?: InputMaybe<Scalars['String']>;
  selectionTextColor?: InputMaybe<Scalars['String']>;
  stepperBorderWidth?: InputMaybe<Scalars['String']>;
  uploadPhoto?: InputMaybe<TradeInLayoutWidgetsUploadPhotoInput>;
};

export type TradeInLayoutWidgetsReturnItem = {
  __typename?: 'TradeInLayoutWidgetsReturnItem';
  backgroundColor?: Maybe<Scalars['String']>;
  border?: Maybe<Scalars['String']>;
  fontFamily?: Maybe<Scalars['String']>;
  fontSize?: Maybe<Scalars['String']>;
  fontWeight?: Maybe<Scalars['String']>;
  scale?: Maybe<Scalars['Float']>;
  textColor?: Maybe<Scalars['String']>;
};

export type TradeInLayoutWidgetsReturnItemInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  border?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  fontSize?: InputMaybe<Scalars['String']>;
  fontWeight?: InputMaybe<Scalars['String']>;
  scale?: InputMaybe<Scalars['Float']>;
  textColor?: InputMaybe<Scalars['String']>;
};

export type TradeInLayoutWidgetsUploadPhoto = {
  __typename?: 'TradeInLayoutWidgetsUploadPhoto';
  border?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  disabledBorder?: Maybe<Scalars['String']>;
  disabledColor?: Maybe<Scalars['String']>;
};

export type TradeInLayoutWidgetsUploadPhotoInput = {
  border?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  disabledBorder?: InputMaybe<Scalars['String']>;
  disabledColor?: InputMaybe<Scalars['String']>;
};

export type TradeInResyncResult = {
  __typename?: 'TradeInResyncResult';
  /** Number of tradeins resynced */
  count: Scalars['Int'];
};

export type TradeInStatistics = {
  __typename?: 'TradeInStatistics';
  /** The average age of the items traded in (only includes items where we know the original buy date) */
  ageOfItems?: Maybe<Scalars['Float']>;
  /** The number of items traded in for business-to-consumer */
  bcItems?: Maybe<Scalars['Float']>;
  /** The number of items traded in for wholesale */
  wsItems?: Maybe<Scalars['Float']>;
  /** The number of items traded in for wholesale that was searched for */
  wsSearch?: Maybe<Scalars['Float']>;
};

export enum TradeInStatusEnum {
  Delivered = 'DELIVERED',
  Initial = 'INITIAL',
  Received = 'RECEIVED',
  Transit = 'TRANSIT'
}

export type TradeInSynchronizeImageInput = {
  /** The ID of the item to add, the ID here is the ID of the category, masterdata or potential */
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** The URL of the image */
  url?: InputMaybe<Scalars['String']>;
};

export type TradeInSynchronizeInput = {
  /** The ID of the tradein to synchronize, if not provided a new tradein will be created */
  _id?: InputMaybe<Scalars['MongoID']>;
  /** The activation strategy for the tradein */
  activationStrategy?: InputMaybe<EnumTradeInActivationStrategy>;
  /** Optional bonus for the tradein, this will be added to the total value of the tradein */
  bonus?: InputMaybe<Scalars['Float']>;
  /** A comment about the tradein */
  comment?: InputMaybe<Scalars['String']>;
  /** If creating a new tradein, then the consumerId must be provided - which is the owner of the new tradein */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  /** Whether to delete the tradein */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** The items for the tradein */
  items?: InputMaybe<Array<TradeInSynchronizeItemInput>>;
  /** The payout type */
  payoutType?: InputMaybe<EnumTradeInPayoutType>;
  /** We got the package? */
  registered?: InputMaybe<Scalars['Boolean']>;
  /** The shipping carrier used for this tradein */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  /** The source of the tradein */
  source?: InputMaybe<EnumTradeInSource>;
  /** Optionally a note about the source of the tradein */
  sourceNote?: InputMaybe<Scalars['String']>;
};

export type TradeInSynchronizeItemInput = {
  /** The ID of tradein item, if not provided then a new item will be created */
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Brand product size id */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** Brand product variant id */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** Whole sale category id */
  categoryId?: InputMaybe<Scalars['MongoID']>;
  /** Optional color of the item */
  color?: InputMaybe<Scalars['String']>;
  /** Optional comment for the item */
  comment?: InputMaybe<Scalars['String']>;
  /** External ID */
  externalId?: InputMaybe<Scalars['String']>;
  /** Optionally images for the item */
  image?: InputMaybe<TradeInSynchronizeImageInput>;
  /** Use this to allow the server to find the masterdata for the tradein item, do not use this if you are setting brandProductSizeId */
  itemId?: InputMaybe<Scalars['MongoID']>;
  /** Optional name of the item */
  name?: InputMaybe<Scalars['String']>;
  /** If this item represents a potential ID, then use that instead of all other properties */
  potentialId?: InputMaybe<Scalars['MongoID']>;
  /** If the item is rejected, then the reason for rejection */
  rejected?: InputMaybe<EnumTradeInItemRejected>;
  /** Optional size of the item */
  size?: InputMaybe<Scalars['String']>;
  /** Optional sku of the item */
  sku?: InputMaybe<Scalars['String']>;
  /** Optional custom currency for the item, if tradeInValue is set, this must also be set */
  tradeInCurrency?: InputMaybe<Scalars['String']>;
  /** Optional custom value for the item, will override any value from the item, must also set tradeInCurrency */
  tradeInValue?: InputMaybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type TradeInTradeInPagination = {
  __typename?: 'TradeInTradeInPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<TradeIn>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type TradeInUpdateInput = {
  activationStrategy?: InputMaybe<EnumTradeInActivationStrategy>;
  /** A comment about the tradein */
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** If true, the tradein has custom carrier/delivery logic */
  customCarrier?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  notified?: InputMaybe<Scalars['Boolean']>;
  /** The payout type */
  payoutType?: InputMaybe<EnumTradeInPayoutType>;
  pickupNotified?: InputMaybe<Scalars['Boolean']>;
  pickupProcessed?: InputMaybe<Scalars['Boolean']>;
  /** We got the package? */
  registered?: InputMaybe<Scalars['Boolean']>;
  remindedCount?: InputMaybe<Scalars['Float']>;
  remindedTs?: InputMaybe<Scalars['Date']>;
  shippingLabelId?: InputMaybe<Scalars['MongoID']>;
  /** The source of the tradein */
  source?: InputMaybe<EnumTradeInSource>;
  /** Optionally a note about the source of the tradein */
  sourceNote?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<ObjectPatchesUpdatedByInput>;
};

export type UpdateByIdAddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdBrandHouseInput = {
  address?: InputMaybe<UpdateByIdAddressInfoInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  apiSecret?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Brandhouse has been deactivated */
  deactivated?: InputMaybe<Scalars['Boolean']>;
  initials?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<Scalars['String']>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  /** When true, all configuration changes require an audit note with explanation */
  requireChangeExplanation?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<UpdateByIdObjectPatchesUpdatedByInput>;
};

export type UpdateByIdBrandHousePayload = {
  __typename?: 'UpdateByIdBrandHousePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BrandHouse>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdBrandProductGroupInput = {
  /** Is the group active for everything */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for potential linking */
  activePotentials?: InputMaybe<Scalars['Boolean']>;
  /** Is the group active for promoting brand items */
  activePromotions?: InputMaybe<Scalars['Boolean']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The name of the group */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdBrandProductGroupPayload = {
  __typename?: 'UpdateByIdBrandProductGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BrandProductGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdBrandProductImageInput = {
  archivedImage?: InputMaybe<Scalars['Boolean']>;
  archivedThumb?: InputMaybe<Scalars['Boolean']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The product that owns this image */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The variant that owns this image */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  /** Colors represented by this image */
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Custom data for the image */
  customData?: InputMaybe<Scalars['JSON']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  error?: InputMaybe<Scalars['String']>;
  errorCount?: InputMaybe<Scalars['Float']>;
  /** An image unique external identifier */
  externalId?: InputMaybe<Scalars['String']>;
  /** The group that this product belongs to */
  groupId?: InputMaybe<Scalars['MongoID']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  /** The storage ID of the file, will be null until the image is successfully stored */
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: InputMaybe<Scalars['String']>;
  /**
   * If the image was processed by us / background removal, then this contains the version of the processing
   * use this to determine if the background process needs to be redone
   */
  imageRemoveBgVersion?: InputMaybe<Scalars['Float']>;
  /** An optional language tag for the image */
  language?: InputMaybe<Scalars['String']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  /** Extra data about the image, localized */
  localizedMetaFields?: InputMaybe<Array<InputMaybe<UpdateByIdLocalizedMetaFieldInstanceInput>>>;
  /** Extra data about the image */
  metaFields?: InputMaybe<Array<InputMaybe<UpdateByIdMetaFieldInput>>>;
  /** The storage ID of the original image file, typically the same as imageId - but if the imageId can be modified */
  originalId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the original image, used to compare images */
  originalMd5?: InputMaybe<Scalars['String']>;
  perspective?: InputMaybe<EnumBrandProductImagePerspective>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** The storage ID of the thumbnail file, will be null until the image is successfully stored */
  thumbnailId?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<EnumBrandProductImageType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdBrandProductImagePayload = {
  __typename?: 'UpdateByIdBrandProductImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<BrandProductImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCampaignInput = {
  /** The brand house id of the campaign */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The name of the campaign */
  campaignName?: InputMaybe<Scalars['String']>;
  /** The status of the campaign */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** The start date of the campaign */
  fromDate?: InputMaybe<Scalars['Date']>;
  /** The percentage discount of the campaign */
  percentage?: InputMaybe<Scalars['Float']>;
  /** The shop id of the campaign */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The end date of the campaign */
  toDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCampaignPayload = {
  __typename?: 'UpdateByIdCampaignPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Campaign>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCircularPayoutInstanceInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  accountNr?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  /** The type of circular payout */
  payoutId: Scalars['MongoID'];
  phoneNr?: InputMaybe<Scalars['String']>;
  regNr?: InputMaybe<Scalars['String']>;
  /** Optionally a tradein that was directly converted for this payout */
  tradeInId?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdCircularPayoutTypeInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The default payout ratio, a number between 0 and 1 */
  defaultRatio?: InputMaybe<Scalars['Float']>;
  /** The name of the payout */
  name?: InputMaybe<Scalars['String']>;
  /** The type of payout */
  payoutType?: InputMaybe<EnumCircularPayoutTypePayoutType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdCircularPayoutTypePayload = {
  __typename?: 'UpdateByIdCircularPayoutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CircularPayoutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCircularPointInput = {
  /** Whether the circularpoint point transaction has been activated for a tradein, or executed with the external service provider for a payout */
  activated?: InputMaybe<Scalars['Boolean']>;
  /** The consumer id / account id, owning the points */
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** Whether this has been processed by the circular points engine */
  eventProcessed?: InputMaybe<Scalars['Boolean']>;
  /** The shop */
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** Optionally data from the source that is relevant to the circular point */
  sourceData?: InputMaybe<UpdateByIdCircularPointSourceDataInput>;
  /** The source of the circularpoint transaction, tradein id, conversion id, etc */
  sourceObjectId?: InputMaybe<Scalars['MongoID']>;
  /** The type of the transaction source, tradein or conversion */
  sourceType?: InputMaybe<EnumCircularPointSourceType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  /** The change in points for this transaction. Can be a negative or positive value. */
  value?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdCircularPointPayload = {
  __typename?: 'UpdateByIdCircularPointPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CircularPoint>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdCircularPointSourceDataInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  actualPayout?: InputMaybe<UpdateByIdCircularPayoutInstanceInput>;
  postPayout?: InputMaybe<UpdateByIdCircularPayoutInstanceInput>;
};

export type UpdateByIdIntegrationConnectorEventbusInput = {
  development?: InputMaybe<UpdateByIdIntegrationConnectorEventbusProductionInput>;
  production?: InputMaybe<UpdateByIdIntegrationConnectorEventbusProductionInput>;
  test?: InputMaybe<UpdateByIdIntegrationConnectorEventbusProductionInput>;
};

export type UpdateByIdIntegrationConnectorEventbusProductionInput = {
  /** The servicebus connection string */
  serviceBus: Scalars['String'];
  /** The topic for the servicebus */
  topic: Scalars['String'];
};

export type UpdateByIdIntegrationConnectorFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Default value for the field */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<Scalars['String']>;
  /** The field */
  field?: InputMaybe<Scalars['String']>;
  /** Namespace grouping of multiple fields */
  namespace?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdIntegrationConnectorFieldsOptionsInput>>>;
  /** Whether the field is required */
  required?: InputMaybe<Scalars['Boolean']>;
  /** text, number, json */
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdIntegrationConnectorFieldsOptionsInput = {
  /** Option label */
  label?: InputMaybe<Scalars['String']>;
  /** The value when the option is selected */
  value?: InputMaybe<Scalars['JSON']>;
};

export type UpdateByIdIntegrationConnectorInput = {
  activeFor?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  autoInstallFor?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorAutoInstallFor>>>;
  /** Whether this connector has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  eventbus?: InputMaybe<UpdateByIdIntegrationConnectorEventbusInput>;
  fields?: InputMaybe<Array<InputMaybe<UpdateByIdIntegrationConnectorFieldsInput>>>;
  /** Icon for the connector */
  icon?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorMessages>>>;
  /** The name of the connector */
  name?: InputMaybe<Scalars['String']>;
  optionals?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorOptionals>>>;
  refTypes?: InputMaybe<Array<InputMaybe<EnumIntegrationConnectorRefTypes>>>;
  /** The type of connector */
  type?: InputMaybe<EnumIntegrationConnectorType>;
  /** The latest entity that updated this connector */
  updatedBy?: InputMaybe<UpdateByIdObjectPatchesUpdatedByInput>;
  webhook?: InputMaybe<UpdateByIdIntegrationConnectorWebhookInput>;
};

export type UpdateByIdIntegrationConnectorPayload = {
  __typename?: 'UpdateByIdIntegrationConnectorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<IntegrationConnector>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdIntegrationConnectorWebhookInput = {
  development?: InputMaybe<UpdateByIdIntegrationConnectorWebhookProductionInput>;
  production?: InputMaybe<UpdateByIdIntegrationConnectorWebhookProductionInput>;
  test?: InputMaybe<UpdateByIdIntegrationConnectorWebhookProductionInput>;
};

export type UpdateByIdIntegrationConnectorWebhookProductionInput = {
  /** Custom headers to include in the webhook request */
  headers?: InputMaybe<Scalars['JSON']>;
  /** The URL that will receive the POST payload message */
  url: Scalars['String'];
};

export type UpdateByIdIntegrationMessageInput = {
  /** The timestamp of the message ackknowledgement, webhooks will set this instantly based on 200 OK response. Servicebus implementationw will need to send an ackknowledge event. */
  acknowledged?: InputMaybe<Scalars['Date']>;
  /** Timestamp of the message creation */
  created?: InputMaybe<Scalars['Date']>;
  /** The source environment of this message : production, development or test */
  env?: InputMaybe<Scalars['String']>;
  /** If the message was unable to be delivered, this will have contain a timestamp of when we gave up */
  failed?: InputMaybe<Scalars['Date']>;
  /** The instance identifier */
  instanceId?: InputMaybe<Scalars['MongoID']>;
  lockedId?: InputMaybe<Scalars['String']>;
  /** The message type */
  message?: InputMaybe<EnumIntegrationMessageMessage>;
  /** True if failure */
  messageFailed?: InputMaybe<Scalars['Boolean']>;
  /** True if ignored */
  messageIgnored?: InputMaybe<Scalars['Boolean']>;
  /** If this message is a retry message, then this points the the previous message that initiated the retry */
  parentId?: InputMaybe<Scalars['MongoID']>;
  /** Optionally a payload for the message */
  payload?: InputMaybe<Scalars['JSON']>;
  /** A token that can be used to read the message */
  readToken?: InputMaybe<Scalars['String']>;
  /** The referenced object this message originated from */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<Scalars['String']>;
  /** Optionally a result data blob for the message */
  result?: InputMaybe<Scalars['JSON']>;
  /** If a result data blob was stored, then this timestamp holds the timestamp for it - otherwise null */
  resultTs?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the message should be sent, this is typically used when retrying failed messages, but can be used for any message delaying */
  sendAt?: InputMaybe<Scalars['Date']>;
  /** Timestamp of when the message was last sent */
  sent?: InputMaybe<Scalars['Date']>;
  /** The number of times we have sent this message */
  sentCount?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdIntegrationMessagePayload = {
  __typename?: 'UpdateByIdIntegrationMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<IntegrationMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdItemIssueInput = {
  externId?: InputMaybe<Scalars['String']>;
  /** URL to the image of the issue */
  imageUrl?: InputMaybe<Scalars['String']>;
  issue?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<EnumItemIssueLocation>;
  /** Marker X position as percent (0-100) of image width, origin top-left */
  markX?: InputMaybe<Scalars['Float']>;
  /** Marker Y position as percent (0-100) of image height, origin top-left */
  markY?: InputMaybe<Scalars['Float']>;
  /** Coordinate of the issue, A1, B2, etc. */
  point?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdItemIssuePayload = {
  __typename?: 'UpdateByIdItemIssuePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ItemIssue>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdLocalizedMetaFieldInstanceInput = {
  /** The language of the localized metafields */
  language?: InputMaybe<Scalars['String']>;
  /** The metafields */
  metaFields?: InputMaybe<Array<InputMaybe<MetaFieldInput>>>;
};

export type UpdateByIdMetaFieldInput = {
  /** Custom data to the metafield */
  customData?: InputMaybe<Scalars['JSON']>;
  /** The key to identify the metafield within a namespace */
  key: Scalars['String'];
  /** Optionally a namespace for the metafield, used to group related fields */
  namespace?: InputMaybe<Scalars['String']>;
  /** Type of the value, required */
  type?: InputMaybe<EnumMetaFieldType>;
  /** The metafield value, JSON data */
  value: Scalars['JSON'];
};

export type UpdateByIdObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdPotentialInput = {
  batchSerial?: InputMaybe<Scalars['String']>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product that this potential is related to */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product size that this potential is related to */
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The brand product variant that this potential is related to */
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  cancelled?: InputMaybe<Scalars['Boolean']>;
  cancelledReason?: InputMaybe<EnumPotentialCancelledReason>;
  color?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['MongoID']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  ean?: InputMaybe<Scalars['String']>;
  externDate?: InputMaybe<Scalars['Date']>;
  externGroupId?: InputMaybe<Scalars['String']>;
  externUrl?: InputMaybe<Scalars['String']>;
  /** True if this potential is free to be added to anyones tradein */
  freePotential?: InputMaybe<Scalars['Boolean']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  isUsingFakeProduct?: InputMaybe<Scalars['Boolean']>;
  /** If present, then this contains the last timestamp of when we tried linking this potential to masterdata */
  linkTs?: InputMaybe<Scalars['Date']>;
  lockedTs?: InputMaybe<Scalars['Date']>;
  /** The MAS masterdata variant id this potential is related to */
  masterVariantId?: InputMaybe<Scalars['String']>;
  masterVariantImageId?: InputMaybe<Scalars['String']>;
  masterVariantImageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Whether this potential has no "date", its not actually bought, or we dont know the date - means that any date check in the tradein rules will be voided */
  noDate?: InputMaybe<Scalars['Boolean']>;
  /** If the owner of this potential was contacting with trade-in offers for this */
  notified?: InputMaybe<EnumPotentialNotified>;
  /** When was the owner of this potential contacting regarding trade-in offers */
  notifiedTs?: InputMaybe<Scalars['Date']>;
  /** The id of the product this potential is related to */
  productId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  /** The id of the product variant this potential is related to */
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  rrp?: InputMaybe<Scalars['Float']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The source of the potential, e.g. order, wholesale */
  sourceType?: InputMaybe<EnumPotentialSourceType>;
  sp?: InputMaybe<Scalars['Float']>;
  spOriginal?: InputMaybe<Scalars['Float']>;
  tradeInItemId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  wholeSale?: InputMaybe<UpdateByIdPotentialWholeSaleInput>;
};

export type UpdateByIdPotentialPayload = {
  __typename?: 'UpdateByIdPotentialPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Potential>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdPotentialWholeSaleInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  categoryId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdProductInput = {
  batchSerial?: InputMaybe<Scalars['String']>;
  /** The brandproduct that is the master data for this product */
  brandProductId?: InputMaybe<Scalars['MongoID']>;
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionLocalized?: InputMaybe<Array<InputMaybe<UpdateByIdLocalizationEntryInput>>>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  isPotential?: InputMaybe<Scalars['Boolean']>;
  isPreOwned?: InputMaybe<Scalars['Boolean']>;
  metaFields?: InputMaybe<Array<InputMaybe<UpdateByIdMetaFieldInput>>>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<UpdateByIdLocalizationEntryInput>>>;
  productType?: InputMaybe<Scalars['String']>;
  productVendor?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  style?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type UpdateByIdProductPayload = {
  __typename?: 'UpdateByIdProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdStockItemImageInput = {
  /** Alternative descriptive text for the image */
  altText?: InputMaybe<Scalars['String']>;
  brandItemImageId?: InputMaybe<Scalars['MongoID']>;
  /** True if this image has been deleted */
  deleted?: InputMaybe<Scalars['Boolean']>;
  externId?: InputMaybe<Scalars['String']>;
  failed?: InputMaybe<Scalars['Boolean']>;
  imageId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  imageMd5?: InputMaybe<Scalars['String']>;
  lockedTs?: InputMaybe<Scalars['Date']>;
  perspective?: InputMaybe<EnumStockItemImagePerspective>;
  process?: InputMaybe<Scalars['Boolean']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  sourceId?: InputMaybe<Scalars['MongoID']>;
  /** The md5 hash of the image, used to compare images */
  sourceMd5?: InputMaybe<Scalars['String']>;
  stockItemId?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<EnumStockItemImageType>;
  updatedBy?: InputMaybe<UpdateByIdObjectPatchesUpdatedByInput>;
};

export type UpdateByIdStockItemImagePayload = {
  __typename?: 'UpdateByIdStockItemImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<StockItemImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdSurveyInput = {
  /** The questions in this survey */
  questions?: InputMaybe<Array<InputMaybe<UpdateByIdSurveyQuestionsInput>>>;
  /** Title of this survey */
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateByIdSurveyPayload = {
  __typename?: 'UpdateByIdSurveyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Survey>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateByIdSurveyQuestionsChoicesInput = {
  /** The choice text */
  choice?: InputMaybe<Scalars['String']>;
  /** Unique choice ID for the question */
  id?: InputMaybe<Scalars['String']>;
  /** Numeric representation of this choice */
  value?: InputMaybe<Scalars['Float']>;
};

export type UpdateByIdSurveyQuestionsInput = {
  choices?: InputMaybe<Array<InputMaybe<UpdateByIdSurveyQuestionsChoicesInput>>>;
  /** A survey unique identifier for this question */
  id?: InputMaybe<Scalars['String']>;
  /** The question text */
  question?: InputMaybe<Scalars['String']>;
  surveyId?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateByIdTradeInItemInput = {
  /** The bonus value of the trade-in item in shop currency */
  bonus?: InputMaybe<Scalars['Float']>;
  brandProductSizeId?: InputMaybe<Scalars['MongoID']>;
  brandProductVariantId?: InputMaybe<Scalars['MongoID']>;
  color?: InputMaybe<Scalars['String']>;
  /** A comment from the previous owner  */
  comment?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  /** The currency of the tradein item value */
  currency?: InputMaybe<Scalars['String']>;
  /** Custom data for the tradein item */
  customData?: InputMaybe<Scalars['JSON']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  /** The purchase/order date from the originating system */
  externDate?: InputMaybe<Scalars['Date']>;
  /** The external order line id from the originating system (e.g. order line item id) */
  externLineId?: InputMaybe<Scalars['String']>;
  /** The external order id that groups multiple line items (e.g. order id) */
  externOrderId?: InputMaybe<Scalars['String']>;
  /** The actual sales price paid by the consumer */
  externPurchasePrice?: InputMaybe<Scalars['Float']>;
  externUrl?: InputMaybe<Scalars['String']>;
  /** The external id of the tradein item, use this to match with external systems */
  externalId?: InputMaybe<Scalars['String']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  /** The MAS masterdata variant id this trade-in item is related to */
  masterVariantId?: InputMaybe<Scalars['String']>;
  masterVariantImageId?: InputMaybe<Scalars['String']>;
  masterVariantImageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productVariantId?: InputMaybe<Scalars['MongoID']>;
  productVariantSizeId?: InputMaybe<Scalars['MongoID']>;
  /** The reason for rejecting the tradein item */
  rejected?: InputMaybe<EnumTradeInItemRejected>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  size?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  /** The source of the item, e.g. ONLINE, WHOLESALE, RECIEPT, SEARCH, DIGITALPASS */
  sourceType?: InputMaybe<EnumTradeInItemSourceType>;
  tradeInId?: InputMaybe<Scalars['MongoID']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<UpdateByIdObjectPatchesUpdatedByInput>;
  /** The value of the trade-in item in shop currency */
  value?: InputMaybe<Scalars['Float']>;
  wholeSale?: InputMaybe<UpdateByIdPotentialWholeSaleInput>;
};

export type UpdateByIdTradeInItemPayload = {
  __typename?: 'UpdateByIdTradeInItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TradeInItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneAddressInfoInput = {
  add1?: InputMaybe<Scalars['String']>;
  add2?: InputMaybe<Scalars['String']>;
  attention?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Optionally the address can come from a referenced object that has address info */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type, Shop, BrandHouse, LogisticsPartner */
  refType?: InputMaybe<EnumAddressInfoRefType>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateOneLocalizationEntryInput = {
  /** ISO Locale code */
  locale?: InputMaybe<Scalars['String']>;
  /** The localized text */
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateOneObjectPatchesUpdatedByInput = {
  ref?: InputMaybe<Scalars['MongoID']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateOneParcelInput = {
  /** The brand that owns this parcel */
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  /** Optional comment for the parcel */
  comment?: InputMaybe<Scalars['String']>;
  /** Items in the parcel */
  items?: InputMaybe<Array<InputMaybe<UpdateOneParcelItemsInput>>>;
  /** The date of the parcel creation */
  parcelDate?: InputMaybe<Scalars['Date']>;
  /** The receiver of the parcel */
  receiver?: InputMaybe<UpdateOneAddressInfoInput>;
  /** The sender of the parcel */
  sender?: InputMaybe<UpdateOneAddressInfoInput>;
  /** The carrier of the parcel */
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  /** The shop that owns this parcel */
  shopId?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateOneParcelItemsInput = {
  refId?: InputMaybe<Scalars['MongoID']>;
  refType?: InputMaybe<EnumParcelItemsRefType>;
};

export type UpdateOneParcelPayload = {
  __typename?: 'UpdateOneParcelPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Parcel>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOnePlannedMailInput = {
  mailType?: InputMaybe<Scalars['String']>;
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  sendAt?: InputMaybe<Scalars['Date']>;
  sent?: InputMaybe<Scalars['Date']>;
  sentStatus?: InputMaybe<Scalars['String']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
};

export type UpdateOnePlannedMailPayload = {
  __typename?: 'UpdateOnePlannedMailPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PlannedMail>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneScheduledEventInput = {
  /** Optionally data that will be sent with the event */
  data?: InputMaybe<Scalars['JSON']>;
  /** The timestamp of when the event should be executed */
  executeAt?: InputMaybe<Scalars['Date']>;
  /** The timestamp of when the event was executed */
  executed?: InputMaybe<Scalars['Date']>;
  /** The referenced object this event is attached to */
  refId?: InputMaybe<Scalars['MongoID']>;
  /** The referenced object type */
  refType?: InputMaybe<EnumScheduledEventRefType>;
};

export type UpdateOneScheduledEventPayload = {
  __typename?: 'UpdateOneScheduledEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ScheduledEvent>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneShippingLabelInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deletedTs?: InputMaybe<Scalars['Date']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  deliveryStatus?: InputMaybe<EnumShippingLabelDeliveryStatus>;
  labelCode?: InputMaybe<Scalars['String']>;
  labelExternalId?: InputMaybe<Scalars['String']>;
  labelFailed?: InputMaybe<Scalars['Boolean']>;
  labelFailedCount?: InputMaybe<Scalars['Float']>;
  labelImageId?: InputMaybe<Scalars['MongoID']>;
  lastUpdate?: InputMaybe<Scalars['Date']>;
  packageCode?: InputMaybe<Scalars['String']>;
  qrImageId?: InputMaybe<Scalars['MongoID']>;
  qrPngId?: InputMaybe<Scalars['MongoID']>;
  receiver?: InputMaybe<UpdateOneAddressInfoInput>;
  sender?: InputMaybe<UpdateOneAddressInfoInput>;
  shippingCarrierId?: InputMaybe<Scalars['MongoID']>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  tracking?: InputMaybe<UpdateOneShippingLabelTrackingInput>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<UpdateOneObjectPatchesUpdatedByInput>;
};

export type UpdateOneShippingLabelPayload = {
  __typename?: 'UpdateOneShippingLabelPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ShippingLabel>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneShippingLabelTrackingInput = {
  carrierCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusFailed?: InputMaybe<Scalars['Boolean']>;
  statusText?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Date']>;
  trackingCode?: InputMaybe<Scalars['String']>;
};

export type UpdateOneShopInput = {
  address?: InputMaybe<UpdateOneAddressInfoInput>;
  brandHouseId?: InputMaybe<Scalars['MongoID']>;
  closeDate?: InputMaybe<Scalars['Date']>;
  configuration?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  currency?: InputMaybe<Scalars['String']>;
  disableContactResetDate?: InputMaybe<Scalars['Date']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalName?: InputMaybe<Scalars['String']>;
  frontendType?: InputMaybe<EnumShopFrontendType>;
  generateThumbnails?: InputMaybe<Scalars['Boolean']>;
  /** Last time an action distribute was triggered */
  lastActionDistribute?: InputMaybe<Scalars['Date']>;
  /** Last time a klaviyo sync was triggered */
  lastKlaviyoSync?: InputMaybe<Scalars['Date']>;
  live?: InputMaybe<Scalars['Boolean']>;
  liveDate?: InputMaybe<Scalars['Date']>;
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  logisticsPartnerId?: InputMaybe<Scalars['MongoID']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ressourceRedirectUrl?: InputMaybe<Scalars['String']>;
  shopCollectionUrl?: InputMaybe<Scalars['String']>;
  /** Timestamp when statistics were last updated */
  statUpdateTs?: InputMaybe<Scalars['Date']>;
  synchronizeActions?: InputMaybe<Scalars['Date']>;
  synchronizeHooks?: InputMaybe<Scalars['Date']>;
  synchronizeOrders?: InputMaybe<Scalars['Date']>;
  synchronizeProducts?: InputMaybe<Scalars['Date']>;
  tradeInBaseUrl?: InputMaybe<Scalars['String']>;
  updateVouchers?: InputMaybe<Scalars['Boolean']>;
  updateVouchersDate?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  updatedBy?: InputMaybe<UpdateOneObjectPatchesUpdatedByInput>;
  wholeSaleActive?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOneShopPayload = {
  __typename?: 'UpdateOneShopPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Shop>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneSystemMessageInput = {
  acknowledgedTs?: InputMaybe<Scalars['Date']>;
};

export type UpdateOneSystemMessagePayload = {
  __typename?: 'UpdateOneSystemMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SystemMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneWholeSaleCategoryInput = {
  advanced?: InputMaybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  iconId?: InputMaybe<Scalars['MongoID']>;
  name?: InputMaybe<Scalars['String']>;
  nameLocalized?: InputMaybe<Array<InputMaybe<UpdateOneLocalizationEntryInput>>>;
  rules?: InputMaybe<Array<InputMaybe<UpdateOneWholeSaleCategoryRulesInput>>>;
  section?: InputMaybe<Scalars['String']>;
  sectionLocalized?: InputMaybe<Array<InputMaybe<UpdateOneLocalizationEntryInput>>>;
  shopId?: InputMaybe<Scalars['MongoID']>;
  /** The other of this category */
  sortOrder?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<UpdateOneObjectPatchesUpdatedByInput>;
  value?: InputMaybe<Scalars['Float']>;
  voucherStrategy?: InputMaybe<EnumWholeSaleCategoryVoucherStrategy>;
};

export type UpdateOneWholeSaleCategoryPayload = {
  __typename?: 'UpdateOneWholeSaleCategoryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<WholeSaleCategory>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']>;
};

export type UpdateOneWholeSaleCategoryRulesExpressionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: InputMaybe<Scalars['String']>;
  expressionType?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsExpressionType>;
  operator?: InputMaybe<EnumWholeSaleCategoryRulesExpressionsOperator>;
  sku?: InputMaybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: InputMaybe<Scalars['String']>;
};

export type UpdateOneWholeSaleCategoryRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expressions?: InputMaybe<Array<InputMaybe<UpdateOneWholeSaleCategoryRulesExpressionsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID'];
  /** Returns information about user accesses */
  access?: Maybe<Array<Maybe<UserAccess>>>;
  /** If true, then user has access to everything */
  administrator?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** True if the user has been disabled */
  disabled?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  lastIp?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  /** Link to OAuth2 user ID */
  oauthSubject?: Maybe<Scalars['String']>;
  /** Can contain any reference to another object, that the user is linked to - this has no effect on the users access whatsoever */
  parentId?: Maybe<Scalars['MongoID']>;
  resetToken?: Maybe<Scalars['String']>;
  resetTokenTs?: Maybe<Scalars['Date']>;
  /** If true, then user has a simplified view */
  simplified?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
};


export type UserAccessArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  _id: Scalars['MongoID'];
  brandHouseId?: Maybe<Scalars['MongoID']>;
  /** The name of the brandhouse */
  brandHouseName?: Maybe<Scalars['String']>;
  /** True if the user has been disabled */
  disabled?: Maybe<Scalars['Boolean']>;
  inviteToken?: Maybe<Scalars['String']>;
  inviteTokenTs?: Maybe<Scalars['Date']>;
  logisticsPartnerId?: Maybe<Scalars['MongoID']>;
  /** The name of the logistics partner */
  logisticsPartnerName?: Maybe<Scalars['String']>;
  /** The user that has this access */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['MongoID']>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int'];
  /** Validation error message */
  message?: Maybe<Scalars['String']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']>;
};

export type VerifyResult = {
  __typename?: 'VerifyResult';
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Voucher = {
  __typename?: 'Voucher';
  _id: Scalars['MongoID'];
  activated: Scalars['Boolean'];
  adjustments?: Maybe<Array<VoucherAdjustment>>;
  brandHouseId: Scalars['MongoID'];
  code?: Maybe<Scalars['String']>;
  /** An alias for the voucher, this alias is typically used when an external voucher service produces other codes than C2S */
  codeAlias?: Maybe<Scalars['String']>;
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['MongoID'];
  createdAt?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  /** The current value of the voucher */
  currentValue?: Maybe<Scalars['Float']>;
  /** Custom data for the voucher */
  customData?: Maybe<Scalars['JSON']>;
  deleted?: Maybe<Scalars['Date']>;
  /** If there is a date, then this voucher is disabled since this date. It should not exist in external shop and should not be useable. It should still be monitored and updated. */
  disabled?: Maybe<Scalars['Date']>;
  expireDate?: Maybe<Scalars['Date']>;
  /** The expiration date of the voucher */
  expireDateFormat?: Maybe<Scalars['String']>;
  /** ID of the voucher in any external storefront. The existence of this ID indicates that the voucher has been created at the storefront */
  externId?: Maybe<Scalars['String']>;
  minimumPurchase?: Maybe<Scalars['Float']>;
  newVoucherUsage: Scalars['Boolean'];
  /** The value of the voucher, as it was last communicated to the customer */
  notificationValue?: Maybe<Scalars['Float']>;
  /** Whether this reward is handled completely by an external system. If true, then we will not try to calculate the remaining value of the voucher - and we expect the value to be updated by external integration */
  passive?: Maybe<Scalars['Boolean']>;
  /** The value to be paid out to the customer, after applying payout percentage or rules */
  payoutValue?: Maybe<Scalars['Float']>;
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  /** Voucher statistics */
  statistics?: Maybe<VoucherStatistics>;
  tradeIn?: Maybe<TradeIn>;
  tradeInId?: Maybe<Scalars['MongoID']>;
  /** Will be updated to reflect the registration timestamp from connected tradeins */
  tradeInReceivedTs?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
  usages?: Maybe<Array<VoucherUsage>>;
  used?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['Float']>;
  /** PDFs for the voucher */
  voucherPdf?: Maybe<Array<VoucherPdf>>;
  voucherStrategy?: Maybe<EnumVoucherVoucherStrategy>;
};


export type VoucherExpireDateFormatArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type VoucherStatisticsArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type VoucherAdjustment = {
  __typename?: 'VoucherAdjustment';
  _id: Scalars['MongoID'];
  /** The adjustment amount in vouchers currency */
  amount: Scalars['Float'];
  /** If this adjustment is a correction to the original voucher value */
  correction?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The adjustment date */
  date: Scalars['Date'];
  /** Reason for adjustment */
  reason: Scalars['String'];
  /** The shop that owns the usage refund */
  shopId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  /** The voucher */
  voucherId: Scalars['MongoID'];
};

/** Input data for voucher updates */
export type VoucherFrontPdfInput = {
  /** The language of the giftcard */
  language: Scalars['String'];
  /** The url to the giftcard - must be a pdf */
  url: Scalars['String'];
};

/** Input data for voucher updates */
export type VoucherFrontUpdateInput = {
  /** Alias for the voucher */
  alias?: InputMaybe<Scalars['String']>;
  /** The current value of the voucher, only provide this for passive vouchers */
  currentValue?: InputMaybe<Scalars['Float']>;
  /** The currency of the current value, only provide this for passive vouchers */
  currentValueCurrency?: InputMaybe<Scalars['String']>;
  /** Custom data stored with the voucher */
  customData?: InputMaybe<Scalars['JSON']>;
  /** Updates the external id on the voucher */
  externId: Scalars['String'];
  /** Whether this reward is handled completely by an external system. If true, then the platform will not try to calculate the remaining value of the reward - and we expect the value and state of the voucher to be updated by external integration */
  passive?: InputMaybe<Scalars['Boolean']>;
  /** If provided - the PDF at the URL will be downloaded and linked to the voucher */
  pdfUrl?: InputMaybe<Array<InputMaybe<VoucherFrontPdfInput>>>;
};

export type VoucherPdf = {
  __typename?: 'VoucherPdf';
  /** The language of the pdf */
  language?: Maybe<Scalars['String']>;
  /** If set, then this points to the storage file that contains the voucher as a PDF (english) */
  pdfId?: Maybe<Scalars['MongoID']>;
  /** URL to the voucher PDF */
  url?: Maybe<Scalars['String']>;
};

export type VoucherStatistics = {
  __typename?: 'VoucherStatistics';
  /** Whether the voucher is active or not */
  active?: Maybe<Scalars['Boolean']>;
  /** The currency for these statistics */
  currency?: Maybe<Scalars['String']>;
  /** The number of days before the voucher is first used */
  daysBeforeUsage?: Maybe<Scalars['Float']>;
  /** The total value of the reward */
  reward?: Maybe<Scalars['Float']>;
  /** The amount of money spent on order divided by the voucher value */
  smashFactor?: Maybe<Scalars['Float']>;
  /** The total amount of money spent using the voucher */
  spending?: Maybe<Scalars['Float']>;
  /** The date the voucher was first used */
  usageDate?: Maybe<Scalars['Date']>;
};

/** Represents a transaction for a voucher, including issuance, usage, refund, and adjustments */
export type VoucherTransaction = {
  __typename?: 'VoucherTransaction';
  _id: Scalars['MongoID'];
  amount: Scalars['Float'];
  balance: Scalars['Float'];
  brandHouseId: Scalars['MongoID'];
  consumerEmail: Scalars['String'];
  consumerId: Scalars['MongoID'];
  currency: Scalars['String'];
  date: Scalars['Date'];
  deleted: Scalars['Boolean'];
  externOrderId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  receivedTs?: Maybe<Scalars['Date']>;
  /** The shop associated with this transaction */
  shop?: Maybe<Shop>;
  shopId: Scalars['MongoID'];
  shopName: Scalars['String'];
  spending: Scalars['Float'];
  /** The tradein associated with this transaction */
  tradeIn?: Maybe<TradeIn>;
  tradeInId: Scalars['MongoID'];
  type?: Maybe<VoucherTransactionEnumType>;
  /** URL to the external ressource for this transaction */
  url?: Maybe<Scalars['String']>;
  /** The user associated with this transaction */
  user?: Maybe<User>;
  /** The voucher associated with this transaction */
  voucher?: Maybe<Voucher>;
  voucherCode: Scalars['String'];
  voucherId: Scalars['MongoID'];
};

/** Types of voucher transactions */
export enum VoucherTransactionEnumType {
  Adjust = 'ADJUST',
  Issued = 'ISSUED',
  Refund = 'REFUND',
  Usage = 'USAGE'
}

export type VoucherUsage = {
  __typename?: 'VoucherUsage';
  _id: Scalars['MongoID'];
  /** The date of the usage cancellation, if cancelled - this usage will be ignored when calculating voucher balance */
  cancelDate?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  /** The external ID of the order that triggered a voucher action. There can be multiple actions for the same order. */
  externOrderId: Scalars['String'];
  /** URL to the external order ressource for this usage */
  externUrl?: Maybe<Scalars['String']>;
  /** The external order */
  externalOrder?: Maybe<ExternOrder2>;
  items?: Maybe<Array<Maybe<VoucherUsageItems>>>;
  /** Refunds for this voucher usage */
  refunds?: Maybe<Array<Maybe<VoucherUsageRefund>>>;
  /** Shipping cost */
  shippingAmount: Scalars['Float'];
  shopId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  /** The date of usage */
  usageDate: Scalars['Date'];
  /** Voucher for this voucher usage */
  voucher?: Maybe<Voucher>;
  voucherId: Scalars['MongoID'];
};

export type VoucherUsageInput = {
  /** The date of the usage cancellation, if cancelled - this usage will be ignored when calculating voucher balance */
  cancelDate?: InputMaybe<Scalars['Date']>;
  /** The voucher code */
  code: Scalars['String'];
  /** The external ID of the order that triggered a voucher action. There can be multiple actions for the same order. */
  externOrderId: Scalars['String'];
  items?: InputMaybe<Array<InputMaybe<VoucherUsageItemsInput>>>;
  refunds?: InputMaybe<Array<InputMaybe<VoucherUsageRefundInput>>>;
  /** Shipping cost */
  shippingAmount: Scalars['Float'];
  /** The date of usage */
  usageDate: Scalars['Date'];
};

export type VoucherUsageItems = {
  __typename?: 'VoucherUsageItems';
  /** The discounted price for item(s) in shop currency */
  discountedPrice: Scalars['Float'];
  /** The discounted price before tax for item(s) in shop currency */
  discountedPricePreTax: Scalars['Float'];
  /** The external ID of the lineitem */
  externLineItemId: Scalars['String'];
  /** The original price for item(s) in shop currency */
  price: Scalars['Float'];
  /** The number of items bought */
  quantity: Scalars['Float'];
};

export type VoucherUsageItemsInput = {
  /** The discounted price for item(s) in shop currency */
  discountedPrice: Scalars['Float'];
  /** The discounted price before tax for item(s) in shop currency */
  discountedPricePreTax: Scalars['Float'];
  /** The external ID of the lineitem */
  externLineItemId: Scalars['String'];
  /** The original price for item(s) in shop currency */
  price: Scalars['Float'];
  /** The number of items bought */
  quantity: Scalars['Float'];
};

export type VoucherUsageRefund = {
  __typename?: 'VoucherUsageRefund';
  _id: Scalars['MongoID'];
  /** The refund amount */
  amount: Scalars['Float'];
  createdAt?: Maybe<Scalars['Date']>;
  /** Refund ID */
  externRefundId: Scalars['String'];
  /** Whether the refund has been processed by the platform */
  processed: Scalars['Boolean'];
  /** The date of the refund */
  refundDate: Scalars['Date'];
  refundItems?: Maybe<Array<Maybe<VoucherUsageRefundRefundItems>>>;
  /** The type of refund */
  refundType: EnumVoucherUsageRefundRefundType;
  /** The shop that owns the usage refund */
  shopId: Scalars['MongoID'];
  updatedAt?: Maybe<Scalars['Date']>;
  /** Voucher Usage refund */
  voucherUsage?: Maybe<VoucherUsage>;
  /** The voucher usage that this refund is related to */
  voucherUsageId: Scalars['MongoID'];
};

export type VoucherUsageRefundInput = {
  /** The refund amount */
  amount: Scalars['Float'];
  /** Refund ID */
  externRefundId: Scalars['String'];
  /** The date of the refund */
  refundDate: Scalars['Date'];
  refundItems?: InputMaybe<Array<InputMaybe<VoucherUsageRefundRefundItemsInput>>>;
  /** The type of refund */
  refundType: EnumVoucherUsageRefundRefundType;
};

export type VoucherUsageRefundRefundItems = {
  __typename?: 'VoucherUsageRefundRefundItems';
  /** Line item ID */
  externLineItemId: Scalars['String'];
  /** Number of items refunded */
  quantity: Scalars['Float'];
};

export type VoucherUsageRefundRefundItemsInput = {
  /** Line item ID */
  externLineItemId: Scalars['String'];
  /** Number of items refunded */
  quantity: Scalars['Float'];
};

/** List of items with pagination. */
export type VoucherVoucherPagination = {
  __typename?: 'VoucherVoucherPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Voucher>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type WarehouseLocation = {
  __typename?: 'WarehouseLocation';
  _id?: Maybe<Scalars['String']>;
  /** Whether all items in this location has been checked */
  checked: Scalars['Boolean'];
  count: Scalars['Float'];
  items?: Maybe<Array<Maybe<StockItem>>>;
};

export type WholeSaleCategory = {
  __typename?: 'WholeSaleCategory';
  _id: Scalars['MongoID'];
  advanced?: Maybe<Scalars['Boolean']>;
  /** Soft-delete flag. When true, the category is hidden from listings but retained so historical TradeInItems can still resolve it. */
  deleted?: Maybe<Scalars['Boolean']>;
  iconId?: Maybe<Scalars['MongoID']>;
  /** Gets the name of the category, if no locale is provided then the default name is returned */
  name: Scalars['String'];
  nameLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  rules?: Maybe<Array<Maybe<WholeSaleCategoryRules>>>;
  section?: Maybe<Scalars['String']>;
  sectionLocalized?: Maybe<Array<Maybe<LocalizationEntry>>>;
  shopId: Scalars['MongoID'];
  /** The other of this category */
  sortOrder?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<ObjectPatchesUpdatedBy>;
  value: Scalars['Float'];
  voucherStrategy?: Maybe<EnumWholeSaleCategoryVoucherStrategy>;
};


export type WholeSaleCategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type WholeSaleCategoryRules = {
  __typename?: 'WholeSaleCategoryRules';
  _id?: Maybe<Scalars['MongoID']>;
  active?: Maybe<Scalars['Boolean']>;
  expressions?: Maybe<Array<Maybe<WholeSaleCategoryRulesExpressions>>>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type WholeSaleCategoryRulesExpressions = {
  __typename?: 'WholeSaleCategoryRulesExpressions';
  _id?: Maybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: Maybe<Scalars['String']>;
  expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType;
  operator: EnumWholeSaleCategoryRulesExpressionsOperator;
  sku?: Maybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: Maybe<Scalars['String']>;
};

export type WholeSaleCategoryRulesExpressionsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  /** Product collection in external shop, see valid collections on Shop.productCollections */
  col?: InputMaybe<Scalars['String']>;
  expressionType: EnumWholeSaleCategoryRulesExpressionsExpressionType;
  operator: EnumWholeSaleCategoryRulesExpressionsOperator;
  sku?: InputMaybe<Scalars['String']>;
  /** Product tag, see valid tags on Shop.productTags */
  tag?: InputMaybe<Scalars['String']>;
};

export type WholeSaleCategoryRulesInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  expressions?: InputMaybe<Array<InputMaybe<WholeSaleCategoryRulesExpressionsInput>>>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type WholeSaleConfigType = {
  __typename?: 'WholeSaleConfigType';
  active: Scalars['Boolean'];
  currency: Scalars['String'];
};

export type WholeSaleProduct = {
  __typename?: 'WholeSaleProduct';
  _id: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  ruleId: Scalars['String'];
  score: Scalars['Float'];
  style?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<Maybe<WholeSaleVariant>>>;
};

export type WholeSaleStatistics = {
  __typename?: 'WholeSaleStatistics';
  count?: Maybe<Scalars['Float']>;
  sample?: Maybe<Array<Maybe<WholeSaleProduct>>>;
};

export type WholeSaleVariant = {
  __typename?: 'WholeSaleVariant';
  _id: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  credit?: Maybe<WholeSaleVariantCredit>;
  ean?: Maybe<Scalars['String']>;
  /** Images for this product variant */
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  score: Scalars['Float'];
  size?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
};

export type WholeSaleVariantCredit = {
  __typename?: 'WholeSaleVariantCredit';
  currency: Scalars['String'];
  value: Scalars['Float'];
};

export type ConsumerLoginMutationVariables = Exact<{
  shopId: Scalars['String'];
  accessToken: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
  multiLogin?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
}>;


export type ConsumerLoginMutation = { __typename?: 'Mutation', ConsumerLogin?: { __typename?: 'ConsumerAuthorizeResult', token: string, consumerId: string, shopId: string, brandName: string, locale: string, currency: string, shopCurrency: string, allowedCountry: boolean, lockEmail: boolean, requestPotentialsSupported: boolean, tradeInComments: boolean } | null };

export type ConsumerCarrierFragment = { __typename?: 'BrandCarrier', _id: string, active?: boolean | null, shippingCarrier?: { __typename?: 'ShippingCarrier', carrierId?: string | null, name?: string | null, externalName?: string | null, localizationKey?: string | null, logo?: string | null } | null };

export type ConsumerCarriersQueryVariables = Exact<{
  shopId: Scalars['String'];
  consumerId: Scalars['String'];
}>;


export type ConsumerCarriersQuery = { __typename?: 'Query', ConsumerCarriers?: Array<{ __typename?: 'BrandCarrier', _id: string, active?: boolean | null, shippingCarrier?: { __typename?: 'ShippingCarrier', carrierId?: string | null, name?: string | null, externalName?: string | null, localizationKey?: string | null, logo?: string | null } | null } | null> | null };

export type WholeSaleCategoriesQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type WholeSaleCategoriesQuery = { __typename?: 'Query', WholeSaleCategories: Array<{ __typename?: 'WholeSaleCategory', _id: string, iconId?: string | null, name: string, section?: string | null, value: number, advanced?: boolean | null, nameLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null, sectionLocalized?: Array<{ __typename?: 'LocalizationEntry', locale: string, value: string } | null> | null }> };

export type TradeInConfigQueryVariables = Exact<{
  shopId: Scalars['MongoID'];
}>;


export type TradeInConfigQuery = { __typename?: 'Query', ShopLanguages?: Array<string> | null, UATrackingId?: string | null, GATrackingId?: string | null, TradeInConfig?: { __typename?: 'TradeInConfig', brandHouseId: string, shopCurrency: string, maximumVoucher: number, defaultImage?: string | null, productSearchEnabled: boolean, productSearchMask?: string | null, voucherStrategy: EnumTradeInActivationStrategy, authMethods: Array<string>, wholeSaleActive: boolean } | null };

export type ConsumerDetailsFragment = { __typename?: 'Consumer', _id: string, shopId?: string | null, name?: string | null, mail?: string | null, phone?: string | null, countryCode?: string | null, add1?: string | null, zipCode?: string | null, city?: string | null, locale?: string | null, currency: string };

export type ConsumerDetailsQueryVariables = Exact<{
  consumerId: Scalars['MongoID'];
}>;


export type ConsumerDetailsQuery = { __typename?: 'Query', ConsumerById?: { __typename?: 'Consumer', _id: string, shopId?: string | null, name?: string | null, mail?: string | null, phone?: string | null, countryCode?: string | null, add1?: string | null, zipCode?: string | null, city?: string | null, locale?: string | null, currency: string } | null };

export type ConsumerUpdateMutationVariables = Exact<{
  consumer: ConsumerInput;
}>;


export type ConsumerUpdateMutation = { __typename?: 'Mutation', ConsumerUpdate?: { __typename?: 'Consumer', _id: string, shopId?: string | null, name?: string | null, mail?: string | null, phone?: string | null, countryCode?: string | null, add1?: string | null, zipCode?: string | null, city?: string | null, locale?: string | null, currency: string } | null };

export type ConvertCurrencyForConsumerQueryVariables = Exact<{
  inputCurrency: Scalars['String'];
  inputValue: Scalars['Float'];
  consumerId: Scalars['MongoID'];
}>;


export type ConvertCurrencyForConsumerQuery = { __typename?: 'Query', ConvertCurrencyForConsumer?: { __typename?: 'Pricing', value: number, currency: string } | null };

export type ConsumerAccessRequestMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  identifier: Scalars['String'];
  authMethod: ConsumerAuthMethodEnum;
  onlyDefaultFlow?: InputMaybe<Scalars['Boolean']>;
}>;


export type ConsumerAccessRequestMutation = { __typename?: 'Mutation', ConsumerAccessRequest?: { __typename?: 'ConsumerAccessRequestResult', status: string, messageId?: string | null } | null };

export type ConsumerVerifyCodeMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  phone: Scalars['String'];
  code: Scalars['String'];
}>;


export type ConsumerVerifyCodeMutation = { __typename?: 'Mutation', ConsumerVerifyCode?: { __typename?: 'ConsumerVerifyCode', status: string, accessToken?: string | null } | null };

export type WholesaleConsumerCreateMutationVariables = Exact<{
  shopId: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
}>;


export type WholesaleConsumerCreateMutation = { __typename?: 'Mutation', ConsumerCreate?: { __typename?: 'Consumer', _id: string, accessToken?: string | null } | null };

export type ConsumerRequestPotentialsMutationVariables = Exact<{
  shopId: Scalars['MongoID'];
  consumerId: Scalars['MongoID'];
}>;


export type ConsumerRequestPotentialsMutation = { __typename?: 'Mutation', ConsumerRequestPotentials?: Array<string> | null };

export type RequestPotentialStatusQueryVariables = Exact<{
  tokens?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type RequestPotentialStatusQuery = { __typename?: 'Query', IntegrationMessage?: Array<{ __typename?: 'IntegrationMessageResult', resultTs?: string | null, messageFailed?: boolean | null } | null> | null };

export type ConsumerPotentialFragment = { __typename?: 'Potential', _id: string, id?: string | null, name?: string | null, color?: string | null, size?: string | null, imageUrls?: Array<string> | null, sourceType?: PotentialSourceTypeEnum | null, externDate?: string | null, offer?: { __typename?: 'PotentialValue', value?: number | null, currency: string, validForTradeIn?: boolean | null } | null, wholeSale?: { __typename?: 'PotentialWholeSale', categoryId?: string | null, name?: string | null, value?: number | null } | null };

export type ConsumerPotentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerPotentialsQuery = { __typename?: 'Query', ConsumerPotentials?: Array<{ __typename?: 'Potential', _id: string, id?: string | null, name?: string | null, color?: string | null, size?: string | null, imageUrls?: Array<string> | null, sourceType?: PotentialSourceTypeEnum | null, externDate?: string | null, offer?: { __typename?: 'PotentialValue', value?: number | null, currency: string, validForTradeIn?: boolean | null } | null, wholeSale?: { __typename?: 'PotentialWholeSale', categoryId?: string | null, name?: string | null, value?: number | null } | null } | null> | null };

export type PotentialCreateMutationVariables = Exact<{
  consumerId: Scalars['MongoID'];
  masterVariantId?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['MongoID']>;
  categoryId?: InputMaybe<Scalars['MongoID']>;
  imageId?: InputMaybe<Scalars['MongoID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
}>;


export type PotentialCreateMutation = { __typename?: 'Mutation', PotentialCreate?: { __typename?: 'Potential', _id: string, id?: string | null, name?: string | null, color?: string | null, size?: string | null, imageUrls?: Array<string> | null, sourceType?: PotentialSourceTypeEnum | null, externDate?: string | null, offer?: { __typename?: 'PotentialValue', value?: number | null, currency: string, validForTradeIn?: boolean | null } | null, wholeSale?: { __typename?: 'PotentialWholeSale', categoryId?: string | null, name?: string | null, value?: number | null } | null } | null };

export type PotentialDeleteMutationVariables = Exact<{
  potentialId: Scalars['MongoID'];
}>;


export type PotentialDeleteMutation = { __typename?: 'Mutation', PotentialDelete?: { __typename?: 'Potential', _id: string } | null };

export type TradeInCreateMutationVariables = Exact<{
  consumerId: Scalars['MongoID'];
  potentialIds: Array<Scalars['MongoID']> | Scalars['MongoID'];
  brandCarrierId?: InputMaybe<Scalars['MongoID']>;
  payout: EnumTradeInPayoutType;
  comments?: InputMaybe<Array<InputMaybe<TradeInCommentInput>> | InputMaybe<TradeInCommentInput>>;
}>;


export type TradeInCreateMutation = { __typename?: 'Mutation', TradeInCreate?: { __typename?: 'TradeIn', _id: string } | null };

export type TradeInLabelQueryVariables = Exact<{
  tradeInId: Scalars['MongoID'];
}>;


export type TradeInLabelQuery = { __typename?: 'Query', TradeInById?: { __typename?: 'TradeIn', _id: string, shippingCarrier?: { __typename?: 'ShippingCarrier', carrierId?: string | null, customCarrier?: boolean | null } | null, items?: Array<{ __typename?: 'TradeInItem', _id: string } | null> | null, vouchers?: Array<{ __typename?: 'Voucher', code?: string | null, value?: number | null, currency?: string | null, activated: boolean, expireDate?: string | null } | null> | null, label?: { __typename?: 'ShippingLabel', labelCode?: string | null, qrUrl?: string | null, url?: string | null, labelFailed?: boolean | null, createdAt?: string | null } | null, dropOffPoints?: Array<{ __typename?: 'Dropoff', name?: string | null, address?: string | null, address2?: string | null, zipcode?: string | null, city?: string | null, opening_hours?: Array<string | null> | null, qr_code?: boolean | null } | null> | null } | null };

export type ConsumerTradeInsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerTradeInsQuery = { __typename?: 'Query', ConsumerTradeIns?: Array<{ __typename?: 'TradeIn', _id: string, dateTime: string, registered?: boolean | null, status?: TradeInStatusEnum | null, items?: Array<{ __typename?: 'TradeInItem', _id: string, name?: string | null, imageUrls?: Array<string> | null, masterVariantImageUrl?: string | null, value?: number | null, currency?: string | null } | null> | null, vouchers?: Array<{ __typename?: 'Voucher', value?: number | null, currency?: string | null } | null> | null, shippingCarrier?: { __typename?: 'ShippingCarrier', carrierId?: string | null, customCarrier?: boolean | null } | null, label?: { __typename?: 'ShippingLabel', labelCode?: string | null, qrUrl?: string | null, url?: string | null, labelFailed?: boolean | null } | null } | null> | null };

export type VouchersQueryVariables = Exact<{
  consumerId: Scalars['MongoID'];
}>;


export type VouchersQuery = { __typename?: 'Query', Vouchers: Array<{ __typename?: 'Voucher', _id: string, code?: string | null, activated: boolean, disabled?: string | null, value?: number | null, currentValue?: number | null, currency?: string | null, expireDate?: string | null, createdAt?: string | null, tradeInReceivedTs?: string | null }> };

export const ConsumerCarrierFragmentDoc = gql`
    fragment ConsumerCarrier on BrandCarrier {
  _id
  active
  shippingCarrier {
    carrierId
    name
    externalName
    localizationKey
    logo
  }
}
    `;
export const ConsumerDetailsFragmentDoc = gql`
    fragment ConsumerDetails on Consumer {
  _id
  shopId
  name
  mail
  phone
  countryCode
  add1
  zipCode
  city
  locale
  currency
}
    `;
export const ConsumerPotentialFragmentDoc = gql`
    fragment ConsumerPotential on Potential {
  _id
  id
  name
  color
  size
  imageUrls
  sourceType
  externDate
  offer(live: false) {
    value
    currency
    validForTradeIn
  }
  wholeSale {
    categoryId
    name
    value
  }
}
    `;
export const ConsumerLoginDocument = gql`
    mutation ConsumerLogin($shopId: String!, $accessToken: String!, $preview: Boolean, $multiLogin: Boolean, $currency: String, $language: String, $countryCode: String) {
  ConsumerLogin(
    shopId: $shopId
    token: $accessToken
    preview: $preview
    multiLogin: $multiLogin
    currency: $currency
    language: $language
    countryCode: $countryCode
  ) {
    token
    consumerId
    shopId
    brandName
    locale
    currency
    shopCurrency
    allowedCountry
    lockEmail
    requestPotentialsSupported
    tradeInComments
  }
}
    `;
export type ConsumerLoginMutationFn = Apollo.MutationFunction<ConsumerLoginMutation, ConsumerLoginMutationVariables>;

/**
 * __useConsumerLoginMutation__
 *
 * To run a mutation, you first call `useConsumerLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerLoginMutation, { data, loading, error }] = useConsumerLoginMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      accessToken: // value for 'accessToken'
 *      preview: // value for 'preview'
 *      multiLogin: // value for 'multiLogin'
 *      currency: // value for 'currency'
 *      language: // value for 'language'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useConsumerLoginMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerLoginMutation, ConsumerLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerLoginMutation, ConsumerLoginMutationVariables>(ConsumerLoginDocument, options);
      }
export type ConsumerLoginMutationHookResult = ReturnType<typeof useConsumerLoginMutation>;
export type ConsumerLoginMutationResult = Apollo.MutationResult<ConsumerLoginMutation>;
export type ConsumerLoginMutationOptions = Apollo.BaseMutationOptions<ConsumerLoginMutation, ConsumerLoginMutationVariables>;
export const ConsumerCarriersDocument = gql`
    query ConsumerCarriers($shopId: String!, $consumerId: String!) {
  ConsumerCarriers(shopId: $shopId, consumerId: $consumerId) {
    ...ConsumerCarrier
  }
}
    ${ConsumerCarrierFragmentDoc}`;

/**
 * __useConsumerCarriersQuery__
 *
 * To run a query within a React component, call `useConsumerCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerCarriersQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useConsumerCarriersQuery(baseOptions: Apollo.QueryHookOptions<ConsumerCarriersQuery, ConsumerCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerCarriersQuery, ConsumerCarriersQueryVariables>(ConsumerCarriersDocument, options);
      }
export function useConsumerCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerCarriersQuery, ConsumerCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerCarriersQuery, ConsumerCarriersQueryVariables>(ConsumerCarriersDocument, options);
        }
export type ConsumerCarriersQueryHookResult = ReturnType<typeof useConsumerCarriersQuery>;
export type ConsumerCarriersLazyQueryHookResult = ReturnType<typeof useConsumerCarriersLazyQuery>;
export type ConsumerCarriersQueryResult = Apollo.QueryResult<ConsumerCarriersQuery, ConsumerCarriersQueryVariables>;
export const WholeSaleCategoriesDocument = gql`
    query WholeSaleCategories($shopId: MongoID!) {
  WholeSaleCategories(filter: {shopId: $shopId}, sort: PRESENTATION) {
    _id
    iconId
    name
    nameLocalized {
      locale
      value
    }
    section
    sectionLocalized {
      locale
      value
    }
    value
    advanced
  }
}
    `;

/**
 * __useWholeSaleCategoriesQuery__
 *
 * To run a query within a React component, call `useWholeSaleCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWholeSaleCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWholeSaleCategoriesQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useWholeSaleCategoriesQuery(baseOptions: Apollo.QueryHookOptions<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>(WholeSaleCategoriesDocument, options);
      }
export function useWholeSaleCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>(WholeSaleCategoriesDocument, options);
        }
export type WholeSaleCategoriesQueryHookResult = ReturnType<typeof useWholeSaleCategoriesQuery>;
export type WholeSaleCategoriesLazyQueryHookResult = ReturnType<typeof useWholeSaleCategoriesLazyQuery>;
export type WholeSaleCategoriesQueryResult = Apollo.QueryResult<WholeSaleCategoriesQuery, WholeSaleCategoriesQueryVariables>;
export const TradeInConfigDocument = gql`
    query TradeInConfig($shopId: MongoID!) {
  ShopLanguages(shopId: $shopId)
  UATrackingId: BrandTrackingId(shopId: $shopId, type: "ua")
  GATrackingId: BrandTrackingId(shopId: $shopId, type: "ga4")
  TradeInConfig(shopId: $shopId) {
    brandHouseId
    shopCurrency
    maximumVoucher
    defaultImage
    productSearchEnabled
    productSearchMask
    voucherStrategy
    authMethods
    wholeSaleActive
  }
}
    `;

/**
 * __useTradeInConfigQuery__
 *
 * To run a query within a React component, call `useTradeInConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeInConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeInConfigQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function useTradeInConfigQuery(baseOptions: Apollo.QueryHookOptions<TradeInConfigQuery, TradeInConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TradeInConfigQuery, TradeInConfigQueryVariables>(TradeInConfigDocument, options);
      }
export function useTradeInConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TradeInConfigQuery, TradeInConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TradeInConfigQuery, TradeInConfigQueryVariables>(TradeInConfigDocument, options);
        }
export type TradeInConfigQueryHookResult = ReturnType<typeof useTradeInConfigQuery>;
export type TradeInConfigLazyQueryHookResult = ReturnType<typeof useTradeInConfigLazyQuery>;
export type TradeInConfigQueryResult = Apollo.QueryResult<TradeInConfigQuery, TradeInConfigQueryVariables>;
export const ConsumerDetailsDocument = gql`
    query ConsumerDetails($consumerId: MongoID!) {
  ConsumerById(_id: $consumerId) {
    ...ConsumerDetails
  }
}
    ${ConsumerDetailsFragmentDoc}`;

/**
 * __useConsumerDetailsQuery__
 *
 * To run a query within a React component, call `useConsumerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerDetailsQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useConsumerDetailsQuery(baseOptions: Apollo.QueryHookOptions<ConsumerDetailsQuery, ConsumerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerDetailsQuery, ConsumerDetailsQueryVariables>(ConsumerDetailsDocument, options);
      }
export function useConsumerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerDetailsQuery, ConsumerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerDetailsQuery, ConsumerDetailsQueryVariables>(ConsumerDetailsDocument, options);
        }
export type ConsumerDetailsQueryHookResult = ReturnType<typeof useConsumerDetailsQuery>;
export type ConsumerDetailsLazyQueryHookResult = ReturnType<typeof useConsumerDetailsLazyQuery>;
export type ConsumerDetailsQueryResult = Apollo.QueryResult<ConsumerDetailsQuery, ConsumerDetailsQueryVariables>;
export const ConsumerUpdateDocument = gql`
    mutation ConsumerUpdate($consumer: ConsumerInput!) {
  ConsumerUpdate(consumer: $consumer) {
    ...ConsumerDetails
  }
}
    ${ConsumerDetailsFragmentDoc}`;
export type ConsumerUpdateMutationFn = Apollo.MutationFunction<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>;

/**
 * __useConsumerUpdateMutation__
 *
 * To run a mutation, you first call `useConsumerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerUpdateMutation, { data, loading, error }] = useConsumerUpdateMutation({
 *   variables: {
 *      consumer: // value for 'consumer'
 *   },
 * });
 */
export function useConsumerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>(ConsumerUpdateDocument, options);
      }
export type ConsumerUpdateMutationHookResult = ReturnType<typeof useConsumerUpdateMutation>;
export type ConsumerUpdateMutationResult = Apollo.MutationResult<ConsumerUpdateMutation>;
export type ConsumerUpdateMutationOptions = Apollo.BaseMutationOptions<ConsumerUpdateMutation, ConsumerUpdateMutationVariables>;
export const ConvertCurrencyForConsumerDocument = gql`
    query ConvertCurrencyForConsumer($inputCurrency: String!, $inputValue: Float!, $consumerId: MongoID!) {
  ConvertCurrencyForConsumer(
    inputCurrency: $inputCurrency
    inputValue: $inputValue
    consumerId: $consumerId
  ) {
    value
    currency
  }
}
    `;

/**
 * __useConvertCurrencyForConsumerQuery__
 *
 * To run a query within a React component, call `useConvertCurrencyForConsumerQuery` and pass it any options that fit your needs.
 * When your component renders, `useConvertCurrencyForConsumerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConvertCurrencyForConsumerQuery({
 *   variables: {
 *      inputCurrency: // value for 'inputCurrency'
 *      inputValue: // value for 'inputValue'
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useConvertCurrencyForConsumerQuery(baseOptions: Apollo.QueryHookOptions<ConvertCurrencyForConsumerQuery, ConvertCurrencyForConsumerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConvertCurrencyForConsumerQuery, ConvertCurrencyForConsumerQueryVariables>(ConvertCurrencyForConsumerDocument, options);
      }
export function useConvertCurrencyForConsumerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConvertCurrencyForConsumerQuery, ConvertCurrencyForConsumerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConvertCurrencyForConsumerQuery, ConvertCurrencyForConsumerQueryVariables>(ConvertCurrencyForConsumerDocument, options);
        }
export type ConvertCurrencyForConsumerQueryHookResult = ReturnType<typeof useConvertCurrencyForConsumerQuery>;
export type ConvertCurrencyForConsumerLazyQueryHookResult = ReturnType<typeof useConvertCurrencyForConsumerLazyQuery>;
export type ConvertCurrencyForConsumerQueryResult = Apollo.QueryResult<ConvertCurrencyForConsumerQuery, ConvertCurrencyForConsumerQueryVariables>;
export const ConsumerAccessRequestDocument = gql`
    mutation ConsumerAccessRequest($shopId: MongoID!, $identifier: String!, $authMethod: ConsumerAuthMethodEnum!, $onlyDefaultFlow: Boolean) {
  ConsumerAccessRequest(
    shopId: $shopId
    identifier: $identifier
    authMethod: $authMethod
    onlyDefaultFlow: $onlyDefaultFlow
  ) {
    status
    messageId
  }
}
    `;
export type ConsumerAccessRequestMutationFn = Apollo.MutationFunction<ConsumerAccessRequestMutation, ConsumerAccessRequestMutationVariables>;

/**
 * __useConsumerAccessRequestMutation__
 *
 * To run a mutation, you first call `useConsumerAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerAccessRequestMutation, { data, loading, error }] = useConsumerAccessRequestMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      identifier: // value for 'identifier'
 *      authMethod: // value for 'authMethod'
 *      onlyDefaultFlow: // value for 'onlyDefaultFlow'
 *   },
 * });
 */
export function useConsumerAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerAccessRequestMutation, ConsumerAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerAccessRequestMutation, ConsumerAccessRequestMutationVariables>(ConsumerAccessRequestDocument, options);
      }
export type ConsumerAccessRequestMutationHookResult = ReturnType<typeof useConsumerAccessRequestMutation>;
export type ConsumerAccessRequestMutationResult = Apollo.MutationResult<ConsumerAccessRequestMutation>;
export type ConsumerAccessRequestMutationOptions = Apollo.BaseMutationOptions<ConsumerAccessRequestMutation, ConsumerAccessRequestMutationVariables>;
export const ConsumerVerifyCodeDocument = gql`
    mutation ConsumerVerifyCode($shopId: MongoID!, $phone: String!, $code: String!) {
  ConsumerVerifyCode(shopId: $shopId, phoneNumber: $phone, code: $code) {
    status
    accessToken
  }
}
    `;
export type ConsumerVerifyCodeMutationFn = Apollo.MutationFunction<ConsumerVerifyCodeMutation, ConsumerVerifyCodeMutationVariables>;

/**
 * __useConsumerVerifyCodeMutation__
 *
 * To run a mutation, you first call `useConsumerVerifyCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerVerifyCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerVerifyCodeMutation, { data, loading, error }] = useConsumerVerifyCodeMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      phone: // value for 'phone'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConsumerVerifyCodeMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerVerifyCodeMutation, ConsumerVerifyCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerVerifyCodeMutation, ConsumerVerifyCodeMutationVariables>(ConsumerVerifyCodeDocument, options);
      }
export type ConsumerVerifyCodeMutationHookResult = ReturnType<typeof useConsumerVerifyCodeMutation>;
export type ConsumerVerifyCodeMutationResult = Apollo.MutationResult<ConsumerVerifyCodeMutation>;
export type ConsumerVerifyCodeMutationOptions = Apollo.BaseMutationOptions<ConsumerVerifyCodeMutation, ConsumerVerifyCodeMutationVariables>;
export const WholesaleConsumerCreateDocument = gql`
    mutation WholesaleConsumerCreate($shopId: String!, $locale: String, $country: String, $currency: String) {
  ConsumerCreate(
    shopId: $shopId
    locale: $locale
    countryCode: $country
    currency: $currency
  ) {
    _id
    accessToken
  }
}
    `;
export type WholesaleConsumerCreateMutationFn = Apollo.MutationFunction<WholesaleConsumerCreateMutation, WholesaleConsumerCreateMutationVariables>;

/**
 * __useWholesaleConsumerCreateMutation__
 *
 * To run a mutation, you first call `useWholesaleConsumerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWholesaleConsumerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wholesaleConsumerCreateMutation, { data, loading, error }] = useWholesaleConsumerCreateMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      locale: // value for 'locale'
 *      country: // value for 'country'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useWholesaleConsumerCreateMutation(baseOptions?: Apollo.MutationHookOptions<WholesaleConsumerCreateMutation, WholesaleConsumerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WholesaleConsumerCreateMutation, WholesaleConsumerCreateMutationVariables>(WholesaleConsumerCreateDocument, options);
      }
export type WholesaleConsumerCreateMutationHookResult = ReturnType<typeof useWholesaleConsumerCreateMutation>;
export type WholesaleConsumerCreateMutationResult = Apollo.MutationResult<WholesaleConsumerCreateMutation>;
export type WholesaleConsumerCreateMutationOptions = Apollo.BaseMutationOptions<WholesaleConsumerCreateMutation, WholesaleConsumerCreateMutationVariables>;
export const ConsumerRequestPotentialsDocument = gql`
    mutation ConsumerRequestPotentials($shopId: MongoID!, $consumerId: MongoID!) {
  ConsumerRequestPotentials(shopId: $shopId, consumerId: $consumerId)
}
    `;
export type ConsumerRequestPotentialsMutationFn = Apollo.MutationFunction<ConsumerRequestPotentialsMutation, ConsumerRequestPotentialsMutationVariables>;

/**
 * __useConsumerRequestPotentialsMutation__
 *
 * To run a mutation, you first call `useConsumerRequestPotentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerRequestPotentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerRequestPotentialsMutation, { data, loading, error }] = useConsumerRequestPotentialsMutation({
 *   variables: {
 *      shopId: // value for 'shopId'
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useConsumerRequestPotentialsMutation(baseOptions?: Apollo.MutationHookOptions<ConsumerRequestPotentialsMutation, ConsumerRequestPotentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumerRequestPotentialsMutation, ConsumerRequestPotentialsMutationVariables>(ConsumerRequestPotentialsDocument, options);
      }
export type ConsumerRequestPotentialsMutationHookResult = ReturnType<typeof useConsumerRequestPotentialsMutation>;
export type ConsumerRequestPotentialsMutationResult = Apollo.MutationResult<ConsumerRequestPotentialsMutation>;
export type ConsumerRequestPotentialsMutationOptions = Apollo.BaseMutationOptions<ConsumerRequestPotentialsMutation, ConsumerRequestPotentialsMutationVariables>;
export const RequestPotentialStatusDocument = gql`
    query RequestPotentialStatus($tokens: [String!]) {
  IntegrationMessage(tokens: $tokens) {
    resultTs
    messageFailed
  }
}
    `;

/**
 * __useRequestPotentialStatusQuery__
 *
 * To run a query within a React component, call `useRequestPotentialStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestPotentialStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestPotentialStatusQuery({
 *   variables: {
 *      tokens: // value for 'tokens'
 *   },
 * });
 */
export function useRequestPotentialStatusQuery(baseOptions?: Apollo.QueryHookOptions<RequestPotentialStatusQuery, RequestPotentialStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestPotentialStatusQuery, RequestPotentialStatusQueryVariables>(RequestPotentialStatusDocument, options);
      }
export function useRequestPotentialStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestPotentialStatusQuery, RequestPotentialStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestPotentialStatusQuery, RequestPotentialStatusQueryVariables>(RequestPotentialStatusDocument, options);
        }
export type RequestPotentialStatusQueryHookResult = ReturnType<typeof useRequestPotentialStatusQuery>;
export type RequestPotentialStatusLazyQueryHookResult = ReturnType<typeof useRequestPotentialStatusLazyQuery>;
export type RequestPotentialStatusQueryResult = Apollo.QueryResult<RequestPotentialStatusQuery, RequestPotentialStatusQueryVariables>;
export const ConsumerPotentialsDocument = gql`
    query ConsumerPotentials {
  ConsumerPotentials {
    ...ConsumerPotential
  }
}
    ${ConsumerPotentialFragmentDoc}`;

/**
 * __useConsumerPotentialsQuery__
 *
 * To run a query within a React component, call `useConsumerPotentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerPotentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerPotentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerPotentialsQuery(baseOptions?: Apollo.QueryHookOptions<ConsumerPotentialsQuery, ConsumerPotentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerPotentialsQuery, ConsumerPotentialsQueryVariables>(ConsumerPotentialsDocument, options);
      }
export function useConsumerPotentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerPotentialsQuery, ConsumerPotentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerPotentialsQuery, ConsumerPotentialsQueryVariables>(ConsumerPotentialsDocument, options);
        }
export type ConsumerPotentialsQueryHookResult = ReturnType<typeof useConsumerPotentialsQuery>;
export type ConsumerPotentialsLazyQueryHookResult = ReturnType<typeof useConsumerPotentialsLazyQuery>;
export type ConsumerPotentialsQueryResult = Apollo.QueryResult<ConsumerPotentialsQuery, ConsumerPotentialsQueryVariables>;
export const PotentialCreateDocument = gql`
    mutation PotentialCreate($consumerId: MongoID!, $masterVariantId: String, $ruleId: MongoID, $categoryId: MongoID, $imageId: MongoID, $imageUrl: String, $currency: String) {
  PotentialCreate(
    consumerId: $consumerId
    masterVariantId: $masterVariantId
    ruleId: $ruleId
    categoryId: $categoryId
    imageId: $imageId
    imageUrl: $imageUrl
    currency: $currency
  ) {
    ...ConsumerPotential
  }
}
    ${ConsumerPotentialFragmentDoc}`;
export type PotentialCreateMutationFn = Apollo.MutationFunction<PotentialCreateMutation, PotentialCreateMutationVariables>;

/**
 * __usePotentialCreateMutation__
 *
 * To run a mutation, you first call `usePotentialCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePotentialCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [potentialCreateMutation, { data, loading, error }] = usePotentialCreateMutation({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      masterVariantId: // value for 'masterVariantId'
 *      ruleId: // value for 'ruleId'
 *      categoryId: // value for 'categoryId'
 *      imageId: // value for 'imageId'
 *      imageUrl: // value for 'imageUrl'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function usePotentialCreateMutation(baseOptions?: Apollo.MutationHookOptions<PotentialCreateMutation, PotentialCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PotentialCreateMutation, PotentialCreateMutationVariables>(PotentialCreateDocument, options);
      }
export type PotentialCreateMutationHookResult = ReturnType<typeof usePotentialCreateMutation>;
export type PotentialCreateMutationResult = Apollo.MutationResult<PotentialCreateMutation>;
export type PotentialCreateMutationOptions = Apollo.BaseMutationOptions<PotentialCreateMutation, PotentialCreateMutationVariables>;
export const PotentialDeleteDocument = gql`
    mutation PotentialDelete($potentialId: MongoID!) {
  PotentialDelete(potentialId: $potentialId) {
    _id
  }
}
    `;
export type PotentialDeleteMutationFn = Apollo.MutationFunction<PotentialDeleteMutation, PotentialDeleteMutationVariables>;

/**
 * __usePotentialDeleteMutation__
 *
 * To run a mutation, you first call `usePotentialDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePotentialDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [potentialDeleteMutation, { data, loading, error }] = usePotentialDeleteMutation({
 *   variables: {
 *      potentialId: // value for 'potentialId'
 *   },
 * });
 */
export function usePotentialDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PotentialDeleteMutation, PotentialDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PotentialDeleteMutation, PotentialDeleteMutationVariables>(PotentialDeleteDocument, options);
      }
export type PotentialDeleteMutationHookResult = ReturnType<typeof usePotentialDeleteMutation>;
export type PotentialDeleteMutationResult = Apollo.MutationResult<PotentialDeleteMutation>;
export type PotentialDeleteMutationOptions = Apollo.BaseMutationOptions<PotentialDeleteMutation, PotentialDeleteMutationVariables>;
export const TradeInCreateDocument = gql`
    mutation TradeInCreate($consumerId: MongoID!, $potentialIds: [MongoID!]!, $brandCarrierId: MongoID, $payout: EnumTradeInPayoutType!, $comments: [TradeInCommentInput]) {
  TradeInCreate(
    consumerId: $consumerId
    potentialIds: $potentialIds
    brandCarrierId: $brandCarrierId
    payout: $payout
    comments: $comments
  ) {
    _id
  }
}
    `;
export type TradeInCreateMutationFn = Apollo.MutationFunction<TradeInCreateMutation, TradeInCreateMutationVariables>;

/**
 * __useTradeInCreateMutation__
 *
 * To run a mutation, you first call `useTradeInCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTradeInCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tradeInCreateMutation, { data, loading, error }] = useTradeInCreateMutation({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *      potentialIds: // value for 'potentialIds'
 *      brandCarrierId: // value for 'brandCarrierId'
 *      payout: // value for 'payout'
 *      comments: // value for 'comments'
 *   },
 * });
 */
export function useTradeInCreateMutation(baseOptions?: Apollo.MutationHookOptions<TradeInCreateMutation, TradeInCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TradeInCreateMutation, TradeInCreateMutationVariables>(TradeInCreateDocument, options);
      }
export type TradeInCreateMutationHookResult = ReturnType<typeof useTradeInCreateMutation>;
export type TradeInCreateMutationResult = Apollo.MutationResult<TradeInCreateMutation>;
export type TradeInCreateMutationOptions = Apollo.BaseMutationOptions<TradeInCreateMutation, TradeInCreateMutationVariables>;
export const TradeInLabelDocument = gql`
    query TradeInLabel($tradeInId: MongoID!) {
  TradeInById(_id: $tradeInId) {
    _id
    shippingCarrier {
      carrierId
      customCarrier
    }
    items {
      _id
    }
    vouchers {
      code
      value
      currency
      activated
      expireDate
    }
    label {
      labelCode
      qrUrl
      url
      labelFailed
      createdAt
    }
    dropOffPoints {
      name
      address
      address2
      zipcode
      city
      opening_hours
      qr_code
    }
  }
}
    `;

/**
 * __useTradeInLabelQuery__
 *
 * To run a query within a React component, call `useTradeInLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeInLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeInLabelQuery({
 *   variables: {
 *      tradeInId: // value for 'tradeInId'
 *   },
 * });
 */
export function useTradeInLabelQuery(baseOptions: Apollo.QueryHookOptions<TradeInLabelQuery, TradeInLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TradeInLabelQuery, TradeInLabelQueryVariables>(TradeInLabelDocument, options);
      }
export function useTradeInLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TradeInLabelQuery, TradeInLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TradeInLabelQuery, TradeInLabelQueryVariables>(TradeInLabelDocument, options);
        }
export type TradeInLabelQueryHookResult = ReturnType<typeof useTradeInLabelQuery>;
export type TradeInLabelLazyQueryHookResult = ReturnType<typeof useTradeInLabelLazyQuery>;
export type TradeInLabelQueryResult = Apollo.QueryResult<TradeInLabelQuery, TradeInLabelQueryVariables>;
export const ConsumerTradeInsDocument = gql`
    query ConsumerTradeIns {
  ConsumerTradeIns {
    _id
    dateTime
    registered
    status
    items {
      _id
      name
      imageUrls
      masterVariantImageUrl
      value
      currency
    }
    vouchers {
      value
      currency
    }
    shippingCarrier {
      carrierId
      customCarrier
    }
    label {
      labelCode
      qrUrl
      url
      labelFailed
    }
  }
}
    `;

/**
 * __useConsumerTradeInsQuery__
 *
 * To run a query within a React component, call `useConsumerTradeInsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerTradeInsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerTradeInsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerTradeInsQuery(baseOptions?: Apollo.QueryHookOptions<ConsumerTradeInsQuery, ConsumerTradeInsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerTradeInsQuery, ConsumerTradeInsQueryVariables>(ConsumerTradeInsDocument, options);
      }
export function useConsumerTradeInsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerTradeInsQuery, ConsumerTradeInsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerTradeInsQuery, ConsumerTradeInsQueryVariables>(ConsumerTradeInsDocument, options);
        }
export type ConsumerTradeInsQueryHookResult = ReturnType<typeof useConsumerTradeInsQuery>;
export type ConsumerTradeInsLazyQueryHookResult = ReturnType<typeof useConsumerTradeInsLazyQuery>;
export type ConsumerTradeInsQueryResult = Apollo.QueryResult<ConsumerTradeInsQuery, ConsumerTradeInsQueryVariables>;
export const VouchersDocument = gql`
    query Vouchers($consumerId: MongoID!) {
  Vouchers(filter: {consumerId: $consumerId}) {
    _id
    code
    activated
    disabled
    value
    currentValue
    currency
    expireDate
    createdAt
    tradeInReceivedTs
  }
}
    `;

/**
 * __useVouchersQuery__
 *
 * To run a query within a React component, call `useVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVouchersQuery({
 *   variables: {
 *      consumerId: // value for 'consumerId'
 *   },
 * });
 */
export function useVouchersQuery(baseOptions: Apollo.QueryHookOptions<VouchersQuery, VouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VouchersQuery, VouchersQueryVariables>(VouchersDocument, options);
      }
export function useVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VouchersQuery, VouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VouchersQuery, VouchersQueryVariables>(VouchersDocument, options);
        }
export type VouchersQueryHookResult = ReturnType<typeof useVouchersQuery>;
export type VouchersLazyQueryHookResult = ReturnType<typeof useVouchersLazyQuery>;
export type VouchersQueryResult = Apollo.QueryResult<VouchersQuery, VouchersQueryVariables>;